/*! lodash.js */
(function () {
  var n,
    r = "Expected a function",
    t = 1,
    e = 2,
    u = 1,
    o = 1 / 0,
    i = 9007199254740991,
    c = "[object Arguments]",
    f = "[object Array]",
    a = "[object AsyncFunction]",
    l = "[object Boolean]",
    p = "[object Date]",
    s = "[object Error]",
    v = "[object Function]",
    h = "[object GeneratorFunction]",
    y = "[object Number]",
    g = "[object Object]",
    _ = "[object Proxy]",
    b = "[object RegExp]",
    j = "[object String]",
    d = /[&<>"']/g,
    m = RegExp(d.source),
    O = /^(?:0|[1-9]\d*)$/,
    x =
      "object" == typeof global && global && global.Object === Object && global,
    w = "object" == typeof self && self && self.Object === Object && self,
    A = x || w || Function("return this")(),
    E = "object" == typeof exports && exports && !exports.nodeType && exports,
    N = E && "object" == typeof module && module && !module.nodeType && module;
  function k(n, r) {
    return n.push.apply(n, r), n;
  }
  function F(r) {
    return function (t) {
      return null == t ? n : t[r];
    };
  }
  var T,
    S =
      ((T = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }),
      function (r) {
        return null == T ? n : T[r];
      });
  var B,
    I,
    R = Array.prototype,
    $ = Object.prototype,
    q = $.hasOwnProperty,
    D = 0,
    P = $.toString,
    z = A._,
    C = Object.create,
    G = $.propertyIsEnumerable,
    J = A.isFinite,
    M =
      ((B = Object.keys),
      (I = Object),
      function (n) {
        return B(I(n));
      }),
    U = Math.max;
  function V(n) {
    return n instanceof K ? n : new K(n);
  }
  var H = (function () {
    function r() {}
    return function (t) {
      if (!Vn(t)) return {};
      if (C) return C(t);
      r.prototype = t;
      var e = new r();
      return (r.prototype = n), e;
    };
  })();
  function K(n, r) {
    (this.__wrapped__ = n), (this.__actions__ = []), (this.__chain__ = !!r);
  }
  function L(n, r, t) {
    n[r] = t;
  }
  function Q(t, e, u) {
    if ("function" != typeof t) throw new TypeError(r);
    return setTimeout(function () {
      t.apply(n, u);
    }, e);
  }
  (K.prototype = H(V.prototype)), (K.prototype.constructor = K);
  var W,
    X,
    Y =
      ((W = un),
      function (n, r) {
        if (null == n) return n;
        if (!Jn(n)) return W(n, r);
        for (
          var t = n.length, e = X ? t : -1, u = Object(n);
          (X ? e-- : ++e < t) && !1 !== r(u[e], e, u);

        );
        return n;
      });
  function Z(r, t, e) {
    for (var u = -1, o = r.length; ++u < o; ) {
      var i = r[u],
        c = t(i);
      if (null != c && (f === n ? c == c : e(c, f)))
        var f = c,
          a = i;
    }
    return a;
  }
  function nn(n, r) {
    var t = [];
    return (
      Y(n, function (n, e, u) {
        r(n, e, u) && t.push(n);
      }),
      t
    );
  }
  function rn(n, r, t, e, u) {
    var o = -1,
      i = n.length;
    for (t || (t = On), u || (u = []); ++o < i; ) {
      var c = n[o];
      r > 0 && t(c)
        ? r > 1
          ? rn(c, r - 1, t, e, u)
          : k(u, c)
        : e || (u[u.length] = c);
    }
    return u;
  }
  var tn,
    en = function (n, r, t) {
      for (var e = -1, u = Object(n), o = t(n), i = o.length; i--; ) {
        var c = o[tn ? i : ++e];
        if (!1 === r(u[c], c, u)) break;
      }
      return n;
    };
  function un(n, r) {
    return n && en(n, r, er);
  }
  function on(n, r) {
    return nn(r, function (r) {
      return Un(n[r]);
    });
  }
  function cn(n) {
    return (r = n), P.call(r);
    var r;
  }
  function fn(n, r) {
    return n > r;
  }
  var an = pr;
  function ln(r, u, o, i, a) {
    return (
      r === u ||
      (null == r || null == u || (!Hn(r) && !Hn(u))
        ? r != r && u != u
        : (function (r, u, o, i, a, v) {
            var h = Gn(r),
              _ = Gn(u),
              d = h ? f : cn(r),
              m = _ ? f : cn(u),
              O = (d = d == c ? g : d) == g,
              x = (m = m == c ? g : m) == g,
              w = d == m;
            v || (v = []);
            var A = Bn(v, function (n) {
                return n[0] == r;
              }),
              E = Bn(v, function (n) {
                return n[0] == u;
              });
            if (A && E) return A[1] == u;
            if ((v.push([r, u]), v.push([u, r]), w && !O)) {
              var N = h
                ? (function (r, u, o, i, c, f) {
                    var a = o & t,
                      l = r.length,
                      p = u.length;
                    if (l != p && !(a && p > l)) return !1;
                    var s = -1,
                      v = !0,
                      h = o & e ? [] : n;
                    for (; ++s < l; ) {
                      var y = r[s],
                        g = u[s];
                      if (void 0 !== n) {
                        void 0, (v = !1);
                        break;
                      }
                      if (h) {
                        if (
                          !bn(u, function (n, r) {
                            if (!Fn(h, r) && (y === n || c(y, n, o, i, f)))
                              return h.push(r);
                          })
                        ) {
                          v = !1;
                          break;
                        }
                      } else if (y !== g && !c(y, g, o, i, f)) {
                        v = !1;
                        break;
                      }
                    }
                    return v;
                  })(r, u, o, i, a, v)
                : (function (n, r, t, e, u, o, i) {
                    switch (t) {
                      case l:
                      case p:
                      case y:
                        return zn(+n, +r);
                      case s:
                        return n.name == r.name && n.message == r.message;
                      case b:
                      case j:
                        return n == r + "";
                    }
                    return !1;
                  })(r, u, d);
              return v.pop(), N;
            }
            if (!(o & t)) {
              var k = O && q.call(r, "__wrapped__"),
                F = x && q.call(u, "__wrapped__");
              if (k || F) {
                var T = k ? r.value() : r,
                  S = F ? u.value() : u,
                  N = a(T, S, o, i, v);
                return v.pop(), N;
              }
            }
            if (!w) return !1;
            var N = (function (r, e, u, o, i, c) {
              var f = u & t,
                a = er(r),
                l = a.length,
                p = er(e).length;
              if (l != p && !f) return !1;
              var s = l;
              for (; s--; ) {
                var v = a[s];
                if (!(f ? v in e : q.call(e, v))) return !1;
              }
              var h = !0,
                y = f;
              for (; ++s < l; ) {
                v = a[s];
                var g = r[v],
                  _ = e[v];
                if (!(void 0 === n ? g === _ || i(g, _, u, o, c) : void 0)) {
                  h = !1;
                  break;
                }
                y || (y = "constructor" == v);
              }
              if (h && !y) {
                var b = r.constructor,
                  j = e.constructor;
                b != j &&
                  "constructor" in r &&
                  "constructor" in e &&
                  !(
                    "function" == typeof b &&
                    b instanceof b &&
                    "function" == typeof j &&
                    j instanceof j
                  ) &&
                  (h = !1);
              }
              return h;
            })(r, u, o, i, a, v);
            return v.pop(), N;
          })(r, u, o, i, ln, a))
    );
  }
  function pn(n) {
    return "function" == typeof n
      ? n
      : null == n
      ? cr
      : ("object" == typeof n ? hn : F)(n);
  }
  function sn(n, r) {
    return n < r;
  }
  function vn(n, r) {
    var t = -1,
      e = Jn(n) ? Array(n.length) : [];
    return (
      Y(n, function (n, u, o) {
        e[++t] = r(n, u, o);
      }),
      e
    );
  }
  function hn(n) {
    var r = M(n);
    return function (u) {
      var o = r.length;
      if (null == u) return !o;
      for (u = Object(u); o--; ) {
        var i = r[o];
        if (!(i in u && ln(n[i], u[i], t | e))) return !1;
      }
      return !0;
    };
  }
  function yn(n, r) {
    return En(An(n, r, cr), n + "");
  }
  function gn(n, r, t) {
    var e = -1,
      u = n.length;
    r < 0 && (r = -r > u ? 0 : u + r),
      (t = t > u ? u : t) < 0 && (t += u),
      (u = r > t ? 0 : (t - r) >>> 0),
      (r >>>= 0);
    for (var o = Array(u); ++e < u; ) o[e] = n[e + r];
    return o;
  }
  function _n(n) {
    return gn(n, 0, n.length);
  }
  function bn(n, r) {
    var t;
    return (
      Y(n, function (n, e, u) {
        return !(t = r(n, e, u));
      }),
      !!t
    );
  }
  function jn(r, t, e, u) {
    var o = !e;
    e || (e = {});
    for (var i, c, f, a, l = -1, p = t.length; ++l < p; ) {
      var s = t[l],
        v = u ? u(e[s], r[s], s, e, r) : n;
      v === n && (v = r[s]),
        o
          ? L(e, s, v)
          : ((f = v),
            void 0,
            (a = (i = e)[(c = s)]),
            (q.call(i, c) && zn(a, f) && (f !== n || c in i)) || L(i, c, f));
    }
    return e;
  }
  function dn(r) {
    return yn(function (t, e) {
      var u = -1,
        o = e.length,
        i = o > 1 ? e[o - 1] : n;
      for (
        i = r.length > 3 && "function" == typeof i ? (o--, i) : n,
          t = Object(t);
        ++u < o;

      ) {
        var c = e[u];
        c && r(t, c, u, i);
      }
      return t;
    });
  }
  function mn(n, t, e, o) {
    if ("function" != typeof n) throw new TypeError(r);
    var i,
      c = t & u,
      f =
        ((i = n),
        function () {
          var n = arguments,
            r = H(i.prototype),
            t = i.apply(r, n);
          return Vn(t) ? t : r;
        });
    return function r() {
      for (
        var t = -1,
          u = arguments.length,
          i = -1,
          a = o.length,
          l = Array(a + u),
          p = this && this !== A && this instanceof r ? f : n;
        ++i < a;

      )
        l[i] = o[i];
      for (; u--; ) l[i++] = arguments[++t];
      return p.apply(c ? e : this, l);
    };
  }
  function On(n) {
    return Gn(n) || Cn(n);
  }
  function xn(n, r, t) {
    if (!Vn(t)) return !1;
    var e,
      u,
      o,
      c = typeof r;
    return (
      !!("number" == c
        ? Jn(t) &&
          ((e = r),
          (u = t.length),
          (o = typeof e),
          (u = null == u ? i : u) &&
            ("number" == o || ("symbol" != o && O.test(e))) &&
            e > -1 &&
            e % 1 == 0 &&
            e < u)
        : "string" == c && r in t) && zn(t[r], n)
    );
  }
  function wn(n) {
    var r = [];
    if (null != n) for (var t in Object(n)) r.push(t);
    return r;
  }
  function An(r, t, e) {
    return (
      (t = U(t === n ? r.length - 1 : t, 0)),
      function () {
        for (
          var n = arguments, u = -1, o = U(n.length - t, 0), i = Array(o);
          ++u < o;

        )
          i[u] = n[t + u];
        u = -1;
        for (var c = Array(t + 1); ++u < t; ) c[u] = n[u];
        return (c[t] = e(i)), r.apply(this, c);
      }
    );
  }
  var En = cr;
  function Nn(n) {
    return (null == n ? 0 : n.length) ? rn(n, 1) : [];
  }
  function kn(r) {
    return r && r.length ? r[0] : n;
  }
  function Fn(n, r, t) {
    for (
      var e = null == n ? 0 : n.length,
        u =
          ((t = "number" == typeof t ? (t < 0 ? U(e + t, 0) : t) : 0) || 0) - 1,
        o = r == r;
      ++u < e;

    ) {
      var i = n[u];
      if (o ? i === r : i != i) return u;
    }
    return -1;
  }
  function Tn(n) {
    var r = V(n);
    return (r.__chain__ = !0), r;
  }
  var Sn,
    Bn =
      ((Sn = function (n, r, t) {
        var e = null == n ? 0 : n.length;
        if (!e) return -1;
        var u = null == t ? 0 : Wn(t);
        return (
          u < 0 && (u = U(e + u, 0)),
          (function (n, r, t, e) {
            for (var u = n.length, o = t + (e ? 1 : -1); e ? o-- : ++o < u; )
              if (r(n[o], o, n)) return o;
            return -1;
          })(n, pn(r), u)
        );
      }),
      function (r, t, e) {
        var u = Object(r);
        if (!Jn(r)) {
          var o = pn(t);
          (r = er(r)),
            (t = function (n) {
              return o(u[n], n, u);
            });
        }
        var i = Sn(r, t, e);
        return i > -1 ? u[o ? r[i] : i] : n;
      });
  function In(n, r) {
    return Y(n, pn(r));
  }
  function Rn(n, r, t) {
    return (
      (e = n),
      (u = pn(r)),
      (o = t),
      (i = arguments.length < 3),
      Y(e, function (n, r, t) {
        o = i ? ((i = !1), n) : u(o, n, r, t);
      }),
      o
    );
    var e, u, o, i;
  }
  function $n(t, e) {
    var u;
    if ("function" != typeof e) throw new TypeError(r);
    return (
      (t = Wn(t)),
      function () {
        return --t > 0 && (u = e.apply(this, arguments)), t <= 1 && (e = n), u;
      }
    );
  }
  var qn = yn(function (n, r, t) {
      return mn(n, 32 | u, r, t);
    }),
    Dn = yn(function (n, r) {
      return Q(n, 1, r);
    }),
    Pn = yn(function (n, r, t) {
      return Q(n, Xn(r) || 0, t);
    });
  function zn(n, r) {
    return n === r || (n != n && r != r);
  }
  var Cn = an(
      (function () {
        return arguments;
      })()
    )
      ? an
      : function (n) {
          return Hn(n) && q.call(n, "callee") && !G.call(n, "callee");
        },
    Gn = Array.isArray;
  function Jn(n) {
    return (
      null != n &&
      "number" == typeof (r = n.length) &&
      r > -1 &&
      r % 1 == 0 &&
      r <= i &&
      !Un(n)
    );
    var r;
  }
  var Mn = function (n) {
    return Hn(n) && cn(n) == p;
  };
  function Un(n) {
    if (!Vn(n)) return !1;
    var r = cn(n);
    return r == v || r == h || r == a || r == _;
  }
  function Vn(n) {
    var r = typeof n;
    return null != n && ("object" == r || "function" == r);
  }
  function Hn(n) {
    return null != n && "object" == typeof n;
  }
  function Kn(n) {
    return "number" == typeof n || (Hn(n) && cn(n) == y);
  }
  var Ln = function (n) {
    return Hn(n) && cn(n) == b;
  };
  function Qn(n) {
    return "string" == typeof n || (!Gn(n) && Hn(n) && cn(n) == j);
  }
  var Wn = Number,
    Xn = Number;
  function Yn(n) {
    return "string" == typeof n ? n : null == n ? "" : n + "";
  }
  var Zn = dn(function (n, r) {
      jn(r, M(r), n);
    }),
    nr = dn(function (n, r) {
      jn(r, wn(r), n);
    });
  var rr = yn(function (r, t) {
    r = Object(r);
    var e = -1,
      u = t.length,
      o = u > 2 ? t[2] : n;
    for (o && xn(t[0], t[1], o) && (u = 1); ++e < u; )
      for (var i = t[e], c = ur(i), f = -1, a = c.length; ++f < a; ) {
        var l = c[f],
          p = r[l];
        (p === n || (zn(p, $[l]) && !q.call(r, l))) && (r[l] = i[l]);
      }
    return r;
  });
  var tr,
    er = M,
    ur = wn,
    or = En(
      An(
        (tr = function (n, r) {
          return null == n
            ? {}
            : ((t = n),
              (e = r),
              (t = Object(t)),
              Rn(
                e,
                function (n, r) {
                  return r in t && (n[r] = t[r]), n;
                },
                {}
              ));
          var t, e;
        }),
        n,
        Nn
      ),
      tr + ""
    );
  function ir(n) {
    return null == n
      ? []
      : ((r = n),
        vn(er(n), function (n) {
          return r[n];
        }));
    var r;
  }
  function cr(n) {
    return n;
  }
  var fr,
    ar = pn;
  function lr(n, r, t) {
    var e = er(r),
      u = on(r, e);
    null != t ||
      (Vn(r) && (u.length || !e.length)) ||
      ((t = r), (r = n), (n = this), (u = on(r, er(r))));
    var o = !(Vn(t) && "chain" in t && !t.chain),
      i = Un(n);
    return (
      Y(u, function (t) {
        var e = r[t];
        (n[t] = e),
          i &&
            (n.prototype[t] = function () {
              var r = this.__chain__;
              if (o || r) {
                var t = n(this.__wrapped__);
                return (
                  (t.__actions__ = _n(this.__actions__)).push({
                    func: e,
                    args: arguments,
                    thisArg: n,
                  }),
                  (t.__chain__ = r),
                  t
                );
              }
              return e.apply(n, k([this.value()], arguments));
            });
      }),
      n
    );
  }
  function pr() {}
  (V.assignIn = nr),
    (V.before = $n),
    (V.bind = qn),
    (V.chain = Tn),
    (V.compact = function (n) {
      return nn(n, Boolean);
    }),
    (V.concat = function () {
      var n = arguments.length;
      if (!n) return [];
      for (var r = Array(n - 1), t = arguments[0], e = n; e--; )
        r[e - 1] = arguments[e];
      return k(Gn(t) ? _n(t) : [t], rn(r, 1));
    }),
    (V.create = function (n, r) {
      var t = H(n);
      return null == r ? t : Zn(t, r);
    }),
    (V.defaults = rr),
    (V.defer = Dn),
    (V.delay = Pn),
    (V.filter = function (n, r) {
      return nn(n, pn(r));
    }),
    (V.flatten = Nn),
    (V.flattenDeep = function (n) {
      return null != n && n.length ? rn(n, o) : [];
    }),
    (V.iteratee = ar),
    (V.keys = er),
    (V.map = function (n, r) {
      return vn(n, pn(r));
    }),
    (V.matches = function (n) {
      return hn(Zn({}, n));
    }),
    (V.mixin = lr),
    (V.negate = function (n) {
      if ("function" != typeof n) throw new TypeError(r);
      return function () {
        var r = arguments;
        return !n.apply(this, r);
      };
    }),
    (V.once = function (n) {
      return $n(2, n);
    }),
    (V.pick = or),
    (V.slice = function (r, t, e) {
      var u = null == r ? 0 : r.length;
      return (
        (t = null == t ? 0 : +t), (e = e === n ? u : +e), u ? gn(r, t, e) : []
      );
    }),
    (V.sortBy = function (r, t) {
      var e = 0;
      return (
        (t = pn(t)),
        vn(
          vn(r, function (n, r, u) {
            return { value: n, index: e++, criteria: t(n, r, u) };
          }).sort(function (r, t) {
            return (
              (function (r, t) {
                if (r !== t) {
                  var e = r !== n,
                    u = null === r,
                    o = r == r,
                    i = t !== n,
                    c = null === t,
                    f = t == t;
                  if ((!c && r > t) || (u && i && f) || (!e && f) || !o)
                    return 1;
                  if ((!u && r < t) || (c && e && o) || (!i && o) || !f)
                    return -1;
                }
                return 0;
              })(r.criteria, t.criteria) || r.index - t.index
            );
          }),
          F("value")
        )
      );
    }),
    (V.tap = function (n, r) {
      return r(n), n;
    }),
    (V.thru = function (n, r) {
      return r(n);
    }),
    (V.toArray = function (n) {
      return Jn(n) ? (n.length ? _n(n) : []) : ir(n);
    }),
    (V.values = ir),
    (V.extend = nr),
    lr(V, V),
    (V.clone = function (n) {
      return Vn(n) ? (Gn(n) ? _n(n) : jn(n, M(n))) : n;
    }),
    (V.escape = function (n) {
      return (n = Yn(n)) && m.test(n) ? n.replace(d, S) : n;
    }),
    (V.every = function (r, t, e) {
      return (
        (u = r),
        (o = pn((t = e ? n : t))),
        (i = !0),
        Y(u, function (n, r, t) {
          return (i = !!o(n, r, t));
        }),
        i
      );
      var u, o, i;
    }),
    (V.find = Bn),
    (V.forEach = In),
    (V.has = function (n, r) {
      return null != n && q.call(n, r);
    }),
    (V.head = kn),
    (V.identity = cr),
    (V.indexOf = Fn),
    (V.isArguments = Cn),
    (V.isArray = Gn),
    (V.isBoolean = function (n) {
      return !0 === n || !1 === n || (Hn(n) && cn(n) == l);
    }),
    (V.isDate = Mn),
    (V.isEmpty = function (n) {
      return Jn(n) && (Gn(n) || Qn(n) || Un(n.splice) || Cn(n))
        ? !n.length
        : !M(n).length;
    }),
    (V.isEqual = function (n, r) {
      return ln(n, r);
    }),
    (V.isFinite = function (n) {
      return "number" == typeof n && J(n);
    }),
    (V.isFunction = Un),
    (V.isNaN = function (n) {
      return Kn(n) && n != +n;
    }),
    (V.isNull = function (n) {
      return null === n;
    }),
    (V.isNumber = Kn),
    (V.isObject = Vn),
    (V.isRegExp = Ln),
    (V.isString = Qn),
    (V.isUndefined = function (r) {
      return r === n;
    }),
    (V.last = function (r) {
      var t = null == r ? 0 : r.length;
      return t ? r[t - 1] : n;
    }),
    (V.max = function (r) {
      return r && r.length ? Z(r, cr, fn) : n;
    }),
    (V.min = function (r) {
      return r && r.length ? Z(r, cr, sn) : n;
    }),
    (V.noConflict = function () {
      return A._ === this && (A._ = z), this;
    }),
    (V.noop = pr),
    (V.reduce = Rn),
    (V.result = function (r, t, e) {
      var u = null == r ? n : r[t];
      return u === n && (u = e), Un(u) ? u.call(r) : u;
    }),
    (V.size = function (n) {
      return null == n ? 0 : (n = Jn(n) ? n : M(n)).length;
    }),
    (V.some = function (r, t, e) {
      return bn(r, pn((t = e ? n : t)));
    }),
    (V.uniqueId = function (n) {
      var r = ++D;
      return Yn(n) + r;
    }),
    (V.each = In),
    (V.first = kn),
    lr(
      V,
      ((fr = {}),
      un(V, function (n, r) {
        q.call(V.prototype, r) || (fr[r] = n);
      }),
      fr),
      { chain: !1 }
    ),
    (V.VERSION = "4.17.10"),
    Y(
      [
        "pop",
        "join",
        "replace",
        "reverse",
        "split",
        "push",
        "shift",
        "sort",
        "splice",
        "unshift",
      ],
      function (n) {
        var r = (/^(?:replace|split)$/.test(n) ? String.prototype : R)[n],
          t = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru",
          e = /^(?:pop|join|replace|shift)$/.test(n);
        V.prototype[n] = function () {
          var n = arguments;
          if (e && !this.__chain__) {
            var u = this.value();
            return r.apply(Gn(u) ? u : [], n);
          }
          return this[t](function (t) {
            return r.apply(Gn(t) ? t : [], n);
          });
        };
      }
    ),
    (V.prototype.toJSON =
      V.prototype.valueOf =
      V.prototype.value =
        function () {
          return (
            (n = this.__wrapped__),
            Rn(
              this.__actions__,
              function (n, r) {
                return r.func.apply(r.thisArg, k([n], r.args));
              },
              n
            )
          );
          var n;
        }),
    "function" == typeof define && "object" == typeof define.amd && define.amd
      ? ((A._ = V),
        define(function () {
          return V;
        }))
      : N
      ? (((N.exports = V)._ = V), (E._ = V))
      : (A._ = V);
}).call(this);
/*! Shopify query params */
if (
  ("undefined" == typeof window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (a, b) {
    return function () {
      return a.apply(b, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (a, b) {
    for (var c = 0, d = a.options.length; d > c; c++) {
      var e = a.options[c];
      if (b == e.value || b == e.innerHTML) return (a.selectedIndex = c), c;
    }
  }),
  (Shopify.addListener = function (a, b, c) {
    a.addEventListener
      ? a.addEventListener(b, c, !1)
      : a.attachEvent("on" + b, c);
  }),
  (Shopify.postLink = function (a, b) {
    b = b || {};
    var c = b.method || "post",
      d = b.parameters || {},
      e = document.createElement("form");
    e.setAttribute("method", c), e.setAttribute("action", a);
    for (var f in d) {
      var g = document.createElement("input");
      g.setAttribute("type", "hidden"),
        g.setAttribute("name", f),
        g.setAttribute("value", d[f]),
        e.appendChild(g);
    }
    document.body.appendChild(e), e.submit(), document.body.removeChild(e);
  }),
  (Shopify.CountryProvinceSelector = function (a, b, c) {
    (this.countryEl = document.getElementById(a)),
      (this.provinceEl = document.getElementById(b)),
      (this.provinceContainer = document.getElementById(c.hideElement || b)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var a = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, a), this.countryHandler();
    },
    initProvince: function () {
      var a = this.provinceEl.getAttribute("data-default");
      a &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, a);
    },
    countryHandler: function (a) {
      var b = this.countryEl.options[this.countryEl.selectedIndex],
        c = b.getAttribute("data-provinces"),
        d = JSON.parse(c);
      if ((this.clearOptions(this.provinceEl), d && 0 == d.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var e = 0; e < d.length; e++) {
          var b = document.createElement("option");
          (b.value = d[e][0]),
            (b.innerHTML = d[e][1]),
            this.provinceEl.appendChild(b);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (a) {
      for (; a.firstChild; ) a.removeChild(a.firstChild);
    },
    setOptions: function (a, b) {
      var c = 0;
      for (b.length; c < b.length; c++) {
        var d = document.createElement("option");
        (d.value = b[c]), (d.innerHTML = b[c]), a.appendChild(d);
      }
    },
  }),
  (Shopify.CustomerAddress = {
    toggleForm: function (a) {
      var b = document.getElementById("view_addresses"),
        c = document.getElementById("edit_address_" + a);
      return (
        (b.style.display = "none" == b.style.display ? "" : "none"),
        (c.style.display = "none" == c.style.display ? "" : "none"),
        !1
      );
    },
    toggleNewForm: function () {
      var a = document.getElementById("add_address"),
        b = document.getElementById("address_tables");
      return (
        (a.style.display = "none" == a.style.display ? "" : "none"),
        (b.style.display = "none" == a.style.display ? "" : "none"),
        !1
      );
    },
    destroy: function (a, b) {
      confirm(b || "Are you sure you wish to delete this address?") &&
        Shopify.postLink("/account/addresses/" + a, {
          parameters: { _method: "delete" },
        });
    },
  }),
  (Shopify.queryParams = {}),
  location.search.length)
)
  for (
    var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
    i < aCouples.length;
    i++
  )
    (aKeyValue = aCouples[i].split("=")),
      aKeyValue.length > 1 &&
        (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]));
/*! enquire.js v2.1.2 */
!(function (t, i, n) {
  var e = window.matchMedia;
  "undefined" != typeof module && module.exports
    ? (module.exports = n(e))
    : "function" == typeof define && define.amd
    ? define(function () {
        return (i[t] = n(e));
      })
    : (i[t] = n(e));
})("enquire", this, function (t) {
  "use strict";
  function i(t, i) {
    for (var n = 0, e = t.length; e > n && !1 !== i(t[n], n); n++);
  }
  function n(t) {
    return "function" == typeof t;
  }
  function e(t) {
    (this.options = t), !t.deferSetup && this.setup();
  }
  function s(i, n) {
    (this.query = i),
      (this.isUnconditional = n),
      (this.handlers = []),
      (this.mql = t(i));
    var e = this;
    (this.listener = function (t) {
      (e.mql = t), e.assess();
    }),
      this.mql.addListener(this.listener);
  }
  function o() {
    if (!t)
      throw new Error(
        "matchMedia not present, legacy browsers require a polyfill"
      );
    (this.queries = {}), (this.browserIsIncapable = !t("only all").matches);
  }
  return (
    (e.prototype = {
      setup: function () {
        this.options.setup && this.options.setup(), (this.initialised = !0);
      },
      on: function () {
        !this.initialised && this.setup(),
          this.options.match && this.options.match();
      },
      off: function () {
        this.options.unmatch && this.options.unmatch();
      },
      destroy: function () {
        this.options.destroy ? this.options.destroy() : this.off();
      },
      equals: function (t) {
        return this.options === t || this.options.match === t;
      },
    }),
    (s.prototype = {
      addHandler: function (t) {
        var i = new e(t);
        this.handlers.push(i), this.matches() && i.on();
      },
      removeHandler: function (t) {
        var n = this.handlers;
        i(n, function (i, e) {
          return i.equals(t) ? (i.destroy(), !n.splice(e, 1)) : void 0;
        });
      },
      matches: function () {
        return this.mql.matches || this.isUnconditional;
      },
      clear: function () {
        i(this.handlers, function (t) {
          t.destroy();
        }),
          this.mql.removeListener(this.listener),
          (this.handlers.length = 0);
      },
      assess: function () {
        var t = this.matches() ? "on" : "off";
        i(this.handlers, function (i) {
          i[t]();
        });
      },
    }),
    (o.prototype = {
      register: function (t, e, o) {
        var r,
          h = this.queries,
          u = o && this.browserIsIncapable;
        return (
          h[t] || (h[t] = new s(t, u)),
          n(e) && (e = { match: e }),
          (r = e),
          "[object Array]" === Object.prototype.toString.apply(r) || (e = [e]),
          i(e, function (i) {
            n(i) && (i = { match: i }), h[t].addHandler(i);
          }),
          this
        );
      },
      unregister: function (t, i) {
        var n = this.queries[t];
        return (
          n && (i ? n.removeHandler(i) : (n.clear(), delete this.queries[t])),
          this
        );
      },
    }),
    new o()
  );
});
/*! jQuery v2.2.3 */
!(function (e, t) {
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document)
              throw new Error("jQuery requires a window with a document");
            return t(e);
          })
    : t(e);
})("undefined" != typeof window ? window : this, function (e, t) {
  var n = [],
    r = e.document,
    i = n.slice,
    o = n.concat,
    s = n.push,
    a = n.indexOf,
    u = {},
    l = u.toString,
    c = u.hasOwnProperty,
    f = {},
    p = "2.2.3",
    d = function (e, t) {
      return new d.fn.init(e, t);
    },
    h = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
    g = /^-ms-/,
    v = /-([\da-z])/gi,
    m = function (e, t) {
      return t.toUpperCase();
    };
  function y(e) {
    var t = !!e && "length" in e && e.length,
      n = d.type(e);
    return (
      "function" !== n &&
      !d.isWindow(e) &&
      ("array" === n ||
        0 === t ||
        ("number" == typeof t && t > 0 && t - 1 in e))
    );
  }
  (d.fn = d.prototype =
    {
      jquery: p,
      constructor: d,
      selector: "",
      length: 0,
      toArray: function () {
        return i.call(this);
      },
      get: function (e) {
        return null != e
          ? 0 > e
            ? this[e + this.length]
            : this[e]
          : i.call(this);
      },
      pushStack: function (e) {
        var t = d.merge(this.constructor(), e);
        return (t.prevObject = this), (t.context = this.context), t;
      },
      each: function (e) {
        return d.each(this, e);
      },
      map: function (e) {
        return this.pushStack(
          d.map(this, function (t, n) {
            return e.call(t, n, t);
          })
        );
      },
      slice: function () {
        return this.pushStack(i.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (0 > e ? t : 0);
        return this.pushStack(n >= 0 && t > n ? [this[n]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: s,
      sort: n.sort,
      splice: n.splice,
    }),
    (d.extend = d.fn.extend =
      function () {
        var e,
          t,
          n,
          r,
          i,
          o,
          s = arguments[0] || {},
          a = 1,
          u = arguments.length,
          l = !1;
        for (
          "boolean" == typeof s && ((l = s), (s = arguments[a] || {}), a++),
            "object" == typeof s || d.isFunction(s) || (s = {}),
            a === u && ((s = this), a--);
          u > a;
          a++
        )
          if (null != (e = arguments[a]))
            for (t in e)
              (n = s[t]),
                s !== (r = e[t]) &&
                  (l && r && (d.isPlainObject(r) || (i = d.isArray(r)))
                    ? (i
                        ? ((i = !1), (o = n && d.isArray(n) ? n : []))
                        : (o = n && d.isPlainObject(n) ? n : {}),
                      (s[t] = d.extend(l, o, r)))
                    : void 0 !== r && (s[t] = r));
        return s;
      }),
    d.extend({
      expando: "jQuery" + (p + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isFunction: function (e) {
        return "function" === d.type(e);
      },
      isArray: Array.isArray,
      isWindow: function (e) {
        return null != e && e === e.window;
      },
      isNumeric: function (e) {
        var t = e && e.toString();
        return !d.isArray(e) && t - parseFloat(t) + 1 >= 0;
      },
      isPlainObject: function (e) {
        var t;
        if ("object" !== d.type(e) || e.nodeType || d.isWindow(e)) return !1;
        if (
          e.constructor &&
          !c.call(e, "constructor") &&
          !c.call(e.constructor.prototype || {}, "isPrototypeOf")
        )
          return !1;
        for (t in e);
        return void 0 === t || c.call(e, t);
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      type: function (e) {
        return null == e
          ? e + ""
          : "object" == typeof e || "function" == typeof e
          ? u[l.call(e)] || "object"
          : typeof e;
      },
      globalEval: function (e) {
        var t,
          n = eval;
        (e = d.trim(e)) &&
          (1 === e.indexOf("use strict")
            ? (((t = r.createElement("script")).text = e),
              r.head.appendChild(t).parentNode.removeChild(t))
            : n(e));
      },
      camelCase: function (e) {
        return e.replace(g, "ms-").replace(v, m);
      },
      nodeName: function (e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
      },
      each: function (e, t) {
        var n,
          r = 0;
        if (y(e))
          for (n = e.length; n > r && !1 !== t.call(e[r], r, e[r]); r++);
        else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
        return e;
      },
      trim: function (e) {
        return null == e ? "" : (e + "").replace(h, "");
      },
      makeArray: function (e, t) {
        var n = t || [];
        return (
          null != e &&
            (y(Object(e))
              ? d.merge(n, "string" == typeof e ? [e] : e)
              : s.call(n, e)),
          n
        );
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : a.call(t, e, n);
      },
      merge: function (e, t) {
        for (var n = +t.length, r = 0, i = e.length; n > r; r++) e[i++] = t[r];
        return (e.length = i), e;
      },
      grep: function (e, t, n) {
        for (var r = [], i = 0, o = e.length, s = !n; o > i; i++)
          !t(e[i], i) !== s && r.push(e[i]);
        return r;
      },
      map: function (e, t, n) {
        var r,
          i,
          s = 0,
          a = [];
        if (y(e))
          for (r = e.length; r > s; s++)
            null != (i = t(e[s], s, n)) && a.push(i);
        else for (s in e) null != (i = t(e[s], s, n)) && a.push(i);
        return o.apply([], a);
      },
      guid: 1,
      proxy: function (e, t) {
        var n, r, o;
        return (
          "string" == typeof t && ((n = e[t]), (t = e), (e = n)),
          d.isFunction(e)
            ? ((r = i.call(arguments, 2)),
              ((o = function () {
                return e.apply(t || this, r.concat(i.call(arguments)));
              }).guid = e.guid =
                e.guid || d.guid++),
              o)
            : void 0
        );
      },
      now: Date.now,
      support: f,
    }),
    "function" == typeof Symbol && (d.fn[Symbol.iterator] = n[Symbol.iterator]),
    d.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (e, t) {
        u["[object " + t + "]"] = t.toLowerCase();
      }
    );
  var x = (function (e) {
    var t,
      n,
      r,
      i,
      o,
      s,
      a,
      u,
      l,
      c,
      f,
      p,
      d,
      h,
      g,
      v,
      m,
      y,
      x,
      b = "sizzle" + 1 * new Date(),
      w = e.document,
      T = 0,
      C = 0,
      k = oe(),
      E = oe(),
      N = oe(),
      S = function (e, t) {
        return e === t && (f = !0), 0;
      },
      D = 1 << 31,
      j = {}.hasOwnProperty,
      A = [],
      q = A.pop,
      L = A.push,
      H = A.push,
      O = A.slice,
      F = function (e, t) {
        for (var n = 0, r = e.length; r > n; n++) if (e[n] === t) return n;
        return -1;
      },
      P =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      R = "[\\x20\\t\\r\\n\\f]",
      M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
      I =
        "\\[" +
        R +
        "*(" +
        M +
        ")(?:" +
        R +
        "*([*^$|!~]?=)" +
        R +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        M +
        "))|)" +
        R +
        "*\\]",
      W =
        ":(" +
        M +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        I +
        ")*)|.*)\\)|)",
      $ = new RegExp(R + "+", "g"),
      B = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$", "g"),
      _ = new RegExp("^" + R + "*," + R + "*"),
      X = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"),
      z = new RegExp("=" + R + "*([^\\]'\"]*?)" + R + "*\\]", "g"),
      U = new RegExp(W),
      V = new RegExp("^" + M + "$"),
      Y = {
        ID: new RegExp("^#(" + M + ")"),
        CLASS: new RegExp("^\\.(" + M + ")"),
        TAG: new RegExp("^(" + M + "|[*])"),
        ATTR: new RegExp("^" + I),
        PSEUDO: new RegExp("^" + W),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            R +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            R +
            "*(?:([+-]|)" +
            R +
            "*(\\d+)|))" +
            R +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + P + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            R +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            R +
            "*((?:-\\d)?\\d*)" +
            R +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      G = /^(?:input|select|textarea|button)$/i,
      Q = /^h\d$/i,
      J = /^[^{]+\{\s*\[native \w/,
      K = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      Z = /[+~]/,
      ee = /'|\\/g,
      te = new RegExp("\\\\([\\da-f]{1,6}" + R + "?|(" + R + ")|.)", "ig"),
      ne = function (e, t, n) {
        var r = "0x" + t - 65536;
        return r != r || n
          ? t
          : 0 > r
          ? String.fromCharCode(r + 65536)
          : String.fromCharCode((r >> 10) | 55296, (1023 & r) | 56320);
      },
      re = function () {
        p();
      };
    try {
      H.apply((A = O.call(w.childNodes)), w.childNodes),
        A[w.childNodes.length].nodeType;
    } catch (e) {
      H = {
        apply: A.length
          ? function (e, t) {
              L.apply(e, O.call(t));
            }
          : function (e, t) {
              for (var n = e.length, r = 0; (e[n++] = t[r++]); );
              e.length = n - 1;
            },
      };
    }
    function ie(e, t, r, i) {
      var o,
        a,
        l,
        c,
        f,
        h,
        m,
        y,
        T = t && t.ownerDocument,
        C = t ? t.nodeType : 9;
      if (
        ((r = r || []),
        "string" != typeof e || !e || (1 !== C && 9 !== C && 11 !== C))
      )
        return r;
      if (
        !i &&
        ((t ? t.ownerDocument || t : w) !== d && p(t), (t = t || d), g)
      ) {
        if (11 !== C && (h = K.exec(e)))
          if ((o = h[1])) {
            if (9 === C) {
              if (!(l = t.getElementById(o))) return r;
              if (l.id === o) return r.push(l), r;
            } else if (T && (l = T.getElementById(o)) && x(t, l) && l.id === o)
              return r.push(l), r;
          } else {
            if (h[2]) return H.apply(r, t.getElementsByTagName(e)), r;
            if (
              (o = h[3]) &&
              n.getElementsByClassName &&
              t.getElementsByClassName
            )
              return H.apply(r, t.getElementsByClassName(o)), r;
          }
        if (n.qsa && !N[e + " "] && (!v || !v.test(e))) {
          if (1 !== C) (T = t), (y = e);
          else if ("object" !== t.nodeName.toLowerCase()) {
            for (
              (c = t.getAttribute("id"))
                ? (c = c.replace(ee, "\\$&"))
                : t.setAttribute("id", (c = b)),
                a = (m = s(e)).length,
                f = V.test(c) ? "#" + c : "[id='" + c + "']";
              a--;

            )
              m[a] = f + " " + ge(m[a]);
            (y = m.join(",")), (T = (Z.test(e) && de(t.parentNode)) || t);
          }
          if (y)
            try {
              return H.apply(r, T.querySelectorAll(y)), r;
            } catch (e) {
            } finally {
              c === b && t.removeAttribute("id");
            }
        }
      }
      return u(e.replace(B, "$1"), t, r, i);
    }
    function oe() {
      var e = [];
      return function t(n, i) {
        return (
          e.push(n + " ") > r.cacheLength && delete t[e.shift()],
          (t[n + " "] = i)
        );
      };
    }
    function se(e) {
      return (e[b] = !0), e;
    }
    function ae(e) {
      var t = d.createElement("div");
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function ue(e, t) {
      for (var n = e.split("|"), i = n.length; i--; ) r.attrHandle[n[i]] = t;
    }
    function le(e, t) {
      var n = t && e,
        r =
          n &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          (~t.sourceIndex || D) - (~e.sourceIndex || D);
      if (r) return r;
      if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
      return e ? 1 : -1;
    }
    function ce(e) {
      return function (t) {
        return "input" === t.nodeName.toLowerCase() && t.type === e;
      };
    }
    function fe(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();
        return ("input" === n || "button" === n) && t.type === e;
      };
    }
    function pe(e) {
      return se(function (t) {
        return (
          (t = +t),
          se(function (n, r) {
            for (var i, o = e([], n.length, t), s = o.length; s--; )
              n[(i = o[s])] && (n[i] = !(r[i] = n[i]));
          })
        );
      });
    }
    function de(e) {
      return e && void 0 !== e.getElementsByTagName && e;
    }
    for (t in ((n = ie.support = {}),
    (o = ie.isXML =
      function (e) {
        var t = e && (e.ownerDocument || e).documentElement;
        return !!t && "HTML" !== t.nodeName;
      }),
    (p = ie.setDocument =
      function (e) {
        var t,
          i,
          s = e ? e.ownerDocument || e : w;
        return s !== d && 9 === s.nodeType && s.documentElement
          ? ((h = (d = s).documentElement),
            (g = !o(d)),
            (i = d.defaultView) &&
              i.top !== i &&
              (i.addEventListener
                ? i.addEventListener("unload", re, !1)
                : i.attachEvent && i.attachEvent("onunload", re)),
            (n.attributes = ae(function (e) {
              return (e.className = "i"), !e.getAttribute("className");
            })),
            (n.getElementsByTagName = ae(function (e) {
              return (
                e.appendChild(d.createComment("")),
                !e.getElementsByTagName("*").length
              );
            })),
            (n.getElementsByClassName = J.test(d.getElementsByClassName)),
            (n.getById = ae(function (e) {
              return (
                (h.appendChild(e).id = b),
                !d.getElementsByName || !d.getElementsByName(b).length
              );
            })),
            n.getById
              ? ((r.find.ID = function (e, t) {
                  if (void 0 !== t.getElementById && g) {
                    var n = t.getElementById(e);
                    return n ? [n] : [];
                  }
                }),
                (r.filter.ID = function (e) {
                  var t = e.replace(te, ne);
                  return function (e) {
                    return e.getAttribute("id") === t;
                  };
                }))
              : (delete r.find.ID,
                (r.filter.ID = function (e) {
                  var t = e.replace(te, ne);
                  return function (e) {
                    var n =
                      void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                    return n && n.value === t;
                  };
                })),
            (r.find.TAG = n.getElementsByTagName
              ? function (e, t) {
                  return void 0 !== t.getElementsByTagName
                    ? t.getElementsByTagName(e)
                    : n.qsa
                    ? t.querySelectorAll(e)
                    : void 0;
                }
              : function (e, t) {
                  var n,
                    r = [],
                    i = 0,
                    o = t.getElementsByTagName(e);
                  if ("*" === e) {
                    for (; (n = o[i++]); ) 1 === n.nodeType && r.push(n);
                    return r;
                  }
                  return o;
                }),
            (r.find.CLASS =
              n.getElementsByClassName &&
              function (e, t) {
                return void 0 !== t.getElementsByClassName && g
                  ? t.getElementsByClassName(e)
                  : void 0;
              }),
            (m = []),
            (v = []),
            (n.qsa = J.test(d.querySelectorAll)) &&
              (ae(function (e) {
                (h.appendChild(e).innerHTML =
                  "<a id='" +
                  b +
                  "'></a><select id='" +
                  b +
                  "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                  e.querySelectorAll("[msallowcapture^='']").length &&
                    v.push("[*^$]=" + R + "*(?:''|\"\")"),
                  e.querySelectorAll("[selected]").length ||
                    v.push("\\[" + R + "*(?:value|" + P + ")"),
                  e.querySelectorAll("[id~=" + b + "-]").length || v.push("~="),
                  e.querySelectorAll(":checked").length || v.push(":checked"),
                  e.querySelectorAll("a#" + b + "+*").length ||
                    v.push(".#.+[+~]");
              }),
              ae(function (e) {
                var t = d.createElement("input");
                t.setAttribute("type", "hidden"),
                  e.appendChild(t).setAttribute("name", "D"),
                  e.querySelectorAll("[name=d]").length &&
                    v.push("name" + R + "*[*^$|!~]?="),
                  e.querySelectorAll(":enabled").length ||
                    v.push(":enabled", ":disabled"),
                  e.querySelectorAll("*,:x"),
                  v.push(",.*:");
              })),
            (n.matchesSelector = J.test(
              (y =
                h.matches ||
                h.webkitMatchesSelector ||
                h.mozMatchesSelector ||
                h.oMatchesSelector ||
                h.msMatchesSelector)
            )) &&
              ae(function (e) {
                (n.disconnectedMatch = y.call(e, "div")),
                  y.call(e, "[s!='']:x"),
                  m.push("!=", W);
              }),
            (v = v.length && new RegExp(v.join("|"))),
            (m = m.length && new RegExp(m.join("|"))),
            (t = J.test(h.compareDocumentPosition)),
            (x =
              t || J.test(h.contains)
                ? function (e, t) {
                    var n = 9 === e.nodeType ? e.documentElement : e,
                      r = t && t.parentNode;
                    return (
                      e === r ||
                      !(
                        !r ||
                        1 !== r.nodeType ||
                        !(n.contains
                          ? n.contains(r)
                          : e.compareDocumentPosition &&
                            16 & e.compareDocumentPosition(r))
                      )
                    );
                  }
                : function (e, t) {
                    if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                    return !1;
                  }),
            (S = t
              ? function (e, t) {
                  if (e === t) return (f = !0), 0;
                  var r =
                    !e.compareDocumentPosition - !t.compareDocumentPosition;
                  return (
                    r ||
                    (1 &
                      (r =
                        (e.ownerDocument || e) === (t.ownerDocument || t)
                          ? e.compareDocumentPosition(t)
                          : 1) ||
                    (!n.sortDetached && t.compareDocumentPosition(e) === r)
                      ? e === d || (e.ownerDocument === w && x(w, e))
                        ? -1
                        : t === d || (t.ownerDocument === w && x(w, t))
                        ? 1
                        : c
                        ? F(c, e) - F(c, t)
                        : 0
                      : 4 & r
                      ? -1
                      : 1)
                  );
                }
              : function (e, t) {
                  if (e === t) return (f = !0), 0;
                  var n,
                    r = 0,
                    i = e.parentNode,
                    o = t.parentNode,
                    s = [e],
                    a = [t];
                  if (!i || !o)
                    return e === d
                      ? -1
                      : t === d
                      ? 1
                      : i
                      ? -1
                      : o
                      ? 1
                      : c
                      ? F(c, e) - F(c, t)
                      : 0;
                  if (i === o) return le(e, t);
                  for (n = e; (n = n.parentNode); ) s.unshift(n);
                  for (n = t; (n = n.parentNode); ) a.unshift(n);
                  for (; s[r] === a[r]; ) r++;
                  return r
                    ? le(s[r], a[r])
                    : s[r] === w
                    ? -1
                    : a[r] === w
                    ? 1
                    : 0;
                }),
            d)
          : d;
      }),
    (ie.matches = function (e, t) {
      return ie(e, null, null, t);
    }),
    (ie.matchesSelector = function (e, t) {
      if (
        ((e.ownerDocument || e) !== d && p(e),
        (t = t.replace(z, "='$1']")),
        n.matchesSelector &&
          g &&
          !N[t + " "] &&
          (!m || !m.test(t)) &&
          (!v || !v.test(t)))
      )
        try {
          var r = y.call(e, t);
          if (
            r ||
            n.disconnectedMatch ||
            (e.document && 11 !== e.document.nodeType)
          )
            return r;
        } catch (e) {}
      return ie(t, d, null, [e]).length > 0;
    }),
    (ie.contains = function (e, t) {
      return (e.ownerDocument || e) !== d && p(e), x(e, t);
    }),
    (ie.attr = function (e, t) {
      (e.ownerDocument || e) !== d && p(e);
      var i = r.attrHandle[t.toLowerCase()],
        o = i && j.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
      return void 0 !== o
        ? o
        : n.attributes || !g
        ? e.getAttribute(t)
        : (o = e.getAttributeNode(t)) && o.specified
        ? o.value
        : null;
    }),
    (ie.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }),
    (ie.uniqueSort = function (e) {
      var t,
        r = [],
        i = 0,
        o = 0;
      if (
        ((f = !n.detectDuplicates),
        (c = !n.sortStable && e.slice(0)),
        e.sort(S),
        f)
      ) {
        for (; (t = e[o++]); ) t === e[o] && (i = r.push(o));
        for (; i--; ) e.splice(r[i], 1);
      }
      return (c = null), e;
    }),
    (i = ie.getText =
      function (e) {
        var t,
          n = "",
          r = 0,
          o = e.nodeType;
        if (o) {
          if (1 === o || 9 === o || 11 === o) {
            if ("string" == typeof e.textContent) return e.textContent;
            for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
          } else if (3 === o || 4 === o) return e.nodeValue;
        } else for (; (t = e[r++]); ) n += i(t);
        return n;
      }),
    ((r = ie.selectors =
      {
        cacheLength: 50,
        createPseudo: se,
        match: Y,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" },
        },
        preFilter: {
          ATTR: function (e) {
            return (
              (e[1] = e[1].replace(te, ne)),
              (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
              "~=" === e[2] && (e[3] = " " + e[3] + " "),
              e.slice(0, 4)
            );
          },
          CHILD: function (e) {
            return (
              (e[1] = e[1].toLowerCase()),
              "nth" === e[1].slice(0, 3)
                ? (e[3] || ie.error(e[0]),
                  (e[4] = +(e[4]
                    ? e[5] + (e[6] || 1)
                    : 2 * ("even" === e[3] || "odd" === e[3]))),
                  (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                : e[3] && ie.error(e[0]),
              e
            );
          },
          PSEUDO: function (e) {
            var t,
              n = !e[6] && e[2];
            return Y.CHILD.test(e[0])
              ? null
              : (e[3]
                  ? (e[2] = e[4] || e[5] || "")
                  : n &&
                    U.test(n) &&
                    (t = s(n, !0)) &&
                    (t = n.indexOf(")", n.length - t) - n.length) &&
                    ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                e.slice(0, 3));
          },
        },
        filter: {
          TAG: function (e) {
            var t = e.replace(te, ne).toLowerCase();
            return "*" === e
              ? function () {
                  return !0;
                }
              : function (e) {
                  return e.nodeName && e.nodeName.toLowerCase() === t;
                };
          },
          CLASS: function (e) {
            var t = k[e + " "];
            return (
              t ||
              ((t = new RegExp("(^|" + R + ")" + e + "(" + R + "|$)")) &&
                k(e, function (e) {
                  return t.test(
                    ("string" == typeof e.className && e.className) ||
                      (void 0 !== e.getAttribute && e.getAttribute("class")) ||
                      ""
                  );
                }))
            );
          },
          ATTR: function (e, t, n) {
            return function (r) {
              var i = ie.attr(r, e);
              return null == i
                ? "!=" === t
                : !t ||
                    ((i += ""),
                    "=" === t
                      ? i === n
                      : "!=" === t
                      ? i !== n
                      : "^=" === t
                      ? n && 0 === i.indexOf(n)
                      : "*=" === t
                      ? n && i.indexOf(n) > -1
                      : "$=" === t
                      ? n && i.slice(-n.length) === n
                      : "~=" === t
                      ? (" " + i.replace($, " ") + " ").indexOf(n) > -1
                      : "|=" === t &&
                        (i === n || i.slice(0, n.length + 1) === n + "-"));
            };
          },
          CHILD: function (e, t, n, r, i) {
            var o = "nth" !== e.slice(0, 3),
              s = "last" !== e.slice(-4),
              a = "of-type" === t;
            return 1 === r && 0 === i
              ? function (e) {
                  return !!e.parentNode;
                }
              : function (t, n, u) {
                  var l,
                    c,
                    f,
                    p,
                    d,
                    h,
                    g = o !== s ? "nextSibling" : "previousSibling",
                    v = t.parentNode,
                    m = a && t.nodeName.toLowerCase(),
                    y = !u && !a,
                    x = !1;
                  if (v) {
                    if (o) {
                      for (; g; ) {
                        for (p = t; (p = p[g]); )
                          if (
                            a
                              ? p.nodeName.toLowerCase() === m
                              : 1 === p.nodeType
                          )
                            return !1;
                        h = g = "only" === e && !h && "nextSibling";
                      }
                      return !0;
                    }
                    if (((h = [s ? v.firstChild : v.lastChild]), s && y)) {
                      for (
                        x =
                          (d =
                            (l =
                              (c =
                                (f = (p = v)[b] || (p[b] = {}))[p.uniqueID] ||
                                (f[p.uniqueID] = {}))[e] || [])[0] === T &&
                            l[1]) && l[2],
                          p = d && v.childNodes[d];
                        (p = (++d && p && p[g]) || (x = d = 0) || h.pop());

                      )
                        if (1 === p.nodeType && ++x && p === t) {
                          c[e] = [T, d, x];
                          break;
                        }
                    } else if (
                      (y &&
                        (x = d =
                          (l =
                            (c =
                              (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] ||
                              (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]),
                      !1 === x)
                    )
                      for (
                        ;
                        (p = (++d && p && p[g]) || (x = d = 0) || h.pop()) &&
                        ((a
                          ? p.nodeName.toLowerCase() !== m
                          : 1 !== p.nodeType) ||
                          !++x ||
                          (y &&
                            ((c =
                              (f = p[b] || (p[b] = {}))[p.uniqueID] ||
                              (f[p.uniqueID] = {}))[e] = [T, x]),
                          p !== t));

                      );
                    return (x -= i) === r || (x % r == 0 && x / r >= 0);
                  }
                };
          },
          PSEUDO: function (e, t) {
            var n,
              i =
                r.pseudos[e] ||
                r.setFilters[e.toLowerCase()] ||
                ie.error("unsupported pseudo: " + e);
            return i[b]
              ? i(t)
              : i.length > 1
              ? ((n = [e, e, "", t]),
                r.setFilters.hasOwnProperty(e.toLowerCase())
                  ? se(function (e, n) {
                      for (var r, o = i(e, t), s = o.length; s--; )
                        e[(r = F(e, o[s]))] = !(n[r] = o[s]);
                    })
                  : function (e) {
                      return i(e, 0, n);
                    })
              : i;
          },
        },
        pseudos: {
          not: se(function (e) {
            var t = [],
              n = [],
              r = a(e.replace(B, "$1"));
            return r[b]
              ? se(function (e, t, n, i) {
                  for (var o, s = r(e, null, i, []), a = e.length; a--; )
                    (o = s[a]) && (e[a] = !(t[a] = o));
                })
              : function (e, i, o) {
                  return (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop();
                };
          }),
          has: se(function (e) {
            return function (t) {
              return ie(e, t).length > 0;
            };
          }),
          contains: se(function (e) {
            return (
              (e = e.replace(te, ne)),
              function (t) {
                return (t.textContent || t.innerText || i(t)).indexOf(e) > -1;
              }
            );
          }),
          lang: se(function (e) {
            return (
              V.test(e || "") || ie.error("unsupported lang: " + e),
              (e = e.replace(te, ne).toLowerCase()),
              function (t) {
                var n;
                do {
                  if (
                    (n = g
                      ? t.lang
                      : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                  )
                    return (
                      (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                    );
                } while ((t = t.parentNode) && 1 === t.nodeType);
                return !1;
              }
            );
          }),
          target: function (t) {
            var n = e.location && e.location.hash;
            return n && n.slice(1) === t.id;
          },
          root: function (e) {
            return e === h;
          },
          focus: function (e) {
            return (
              e === d.activeElement &&
              (!d.hasFocus || d.hasFocus()) &&
              !!(e.type || e.href || ~e.tabIndex)
            );
          },
          enabled: function (e) {
            return !1 === e.disabled;
          },
          disabled: function (e) {
            return !0 === e.disabled;
          },
          checked: function (e) {
            var t = e.nodeName.toLowerCase();
            return (
              ("input" === t && !!e.checked) || ("option" === t && !!e.selected)
            );
          },
          selected: function (e) {
            return (
              e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
            );
          },
          empty: function (e) {
            for (e = e.firstChild; e; e = e.nextSibling)
              if (e.nodeType < 6) return !1;
            return !0;
          },
          parent: function (e) {
            return !r.pseudos.empty(e);
          },
          header: function (e) {
            return Q.test(e.nodeName);
          },
          input: function (e) {
            return G.test(e.nodeName);
          },
          button: function (e) {
            var t = e.nodeName.toLowerCase();
            return ("input" === t && "button" === e.type) || "button" === t;
          },
          text: function (e) {
            var t;
            return (
              "input" === e.nodeName.toLowerCase() &&
              "text" === e.type &&
              (null == (t = e.getAttribute("type")) ||
                "text" === t.toLowerCase())
            );
          },
          first: pe(function () {
            return [0];
          }),
          last: pe(function (e, t) {
            return [t - 1];
          }),
          eq: pe(function (e, t, n) {
            return [0 > n ? n + t : n];
          }),
          even: pe(function (e, t) {
            for (var n = 0; t > n; n += 2) e.push(n);
            return e;
          }),
          odd: pe(function (e, t) {
            for (var n = 1; t > n; n += 2) e.push(n);
            return e;
          }),
          lt: pe(function (e, t, n) {
            for (var r = 0 > n ? n + t : n; --r >= 0; ) e.push(r);
            return e;
          }),
          gt: pe(function (e, t, n) {
            for (var r = 0 > n ? n + t : n; ++r < t; ) e.push(r);
            return e;
          }),
        },
      }).pseudos.nth = r.pseudos.eq),
    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
      r.pseudos[t] = ce(t);
    for (t in { submit: !0, reset: !0 }) r.pseudos[t] = fe(t);
    function he() {}
    function ge(e) {
      for (var t = 0, n = e.length, r = ""; n > t; t++) r += e[t].value;
      return r;
    }
    function ve(e, t, n) {
      var r = t.dir,
        i = n && "parentNode" === r,
        o = C++;
      return t.first
        ? function (t, n, o) {
            for (; (t = t[r]); ) if (1 === t.nodeType || i) return e(t, n, o);
          }
        : function (t, n, s) {
            var a,
              u,
              l,
              c = [T, o];
            if (s) {
              for (; (t = t[r]); )
                if ((1 === t.nodeType || i) && e(t, n, s)) return !0;
            } else
              for (; (t = t[r]); )
                if (1 === t.nodeType || i) {
                  if (
                    (a = (u =
                      (l = t[b] || (t[b] = {}))[t.uniqueID] ||
                      (l[t.uniqueID] = {}))[r]) &&
                    a[0] === T &&
                    a[1] === o
                  )
                    return (c[2] = a[2]);
                  if (((u[r] = c), (c[2] = e(t, n, s)))) return !0;
                }
          };
    }
    function me(e) {
      return e.length > 1
        ? function (t, n, r) {
            for (var i = e.length; i--; ) if (!e[i](t, n, r)) return !1;
            return !0;
          }
        : e[0];
    }
    function ye(e, t, n, r, i) {
      for (var o, s = [], a = 0, u = e.length, l = null != t; u > a; a++)
        (o = e[a]) && ((n && !n(o, r, i)) || (s.push(o), l && t.push(a)));
      return s;
    }
    function xe(e, t, n, r, i, o) {
      return (
        r && !r[b] && (r = xe(r)),
        i && !i[b] && (i = xe(i, o)),
        se(function (o, s, a, u) {
          var l,
            c,
            f,
            p = [],
            d = [],
            h = s.length,
            g =
              o ||
              (function (e, t, n) {
                for (var r = 0, i = t.length; i > r; r++) ie(e, t[r], n);
                return n;
              })(t || "*", a.nodeType ? [a] : a, []),
            v = !e || (!o && t) ? g : ye(g, p, e, a, u),
            m = n ? (i || (o ? e : h || r) ? [] : s) : v;
          if ((n && n(v, m, a, u), r))
            for (l = ye(m, d), r(l, [], a, u), c = l.length; c--; )
              (f = l[c]) && (m[d[c]] = !(v[d[c]] = f));
          if (o) {
            if (i || e) {
              if (i) {
                for (l = [], c = m.length; c--; )
                  (f = m[c]) && l.push((v[c] = f));
                i(null, (m = []), l, u);
              }
              for (c = m.length; c--; )
                (f = m[c]) &&
                  (l = i ? F(o, f) : p[c]) > -1 &&
                  (o[l] = !(s[l] = f));
            }
          } else (m = ye(m === s ? m.splice(h, m.length) : m)), i ? i(null, s, m, u) : H.apply(s, m);
        })
      );
    }
    function be(e) {
      for (
        var t,
          n,
          i,
          o = e.length,
          s = r.relative[e[0].type],
          a = s || r.relative[" "],
          u = s ? 1 : 0,
          c = ve(
            function (e) {
              return e === t;
            },
            a,
            !0
          ),
          f = ve(
            function (e) {
              return F(t, e) > -1;
            },
            a,
            !0
          ),
          p = [
            function (e, n, r) {
              var i =
                (!s && (r || n !== l)) ||
                ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
              return (t = null), i;
            },
          ];
        o > u;
        u++
      )
        if ((n = r.relative[e[u].type])) p = [ve(me(p), n)];
        else {
          if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
            for (i = ++u; o > i && !r.relative[e[i].type]; i++);
            return xe(
              u > 1 && me(p),
              u > 1 &&
                ge(
                  e
                    .slice(0, u - 1)
                    .concat({ value: " " === e[u - 2].type ? "*" : "" })
                ).replace(B, "$1"),
              n,
              i > u && be(e.slice(u, i)),
              o > i && be((e = e.slice(i))),
              o > i && ge(e)
            );
          }
          p.push(n);
        }
      return me(p);
    }
    return (
      (he.prototype = r.filters = r.pseudos),
      (r.setFilters = new he()),
      (s = ie.tokenize =
        function (e, t) {
          var n,
            i,
            o,
            s,
            a,
            u,
            l,
            c = E[e + " "];
          if (c) return t ? 0 : c.slice(0);
          for (a = e, u = [], l = r.preFilter; a; ) {
            for (s in ((n && !(i = _.exec(a))) ||
              (i && (a = a.slice(i[0].length) || a), u.push((o = []))),
            (n = !1),
            (i = X.exec(a)) &&
              ((n = i.shift()),
              o.push({ value: n, type: i[0].replace(B, " ") }),
              (a = a.slice(n.length))),
            r.filter))
              !(i = Y[s].exec(a)) ||
                (l[s] && !(i = l[s](i))) ||
                ((n = i.shift()),
                o.push({ value: n, type: s, matches: i }),
                (a = a.slice(n.length)));
            if (!n) break;
          }
          return t ? a.length : a ? ie.error(e) : E(e, u).slice(0);
        }),
      (a = ie.compile =
        function (e, t) {
          var n,
            i,
            o,
            a,
            u,
            c,
            f = [],
            h = [],
            v = N[e + " "];
          if (!v) {
            for (t || (t = s(e)), n = t.length; n--; )
              (v = be(t[n]))[b] ? f.push(v) : h.push(v);
            (v = N(
              e,
              ((i = h),
              (a = (o = f).length > 0),
              (u = i.length > 0),
              (c = function (e, t, n, s, c) {
                var f,
                  h,
                  v,
                  m = 0,
                  y = "0",
                  x = e && [],
                  b = [],
                  w = l,
                  C = e || (u && r.find.TAG("*", c)),
                  k = (T += null == w ? 1 : Math.random() || 0.1),
                  E = C.length;
                for (
                  c && (l = t === d || t || c);
                  y !== E && null != (f = C[y]);
                  y++
                ) {
                  if (u && f) {
                    for (
                      h = 0, t || f.ownerDocument === d || (p(f), (n = !g));
                      (v = i[h++]);

                    )
                      if (v(f, t || d, n)) {
                        s.push(f);
                        break;
                      }
                    c && (T = k);
                  }
                  a && ((f = !v && f) && m--, e && x.push(f));
                }
                if (((m += y), a && y !== m)) {
                  for (h = 0; (v = o[h++]); ) v(x, b, t, n);
                  if (e) {
                    if (m > 0) for (; y--; ) x[y] || b[y] || (b[y] = q.call(s));
                    b = ye(b);
                  }
                  H.apply(s, b),
                    c &&
                      !e &&
                      b.length > 0 &&
                      m + o.length > 1 &&
                      ie.uniqueSort(s);
                }
                return c && ((T = k), (l = w)), x;
              }),
              a ? se(c) : c)
            )).selector = e;
          }
          return v;
        }),
      (u = ie.select =
        function (e, t, i, o) {
          var u,
            l,
            c,
            f,
            p,
            d = "function" == typeof e && e,
            h = !o && s((e = d.selector || e));
          if (((i = i || []), 1 === h.length)) {
            if (
              (l = h[0] = h[0].slice(0)).length > 2 &&
              "ID" === (c = l[0]).type &&
              n.getById &&
              9 === t.nodeType &&
              g &&
              r.relative[l[1].type]
            ) {
              if (!(t = (r.find.ID(c.matches[0].replace(te, ne), t) || [])[0]))
                return i;
              d && (t = t.parentNode), (e = e.slice(l.shift().value.length));
            }
            for (
              u = Y.needsContext.test(e) ? 0 : l.length;
              u-- && ((c = l[u]), !r.relative[(f = c.type)]);

            )
              if (
                (p = r.find[f]) &&
                (o = p(
                  c.matches[0].replace(te, ne),
                  (Z.test(l[0].type) && de(t.parentNode)) || t
                ))
              ) {
                if ((l.splice(u, 1), !(e = o.length && ge(l))))
                  return H.apply(i, o), i;
                break;
              }
          }
          return (
            (d || a(e, h))(
              o,
              t,
              !g,
              i,
              !t || (Z.test(e) && de(t.parentNode)) || t
            ),
            i
          );
        }),
      (n.sortStable = b.split("").sort(S).join("") === b),
      (n.detectDuplicates = !!f),
      p(),
      (n.sortDetached = ae(function (e) {
        return 1 & e.compareDocumentPosition(d.createElement("div"));
      })),
      ae(function (e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          "#" === e.firstChild.getAttribute("href")
        );
      }) ||
        ue("type|href|height|width", function (e, t, n) {
          return n
            ? void 0
            : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }),
      (n.attributes &&
        ae(function (e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          );
        })) ||
        ue("value", function (e, t, n) {
          return n || "input" !== e.nodeName.toLowerCase()
            ? void 0
            : e.defaultValue;
        }),
      ae(function (e) {
        return null == e.getAttribute("disabled");
      }) ||
        ue(P, function (e, t, n) {
          var r;
          return n
            ? void 0
            : !0 === e[t]
            ? t.toLowerCase()
            : (r = e.getAttributeNode(t)) && r.specified
            ? r.value
            : null;
        }),
      ie
    );
  })(e);
  (d.find = x),
    (d.expr = x.selectors),
    (d.expr[":"] = d.expr.pseudos),
    (d.uniqueSort = d.unique = x.uniqueSort),
    (d.text = x.getText),
    (d.isXMLDoc = x.isXML),
    (d.contains = x.contains);
  var b = function (e, t, n) {
      for (var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
        if (1 === e.nodeType) {
          if (i && d(e).is(n)) break;
          r.push(e);
        }
      return r;
    },
    w = function (e, t) {
      for (var n = []; e; e = e.nextSibling)
        1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    T = d.expr.match.needsContext,
    C = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
    k = /^.[^:#\[\.,]*$/;
  function E(e, t, n) {
    if (d.isFunction(t))
      return d.grep(e, function (e, r) {
        return !!t.call(e, r, e) !== n;
      });
    if (t.nodeType)
      return d.grep(e, function (e) {
        return (e === t) !== n;
      });
    if ("string" == typeof t) {
      if (k.test(t)) return d.filter(t, e, n);
      t = d.filter(t, e);
    }
    return d.grep(e, function (e) {
      return a.call(t, e) > -1 !== n;
    });
  }
  (d.filter = function (e, t, n) {
    var r = t[0];
    return (
      n && (e = ":not(" + e + ")"),
      1 === t.length && 1 === r.nodeType
        ? d.find.matchesSelector(r, e)
          ? [r]
          : []
        : d.find.matches(
            e,
            d.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    d.fn.extend({
      find: function (e) {
        var t,
          n = this.length,
          r = [],
          i = this;
        if ("string" != typeof e)
          return this.pushStack(
            d(e).filter(function () {
              for (t = 0; n > t; t++) if (d.contains(i[t], this)) return !0;
            })
          );
        for (t = 0; n > t; t++) d.find(e, i[t], r);
        return (
          ((r = this.pushStack(n > 1 ? d.unique(r) : r)).selector = this
            .selector
            ? this.selector + " " + e
            : e),
          r
        );
      },
      filter: function (e) {
        return this.pushStack(E(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(E(this, e || [], !0));
      },
      is: function (e) {
        return !!E(this, "string" == typeof e && T.test(e) ? d(e) : e || [], !1)
          .length;
      },
    });
  var N,
    S = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
  ((d.fn.init = function (e, t, n) {
    var i, o;
    if (!e) return this;
    if (((n = n || N), "string" == typeof e)) {
      if (
        !(i =
          "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
            ? [null, e, null]
            : S.exec(e)) ||
        (!i[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (i[1]) {
        if (
          ((t = t instanceof d ? t[0] : t),
          d.merge(
            this,
            d.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)
          ),
          C.test(i[1]) && d.isPlainObject(t))
        )
          for (i in t)
            d.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        return this;
      }
      return (
        (o = r.getElementById(i[2])) &&
          o.parentNode &&
          ((this.length = 1), (this[0] = o)),
        (this.context = r),
        (this.selector = e),
        this
      );
    }
    return e.nodeType
      ? ((this.context = this[0] = e), (this.length = 1), this)
      : d.isFunction(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(d)
      : (void 0 !== e.selector &&
          ((this.selector = e.selector), (this.context = e.context)),
        d.makeArray(e, this));
  }).prototype = d.fn),
    (N = d(r));
  var D = /^(?:parents|prev(?:Until|All))/,
    j = { children: !0, contents: !0, next: !0, prev: !0 };
  function A(e, t) {
    for (; (e = e[t]) && 1 !== e.nodeType; );
    return e;
  }
  d.fn.extend({
    has: function (e) {
      var t = d(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; n > e; e++) if (d.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      for (
        var n,
          r = 0,
          i = this.length,
          o = [],
          s = T.test(e) || "string" != typeof e ? d(e, t || this.context) : 0;
        i > r;
        r++
      )
        for (n = this[r]; n && n !== t; n = n.parentNode)
          if (
            n.nodeType < 11 &&
            (s
              ? s.index(n) > -1
              : 1 === n.nodeType && d.find.matchesSelector(n, e))
          ) {
            o.push(n);
            break;
          }
      return this.pushStack(o.length > 1 ? d.uniqueSort(o) : o);
    },
    index: function (e) {
      return e
        ? "string" == typeof e
          ? a.call(d(e), this[0])
          : a.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(d.uniqueSort(d.merge(this.get(), d(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    d.each(
      {
        parent: function (e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function (e) {
          return b(e, "parentNode");
        },
        parentsUntil: function (e, t, n) {
          return b(e, "parentNode", n);
        },
        next: function (e) {
          return A(e, "nextSibling");
        },
        prev: function (e) {
          return A(e, "previousSibling");
        },
        nextAll: function (e) {
          return b(e, "nextSibling");
        },
        prevAll: function (e) {
          return b(e, "previousSibling");
        },
        nextUntil: function (e, t, n) {
          return b(e, "nextSibling", n);
        },
        prevUntil: function (e, t, n) {
          return b(e, "previousSibling", n);
        },
        siblings: function (e) {
          return w((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return w(e.firstChild);
        },
        contents: function (e) {
          return e.contentDocument || d.merge([], e.childNodes);
        },
      },
      function (e, t) {
        d.fn[e] = function (n, r) {
          var i = d.map(this, t, n);
          return (
            "Until" !== e.slice(-5) && (r = n),
            r && "string" == typeof r && (i = d.filter(r, i)),
            this.length > 1 &&
              (j[e] || d.uniqueSort(i), D.test(e) && i.reverse()),
            this.pushStack(i)
          );
        };
      }
    );
  var q,
    L = /\S+/g;
  function H() {
    r.removeEventListener("DOMContentLoaded", H),
      e.removeEventListener("load", H),
      d.ready();
  }
  (d.Callbacks = function (e) {
    var t, n;
    e =
      "string" == typeof e
        ? ((t = e),
          (n = {}),
          d.each(t.match(L) || [], function (e, t) {
            n[t] = !0;
          }),
          n)
        : d.extend({}, e);
    var r,
      i,
      o,
      s,
      a = [],
      u = [],
      l = -1,
      c = function () {
        for (s = e.once, o = r = !0; u.length; l = -1)
          for (i = u.shift(); ++l < a.length; )
            !1 === a[l].apply(i[0], i[1]) &&
              e.stopOnFalse &&
              ((l = a.length), (i = !1));
        e.memory || (i = !1), (r = !1), s && (a = i ? [] : "");
      },
      f = {
        add: function () {
          return (
            a &&
              (i && !r && ((l = a.length - 1), u.push(i)),
              (function t(n) {
                d.each(n, function (n, r) {
                  d.isFunction(r)
                    ? (e.unique && f.has(r)) || a.push(r)
                    : r && r.length && "string" !== d.type(r) && t(r);
                });
              })(arguments),
              i && !r && c()),
            this
          );
        },
        remove: function () {
          return (
            d.each(arguments, function (e, t) {
              for (var n; (n = d.inArray(t, a, n)) > -1; )
                a.splice(n, 1), l >= n && l--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? d.inArray(e, a) > -1 : a.length > 0;
        },
        empty: function () {
          return a && (a = []), this;
        },
        disable: function () {
          return (s = u = []), (a = i = ""), this;
        },
        disabled: function () {
          return !a;
        },
        lock: function () {
          return (s = u = []), i || (a = i = ""), this;
        },
        locked: function () {
          return !!s;
        },
        fireWith: function (e, t) {
          return (
            s ||
              ((t = [e, (t = t || []).slice ? t.slice() : t]),
              u.push(t),
              r || c()),
            this
          );
        },
        fire: function () {
          return f.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!o;
        },
      };
    return f;
  }),
    d.extend({
      Deferred: function (e) {
        var t = [
            ["resolve", "done", d.Callbacks("once memory"), "resolved"],
            ["reject", "fail", d.Callbacks("once memory"), "rejected"],
            ["notify", "progress", d.Callbacks("memory")],
          ],
          n = "pending",
          r = {
            state: function () {
              return n;
            },
            always: function () {
              return i.done(arguments).fail(arguments), this;
            },
            then: function () {
              var e = arguments;
              return d
                .Deferred(function (n) {
                  d.each(t, function (t, o) {
                    var s = d.isFunction(e[t]) && e[t];
                    i[o[1]](function () {
                      var e = s && s.apply(this, arguments);
                      e && d.isFunction(e.promise)
                        ? e
                            .promise()
                            .progress(n.notify)
                            .done(n.resolve)
                            .fail(n.reject)
                        : n[o[0] + "With"](
                            this === r ? n.promise() : this,
                            s ? [e] : arguments
                          );
                    });
                  }),
                    (e = null);
                })
                .promise();
            },
            promise: function (e) {
              return null != e ? d.extend(e, r) : r;
            },
          },
          i = {};
        return (
          (r.pipe = r.then),
          d.each(t, function (e, o) {
            var s = o[2],
              a = o[3];
            (r[o[1]] = s.add),
              a &&
                s.add(
                  function () {
                    n = a;
                  },
                  t[1 ^ e][2].disable,
                  t[2][2].lock
                ),
              (i[o[0]] = function () {
                return i[o[0] + "With"](this === i ? r : this, arguments), this;
              }),
              (i[o[0] + "With"] = s.fireWith);
          }),
          r.promise(i),
          e && e.call(i, i),
          i
        );
      },
      when: function (e) {
        var t,
          n,
          r,
          o = 0,
          s = i.call(arguments),
          a = s.length,
          u = 1 !== a || (e && d.isFunction(e.promise)) ? a : 0,
          l = 1 === u ? e : d.Deferred(),
          c = function (e, n, r) {
            return function (o) {
              (n[e] = this),
                (r[e] = arguments.length > 1 ? i.call(arguments) : o),
                r === t ? l.notifyWith(n, r) : --u || l.resolveWith(n, r);
            };
          };
        if (a > 1)
          for (t = new Array(a), n = new Array(a), r = new Array(a); a > o; o++)
            s[o] && d.isFunction(s[o].promise)
              ? s[o]
                  .promise()
                  .progress(c(o, n, t))
                  .done(c(o, r, s))
                  .fail(l.reject)
              : --u;
        return u || l.resolveWith(r, s), l.promise();
      },
    }),
    (d.fn.ready = function (e) {
      return d.ready.promise().done(e), this;
    }),
    d.extend({
      isReady: !1,
      readyWait: 1,
      holdReady: function (e) {
        e ? d.readyWait++ : d.ready(!0);
      },
      ready: function (e) {
        (!0 === e ? --d.readyWait : d.isReady) ||
          ((d.isReady = !0),
          (!0 !== e && --d.readyWait > 0) ||
            (q.resolveWith(r, [d]),
            d.fn.triggerHandler &&
              (d(r).triggerHandler("ready"), d(r).off("ready"))));
      },
    }),
    (d.ready.promise = function (t) {
      return (
        q ||
          ((q = d.Deferred()),
          "complete" === r.readyState ||
          ("loading" !== r.readyState && !r.documentElement.doScroll)
            ? e.setTimeout(d.ready)
            : (r.addEventListener("DOMContentLoaded", H),
              e.addEventListener("load", H))),
        q.promise(t)
      );
    }),
    d.ready.promise();
  var O = function (e, t, n, r, i, o, s) {
      var a = 0,
        u = e.length,
        l = null == n;
      if ("object" === d.type(n))
        for (a in ((i = !0), n)) O(e, t, a, n[a], !0, o, s);
      else if (
        void 0 !== r &&
        ((i = !0),
        d.isFunction(r) || (s = !0),
        l &&
          (s
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function (e, t, n) {
                return l.call(d(e), n);
              }))),
        t)
      )
        for (; u > a; a++) t(e[a], n, s ? r : r.call(e[a], a, t(e[a], n)));
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
    },
    F = function (e) {
      return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    };
  function P() {
    this.expando = d.expando + P.uid++;
  }
  (P.uid = 1),
    (P.prototype = {
      register: function (e, t) {
        var n = t || {};
        return (
          e.nodeType
            ? (e[this.expando] = n)
            : Object.defineProperty(e, this.expando, {
                value: n,
                writable: !0,
                configurable: !0,
              }),
          e[this.expando]
        );
      },
      cache: function (e) {
        if (!F(e)) return {};
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            F(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, n) {
        var r,
          i = this.cache(e);
        if ("string" == typeof t) i[t] = n;
        else for (r in t) i[r] = t[r];
        return i;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][t];
      },
      access: function (e, t, n) {
        var r;
        return void 0 === t || (t && "string" == typeof t && void 0 === n)
          ? void 0 !== (r = this.get(e, t))
            ? r
            : this.get(e, d.camelCase(t))
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          r,
          i,
          o = e[this.expando];
        if (void 0 !== o) {
          if (void 0 === t) this.register(e);
          else {
            d.isArray(t)
              ? (r = t.concat(t.map(d.camelCase)))
              : ((i = d.camelCase(t)),
                t in o
                  ? (r = [t, i])
                  : (r = (r = i) in o ? [r] : r.match(L) || [])),
              (n = r.length);
            for (; n--; ) delete o[r[n]];
          }
          (void 0 === t || d.isEmptyObject(o)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !d.isEmptyObject(t);
      },
    });
  var R = new P(),
    M = new P(),
    I = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    W = /[A-Z]/g;
  function $(e, t, n) {
    var r;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((r = "data-" + t.replace(W, "-$&").toLowerCase()),
        "string" == typeof (n = e.getAttribute(r)))
      ) {
        try {
          n =
            "true" === n ||
            ("false" !== n &&
              ("null" === n
                ? null
                : +n + "" === n
                ? +n
                : I.test(n)
                ? d.parseJSON(n)
                : n));
        } catch (e) {}
        M.set(e, t, n);
      } else n = void 0;
    return n;
  }
  d.extend({
    hasData: function (e) {
      return M.hasData(e) || R.hasData(e);
    },
    data: function (e, t, n) {
      return M.access(e, t, n);
    },
    removeData: function (e, t) {
      M.remove(e, t);
    },
    _data: function (e, t, n) {
      return R.access(e, t, n);
    },
    _removeData: function (e, t) {
      R.remove(e, t);
    },
  }),
    d.fn.extend({
      data: function (e, t) {
        var n,
          r,
          i,
          o = this[0],
          s = o && o.attributes;
        if (void 0 === e) {
          if (
            this.length &&
            ((i = M.get(o)), 1 === o.nodeType && !R.get(o, "hasDataAttrs"))
          ) {
            for (n = s.length; n--; )
              s[n] &&
                0 === (r = s[n].name).indexOf("data-") &&
                ((r = d.camelCase(r.slice(5))), $(o, r, i[r]));
            R.set(o, "hasDataAttrs", !0);
          }
          return i;
        }
        return "object" == typeof e
          ? this.each(function () {
              M.set(this, e);
            })
          : O(
              this,
              function (t) {
                var n, r;
                if (o && void 0 === t) {
                  if (
                    void 0 !==
                    (n =
                      M.get(o, e) ||
                      M.get(o, e.replace(W, "-$&").toLowerCase()))
                  )
                    return n;
                  if (((r = d.camelCase(e)), void 0 !== (n = M.get(o, r))))
                    return n;
                  if (void 0 !== (n = $(o, r, void 0))) return n;
                } else
                  (r = d.camelCase(e)),
                    this.each(function () {
                      var n = M.get(this, r);
                      M.set(this, r, t),
                        e.indexOf("-") > -1 &&
                          void 0 !== n &&
                          M.set(this, e, t);
                    });
              },
              null,
              t,
              arguments.length > 1,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          M.remove(this, e);
        });
      },
    }),
    d.extend({
      queue: function (e, t, n) {
        var r;
        return e
          ? ((t = (t || "fx") + "queue"),
            (r = R.get(e, t)),
            n &&
              (!r || d.isArray(n)
                ? (r = R.access(e, t, d.makeArray(n)))
                : r.push(n)),
            r || [])
          : void 0;
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var n = d.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = d._queueHooks(e, t);
        "inprogress" === i && ((i = n.shift()), r--),
          i &&
            ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            i.call(
              e,
              function () {
                d.dequeue(e, t);
              },
              o
            )),
          !r && o && o.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + "queueHooks";
        return (
          R.get(e, n) ||
          R.access(e, n, {
            empty: d.Callbacks("once memory").add(function () {
              R.remove(e, [t + "queue", n]);
            }),
          })
        );
      },
    }),
    d.fn.extend({
      queue: function (e, t) {
        var n = 2;
        return (
          "string" != typeof e && ((t = e), (e = "fx"), n--),
          arguments.length < n
            ? d.queue(this[0], e)
            : void 0 === t
            ? this
            : this.each(function () {
                var n = d.queue(this, e, t);
                d._queueHooks(this, e),
                  "fx" === e && "inprogress" !== n[0] && d.dequeue(this, e);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          d.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", []);
      },
      promise: function (e, t) {
        var n,
          r = 1,
          i = d.Deferred(),
          o = this,
          s = this.length,
          a = function () {
            --r || i.resolveWith(o, [o]);
          };
        for (
          "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
          s--;

        )
          (n = R.get(o[s], e + "queueHooks")) &&
            n.empty &&
            (r++, n.empty.add(a));
        return a(), i.promise(t);
      },
    });
  var B = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    _ = new RegExp("^(?:([+-])=|)(" + B + ")([a-z%]*)$", "i"),
    X = ["Top", "Right", "Bottom", "Left"],
    z = function (e, t) {
      return (
        (e = t || e),
        "none" === d.css(e, "display") || !d.contains(e.ownerDocument, e)
      );
    };
  function U(e, t, n, r) {
    var i,
      o = 1,
      s = 20,
      a = r
        ? function () {
            return r.cur();
          }
        : function () {
            return d.css(e, t, "");
          },
      u = a(),
      l = (n && n[3]) || (d.cssNumber[t] ? "" : "px"),
      c = (d.cssNumber[t] || ("px" !== l && +u)) && _.exec(d.css(e, t));
    if (c && c[3] !== l) {
      (l = l || c[3]), (n = n || []), (c = +u || 1);
      do {
        (c /= o = o || ".5"), d.style(e, t, c + l);
      } while (o !== (o = a() / u) && 1 !== o && --s);
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    );
  }
  var V = /^(?:checkbox|radio)$/i,
    Y = /<([\w:-]+)/,
    G = /^$|\/(?:java|ecma)script/i,
    Q = {
      option: [1, "<select multiple='multiple'>", "</select>"],
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""],
    };
  function J(e, t) {
    var n =
      void 0 !== e.getElementsByTagName
        ? e.getElementsByTagName(t || "*")
        : void 0 !== e.querySelectorAll
        ? e.querySelectorAll(t || "*")
        : [];
    return void 0 === t || (t && d.nodeName(e, t)) ? d.merge([e], n) : n;
  }
  function K(e, t) {
    for (var n = 0, r = e.length; r > n; n++)
      R.set(e[n], "globalEval", !t || R.get(t[n], "globalEval"));
  }
  (Q.optgroup = Q.option),
    (Q.tbody = Q.tfoot = Q.colgroup = Q.caption = Q.thead),
    (Q.th = Q.td);
  var Z,
    ee,
    te = /<|&#?\w+;/;
  function ne(e, t, n, r, i) {
    for (
      var o,
        s,
        a,
        u,
        l,
        c,
        f = t.createDocumentFragment(),
        p = [],
        h = 0,
        g = e.length;
      g > h;
      h++
    )
      if ((o = e[h]) || 0 === o)
        if ("object" === d.type(o)) d.merge(p, o.nodeType ? [o] : o);
        else if (te.test(o)) {
          for (
            s = s || f.appendChild(t.createElement("div")),
              a = (Y.exec(o) || ["", ""])[1].toLowerCase(),
              u = Q[a] || Q._default,
              s.innerHTML = u[1] + d.htmlPrefilter(o) + u[2],
              c = u[0];
            c--;

          )
            s = s.lastChild;
          d.merge(p, s.childNodes), ((s = f.firstChild).textContent = "");
        } else p.push(t.createTextNode(o));
    for (f.textContent = "", h = 0; (o = p[h++]); )
      if (r && d.inArray(o, r) > -1) i && i.push(o);
      else if (
        ((l = d.contains(o.ownerDocument, o)),
        (s = J(f.appendChild(o), "script")),
        l && K(s),
        n)
      )
        for (c = 0; (o = s[c++]); ) G.test(o.type || "") && n.push(o);
    return f;
  }
  (Z = r.createDocumentFragment().appendChild(r.createElement("div"))),
    (ee = r.createElement("input")).setAttribute("type", "radio"),
    ee.setAttribute("checked", "checked"),
    ee.setAttribute("name", "t"),
    Z.appendChild(ee),
    (f.checkClone = Z.cloneNode(!0).cloneNode(!0).lastChild.checked),
    (Z.innerHTML = "<textarea>x</textarea>"),
    (f.noCloneChecked = !!Z.cloneNode(!0).lastChild.defaultValue);
  var re = /^key/,
    ie = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    oe = /^([^.]*)(?:\.(.+)|)/;
  function se() {
    return !0;
  }
  function ae() {
    return !1;
  }
  function ue() {
    try {
      return r.activeElement;
    } catch (e) {}
  }
  function le(e, t, n, r, i, o) {
    var s, a;
    if ("object" == typeof t) {
      for (a in ("string" != typeof n && ((r = r || n), (n = void 0)), t))
        le(e, a, n, r, t[a], o);
      return e;
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i &&
          ("string" == typeof n
            ? ((i = r), (r = void 0))
            : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = ae;
    else if (!i) return e;
    return (
      1 === o &&
        ((s = i),
        ((i = function (e) {
          return d().off(e), s.apply(this, arguments);
        }).guid = s.guid || (s.guid = d.guid++))),
      e.each(function () {
        d.event.add(this, t, i, r, n);
      })
    );
  }
  (d.event = {
    global: {},
    add: function (e, t, n, r, i) {
      var o,
        s,
        a,
        u,
        l,
        c,
        f,
        p,
        h,
        g,
        v,
        m = R.get(e);
      if (m)
        for (
          n.handler && ((n = (o = n).handler), (i = o.selector)),
            n.guid || (n.guid = d.guid++),
            (u = m.events) || (u = m.events = {}),
            (s = m.handle) ||
              (s = m.handle =
                function (t) {
                  return void 0 !== d && d.event.triggered !== t.type
                    ? d.event.dispatch.apply(e, arguments)
                    : void 0;
                }),
            l = (t = (t || "").match(L) || [""]).length;
          l--;

        )
          (h = v = (a = oe.exec(t[l]) || [])[1]),
            (g = (a[2] || "").split(".").sort()),
            h &&
              ((f = d.event.special[h] || {}),
              (h = (i ? f.delegateType : f.bindType) || h),
              (f = d.event.special[h] || {}),
              (c = d.extend(
                {
                  type: h,
                  origType: v,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && d.expr.match.needsContext.test(i),
                  namespace: g.join("."),
                },
                o
              )),
              (p = u[h]) ||
                (((p = u[h] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(e, r, g, s)) ||
                  (e.addEventListener && e.addEventListener(h, s))),
              f.add &&
                (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (d.event.global[h] = !0));
    },
    remove: function (e, t, n, r, i) {
      var o,
        s,
        a,
        u,
        l,
        c,
        f,
        p,
        h,
        g,
        v,
        m = R.hasData(e) && R.get(e);
      if (m && (u = m.events)) {
        for (l = (t = (t || "").match(L) || [""]).length; l--; )
          if (
            ((h = v = (a = oe.exec(t[l]) || [])[1]),
            (g = (a[2] || "").split(".").sort()),
            h)
          ) {
            for (
              f = d.event.special[h] || {},
                p = u[(h = (r ? f.delegateType : f.bindType) || h)] || [],
                a =
                  a[2] &&
                  new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                s = o = p.length;
              o--;

            )
              (c = p[o]),
                (!i && v !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (a && !a.test(c.namespace)) ||
                  (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                  (p.splice(o, 1),
                  c.selector && p.delegateCount--,
                  f.remove && f.remove.call(e, c));
            s &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, g, m.handle)) ||
                d.removeEvent(e, h, m.handle),
              delete u[h]);
          } else for (h in u) d.event.remove(e, h + t[l], n, r, !0);
        d.isEmptyObject(u) && R.remove(e, "handle events");
      }
    },
    dispatch: function (e) {
      e = d.event.fix(e);
      var t,
        n,
        r,
        o,
        s,
        a = [],
        u = i.call(arguments),
        l = (R.get(this, "events") || {})[e.type] || [],
        c = d.event.special[e.type] || {};
      if (
        ((u[0] = e),
        (e.delegateTarget = this),
        !c.preDispatch || !1 !== c.preDispatch.call(this, e))
      ) {
        for (
          a = d.event.handlers.call(this, e, l), t = 0;
          (o = a[t++]) && !e.isPropagationStopped();

        )
          for (
            e.currentTarget = o.elem, n = 0;
            (s = o.handlers[n++]) && !e.isImmediatePropagationStopped();

          )
            (e.rnamespace && !e.rnamespace.test(s.namespace)) ||
              ((e.handleObj = s),
              (e.data = s.data),
              void 0 !==
                (r = (
                  (d.event.special[s.origType] || {}).handle || s.handler
                ).apply(o.elem, u)) &&
                !1 === (e.result = r) &&
                (e.preventDefault(), e.stopPropagation()));
        return c.postDispatch && c.postDispatch.call(this, e), e.result;
      }
    },
    handlers: function (e, t) {
      var n,
        r,
        i,
        o,
        s = [],
        a = t.delegateCount,
        u = e.target;
      if (
        a &&
        u.nodeType &&
        ("click" !== e.type || isNaN(e.button) || e.button < 1)
      )
        for (; u !== this; u = u.parentNode || this)
          if (1 === u.nodeType && (!0 !== u.disabled || "click" !== e.type)) {
            for (r = [], n = 0; a > n; n++)
              void 0 === r[(i = (o = t[n]).selector + " ")] &&
                (r[i] = o.needsContext
                  ? d(i, this).index(u) > -1
                  : d.find(i, this, null, [u]).length),
                r[i] && r.push(o);
            r.length && s.push({ elem: u, handlers: r });
          }
      return a < t.length && s.push({ elem: this, handlers: t.slice(a) }), s;
    },
    props:
      "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
        " "
      ),
    fixHooks: {},
    keyHooks: {
      props: "char charCode key keyCode".split(" "),
      filter: function (e, t) {
        return (
          null == e.which &&
            (e.which = null != t.charCode ? t.charCode : t.keyCode),
          e
        );
      },
    },
    mouseHooks: {
      props:
        "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(
          " "
        ),
      filter: function (e, t) {
        var n,
          i,
          o,
          s = t.button;
        return (
          null == e.pageX &&
            null != t.clientX &&
            ((i = (n = e.target.ownerDocument || r).documentElement),
            (o = n.body),
            (e.pageX =
              t.clientX +
              ((i && i.scrollLeft) || (o && o.scrollLeft) || 0) -
              ((i && i.clientLeft) || (o && o.clientLeft) || 0)),
            (e.pageY =
              t.clientY +
              ((i && i.scrollTop) || (o && o.scrollTop) || 0) -
              ((i && i.clientTop) || (o && o.clientTop) || 0))),
          e.which ||
            void 0 === s ||
            (e.which = 1 & s ? 1 : 2 & s ? 3 : 4 & s ? 2 : 0),
          e
        );
      },
    },
    fix: function (e) {
      if (e[d.expando]) return e;
      var t,
        n,
        i,
        o = e.type,
        s = e,
        a = this.fixHooks[o];
      for (
        a ||
          (this.fixHooks[o] = a =
            ie.test(o) ? this.mouseHooks : re.test(o) ? this.keyHooks : {}),
          i = a.props ? this.props.concat(a.props) : this.props,
          e = new d.Event(s),
          t = i.length;
        t--;

      )
        e[(n = i[t])] = s[n];
      return (
        e.target || (e.target = r),
        3 === e.target.nodeType && (e.target = e.target.parentNode),
        a.filter ? a.filter(e, s) : e
      );
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function () {
          return this !== ue() && this.focus ? (this.focus(), !1) : void 0;
        },
        delegateType: "focusin",
      },
      blur: {
        trigger: function () {
          return this === ue() && this.blur ? (this.blur(), !1) : void 0;
        },
        delegateType: "focusout",
      },
      click: {
        trigger: function () {
          return "checkbox" === this.type &&
            this.click &&
            d.nodeName(this, "input")
            ? (this.click(), !1)
            : void 0;
        },
        _default: function (e) {
          return d.nodeName(e.target, "a");
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (d.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (d.Event = function (e, t) {
      return this instanceof d.Event
        ? (e && e.type
            ? ((this.originalEvent = e),
              (this.type = e.type),
              (this.isDefaultPrevented =
                e.defaultPrevented ||
                (void 0 === e.defaultPrevented && !1 === e.returnValue)
                  ? se
                  : ae))
            : (this.type = e),
          t && d.extend(this, t),
          (this.timeStamp = (e && e.timeStamp) || d.now()),
          void (this[d.expando] = !0))
        : new d.Event(e, t);
    }),
    (d.Event.prototype = {
      constructor: d.Event,
      isDefaultPrevented: ae,
      isPropagationStopped: ae,
      isImmediatePropagationStopped: ae,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = se), e && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = se), e && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = se),
          e && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    d.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (e, t) {
        d.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function (e) {
            var n,
              r = e.relatedTarget,
              i = e.handleObj;
            return (
              (r && (r === this || d.contains(this, r))) ||
                ((e.type = i.origType),
                (n = i.handler.apply(this, arguments)),
                (e.type = t)),
              n
            );
          },
        };
      }
    ),
    d.fn.extend({
      on: function (e, t, n, r) {
        return le(this, e, t, n, r);
      },
      one: function (e, t, n, r) {
        return le(this, e, t, n, r, 1);
      },
      off: function (e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            d(e.delegateTarget).off(
              r.namespace ? r.origType + "." + r.namespace : r.origType,
              r.selector,
              r.handler
            ),
            this
          );
        if ("object" == typeof e) {
          for (i in e) this.off(i, t, e[i]);
          return this;
        }
        return (
          (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = ae),
          this.each(function () {
            d.event.remove(this, e, n, t);
          })
        );
      },
    });
  var ce =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
    fe = /<script|<style|<link/i,
    pe = /checked\s*(?:[^=]|=\s*.checked.)/i,
    de = /^true\/(.*)/,
    he = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function ge(e, t) {
    return d.nodeName(e, "table") &&
      d.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr")
      ? e.getElementsByTagName("tbody")[0] ||
          e.appendChild(e.ownerDocument.createElement("tbody"))
      : e;
  }
  function ve(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
  }
  function me(e) {
    var t = de.exec(e.type);
    return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
  }
  function ye(e, t) {
    var n, r, i, o, s, a, u, l;
    if (1 === t.nodeType) {
      if (
        R.hasData(e) &&
        ((o = R.access(e)), (s = R.set(t, o)), (l = o.events))
      )
        for (i in (delete s.handle, (s.events = {}), l))
          for (n = 0, r = l[i].length; r > n; n++) d.event.add(t, i, l[i][n]);
      M.hasData(e) && ((a = M.access(e)), (u = d.extend({}, a)), M.set(t, u));
    }
  }
  function xe(e, t, n, r) {
    t = o.apply([], t);
    var i,
      s,
      a,
      u,
      l,
      c,
      p = 0,
      h = e.length,
      g = h - 1,
      v = t[0],
      m = d.isFunction(v);
    if (m || (h > 1 && "string" == typeof v && !f.checkClone && pe.test(v)))
      return e.each(function (i) {
        var o = e.eq(i);
        m && (t[0] = v.call(this, i, o.html())), xe(o, t, n, r);
      });
    if (
      h &&
      ((s = (i = ne(t, e[0].ownerDocument, !1, e, r)).firstChild),
      1 === i.childNodes.length && (i = s),
      s || r)
    ) {
      for (u = (a = d.map(J(i, "script"), ve)).length; h > p; p++)
        (l = i),
          p !== g &&
            ((l = d.clone(l, !0, !0)), u && d.merge(a, J(l, "script"))),
          n.call(e[p], l, p);
      if (u)
        for (c = a[a.length - 1].ownerDocument, d.map(a, me), p = 0; u > p; p++)
          (l = a[p]),
            G.test(l.type || "") &&
              !R.access(l, "globalEval") &&
              d.contains(c, l) &&
              (l.src
                ? d._evalUrl && d._evalUrl(l.src)
                : d.globalEval(l.textContent.replace(he, "")));
    }
    return e;
  }
  function be(e, t, n) {
    for (var r, i = t ? d.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || d.cleanData(J(r)),
        r.parentNode &&
          (n && d.contains(r.ownerDocument, r) && K(J(r, "script")),
          r.parentNode.removeChild(r));
    return e;
  }
  d.extend({
    htmlPrefilter: function (e) {
      return e.replace(ce, "<$1></$2>");
    },
    clone: function (e, t, n) {
      var r,
        i,
        o,
        s,
        a,
        u,
        l,
        c = e.cloneNode(!0),
        p = d.contains(e.ownerDocument, e);
      if (
        !(
          f.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          d.isXMLDoc(e)
        )
      )
        for (s = J(c), r = 0, i = (o = J(e)).length; i > r; r++)
          (a = o[r]),
            (u = s[r]),
            void 0,
            "input" === (l = u.nodeName.toLowerCase()) && V.test(a.type)
              ? (u.checked = a.checked)
              : ("input" !== l && "textarea" !== l) ||
                (u.defaultValue = a.defaultValue);
      if (t)
        if (n)
          for (o = o || J(e), s = s || J(c), r = 0, i = o.length; i > r; r++)
            ye(o[r], s[r]);
        else ye(e, c);
      return (s = J(c, "script")).length > 0 && K(s, !p && J(e, "script")), c;
    },
    cleanData: function (e) {
      for (var t, n, r, i = d.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if (F(n)) {
          if ((t = n[R.expando])) {
            if (t.events)
              for (r in t.events)
                i[r] ? d.event.remove(n, r) : d.removeEvent(n, r, t.handle);
            n[R.expando] = void 0;
          }
          n[M.expando] && (n[M.expando] = void 0);
        }
    },
  }),
    d.fn.extend({
      domManip: xe,
      detach: function (e) {
        return be(this, e, !0);
      },
      remove: function (e) {
        return be(this, e);
      },
      text: function (e) {
        return O(
          this,
          function (e) {
            return void 0 === e
              ? d.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return xe(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            ge(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return xe(this, arguments, function (e) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var t = ge(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return xe(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return xe(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (d.cleanData(J(e, !1)), (e.textContent = ""));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return d.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return O(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              "string" == typeof e &&
              !fe.test(e) &&
              !Q[(Y.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = d.htmlPrefilter(e);
              try {
                for (; r > n; n++)
                  1 === (t = this[n] || {}).nodeType &&
                    (d.cleanData(J(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var e = [];
        return xe(
          this,
          arguments,
          function (t) {
            var n = this.parentNode;
            d.inArray(this, e) < 0 &&
              (d.cleanData(J(this)), n && n.replaceChild(t, this));
          },
          e
        );
      },
    }),
    d.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (e, t) {
        d.fn[e] = function (e) {
          for (var n, r = [], i = d(e), o = i.length - 1, a = 0; o >= a; a++)
            (n = a === o ? this : this.clone(!0)),
              d(i[a])[t](n),
              s.apply(r, n.get());
          return this.pushStack(r);
        };
      }
    );
  var we,
    Te = { HTML: "block", BODY: "block" };
  function Ce(e, t) {
    var n = d(t.createElement(e)).appendTo(t.body),
      r = d.css(n[0], "display");
    return n.detach(), r;
  }
  function ke(e) {
    var t = r,
      n = Te[e];
    return (
      n ||
        (("none" !== (n = Ce(e, t)) && n) ||
          ((t = (we = (
            we || d("<iframe frameborder='0' width='0' height='0'/>")
          ).appendTo(t.documentElement))[0].contentDocument).write(),
          t.close(),
          (n = Ce(e, t)),
          we.detach()),
        (Te[e] = n)),
      n
    );
  }
  var Ee = /^margin/,
    Ne = new RegExp("^(" + B + ")(?!px)[a-z%]+$", "i"),
    Se = function (t) {
      var n = t.ownerDocument.defaultView;
      return (n && n.opener) || (n = e), n.getComputedStyle(t);
    },
    De = function (e, t, n, r) {
      var i,
        o,
        s = {};
      for (o in t) (s[o] = e.style[o]), (e.style[o] = t[o]);
      for (o in ((i = n.apply(e, r || [])), t)) e.style[o] = s[o];
      return i;
    },
    je = r.documentElement;
  function Ae(e, t, n) {
    var r,
      i,
      o,
      s,
      a = e.style;
    return (
      ("" !== (s = (n = n || Se(e)) ? n.getPropertyValue(t) || n[t] : void 0) &&
        void 0 !== s) ||
        d.contains(e.ownerDocument, e) ||
        (s = d.style(e, t)),
      n &&
        !f.pixelMarginRight() &&
        Ne.test(s) &&
        Ee.test(t) &&
        ((r = a.width),
        (i = a.minWidth),
        (o = a.maxWidth),
        (a.minWidth = a.maxWidth = a.width = s),
        (s = n.width),
        (a.width = r),
        (a.minWidth = i),
        (a.maxWidth = o)),
      void 0 !== s ? s + "" : s
    );
  }
  function qe(e, t) {
    return {
      get: function () {
        return e()
          ? void delete this.get
          : (this.get = t).apply(this, arguments);
      },
    };
  }
  !(function () {
    var t,
      n,
      i,
      o,
      s = r.createElement("div"),
      a = r.createElement("div");
    if (a.style) {
      function u() {
        (a.style.cssText =
          "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
          (a.innerHTML = ""),
          je.appendChild(s);
        var r = e.getComputedStyle(a);
        (t = "1%" !== r.top),
          (o = "2px" === r.marginLeft),
          (n = "4px" === r.width),
          (a.style.marginRight = "50%"),
          (i = "4px" === r.marginRight),
          je.removeChild(s);
      }
      (a.style.backgroundClip = "content-box"),
        (a.cloneNode(!0).style.backgroundClip = ""),
        (f.clearCloneStyle = "content-box" === a.style.backgroundClip),
        (s.style.cssText =
          "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
        s.appendChild(a),
        d.extend(f, {
          pixelPosition: function () {
            return u(), t;
          },
          boxSizingReliable: function () {
            return null == n && u(), n;
          },
          pixelMarginRight: function () {
            return null == n && u(), i;
          },
          reliableMarginLeft: function () {
            return null == n && u(), o;
          },
          reliableMarginRight: function () {
            var t,
              n = a.appendChild(r.createElement("div"));
            return (
              (n.style.cssText = a.style.cssText =
                "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
              (n.style.marginRight = n.style.width = "0"),
              (a.style.width = "1px"),
              je.appendChild(s),
              (t = !parseFloat(e.getComputedStyle(n).marginRight)),
              je.removeChild(s),
              a.removeChild(n),
              t
            );
          },
        });
    }
  })();
  var Le = /^(none|table(?!-c[ea]).+)/,
    He = { position: "absolute", visibility: "hidden", display: "block" },
    Oe = { letterSpacing: "0", fontWeight: "400" },
    Fe = ["Webkit", "O", "Moz", "ms"],
    Pe = r.createElement("div").style;
  function Re(e) {
    if (e in Pe) return e;
    for (var t = e[0].toUpperCase() + e.slice(1), n = Fe.length; n--; )
      if ((e = Fe[n] + t) in Pe) return e;
  }
  function Me(e, t, n) {
    var r = _.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
  }
  function Ie(e, t, n, r, i) {
    for (
      var o = n === (r ? "border" : "content") ? 4 : "width" === t ? 1 : 0,
        s = 0;
      4 > o;
      o += 2
    )
      "margin" === n && (s += d.css(e, n + X[o], !0, i)),
        r
          ? ("content" === n && (s -= d.css(e, "padding" + X[o], !0, i)),
            "margin" !== n && (s -= d.css(e, "border" + X[o] + "Width", !0, i)))
          : ((s += d.css(e, "padding" + X[o], !0, i)),
            "padding" !== n &&
              (s += d.css(e, "border" + X[o] + "Width", !0, i)));
    return s;
  }
  function We(t, n, i) {
    var o = !0,
      s = "width" === n ? t.offsetWidth : t.offsetHeight,
      a = Se(t),
      u = "border-box" === d.css(t, "boxSizing", !1, a);
    if (
      (r.msFullscreenElement &&
        e.top !== e &&
        t.getClientRects().length &&
        (s = Math.round(100 * t.getBoundingClientRect()[n])),
      0 >= s || null == s)
    ) {
      if (
        ((0 > (s = Ae(t, n, a)) || null == s) && (s = t.style[n]), Ne.test(s))
      )
        return s;
      (o = u && (f.boxSizingReliable() || s === t.style[n])),
        (s = parseFloat(s) || 0);
    }
    return s + Ie(t, n, i || (u ? "border" : "content"), o, a) + "px";
  }
  function $e(e, t) {
    for (var n, r, i, o = [], s = 0, a = e.length; a > s; s++)
      (r = e[s]).style &&
        ((o[s] = R.get(r, "olddisplay")),
        (n = r.style.display),
        t
          ? (o[s] || "none" !== n || (r.style.display = ""),
            "" === r.style.display &&
              z(r) &&
              (o[s] = R.access(r, "olddisplay", ke(r.nodeName))))
          : ((i = z(r)),
            ("none" === n && i) ||
              R.set(r, "olddisplay", i ? n : d.css(r, "display"))));
    for (s = 0; a > s; s++)
      (r = e[s]).style &&
        ((t && "none" !== r.style.display && "" !== r.style.display) ||
          (r.style.display = t ? o[s] || "" : "none"));
    return e;
  }
  function Be(e, t, n, r, i) {
    return new Be.prototype.init(e, t, n, r, i);
  }
  d.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = Ae(e, "opacity");
            return "" === n ? "1" : n;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: { float: "cssFloat" },
    style: function (e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          s,
          a = d.camelCase(t),
          u = e.style;
        return (
          (t = d.cssProps[a] || (d.cssProps[a] = Re(a) || a)),
          (s = d.cssHooks[t] || d.cssHooks[a]),
          void 0 === n
            ? s && "get" in s && void 0 !== (i = s.get(e, !1, r))
              ? i
              : u[t]
            : ("string" === (o = typeof n) &&
                (i = _.exec(n)) &&
                i[1] &&
                ((n = U(e, t, i)), (o = "number")),
              void (
                null != n &&
                n == n &&
                ("number" === o &&
                  (n += (i && i[3]) || (d.cssNumber[a] ? "" : "px")),
                f.clearCloneStyle ||
                  "" !== n ||
                  0 !== t.indexOf("background") ||
                  (u[t] = "inherit"),
                (s && "set" in s && void 0 === (n = s.set(e, n, r))) ||
                  (u[t] = n))
              ))
        );
      }
    },
    css: function (e, t, n, r) {
      var i,
        o,
        s,
        a = d.camelCase(t);
      return (
        (t = d.cssProps[a] || (d.cssProps[a] = Re(a) || a)),
        (s = d.cssHooks[t] || d.cssHooks[a]) &&
          "get" in s &&
          (i = s.get(e, !0, n)),
        void 0 === i && (i = Ae(e, t, r)),
        "normal" === i && t in Oe && (i = Oe[t]),
        "" === n || n
          ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i)
          : i
      );
    },
  }),
    d.each(["height", "width"], function (e, t) {
      d.cssHooks[t] = {
        get: function (e, n, r) {
          return n
            ? Le.test(d.css(e, "display")) && 0 === e.offsetWidth
              ? De(e, He, function () {
                  return We(e, t, r);
                })
              : We(e, t, r)
            : void 0;
        },
        set: function (e, n, r) {
          var i,
            o = r && Se(e),
            s =
              r &&
              Ie(e, t, r, "border-box" === d.css(e, "boxSizing", !1, o), o);
          return (
            s &&
              (i = _.exec(n)) &&
              "px" !== (i[3] || "px") &&
              ((e.style[t] = n), (n = d.css(e, t))),
            Me(0, n, s)
          );
        },
      };
    }),
    (d.cssHooks.marginLeft = qe(f.reliableMarginLeft, function (e, t) {
      return t
        ? (parseFloat(Ae(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              De(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
              })) + "px"
        : void 0;
    })),
    (d.cssHooks.marginRight = qe(f.reliableMarginRight, function (e, t) {
      return t
        ? De(e, { display: "inline-block" }, Ae, [e, "marginRight"])
        : void 0;
    })),
    d.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
      (d.cssHooks[e + t] = {
        expand: function (n) {
          for (
            var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n];
            4 > r;
            r++
          )
            i[e + X[r] + t] = o[r] || o[r - 2] || o[0];
          return i;
        },
      }),
        Ee.test(e) || (d.cssHooks[e + t].set = Me);
    }),
    d.fn.extend({
      css: function (e, t) {
        return O(
          this,
          function (e, t, n) {
            var r,
              i,
              o = {},
              s = 0;
            if (d.isArray(t)) {
              for (r = Se(e), i = t.length; i > s; s++)
                o[t[s]] = d.css(e, t[s], !1, r);
              return o;
            }
            return void 0 !== n ? d.style(e, t, n) : d.css(e, t);
          },
          e,
          t,
          arguments.length > 1
        );
      },
      show: function () {
        return $e(this, !0);
      },
      hide: function () {
        return $e(this);
      },
      toggle: function (e) {
        return "boolean" == typeof e
          ? e
            ? this.show()
            : this.hide()
          : this.each(function () {
              z(this) ? d(this).show() : d(this).hide();
            });
      },
    }),
    (d.Tween = Be),
    (Be.prototype = {
      constructor: Be,
      init: function (e, t, n, r, i, o) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = i || d.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (d.cssNumber[n] ? "" : "px"));
      },
      cur: function () {
        var e = Be.propHooks[this.prop];
        return e && e.get ? e.get(this) : Be.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          n = Be.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                d.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : Be.propHooks._default.set(this),
          this
        );
      },
    }),
    (Be.prototype.init.prototype = Be.prototype),
    (Be.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = d.css(e.elem, e.prop, "")) && "auto" !== t
            ? t
            : 0;
        },
        set: function (e) {
          d.fx.step[e.prop]
            ? d.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (null == e.elem.style[d.cssProps[e.prop]] && !d.cssHooks[e.prop])
            ? (e.elem[e.prop] = e.now)
            : d.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }),
    (Be.propHooks.scrollTop = Be.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (d.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (d.fx = Be.prototype.init),
    (d.fx.step = {});
  var _e,
    Xe,
    ze,
    Ue,
    Ve,
    Ye = /^(?:toggle|show|hide)$/,
    Ge = /queueHooks$/;
  function Qe() {
    return (
      e.setTimeout(function () {
        _e = void 0;
      }),
      (_e = d.now())
    );
  }
  function Je(e, t) {
    var n,
      r = 0,
      i = { height: e };
    for (t = t ? 1 : 0; 4 > r; r += 2 - t)
      i["margin" + (n = X[r])] = i["padding" + n] = e;
    return t && (i.opacity = i.width = e), i;
  }
  function Ke(e, t, n) {
    for (
      var r,
        i = (Ze.tweeners[t] || []).concat(Ze.tweeners["*"]),
        o = 0,
        s = i.length;
      s > o;
      o++
    )
      if ((r = i[o].call(n, t, e))) return r;
  }
  function Ze(e, t, n) {
    var r,
      i,
      o = 0,
      s = Ze.prefilters.length,
      a = d.Deferred().always(function () {
        delete u.elem;
      }),
      u = function () {
        if (i) return !1;
        for (
          var t = _e || Qe(),
            n = Math.max(0, l.startTime + l.duration - t),
            r = 1 - (n / l.duration || 0),
            o = 0,
            s = l.tweens.length;
          s > o;
          o++
        )
          l.tweens[o].run(r);
        return (
          a.notifyWith(e, [l, r, n]),
          1 > r && s ? n : (a.resolveWith(e, [l]), !1)
        );
      },
      l = a.promise({
        elem: e,
        props: d.extend({}, t),
        opts: d.extend(!0, { specialEasing: {}, easing: d.easing._default }, n),
        originalProperties: t,
        originalOptions: n,
        startTime: _e || Qe(),
        duration: n.duration,
        tweens: [],
        createTween: function (t, n) {
          var r = d.Tween(
            e,
            l.opts,
            t,
            n,
            l.opts.specialEasing[t] || l.opts.easing
          );
          return l.tweens.push(r), r;
        },
        stop: function (t) {
          var n = 0,
            r = t ? l.tweens.length : 0;
          if (i) return this;
          for (i = !0; r > n; n++) l.tweens[n].run(1);
          return (
            t
              ? (a.notifyWith(e, [l, 1, 0]), a.resolveWith(e, [l, t]))
              : a.rejectWith(e, [l, t]),
            this
          );
        },
      }),
      c = l.props;
    for (
      (function (e, t) {
        var n, r, i, o, s;
        for (n in e)
          if (
            ((i = t[(r = d.camelCase(n))]),
            (o = e[n]),
            d.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
            n !== r && ((e[r] = o), delete e[n]),
            (s = d.cssHooks[r]) && ("expand" in s))
          )
            for (n in ((o = s.expand(o)), delete e[r], o))
              (n in e) || ((e[n] = o[n]), (t[n] = i));
          else t[r] = i;
      })(c, l.opts.specialEasing);
      s > o;
      o++
    )
      if ((r = Ze.prefilters[o].call(l, e, c, l.opts)))
        return (
          d.isFunction(r.stop) &&
            (d._queueHooks(l.elem, l.opts.queue).stop = d.proxy(r.stop, r)),
          r
        );
    return (
      d.map(c, Ke, l),
      d.isFunction(l.opts.start) && l.opts.start.call(e, l),
      d.fx.timer(d.extend(u, { elem: e, anim: l, queue: l.opts.queue })),
      l
        .progress(l.opts.progress)
        .done(l.opts.done, l.opts.complete)
        .fail(l.opts.fail)
        .always(l.opts.always)
    );
  }
  (d.Animation = d.extend(Ze, {
    tweeners: {
      "*": [
        function (e, t) {
          var n = this.createTween(e, t);
          return U(n.elem, e, _.exec(t), n), n;
        },
      ],
    },
    tweener: function (e, t) {
      d.isFunction(e) ? ((t = e), (e = ["*"])) : (e = e.match(L));
      for (var n, r = 0, i = e.length; i > r; r++)
        (n = e[r]),
          (Ze.tweeners[n] = Ze.tweeners[n] || []),
          Ze.tweeners[n].unshift(t);
    },
    prefilters: [
      function (e, t, n) {
        var r,
          i,
          o,
          s,
          a,
          u,
          l,
          c = this,
          f = {},
          p = e.style,
          h = e.nodeType && z(e),
          g = R.get(e, "fxshow");
        for (r in (n.queue ||
          (null == (a = d._queueHooks(e, "fx")).unqueued &&
            ((a.unqueued = 0),
            (u = a.empty.fire),
            (a.empty.fire = function () {
              a.unqueued || u();
            })),
          a.unqueued++,
          c.always(function () {
            c.always(function () {
              a.unqueued--, d.queue(e, "fx").length || a.empty.fire();
            });
          })),
        1 === e.nodeType &&
          ("height" in t || "width" in t) &&
          ((n.overflow = [p.overflow, p.overflowX, p.overflowY]),
          "inline" ===
            ("none" === (l = d.css(e, "display"))
              ? R.get(e, "olddisplay") || ke(e.nodeName)
              : l) &&
            "none" === d.css(e, "float") &&
            (p.display = "inline-block")),
        n.overflow &&
          ((p.overflow = "hidden"),
          c.always(function () {
            (p.overflow = n.overflow[0]),
              (p.overflowX = n.overflow[1]),
              (p.overflowY = n.overflow[2]);
          })),
        t))
          if (((i = t[r]), Ye.exec(i))) {
            if (
              (delete t[r],
              (o = o || "toggle" === i),
              i === (h ? "hide" : "show"))
            ) {
              if ("show" !== i || !g || void 0 === g[r]) continue;
              h = !0;
            }
            f[r] = (g && g[r]) || d.style(e, r);
          } else l = void 0;
        if (d.isEmptyObject(f))
          "inline" === ("none" === l ? ke(e.nodeName) : l) && (p.display = l);
        else
          for (r in (g
            ? "hidden" in g && (h = g.hidden)
            : (g = R.access(e, "fxshow", {})),
          o && (g.hidden = !h),
          h
            ? d(e).show()
            : c.done(function () {
                d(e).hide();
              }),
          c.done(function () {
            var t;
            for (t in (R.remove(e, "fxshow"), f)) d.style(e, t, f[t]);
          }),
          f))
            (s = Ke(h ? g[r] : 0, r, c)),
              r in g ||
                ((g[r] = s.start),
                h &&
                  ((s.end = s.start),
                  (s.start = "width" === r || "height" === r ? 1 : 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? Ze.prefilters.unshift(e) : Ze.prefilters.push(e);
    },
  })),
    (d.speed = function (e, t, n) {
      var r =
        e && "object" == typeof e
          ? d.extend({}, e)
          : {
              complete: n || (!n && t) || (d.isFunction(e) && e),
              duration: e,
              easing: (n && t) || (t && !d.isFunction(t) && t),
            };
      return (
        (r.duration = d.fx.off
          ? 0
          : "number" == typeof r.duration
          ? r.duration
          : r.duration in d.fx.speeds
          ? d.fx.speeds[r.duration]
          : d.fx.speeds._default),
        (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
        (r.old = r.complete),
        (r.complete = function () {
          d.isFunction(r.old) && r.old.call(this),
            r.queue && d.dequeue(this, r.queue);
        }),
        r
      );
    }),
    d.fn.extend({
      fadeTo: function (e, t, n, r) {
        return this.filter(z)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: t }, e, n, r);
      },
      animate: function (e, t, n, r) {
        var i = d.isEmptyObject(e),
          o = d.speed(t, n, r),
          s = function () {
            var t = Ze(this, d.extend({}, e), o);
            (i || R.get(this, "finish")) && t.stop(!0);
          };
        return (
          (s.finish = s),
          i || !1 === o.queue ? this.each(s) : this.queue(o.queue, s)
        );
      },
      stop: function (e, t, n) {
        var r = function (e) {
          var t = e.stop;
          delete e.stop, t(n);
        };
        return (
          "string" != typeof e && ((n = t), (t = e), (e = void 0)),
          t && !1 !== e && this.queue(e || "fx", []),
          this.each(function () {
            var t = !0,
              i = null != e && e + "queueHooks",
              o = d.timers,
              s = R.get(this);
            if (i) s[i] && s[i].stop && r(s[i]);
            else for (i in s) s[i] && s[i].stop && Ge.test(i) && r(s[i]);
            for (i = o.length; i--; )
              o[i].elem !== this ||
                (null != e && o[i].queue !== e) ||
                (o[i].anim.stop(n), (t = !1), o.splice(i, 1));
            (!t && n) || d.dequeue(this, e);
          })
        );
      },
      finish: function (e) {
        return (
          !1 !== e && (e = e || "fx"),
          this.each(function () {
            var t,
              n = R.get(this),
              r = n[e + "queue"],
              i = n[e + "queueHooks"],
              o = d.timers,
              s = r ? r.length : 0;
            for (
              n.finish = !0,
                d.queue(this, e, []),
                i && i.stop && i.stop.call(this, !0),
                t = o.length;
              t--;

            )
              o[t].elem === this &&
                o[t].queue === e &&
                (o[t].anim.stop(!0), o.splice(t, 1));
            for (t = 0; s > t; t++)
              r[t] && r[t].finish && r[t].finish.call(this);
            delete n.finish;
          })
        );
      },
    }),
    d.each(["toggle", "show", "hide"], function (e, t) {
      var n = d.fn[t];
      d.fn[t] = function (e, r, i) {
        return null == e || "boolean" == typeof e
          ? n.apply(this, arguments)
          : this.animate(Je(t, !0), e, r, i);
      };
    }),
    d.each(
      {
        slideDown: Je("show"),
        slideUp: Je("hide"),
        slideToggle: Je("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (e, t) {
        d.fn[e] = function (e, n, r) {
          return this.animate(t, e, n, r);
        };
      }
    ),
    (d.timers = []),
    (d.fx.tick = function () {
      var e,
        t = 0,
        n = d.timers;
      for (_e = d.now(); t < n.length; t++)
        (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || d.fx.stop(), (_e = void 0);
    }),
    (d.fx.timer = function (e) {
      d.timers.push(e), e() ? d.fx.start() : d.timers.pop();
    }),
    (d.fx.interval = 13),
    (d.fx.start = function () {
      Xe || (Xe = e.setInterval(d.fx.tick, d.fx.interval));
    }),
    (d.fx.stop = function () {
      e.clearInterval(Xe), (Xe = null);
    }),
    (d.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (d.fn.delay = function (t, n) {
      return (
        (t = (d.fx && d.fx.speeds[t]) || t),
        (n = n || "fx"),
        this.queue(n, function (n, r) {
          var i = e.setTimeout(n, t);
          r.stop = function () {
            e.clearTimeout(i);
          };
        })
      );
    }),
    (ze = r.createElement("input")),
    (Ue = r.createElement("select")),
    (Ve = Ue.appendChild(r.createElement("option"))),
    (ze.type = "checkbox"),
    (f.checkOn = "" !== ze.value),
    (f.optSelected = Ve.selected),
    (Ue.disabled = !0),
    (f.optDisabled = !Ve.disabled),
    ((ze = r.createElement("input")).value = "t"),
    (ze.type = "radio"),
    (f.radioValue = "t" === ze.value);
  var et,
    tt = d.expr.attrHandle;
  d.fn.extend({
    attr: function (e, t) {
      return O(this, d.attr, e, t, arguments.length > 1);
    },
    removeAttr: function (e) {
      return this.each(function () {
        d.removeAttr(this, e);
      });
    },
  }),
    d.extend({
      attr: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return void 0 === e.getAttribute
            ? d.prop(e, t, n)
            : ((1 === o && d.isXMLDoc(e)) ||
                ((t = t.toLowerCase()),
                (i =
                  d.attrHooks[t] || (d.expr.match.bool.test(t) ? et : void 0))),
              void 0 !== n
                ? null === n
                  ? void d.removeAttr(e, t)
                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                  ? r
                  : (e.setAttribute(t, n + ""), n)
                : i && "get" in i && null !== (r = i.get(e, t))
                ? r
                : null == (r = d.find.attr(e, t))
                ? void 0
                : r);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!f.radioValue && "radio" === t && d.nodeName(e, "input")) {
              var n = e.value;
              return e.setAttribute("type", t), n && (e.value = n), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var n,
          r,
          i = 0,
          o = t && t.match(L);
        if (o && 1 === e.nodeType)
          for (; (n = o[i++]); )
            (r = d.propFix[n] || n),
              d.expr.match.bool.test(n) && (e[r] = !1),
              e.removeAttribute(n);
      },
    }),
    (et = {
      set: function (e, t, n) {
        return !1 === t ? d.removeAttr(e, n) : e.setAttribute(n, n), n;
      },
    }),
    d.each(d.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var n = tt[t] || d.find.attr;
      tt[t] = function (e, t, r) {
        var i, o;
        return (
          r ||
            ((o = tt[t]),
            (tt[t] = i),
            (i = null != n(e, t, r) ? t.toLowerCase() : null),
            (tt[t] = o)),
          i
        );
      };
    });
  var nt = /^(?:input|select|textarea|button)$/i,
    rt = /^(?:a|area)$/i;
  d.fn.extend({
    prop: function (e, t) {
      return O(this, d.prop, e, t, arguments.length > 1);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[d.propFix[e] || e];
      });
    },
  }),
    d.extend({
      prop: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && d.isXMLDoc(e)) ||
              ((t = d.propFix[t] || t), (i = d.propHooks[t])),
            void 0 !== n
              ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && "get" in i && null !== (r = i.get(e, t))
              ? r
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = d.find.attr(e, "tabindex");
            return t
              ? parseInt(t, 10)
              : nt.test(e.nodeName) || (rt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    f.optSelected ||
      (d.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        },
      }),
    d.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        d.propFix[this.toLowerCase()] = this;
      }
    );
  var it = /[\t\r\n\f]/g;
  function ot(e) {
    return (e.getAttribute && e.getAttribute("class")) || "";
  }
  d.fn.extend({
    addClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        s,
        a,
        u = 0;
      if (d.isFunction(e))
        return this.each(function (t) {
          d(this).addClass(e.call(this, t, ot(this)));
        });
      if ("string" == typeof e && e)
        for (t = e.match(L) || []; (n = this[u++]); )
          if (
            ((i = ot(n)),
            (r = 1 === n.nodeType && (" " + i + " ").replace(it, " ")))
          ) {
            for (s = 0; (o = t[s++]); )
              r.indexOf(" " + o + " ") < 0 && (r += o + " ");
            i !== (a = d.trim(r)) && n.setAttribute("class", a);
          }
      return this;
    },
    removeClass: function (e) {
      var t,
        n,
        r,
        i,
        o,
        s,
        a,
        u = 0;
      if (d.isFunction(e))
        return this.each(function (t) {
          d(this).removeClass(e.call(this, t, ot(this)));
        });
      if (!arguments.length) return this.attr("class", "");
      if ("string" == typeof e && e)
        for (t = e.match(L) || []; (n = this[u++]); )
          if (
            ((i = ot(n)),
            (r = 1 === n.nodeType && (" " + i + " ").replace(it, " ")))
          ) {
            for (s = 0; (o = t[s++]); )
              for (; r.indexOf(" " + o + " ") > -1; )
                r = r.replace(" " + o + " ", " ");
            i !== (a = d.trim(r)) && n.setAttribute("class", a);
          }
      return this;
    },
    toggleClass: function (e, t) {
      var n = typeof e;
      return "boolean" == typeof t && "string" === n
        ? t
          ? this.addClass(e)
          : this.removeClass(e)
        : d.isFunction(e)
        ? this.each(function (n) {
            d(this).toggleClass(e.call(this, n, ot(this), t), t);
          })
        : this.each(function () {
            var t, r, i, o;
            if ("string" === n)
              for (r = 0, i = d(this), o = e.match(L) || []; (t = o[r++]); )
                i.hasClass(t) ? i.removeClass(t) : i.addClass(t);
            else
              (void 0 !== e && "boolean" !== n) ||
                ((t = ot(this)) && R.set(this, "__className__", t),
                this.setAttribute &&
                  this.setAttribute(
                    "class",
                    t || !1 === e ? "" : R.get(this, "__className__") || ""
                  ));
          });
    },
    hasClass: function (e) {
      var t,
        n,
        r = 0;
      for (t = " " + e + " "; (n = this[r++]); )
        if (
          1 === n.nodeType &&
          (" " + ot(n) + " ").replace(it, " ").indexOf(t) > -1
        )
          return !0;
      return !1;
    },
  });
  var st = /\r/g,
    at = /[\x20\t\r\n\f]+/g;
  d.fn.extend({
    val: function (e) {
      var t,
        n,
        r,
        i = this[0];
      return arguments.length
        ? ((r = d.isFunction(e)),
          this.each(function (n) {
            var i;
            1 === this.nodeType &&
              (null == (i = r ? e.call(this, n, d(this).val()) : e)
                ? (i = "")
                : "number" == typeof i
                ? (i += "")
                : d.isArray(i) &&
                  (i = d.map(i, function (e) {
                    return null == e ? "" : e + "";
                  })),
              ((t =
                d.valHooks[this.type] ||
                d.valHooks[this.nodeName.toLowerCase()]) &&
                "set" in t &&
                void 0 !== t.set(this, i, "value")) ||
                (this.value = i));
          }))
        : i
        ? (t = d.valHooks[i.type] || d.valHooks[i.nodeName.toLowerCase()]) &&
          "get" in t &&
          void 0 !== (n = t.get(i, "value"))
          ? n
          : "string" == typeof (n = i.value)
          ? n.replace(st, "")
          : null == n
          ? ""
          : n
        : void 0;
    },
  }),
    d.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = d.find.attr(e, "value");
            return null != t ? t : d.trim(d.text(e)).replace(at, " ");
          },
        },
        select: {
          get: function (e) {
            for (
              var t,
                n,
                r = e.options,
                i = e.selectedIndex,
                o = "select-one" === e.type || 0 > i,
                s = o ? null : [],
                a = o ? i + 1 : r.length,
                u = 0 > i ? a : o ? i : 0;
              a > u;
              u++
            )
              if (
                ((n = r[u]).selected || u === i) &&
                (f.optDisabled
                  ? !n.disabled
                  : null === n.getAttribute("disabled")) &&
                (!n.parentNode.disabled ||
                  !d.nodeName(n.parentNode, "optgroup"))
              ) {
                if (((t = d(n).val()), o)) return t;
                s.push(t);
              }
            return s;
          },
          set: function (e, t) {
            for (
              var n, r, i = e.options, o = d.makeArray(t), s = i.length;
              s--;

            )
              ((r = i[s]).selected =
                d.inArray(d.valHooks.option.get(r), o) > -1) && (n = !0);
            return n || (e.selectedIndex = -1), o;
          },
        },
      },
    }),
    d.each(["radio", "checkbox"], function () {
      (d.valHooks[this] = {
        set: function (e, t) {
          return d.isArray(t)
            ? (e.checked = d.inArray(d(e).val(), t) > -1)
            : void 0;
        },
      }),
        f.checkOn ||
          (d.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value;
          });
    });
  var ut = /^(?:focusinfocus|focusoutblur)$/;
  d.extend(d.event, {
    trigger: function (t, n, i, o) {
      var s,
        a,
        u,
        l,
        f,
        p,
        h,
        g = [i || r],
        v = c.call(t, "type") ? t.type : t,
        m = c.call(t, "namespace") ? t.namespace.split(".") : [];
      if (
        ((a = u = i = i || r),
        3 !== i.nodeType &&
          8 !== i.nodeType &&
          !ut.test(v + d.event.triggered) &&
          (v.indexOf(".") > -1 && ((v = (m = v.split(".")).shift()), m.sort()),
          (f = v.indexOf(":") < 0 && "on" + v),
          ((t = t[d.expando]
            ? t
            : new d.Event(v, "object" == typeof t && t)).isTrigger = o ? 2 : 3),
          (t.namespace = m.join(".")),
          (t.rnamespace = t.namespace
            ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (t.result = void 0),
          t.target || (t.target = i),
          (n = null == n ? [t] : d.makeArray(n, [t])),
          (h = d.event.special[v] || {}),
          o || !h.trigger || !1 !== h.trigger.apply(i, n)))
      ) {
        if (!o && !h.noBubble && !d.isWindow(i)) {
          for (
            l = h.delegateType || v, ut.test(l + v) || (a = a.parentNode);
            a;
            a = a.parentNode
          )
            g.push(a), (u = a);
          u === (i.ownerDocument || r) &&
            g.push(u.defaultView || u.parentWindow || e);
        }
        for (s = 0; (a = g[s++]) && !t.isPropagationStopped(); )
          (t.type = s > 1 ? l : h.bindType || v),
            (p = (R.get(a, "events") || {})[t.type] && R.get(a, "handle")) &&
              p.apply(a, n),
            (p = f && a[f]) &&
              p.apply &&
              F(a) &&
              ((t.result = p.apply(a, n)),
              !1 === t.result && t.preventDefault());
        return (
          (t.type = v),
          o ||
            t.isDefaultPrevented() ||
            (h._default && !1 !== h._default.apply(g.pop(), n)) ||
            !F(i) ||
            (f &&
              d.isFunction(i[v]) &&
              !d.isWindow(i) &&
              ((u = i[f]) && (i[f] = null),
              (d.event.triggered = v),
              i[v](),
              (d.event.triggered = void 0),
              u && (i[f] = u))),
          t.result
        );
      }
    },
    simulate: function (e, t, n) {
      var r = d.extend(new d.Event(), n, { type: e, isSimulated: !0 });
      d.event.trigger(r, null, t), r.isDefaultPrevented() && n.preventDefault();
    },
  }),
    d.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          d.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        return n ? d.event.trigger(e, t, n, !0) : void 0;
      },
    }),
    d.each(
      "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
        " "
      ),
      function (e, t) {
        d.fn[t] = function (e, n) {
          return arguments.length > 0
            ? this.on(t, null, e, n)
            : this.trigger(t);
        };
      }
    ),
    d.fn.extend({
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      },
    }),
    (f.focusin = "onfocusin" in e),
    f.focusin ||
      d.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
        var n = function (e) {
          d.event.simulate(t, e.target, d.event.fix(e));
        };
        d.event.special[t] = {
          setup: function () {
            var r = this.ownerDocument || this,
              i = R.access(r, t);
            i || r.addEventListener(e, n, !0), R.access(r, t, (i || 0) + 1);
          },
          teardown: function () {
            var r = this.ownerDocument || this,
              i = R.access(r, t) - 1;
            i
              ? R.access(r, t, i)
              : (r.removeEventListener(e, n, !0), R.remove(r, t));
          },
        };
      });
  var lt = e.location,
    ct = d.now(),
    ft = /\?/;
  (d.parseJSON = function (e) {
    return JSON.parse(e + "");
  }),
    (d.parseXML = function (t) {
      var n;
      if (!t || "string" != typeof t) return null;
      try {
        n = new e.DOMParser().parseFromString(t, "text/xml");
      } catch (e) {
        n = void 0;
      }
      return (
        (n && !n.getElementsByTagName("parsererror").length) ||
          d.error("Invalid XML: " + t),
        n
      );
    });
  var pt = /#.*$/,
    dt = /([?&])_=[^&]*/,
    ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    gt = /^(?:GET|HEAD)$/,
    vt = /^\/\//,
    mt = {},
    yt = {},
    xt = "*/".concat("*"),
    bt = r.createElement("a");
  function wt(e) {
    return function (t, n) {
      "string" != typeof t && ((n = t), (t = "*"));
      var r,
        i = 0,
        o = t.toLowerCase().match(L) || [];
      if (d.isFunction(n))
        for (; (r = o[i++]); )
          "+" === r[0]
            ? ((r = r.slice(1) || "*"), (e[r] = e[r] || []).unshift(n))
            : (e[r] = e[r] || []).push(n);
    };
  }
  function Tt(e, t, n, r) {
    var i = {},
      o = e === yt;
    function s(a) {
      var u;
      return (
        (i[a] = !0),
        d.each(e[a] || [], function (e, a) {
          var l = a(t, n, r);
          return "string" != typeof l || o || i[l]
            ? o
              ? !(u = l)
              : void 0
            : (t.dataTypes.unshift(l), s(l), !1);
        }),
        u
      );
    }
    return s(t.dataTypes[0]) || (!i["*"] && s("*"));
  }
  function Ct(e, t) {
    var n,
      r,
      i = d.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    return r && d.extend(!0, e, r), e;
  }
  (bt.href = lt.href),
    d.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: lt.href,
        type: "GET",
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            lt.protocol
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": xt,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": d.parseJSON,
          "text xml": d.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e, t) {
        return t ? Ct(Ct(e, d.ajaxSettings), t) : Ct(d.ajaxSettings, e);
      },
      ajaxPrefilter: wt(mt),
      ajaxTransport: wt(yt),
      ajax: function (t, n) {
        "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
        var i,
          o,
          s,
          a,
          u,
          l,
          c,
          f,
          p = d.ajaxSetup({}, n),
          h = p.context || p,
          g = p.context && (h.nodeType || h.jquery) ? d(h) : d.event,
          v = d.Deferred(),
          m = d.Callbacks("once memory"),
          y = p.statusCode || {},
          x = {},
          b = {},
          w = 0,
          T = "canceled",
          C = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (2 === w) {
                if (!a)
                  for (a = {}; (t = ht.exec(s)); ) a[t[1].toLowerCase()] = t[2];
                t = a[e.toLowerCase()];
              }
              return null == t ? null : t;
            },
            getAllResponseHeaders: function () {
              return 2 === w ? s : null;
            },
            setRequestHeader: function (e, t) {
              var n = e.toLowerCase();
              return w || ((e = b[n] = b[n] || e), (x[e] = t)), this;
            },
            overrideMimeType: function (e) {
              return w || (p.mimeType = e), this;
            },
            statusCode: function (e) {
              var t;
              if (e)
                if (2 > w) for (t in e) y[t] = [y[t], e[t]];
                else C.always(e[C.status]);
              return this;
            },
            abort: function (e) {
              var t = e || T;
              return i && i.abort(t), k(0, t), this;
            },
          };
        if (
          ((v.promise(C).complete = m.add),
          (C.success = C.done),
          (C.error = C.fail),
          (p.url = ((t || p.url || lt.href) + "")
            .replace(pt, "")
            .replace(vt, lt.protocol + "//")),
          (p.type = n.method || n.type || p.method || p.type),
          (p.dataTypes = d
            .trim(p.dataType || "*")
            .toLowerCase()
            .match(L) || [""]),
          null == p.crossDomain)
        ) {
          l = r.createElement("a");
          try {
            (l.href = p.url),
              (l.href = l.href),
              (p.crossDomain =
                bt.protocol + "//" + bt.host != l.protocol + "//" + l.host);
          } catch (e) {
            p.crossDomain = !0;
          }
        }
        if (
          (p.data &&
            p.processData &&
            "string" != typeof p.data &&
            (p.data = d.param(p.data, p.traditional)),
          Tt(mt, p, n, C),
          2 === w)
        )
          return C;
        for (f in ((c = d.event && p.global) &&
          0 == d.active++ &&
          d.event.trigger("ajaxStart"),
        (p.type = p.type.toUpperCase()),
        (p.hasContent = !gt.test(p.type)),
        (o = p.url),
        p.hasContent ||
          (p.data &&
            ((o = p.url += (ft.test(o) ? "&" : "?") + p.data), delete p.data),
          !1 === p.cache &&
            (p.url = dt.test(o)
              ? o.replace(dt, "$1_=" + ct++)
              : o + (ft.test(o) ? "&" : "?") + "_=" + ct++)),
        p.ifModified &&
          (d.lastModified[o] &&
            C.setRequestHeader("If-Modified-Since", d.lastModified[o]),
          d.etag[o] && C.setRequestHeader("If-None-Match", d.etag[o])),
        ((p.data && p.hasContent && !1 !== p.contentType) || n.contentType) &&
          C.setRequestHeader("Content-Type", p.contentType),
        C.setRequestHeader(
          "Accept",
          p.dataTypes[0] && p.accepts[p.dataTypes[0]]
            ? p.accepts[p.dataTypes[0]] +
                ("*" !== p.dataTypes[0] ? ", " + xt + "; q=0.01" : "")
            : p.accepts["*"]
        ),
        p.headers))
          C.setRequestHeader(f, p.headers[f]);
        if (p.beforeSend && (!1 === p.beforeSend.call(h, C, p) || 2 === w))
          return C.abort();
        for (f in ((T = "abort"), { success: 1, error: 1, complete: 1 }))
          C[f](p[f]);
        if ((i = Tt(yt, p, n, C))) {
          if (((C.readyState = 1), c && g.trigger("ajaxSend", [C, p]), 2 === w))
            return C;
          p.async &&
            p.timeout > 0 &&
            (u = e.setTimeout(function () {
              C.abort("timeout");
            }, p.timeout));
          try {
            (w = 1), i.send(x, k);
          } catch (e) {
            if (!(2 > w)) throw e;
            k(-1, e);
          }
        } else k(-1, "No Transport");
        function k(t, n, r, a) {
          var l,
            f,
            x,
            b,
            T,
            k = n;
          2 !== w &&
            ((w = 2),
            u && e.clearTimeout(u),
            (i = void 0),
            (s = a || ""),
            (C.readyState = t > 0 ? 4 : 0),
            (l = (t >= 200 && 300 > t) || 304 === t),
            r &&
              (b = (function (e, t, n) {
                for (
                  var r, i, o, s, a = e.contents, u = e.dataTypes;
                  "*" === u[0];

                )
                  u.shift(),
                    void 0 === r &&
                      (r = e.mimeType || t.getResponseHeader("Content-Type"));
                if (r)
                  for (i in a)
                    if (a[i] && a[i].test(r)) {
                      u.unshift(i);
                      break;
                    }
                if (u[0] in n) o = u[0];
                else {
                  for (i in n) {
                    if (!u[0] || e.converters[i + " " + u[0]]) {
                      o = i;
                      break;
                    }
                    s || (s = i);
                  }
                  o = o || s;
                }
                return o ? (o !== u[0] && u.unshift(o), n[o]) : void 0;
              })(p, C, r)),
            (b = (function (e, t, n, r) {
              var i,
                o,
                s,
                a,
                u,
                l = {},
                c = e.dataTypes.slice();
              if (c[1])
                for (s in e.converters) l[s.toLowerCase()] = e.converters[s];
              for (o = c.shift(); o; )
                if (
                  (e.responseFields[o] && (n[e.responseFields[o]] = t),
                  !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (u = o),
                  (o = c.shift()))
                )
                  if ("*" === o) o = u;
                  else if ("*" !== u && u !== o) {
                    if (!(s = l[u + " " + o] || l["* " + o]))
                      for (i in l)
                        if (
                          (a = i.split(" "))[1] === o &&
                          (s = l[u + " " + a[0]] || l["* " + a[0]])
                        ) {
                          !0 === s
                            ? (s = l[i])
                            : !0 !== l[i] && ((o = a[0]), c.unshift(a[1]));
                          break;
                        }
                    if (!0 !== s)
                      if (s && e.throws) t = s(t);
                      else
                        try {
                          t = s(t);
                        } catch (e) {
                          return {
                            state: "parsererror",
                            error: s
                              ? e
                              : "No conversion from " + u + " to " + o,
                          };
                        }
                  }
              return { state: "success", data: t };
            })(p, b, C, l)),
            l
              ? (p.ifModified &&
                  ((T = C.getResponseHeader("Last-Modified")) &&
                    (d.lastModified[o] = T),
                  (T = C.getResponseHeader("etag")) && (d.etag[o] = T)),
                204 === t || "HEAD" === p.type
                  ? (k = "nocontent")
                  : 304 === t
                  ? (k = "notmodified")
                  : ((k = b.state), (f = b.data), (l = !(x = b.error))))
              : ((x = k), (!t && k) || ((k = "error"), 0 > t && (t = 0))),
            (C.status = t),
            (C.statusText = (n || k) + ""),
            l ? v.resolveWith(h, [f, k, C]) : v.rejectWith(h, [C, k, x]),
            C.statusCode(y),
            (y = void 0),
            c && g.trigger(l ? "ajaxSuccess" : "ajaxError", [C, p, l ? f : x]),
            m.fireWith(h, [C, k]),
            c &&
              (g.trigger("ajaxComplete", [C, p]),
              --d.active || d.event.trigger("ajaxStop")));
        }
        return C;
      },
      getJSON: function (e, t, n) {
        return d.get(e, t, n, "json");
      },
      getScript: function (e, t) {
        return d.get(e, void 0, t, "script");
      },
    }),
    d.each(["get", "post"], function (e, t) {
      d[t] = function (e, n, r, i) {
        return (
          d.isFunction(n) && ((i = i || r), (r = n), (n = void 0)),
          d.ajax(
            d.extend(
              { url: e, type: t, dataType: i, data: n, success: r },
              d.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    (d._evalUrl = function (e) {
      return d.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        async: !1,
        global: !1,
        throws: !0,
      });
    }),
    d.fn.extend({
      wrapAll: function (e) {
        var t;
        return d.isFunction(e)
          ? this.each(function (t) {
              d(this).wrapAll(e.call(this, t));
            })
          : (this[0] &&
              ((t = d(e, this[0].ownerDocument).eq(0).clone(!0)),
              this[0].parentNode && t.insertBefore(this[0]),
              t
                .map(function () {
                  for (var e = this; e.firstElementChild; )
                    e = e.firstElementChild;
                  return e;
                })
                .append(this)),
            this);
      },
      wrapInner: function (e) {
        return d.isFunction(e)
          ? this.each(function (t) {
              d(this).wrapInner(e.call(this, t));
            })
          : this.each(function () {
              var t = d(this),
                n = t.contents();
              n.length ? n.wrapAll(e) : t.append(e);
            });
      },
      wrap: function (e) {
        var t = d.isFunction(e);
        return this.each(function (n) {
          d(this).wrapAll(t ? e.call(this, n) : e);
        });
      },
      unwrap: function () {
        return this.parent()
          .each(function () {
            d.nodeName(this, "body") || d(this).replaceWith(this.childNodes);
          })
          .end();
      },
    }),
    (d.expr.filters.hidden = function (e) {
      return !d.expr.filters.visible(e);
    }),
    (d.expr.filters.visible = function (e) {
      return (
        e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0
      );
    });
  var kt = /%20/g,
    Et = /\[\]$/,
    Nt = /\r?\n/g,
    St = /^(?:submit|button|image|reset|file)$/i,
    Dt = /^(?:input|select|textarea|keygen)/i;
  function jt(e, t, n, r) {
    var i;
    if (d.isArray(t))
      d.each(t, function (t, i) {
        n || Et.test(e)
          ? r(e, i)
          : jt(
              e + "[" + ("object" == typeof i && null != i ? t : "") + "]",
              i,
              n,
              r
            );
      });
    else if (n || "object" !== d.type(t)) r(e, t);
    else for (i in t) jt(e + "[" + i + "]", t[i], n, r);
  }
  (d.param = function (e, t) {
    var n,
      r = [],
      i = function (e, t) {
        (t = d.isFunction(t) ? t() : null == t ? "" : t),
          (r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t));
      };
    if (
      (void 0 === t && (t = d.ajaxSettings && d.ajaxSettings.traditional),
      d.isArray(e) || (e.jquery && !d.isPlainObject(e)))
    )
      d.each(e, function () {
        i(this.name, this.value);
      });
    else for (n in e) jt(n, e[n], t, i);
    return r.join("&").replace(kt, "+");
  }),
    d.fn.extend({
      serialize: function () {
        return d.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = d.prop(this, "elements");
          return e ? d.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !d(this).is(":disabled") &&
              Dt.test(this.nodeName) &&
              !St.test(e) &&
              (this.checked || !V.test(e))
            );
          })
          .map(function (e, t) {
            var n = d(this).val();
            return null == n
              ? null
              : d.isArray(n)
              ? d.map(n, function (e) {
                  return { name: t.name, value: e.replace(Nt, "\r\n") };
                })
              : { name: t.name, value: n.replace(Nt, "\r\n") };
          })
          .get();
      },
    }),
    (d.ajaxSettings.xhr = function () {
      try {
        return new e.XMLHttpRequest();
      } catch (e) {}
    });
  var At = { 0: 200, 1223: 204 },
    qt = d.ajaxSettings.xhr();
  (f.cors = !!qt && "withCredentials" in qt),
    (f.ajax = qt = !!qt),
    d.ajaxTransport(function (t) {
      var n, r;
      return f.cors || (qt && !t.crossDomain)
        ? {
            send: function (i, o) {
              var s,
                a = t.xhr();
              if (
                (a.open(t.type, t.url, t.async, t.username, t.password),
                t.xhrFields)
              )
                for (s in t.xhrFields) a[s] = t.xhrFields[s];
              for (s in (t.mimeType &&
                a.overrideMimeType &&
                a.overrideMimeType(t.mimeType),
              t.crossDomain ||
                i["X-Requested-With"] ||
                (i["X-Requested-With"] = "XMLHttpRequest"),
              i))
                a.setRequestHeader(s, i[s]);
              (n = function (e) {
                return function () {
                  n &&
                    ((n =
                      r =
                      a.onload =
                      a.onerror =
                      a.onabort =
                      a.onreadystatechange =
                        null),
                    "abort" === e
                      ? a.abort()
                      : "error" === e
                      ? "number" != typeof a.status
                        ? o(0, "error")
                        : o(a.status, a.statusText)
                      : o(
                          At[a.status] || a.status,
                          a.statusText,
                          "text" !== (a.responseType || "text") ||
                            "string" != typeof a.responseText
                            ? { binary: a.response }
                            : { text: a.responseText },
                          a.getAllResponseHeaders()
                        ));
                };
              }),
                (a.onload = n()),
                (r = a.onerror = n("error")),
                void 0 !== a.onabort
                  ? (a.onabort = r)
                  : (a.onreadystatechange = function () {
                      4 === a.readyState &&
                        e.setTimeout(function () {
                          n && r();
                        });
                    }),
                (n = n("abort"));
              try {
                a.send((t.hasContent && t.data) || null);
              } catch (e) {
                if (n) throw e;
              }
            },
            abort: function () {
              n && n();
            },
          }
        : void 0;
    }),
    d.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (e) {
          return d.globalEval(e), e;
        },
      },
    }),
    d.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }),
    d.ajaxTransport("script", function (e) {
      var t, n;
      if (e.crossDomain)
        return {
          send: function (i, o) {
            (t = d("<script>")
              .prop({ charset: e.scriptCharset, src: e.url })
              .on(
                "load error",
                (n = function (e) {
                  t.remove(),
                    (n = null),
                    e && o("error" === e.type ? 404 : 200, e.type);
                })
              )),
              r.head.appendChild(t[0]);
          },
          abort: function () {
            n && n();
          },
        };
    });
  var Lt = [],
    Ht = /(=)\?(?=&|$)|\?\?/;
  d.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var e = Lt.pop() || d.expando + "_" + ct++;
      return (this[e] = !0), e;
    },
  }),
    d.ajaxPrefilter("json jsonp", function (t, n, r) {
      var i,
        o,
        s,
        a =
          !1 !== t.jsonp &&
          (Ht.test(t.url)
            ? "url"
            : "string" == typeof t.data &&
              0 ===
                (t.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              Ht.test(t.data) &&
              "data");
      return a || "jsonp" === t.dataTypes[0]
        ? ((i = t.jsonpCallback =
            d.isFunction(t.jsonpCallback)
              ? t.jsonpCallback()
              : t.jsonpCallback),
          a
            ? (t[a] = t[a].replace(Ht, "$1" + i))
            : !1 !== t.jsonp &&
              (t.url += (ft.test(t.url) ? "&" : "?") + t.jsonp + "=" + i),
          (t.converters["script json"] = function () {
            return s || d.error(i + " was not called"), s[0];
          }),
          (t.dataTypes[0] = "json"),
          (o = e[i]),
          (e[i] = function () {
            s = arguments;
          }),
          r.always(function () {
            void 0 === o ? d(e).removeProp(i) : (e[i] = o),
              t[i] && ((t.jsonpCallback = n.jsonpCallback), Lt.push(i)),
              s && d.isFunction(o) && o(s[0]),
              (s = o = void 0);
          }),
          "script")
        : void 0;
    }),
    (d.parseHTML = function (e, t, n) {
      if (!e || "string" != typeof e) return null;
      "boolean" == typeof t && ((n = t), (t = !1)), (t = t || r);
      var i = C.exec(e),
        o = !n && [];
      return i
        ? [t.createElement(i[1])]
        : ((i = ne([e], t, o)),
          o && o.length && d(o).remove(),
          d.merge([], i.childNodes));
    });
  var Ot = d.fn.load;
  function Ft(e) {
    return d.isWindow(e) ? e : 9 === e.nodeType && e.defaultView;
  }
  (d.fn.load = function (e, t, n) {
    if ("string" != typeof e && Ot) return Ot.apply(this, arguments);
    var r,
      i,
      o,
      s = this,
      a = e.indexOf(" ");
    return (
      a > -1 && ((r = d.trim(e.slice(a))), (e = e.slice(0, a))),
      d.isFunction(t)
        ? ((n = t), (t = void 0))
        : t && "object" == typeof t && (i = "POST"),
      s.length > 0 &&
        d
          .ajax({ url: e, type: i || "GET", dataType: "html", data: t })
          .done(function (e) {
            (o = arguments),
              s.html(r ? d("<div>").append(d.parseHTML(e)).find(r) : e);
          })
          .always(
            n &&
              function (e, t) {
                s.each(function () {
                  n.apply(this, o || [e.responseText, t, e]);
                });
              }
          ),
      this
    );
  }),
    d.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (e, t) {
        d.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    (d.expr.filters.animated = function (e) {
      return d.grep(d.timers, function (t) {
        return e === t.elem;
      }).length;
    }),
    (d.offset = {
      setOffset: function (e, t, n) {
        var r,
          i,
          o,
          s,
          a,
          u,
          l = d.css(e, "position"),
          c = d(e),
          f = {};
        "static" === l && (e.style.position = "relative"),
          (a = c.offset()),
          (o = d.css(e, "top")),
          (u = d.css(e, "left")),
          ("absolute" === l || "fixed" === l) && (o + u).indexOf("auto") > -1
            ? ((s = (r = c.position()).top), (i = r.left))
            : ((s = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          d.isFunction(t) && (t = t.call(e, n, d.extend({}, a))),
          null != t.top && (f.top = t.top - a.top + s),
          null != t.left && (f.left = t.left - a.left + i),
          "using" in t ? t.using.call(e, f) : c.css(f);
      },
    }),
    d.fn.extend({
      offset: function (e) {
        if (arguments.length)
          return void 0 === e
            ? this
            : this.each(function (t) {
                d.offset.setOffset(this, e, t);
              });
        var t,
          n,
          r = this[0],
          i = { top: 0, left: 0 },
          o = r && r.ownerDocument;
        return o
          ? ((t = o.documentElement),
            d.contains(t, r)
              ? ((i = r.getBoundingClientRect()),
                (n = Ft(o)),
                {
                  top: i.top + n.pageYOffset - t.clientTop,
                  left: i.left + n.pageXOffset - t.clientLeft,
                })
              : i)
          : void 0;
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n = this[0],
            r = { top: 0, left: 0 };
          return (
            "fixed" === d.css(n, "position")
              ? (t = n.getBoundingClientRect())
              : ((e = this.offsetParent()),
                (t = this.offset()),
                d.nodeName(e[0], "html") || (r = e.offset()),
                (r.top += d.css(e[0], "borderTopWidth", !0)),
                (r.left += d.css(e[0], "borderLeftWidth", !0))),
            {
              top: t.top - r.top - d.css(n, "marginTop", !0),
              left: t.left - r.left - d.css(n, "marginLeft", !0),
            }
          );
        }
      },
      offsetParent: function () {
        return this.map(function () {
          for (
            var e = this.offsetParent;
            e && "static" === d.css(e, "position");

          )
            e = e.offsetParent;
          return e || je;
        });
      },
    }),
    d.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (e, t) {
        var n = "pageYOffset" === t;
        d.fn[e] = function (r) {
          return O(
            this,
            function (e, r, i) {
              var o = Ft(e);
              return void 0 === i
                ? o
                  ? o[t]
                  : e[r]
                : void (o
                    ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset)
                    : (e[r] = i));
            },
            e,
            r,
            arguments.length
          );
        };
      }
    ),
    d.each(["top", "left"], function (e, t) {
      d.cssHooks[t] = qe(f.pixelPosition, function (e, n) {
        return n
          ? ((n = Ae(e, t)), Ne.test(n) ? d(e).position()[t] + "px" : n)
          : void 0;
      });
    }),
    d.each({ Height: "height", Width: "width" }, function (e, t) {
      d.each(
        { padding: "inner" + e, content: t, "": "outer" + e },
        function (n, r) {
          d.fn[r] = function (r, i) {
            var o = arguments.length && (n || "boolean" != typeof r),
              s = n || (!0 === r || !0 === i ? "margin" : "border");
            return O(
              this,
              function (t, n, r) {
                var i;
                return d.isWindow(t)
                  ? t.document.documentElement["client" + e]
                  : 9 === t.nodeType
                  ? ((i = t.documentElement),
                    Math.max(
                      t.body["scroll" + e],
                      i["scroll" + e],
                      t.body["offset" + e],
                      i["offset" + e],
                      i["client" + e]
                    ))
                  : void 0 === r
                  ? d.css(t, n, s)
                  : d.style(t, n, r, s);
              },
              t,
              o ? r : void 0,
              o,
              null
            );
          };
        }
      );
    }),
    d.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length
          ? this.off(e, "**")
          : this.off(t, e || "**", n);
      },
      size: function () {
        return this.length;
      },
    }),
    (d.fn.andSelf = d.fn.addBack),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return d;
      });
  var Pt = e.jQuery,
    Rt = e.$;
  return (
    (d.noConflict = function (t) {
      return e.$ === d && (e.$ = Rt), t && e.jQuery === d && (e.jQuery = Pt), d;
    }),
    t || (e.jQuery = e.$ = d),
    d
  );
});
/*! Zoom 1.7.21 */
!(function (o) {
  var t = {
    url: !1,
    callback: !1,
    target: !1,
    duration: 120,
    on: "mouseover",
    touch: !0,
    onZoomIn: !1,
    onZoomOut: !1,
    magnify: 1,
  };
  (o.zoom = function (t, n, e, i) {
    var u,
      c,
      a,
      r,
      m,
      l,
      s,
      f = o(t),
      h = f.css("position"),
      d = o(n);
    return (
      (t.style.position = /(absolute|fixed)/.test(h) ? h : "relative"),
      (t.style.overflow = "hidden"),
      (e.style.width = e.style.height = ""),
      o(e)
        .addClass("zoomImg")
        .css({
          position: "absolute",
          top: 0,
          left: 0,
          opacity: 0,
          width: e.width * i,
          height: e.height * i,
          border: "none",
          maxWidth: "none",
          maxHeight: "none",
        })
        .appendTo(t),
      {
        init: function () {
          (c = f.outerWidth()),
            (u = f.outerHeight()),
            n === t
              ? ((r = c), (a = u))
              : ((r = d.outerWidth()), (a = d.outerHeight())),
            (m = (e.width - c) / r),
            (l = (e.height - u) / a),
            (s = d.offset());
        },
        move: function (o) {
          var t = o.pageX - s.left,
            n = o.pageY - s.top;
          (n = Math.max(Math.min(n, a), 0)),
            (t = Math.max(Math.min(t, r), 0)),
            (e.style.left = t * -m + "px"),
            (e.style.top = n * -l + "px");
        },
      }
    );
  }),
    (o.fn.zoom = function (n) {
      return this.each(function () {
        var e = o.extend({}, t, n || {}),
          i = (e.target && o(e.target)[0]) || this,
          u = this,
          c = o(u),
          a = document.createElement("img"),
          r = o(a),
          m = "mousemove.zoom",
          l = !1,
          s = !1;
        if (!e.url) {
          var f = u.querySelector("img");
          if (
            (f && (e.url = f.getAttribute("data-src") || f.currentSrc || f.src),
            !e.url)
          )
            return;
        }
        c.one(
          "zoom.destroy",
          function (o, t) {
            c.off(".zoom"),
              (i.style.position = o),
              (i.style.overflow = t),
              (a.onload = null),
              r.remove();
          }.bind(this, i.style.position, i.style.overflow)
        ),
          (a.onload = function () {
            function t(t) {
              f.init(),
                f.move(t),
                r
                  .stop()
                  .fadeTo(
                    o.support.opacity ? e.duration : 0,
                    1,
                    !!o.isFunction(e.onZoomIn) && e.onZoomIn.call(a)
                  );
            }
            function n() {
              r.stop().fadeTo(
                e.duration,
                0,
                !!o.isFunction(e.onZoomOut) && e.onZoomOut.call(a)
              );
            }
            var f = o.zoom(i, u, a, e.magnify);
            "grab" === e.on
              ? c.on("mousedown.zoom", function (e) {
                  1 === e.which &&
                    (o(document).one("mouseup.zoom", function () {
                      n(), o(document).off(m, f.move);
                    }),
                    t(e),
                    o(document).on(m, f.move),
                    e.preventDefault());
                })
              : "click" === e.on
              ? c.on("click.zoom", function (e) {
                  return l
                    ? void 0
                    : ((l = !0),
                      t(e),
                      o(document).on(m, f.move),
                      o(document).one("click.zoom", function () {
                        n(), (l = !1), o(document).off(m, f.move);
                      }),
                      !1);
                })
              : "toggle" === e.on
              ? c.on("click.zoom", function (o) {
                  l ? n() : t(o), (l = !l);
                })
              : "mouseover" === e.on &&
                (f.init(),
                c
                  .on("mouseenter.zoom", t)
                  .on("mouseleave.zoom", n)
                  .on(m, f.move)),
              e.touch &&
                c
                  .on("touchstart.zoom", function (o) {
                    o.preventDefault(),
                      s
                        ? ((s = !1), n())
                        : ((s = !0),
                          t(
                            o.originalEvent.touches[0] ||
                              o.originalEvent.changedTouches[0]
                          ));
                  })
                  .on("touchmove.zoom", function (o) {
                    o.preventDefault(),
                      f.move(
                        o.originalEvent.touches[0] ||
                          o.originalEvent.changedTouches[0]
                      );
                  })
                  .on("touchend.zoom", function (o) {
                    o.preventDefault(), s && ((s = !1), n());
                  }),
              o.isFunction(e.callback) && e.callback.call(a);
          }),
          a.setAttribute("role", "presentation"),
          (a.alt = ""),
          (a.src = e.url);
      });
    }),
    (o.fn.zoom.defaults = t);
})(window.jQuery);
/*! mobile-sniff.min.js */
window.mobileCheck = function () {
  var i,
    a = !1;
  return (
    (i = navigator.userAgent || navigator.vendor || window.opera),
    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      i
    ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        i.substr(0, 4)
      )) &&
      (a = !0),
    a
  );
};
/*! modernizr 3.3.1 */
!(function (e, n, t) {
  function s(e, n) {
    return typeof e === n;
  }
  function r() {
    return "function" != typeof n.createElement
      ? n.createElement(arguments[0])
      : v
      ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0])
      : n.createElement.apply(n, arguments);
  }
  function o(e, n) {
    return function () {
      return e.apply(n, arguments);
    };
  }
  function i(e) {
    return e
      .replace(/([A-Z])/g, function (e, n) {
        return "-" + n.toLowerCase();
      })
      .replace(/^ms-/, "-ms-");
  }
  function a(e, t, s, o) {
    var i,
      a,
      l,
      f,
      u,
      d = "modernizr",
      p = r("div"),
      c = ((u = n.body) || ((u = r(v ? "svg" : "body")).fake = !0), u);
    if (parseInt(s, 10))
      for (; s--; )
        ((l = r("div")).id = o ? o[s] : d + (s + 1)), p.appendChild(l);
    return (
      ((i = r("style")).type = "text/css"),
      (i.id = "s" + d),
      (c.fake ? c : p).appendChild(i),
      c.appendChild(p),
      i.styleSheet
        ? (i.styleSheet.cssText = e)
        : i.appendChild(n.createTextNode(e)),
      (p.id = d),
      c.fake &&
        ((c.style.background = ""),
        (c.style.overflow = "hidden"),
        (f = h.style.overflow),
        (h.style.overflow = "hidden"),
        h.appendChild(c)),
      (a = t(p, e)),
      c.fake
        ? (c.parentNode.removeChild(c), (h.style.overflow = f), h.offsetHeight)
        : p.parentNode.removeChild(p),
      !!a
    );
  }
  function l(n, o, l, f) {
    function u() {
      p && (delete x.style, delete x.modElem);
    }
    if (((f = !s(f, "undefined") && f), !s(l, "undefined"))) {
      var d = (function (n, s) {
        var r = n.length;
        if ("CSS" in e && "supports" in e.CSS) {
          for (; r--; ) if (e.CSS.supports(i(n[r]), s)) return !0;
          return !1;
        }
        if ("CSSSupportsRule" in e) {
          for (var o = []; r--; ) o.push("(" + i(n[r]) + ":" + s + ")");
          return a(
            "@supports (" +
              (o = o.join(" or ")) +
              ") { #modernizr { position: absolute; } }",
            function (e) {
              return "absolute" == getComputedStyle(e, null).position;
            }
          );
        }
        return t;
      })(n, l);
      if (!s(d, "undefined")) return d;
    }
    for (
      var p, c, m, h, v, y = ["modernizr", "tspan", "samp"];
      !x.style && y.length;

    )
      (p = !0), (x.modElem = r(y.shift())), (x.style = x.modElem.style);
    for (m = n.length, c = 0; m > c; c++)
      if (
        ((h = n[c]),
        (v = x.style[h]),
        !!~("" + h).indexOf("-") &&
          (h = h
            .replace(/([a-z])-([a-z])/g, function (e, n, t) {
              return n + t.toUpperCase();
            })
            .replace(/^-/, "")),
        x.style[h] !== t)
      ) {
        if (f || s(l, "undefined")) return u(), "pfx" != o || h;
        try {
          x.style[h] = l;
        } catch (n) {}
        if (x.style[h] != v) return u(), "pfx" != o || h;
      }
    return u(), !1;
  }
  function f(e, n, t, r, i) {
    var a = e.charAt(0).toUpperCase() + e.slice(1),
      f = (e + " " + g.join(a + " ") + a).split(" ");
    return s(n, "string") || s(n, "undefined")
      ? l(f, n, r, i)
      : (function (e, n, t) {
          var r;
          for (var i in e)
            if (e[i] in n)
              return !1 === t
                ? e[i]
                : s((r = n[e[i]]), "function")
                ? o(r, t || n)
                : r;
          return !1;
        })((f = (e + " " + w.join(a + " ") + a).split(" ")), n, t);
  }
  function u(e, n, s) {
    return f(e, t, t, n, s);
  }
  var d = [],
    p = [],
    c = {
      _version: "3.3.1",
      _config: {
        classPrefix: "",
        enableClasses: !0,
        enableJSClass: !0,
        usePrefixes: !0,
      },
      _q: [],
      on: function (e, n) {
        var t = this;
        setTimeout(function () {
          n(t[e]);
        }, 0);
      },
      addTest: function (e, n, t) {
        p.push({ name: e, fn: n, options: t });
      },
      addAsyncTest: function (e) {
        p.push({ name: null, fn: e });
      },
    },
    m = function () {};
  (m.prototype = c),
    (m = new m()).addTest(
      "svg",
      !!n.createElementNS &&
        !!n.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect
    );
  var h = n.documentElement,
    v = "svg" === h.nodeName.toLowerCase(),
    y = "Moz O ms Webkit",
    g = c._config.usePrefixes ? y.split(" ") : [];
  c._cssomPrefixes = g;
  var w = c._config.usePrefixes ? y.toLowerCase().split(" ") : [];
  c._domPrefixes = w;
  var C = { elem: r("modernizr") };
  m._q.push(function () {
    delete C.elem;
  });
  var x = { style: C.elem.style };
  m._q.unshift(function () {
    delete x.style;
  }),
    (c.testAllProps = f),
    (c.testAllProps = u),
    m.addTest("flexbox", u("flexBasis", "1px", !0)),
    m.addTest("csstransforms", function () {
      return (
        -1 === navigator.userAgent.indexOf("Android 2.") &&
        u("transform", "scale(1)", !0)
      );
    }),
    (function () {
      var e, n, t, r, o, i;
      for (var a in p)
        if (p.hasOwnProperty(a)) {
          if (
            ((e = []),
            (n = p[a]).name &&
              (e.push(n.name.toLowerCase()),
              n.options && n.options.aliases && n.options.aliases.length))
          )
            for (t = 0; t < n.options.aliases.length; t++)
              e.push(n.options.aliases[t].toLowerCase());
          for (
            r = s(n.fn, "function") ? n.fn() : n.fn, o = 0;
            o < e.length;
            o++
          )
            1 === (i = e[o].split(".")).length
              ? (m[i[0]] = r)
              : (!m[i[0]] ||
                  m[i[0]] instanceof Boolean ||
                  (m[i[0]] = new Boolean(m[i[0]])),
                (m[i[0]][i[1]] = r)),
              d.push((r ? "" : "no-") + i.join("-"));
        }
    })(),
    (function (e) {
      var n = h.className,
        t = m._config.classPrefix || "";
      if ((v && (n = n.baseVal), m._config.enableJSClass)) {
        var s = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
        n = n.replace(s, "$1" + t + "js$2");
      }
      m._config.enableClasses &&
        ((n += " " + t + e.join(" " + t)),
        v ? (h.className.baseVal = n) : (h.className = n));
    })(d),
    delete c.addTest,
    delete c.addAsyncTest;
  for (var S = 0; S < m._q.length; S++) m._q[S]();
  e.Modernizr = m;
})(window, document);
/*! prepare-transition.min.js */
!(function (n) {
  n.fn.prepareTransition = function () {
    return this.each(function () {
      var i = n(this);
      i.one(
        "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
        function () {
          i.removeClass("is-transitioning");
        }
      );
      var t = 0;
      n.each(
        [
          "transition-duration",
          "-moz-transition-duration",
          "-webkit-transition-duration",
          "-o-transition-duration",
        ],
        function (n, o) {
          t || (t = parseFloat(i.css(o)));
        }
      ),
        0 != t && (i.addClass("is-transitioning"), i[0].offsetWidth);
    });
  };
})(jQuery);
/*! slick.min.js */
!(function (i) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], i)
    : "undefined" != typeof exports
    ? (module.exports = i(require("jquery")))
    : i(jQuery);
})(function (i) {
  "use strict";
  var e = window.Slick || {};
  ((e = (function () {
    var e = 0;
    return function (t, o) {
      var s,
        n = this;
      (n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(t),
        appendDots: i(t),
        arrows: !0,
        asNavFor: null,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function (e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3,
      }),
        (n.initials = {
          animating: !1,
          dragging: !1,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          scrolling: !1,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: !1,
          slideOffset: 0,
          swipeLeft: null,
          swiping: !1,
          $list: null,
          touchObject: {},
          transformsEnabled: !1,
          unslicked: !1,
        }),
        i.extend(n, n.initials),
        (n.activeBreakpoint = null),
        (n.animType = null),
        (n.animProp = null),
        (n.breakpoints = []),
        (n.breakpointSettings = []),
        (n.cssTransitions = !1),
        (n.focussed = !1),
        (n.interrupted = !1),
        (n.hidden = "hidden"),
        (n.paused = !0),
        (n.positionProp = null),
        (n.respondTo = null),
        (n.rowCount = 1),
        (n.shouldClick = !0),
        (n.$slider = i(t)),
        (n.$slidesCache = null),
        (n.transformType = null),
        (n.transitionType = null),
        (n.visibilityChange = "visibilitychange"),
        (n.windowWidth = 0),
        (n.windowTimer = null),
        (s = i(t).data("slick") || {}),
        (n.options = i.extend({}, n.defaults, o, s)),
        (n.currentSlide = n.options.initialSlide),
        (n.originalSettings = n.options),
        void 0 !== document.mozHidden
          ? ((n.hidden = "mozHidden"),
            (n.visibilityChange = "mozvisibilitychange"))
          : void 0 !== document.webkitHidden &&
            ((n.hidden = "webkitHidden"),
            (n.visibilityChange = "webkitvisibilitychange")),
        (n.autoPlay = i.proxy(n.autoPlay, n)),
        (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
        (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
        (n.changeSlide = i.proxy(n.changeSlide, n)),
        (n.clickHandler = i.proxy(n.clickHandler, n)),
        (n.selectHandler = i.proxy(n.selectHandler, n)),
        (n.setPosition = i.proxy(n.setPosition, n)),
        (n.swipeHandler = i.proxy(n.swipeHandler, n)),
        (n.dragHandler = i.proxy(n.dragHandler, n)),
        (n.keyHandler = i.proxy(n.keyHandler, n)),
        (n.instanceUid = e++),
        (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
        n.registerBreakpoints(),
        n.init(!0);
    };
  })()).prototype.activateADA = function () {
    this.$slideTrack
      .find(".slick-active")
      .attr({ "aria-hidden": "false" })
      .find("a, input, button, select")
      .attr({ tabindex: "0" });
  }),
    (e.prototype.addSlide = e.prototype.slickAdd =
      function (e, t, o) {
        var s = this;
        if ("boolean" == typeof t) (o = t), (t = null);
        else if (t < 0 || t >= s.slideCount) return !1;
        s.unload(),
          "number" == typeof t
            ? 0 === t && 0 === s.$slides.length
              ? i(e).appendTo(s.$slideTrack)
              : o
              ? i(e).insertBefore(s.$slides.eq(t))
              : i(e).insertAfter(s.$slides.eq(t))
            : !0 === o
            ? i(e).prependTo(s.$slideTrack)
            : i(e).appendTo(s.$slideTrack),
          (s.$slides = s.$slideTrack.children(this.options.slide)),
          s.$slideTrack.children(this.options.slide).detach(),
          s.$slideTrack.append(s.$slides),
          s.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e);
          }),
          (s.$slidesCache = s.$slides),
          s.reinit();
      }),
    (e.prototype.animateHeight = function () {
      var i = this;
      if (
        1 === i.options.slidesToShow &&
        !0 === i.options.adaptiveHeight &&
        !1 === i.options.vertical
      ) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
        i.$list.animate({ height: e }, i.options.speed);
      }
    }),
    (e.prototype.animateSlide = function (e, t) {
      var o = {},
        s = this;
      s.animateHeight(),
        !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
        !1 === s.transformsEnabled
          ? !1 === s.options.vertical
            ? s.$slideTrack.animate(
                { left: e },
                s.options.speed,
                s.options.easing,
                t
              )
            : s.$slideTrack.animate(
                { top: e },
                s.options.speed,
                s.options.easing,
                t
              )
          : !1 === s.cssTransitions
          ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
            i({ animStart: s.currentLeft }).animate(
              { animStart: e },
              {
                duration: s.options.speed,
                easing: s.options.easing,
                step: function (i) {
                  (i = Math.ceil(i)),
                    !1 === s.options.vertical
                      ? ((o[s.animType] = "translate(" + i + "px, 0px)"),
                        s.$slideTrack.css(o))
                      : ((o[s.animType] = "translate(0px," + i + "px)"),
                        s.$slideTrack.css(o));
                },
                complete: function () {
                  t && t.call();
                },
              }
            ))
          : (s.applyTransition(),
            (e = Math.ceil(e)),
            !1 === s.options.vertical
              ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)")
              : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
            s.$slideTrack.css(o),
            t &&
              setTimeout(function () {
                s.disableTransition(), t.call();
              }, s.options.speed));
    }),
    (e.prototype.getNavTarget = function () {
      var e = this.options.asNavFor;
      return e && null !== e && (e = i(e).not(this.$slider)), e;
    }),
    (e.prototype.asNavFor = function (e) {
      var t = this.getNavTarget();
      null !== t &&
        "object" == typeof t &&
        t.each(function () {
          var t = i(this).slick("getSlick");
          t.unslicked || t.slideHandler(e, !0);
        });
    }),
    (e.prototype.applyTransition = function (i) {
      var e = this,
        t = {};
      !1 === e.options.fade
        ? (t[e.transitionType] =
            e.transformType + " " + e.options.speed + "ms " + e.options.cssEase)
        : (t[e.transitionType] =
            "opacity " + e.options.speed + "ms " + e.options.cssEase),
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
    }),
    (e.prototype.autoPlay = function () {
      var i = this;
      i.autoPlayClear(),
        i.slideCount > i.options.slidesToShow &&
          (i.autoPlayTimer = setInterval(
            i.autoPlayIterator,
            i.options.autoplaySpeed
          ));
    }),
    (e.prototype.autoPlayClear = function () {
      this.autoPlayTimer && clearInterval(this.autoPlayTimer);
    }),
    (e.prototype.autoPlayIterator = function () {
      var i = this,
        e = i.currentSlide + i.options.slidesToScroll;
      i.paused ||
        i.interrupted ||
        i.focussed ||
        (!1 === i.options.infinite &&
          (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
            ? (i.direction = 0)
            : 0 === i.direction &&
              ((e = i.currentSlide - i.options.slidesToScroll),
              i.currentSlide - 1 == 0 && (i.direction = 1))),
        i.slideHandler(e));
    }),
    (e.prototype.buildArrows = function () {
      var e = this;
      !0 === e.options.arrows &&
        ((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")),
        (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
        e.slideCount > e.options.slidesToShow
          ? (e.$prevArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e.$nextArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e.htmlExpr.test(e.options.prevArrow) &&
              e.$prevArrow.prependTo(e.options.appendArrows),
            e.htmlExpr.test(e.options.nextArrow) &&
              e.$nextArrow.appendTo(e.options.appendArrows),
            !0 !== e.options.infinite &&
              e.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"))
          : e.$prevArrow
              .add(e.$nextArrow)
              .addClass("slick-hidden")
              .attr({ "aria-disabled": "true", tabindex: "-1" }));
    }),
    (e.prototype.buildDots = function () {
      var e,
        t,
        o = this;
      if (!0 === o.options.dots && o.slideCount > o.options.slidesToShow) {
        for (
          o.$slider.addClass("slick-dotted"),
            t = i("<ul />").addClass(o.options.dotsClass),
            e = 0;
          e <= o.getDotCount();
          e += 1
        )
          t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
        (o.$dots = t.appendTo(o.options.appendDots)),
          o.$dots.find("li").first().addClass("slick-active");
      }
    }),
    (e.prototype.buildOut = function () {
      var e = this;
      (e.$slides = e.$slider
        .children(e.options.slide + ":not(.slick-cloned)")
        .addClass("slick-slide")),
        (e.slideCount = e.$slides.length),
        e.$slides.each(function (e, t) {
          i(t)
            .attr("data-slick-index", e)
            .data("originalStyling", i(t).attr("style") || "");
        }),
        e.$slider.addClass("slick-slider"),
        (e.$slideTrack =
          0 === e.slideCount
            ? i('<div class="slick-track"/>').appendTo(e.$slider)
            : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
        (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
        e.$slideTrack.css("opacity", 0),
        (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
          (e.options.slidesToScroll = 1),
        i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
        e.setupInfinite(),
        e.buildArrows(),
        e.buildDots(),
        e.updateDots(),
        e.setSlideClasses(
          "number" == typeof e.currentSlide ? e.currentSlide : 0
        ),
        !0 === e.options.draggable && e.$list.addClass("draggable");
    }),
    (e.prototype.buildRows = function () {
      var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;
      if (
        ((o = document.createDocumentFragment()),
        (n = l.$slider.children()),
        l.options.rows > 0)
      ) {
        for (
          r = l.options.slidesPerRow * l.options.rows,
            s = Math.ceil(n.length / r),
            i = 0;
          i < s;
          i++
        ) {
          var d = document.createElement("div");
          for (e = 0; e < l.options.rows; e++) {
            var a = document.createElement("div");
            for (t = 0; t < l.options.slidesPerRow; t++) {
              var c = i * r + (e * l.options.slidesPerRow + t);
              n.get(c) && a.appendChild(n.get(c));
            }
            d.appendChild(a);
          }
          o.appendChild(d);
        }
        l.$slider.empty().append(o),
          l.$slider
            .children()
            .children()
            .children()
            .css({
              width: 100 / l.options.slidesPerRow + "%",
              display: "inline-block",
            });
      }
    }),
    (e.prototype.checkResponsive = function (e, t) {
      var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();
      if (
        ("window" === r.respondTo
          ? (n = a)
          : "slider" === r.respondTo
          ? (n = d)
          : "min" === r.respondTo && (n = Math.min(a, d)),
        r.options.responsive &&
          r.options.responsive.length &&
          null !== r.options.responsive)
      ) {
        for (o in ((s = null), r.breakpoints))
          r.breakpoints.hasOwnProperty(o) &&
            (!1 === r.originalSettings.mobileFirst
              ? n < r.breakpoints[o] && (s = r.breakpoints[o])
              : n > r.breakpoints[o] && (s = r.breakpoints[o]));
        null !== s
          ? null !== r.activeBreakpoint
            ? (s !== r.activeBreakpoint || t) &&
              ((r.activeBreakpoint = s),
              "unslick" === r.breakpointSettings[s]
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (l = s))
            : ((r.activeBreakpoint = s),
              "unslick" === r.breakpointSettings[s]
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (l = s))
          : null !== r.activeBreakpoint &&
            ((r.activeBreakpoint = null),
            (r.options = r.originalSettings),
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e),
            (l = s)),
          e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
      }
    }),
    (e.prototype.changeSlide = function (e, t) {
      var o,
        s,
        n = this,
        r = i(e.currentTarget);
      switch (
        (r.is("a") && e.preventDefault(),
        r.is("li") || (r = r.closest("li")),
        (o =
          n.slideCount % n.options.slidesToScroll != 0
            ? 0
            : (n.slideCount - n.currentSlide) % n.options.slidesToScroll),
        e.data.message)
      ) {
        case "previous":
          (s = 0 === o ? n.options.slidesToScroll : n.options.slidesToShow - o),
            n.slideCount > n.options.slidesToShow &&
              n.slideHandler(n.currentSlide - s, !1, t);
          break;
        case "next":
          (s = 0 === o ? n.options.slidesToScroll : o),
            n.slideCount > n.options.slidesToShow &&
              n.slideHandler(n.currentSlide + s, !1, t);
          break;
        case "index":
          var l =
            0 === e.data.index
              ? 0
              : e.data.index || r.index() * n.options.slidesToScroll;
          n.slideHandler(n.checkNavigable(l), !1, t),
            r.children().trigger("focus");
          break;
        default:
          return;
      }
    }),
    (e.prototype.checkNavigable = function (i) {
      var e, t;
      if (((t = 0), i > (e = this.getNavigableIndexes())[e.length - 1]))
        i = e[e.length - 1];
      else
        for (var o in e) {
          if (i < e[o]) {
            i = t;
            break;
          }
          t = e[o];
        }
      return i;
    }),
    (e.prototype.cleanUpEvents = function () {
      var e = this;
      e.options.dots &&
        null !== e.$dots &&
        (i("li", e.$dots)
          .off("click.slick", e.changeSlide)
          .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
          .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
        !0 === e.options.accessibility &&
          e.$dots.off("keydown.slick", e.keyHandler)),
        e.$slider.off("focus.slick blur.slick"),
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
          e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
          !0 === e.options.accessibility &&
            (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
            e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
        e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
        e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
        e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
        e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
        e.$list.off("click.slick", e.clickHandler),
        i(document).off(e.visibilityChange, e.visibility),
        e.cleanUpSlideEvents(),
        !0 === e.options.accessibility &&
          e.$list.off("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().off("click.slick", e.selectHandler),
        i(window).off(
          "orientationchange.slick.slick-" + e.instanceUid,
          e.orientationChange
        ),
        i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
        i("[draggable!=true]", e.$slideTrack).off(
          "dragstart",
          e.preventDefault
        ),
        i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
    }),
    (e.prototype.cleanUpSlideEvents = function () {
      var e = this;
      e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
    }),
    (e.prototype.cleanUpRows = function () {
      var i;
      this.options.rows > 0 &&
        ((i = this.$slides.children().children()).removeAttr("style"),
        this.$slider.empty().append(i));
    }),
    (e.prototype.clickHandler = function (i) {
      !1 === this.shouldClick &&
        (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
    }),
    (e.prototype.destroy = function (e) {
      var t = this;
      t.autoPlayClear(),
        (t.touchObject = {}),
        t.cleanUpEvents(),
        i(".slick-cloned", t.$slider).detach(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow &&
          t.$prevArrow.length &&
          (t.$prevArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
        t.$nextArrow &&
          t.$nextArrow.length &&
          (t.$nextArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
        t.$slides &&
          (t.$slides
            .removeClass(
              "slick-slide slick-active slick-center slick-visible slick-current"
            )
            .removeAttr("aria-hidden")
            .removeAttr("data-slick-index")
            .each(function () {
              i(this).attr("style", i(this).data("originalStyling"));
            }),
          t.$slideTrack.children(this.options.slide).detach(),
          t.$slideTrack.detach(),
          t.$list.detach(),
          t.$slider.append(t.$slides)),
        t.cleanUpRows(),
        t.$slider.removeClass("slick-slider"),
        t.$slider.removeClass("slick-initialized"),
        t.$slider.removeClass("slick-dotted"),
        (t.unslicked = !0),
        e || t.$slider.trigger("destroy", [t]);
    }),
    (e.prototype.disableTransition = function (i) {
      var e = {};
      (e[this.transitionType] = ""),
        !1 === this.options.fade
          ? this.$slideTrack.css(e)
          : this.$slides.eq(i).css(e);
    }),
    (e.prototype.fadeSlide = function (i, e) {
      var t = this;
      !1 === t.cssTransitions
        ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
          t.$slides
            .eq(i)
            .animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
        : (t.applyTransition(i),
          t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
          e &&
            setTimeout(function () {
              t.disableTransition(i), e.call();
            }, t.options.speed));
    }),
    (e.prototype.fadeSlideOut = function (i) {
      var e = this;
      !1 === e.cssTransitions
        ? e.$slides
            .eq(i)
            .animate(
              { opacity: 0, zIndex: e.options.zIndex - 2 },
              e.options.speed,
              e.options.easing
            )
        : (e.applyTransition(i),
          e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
    }),
    (e.prototype.filterSlides = e.prototype.slickFilter =
      function (i) {
        var e = this;
        null !== i &&
          ((e.$slidesCache = e.$slides),
          e.unload(),
          e.$slideTrack.children(this.options.slide).detach(),
          e.$slidesCache.filter(i).appendTo(e.$slideTrack),
          e.reinit());
      }),
    (e.prototype.focusHandler = function () {
      var e = this;
      e.$slider
        .off("focus.slick blur.slick")
        .on("focus.slick", "*", function (t) {
          var o = i(this);
          setTimeout(function () {
            e.options.pauseOnFocus &&
              o.is(":focus") &&
              ((e.focussed = !0), e.autoPlay());
          }, 0);
        })
        .on("blur.slick", "*", function (t) {
          i(this), e.options.pauseOnFocus && ((e.focussed = !1), e.autoPlay());
        });
    }),
    (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
      function () {
        return this.currentSlide;
      }),
    (e.prototype.getDotCount = function () {
      var i = this,
        e = 0,
        t = 0,
        o = 0;
      if (!0 === i.options.infinite)
        if (i.slideCount <= i.options.slidesToShow) ++o;
        else
          for (; e < i.slideCount; )
            ++o,
              (e = t + i.options.slidesToScroll),
              (t +=
                i.options.slidesToScroll <= i.options.slidesToShow
                  ? i.options.slidesToScroll
                  : i.options.slidesToShow);
      else if (!0 === i.options.centerMode) o = i.slideCount;
      else if (i.options.asNavFor)
        for (; e < i.slideCount; )
          ++o,
            (e = t + i.options.slidesToScroll),
            (t +=
              i.options.slidesToScroll <= i.options.slidesToShow
                ? i.options.slidesToScroll
                : i.options.slidesToShow);
      else
        o =
          1 +
          Math.ceil(
            (i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll
          );
      return o - 1;
    }),
    (e.prototype.getLeft = function (i) {
      var e,
        t,
        o,
        s,
        n = this,
        r = 0;
      return (
        (n.slideOffset = 0),
        (t = n.$slides.first().outerHeight(!0)),
        !0 === n.options.infinite
          ? (n.slideCount > n.options.slidesToShow &&
              ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
              (s = -1),
              !0 === n.options.vertical &&
                !0 === n.options.centerMode &&
                (2 === n.options.slidesToShow
                  ? (s = -1.5)
                  : 1 === n.options.slidesToShow && (s = -2)),
              (r = t * n.options.slidesToShow * s)),
            n.slideCount % n.options.slidesToScroll != 0 &&
              i + n.options.slidesToScroll > n.slideCount &&
              n.slideCount > n.options.slidesToShow &&
              (i > n.slideCount
                ? ((n.slideOffset =
                    (n.options.slidesToShow - (i - n.slideCount)) *
                    n.slideWidth *
                    -1),
                  (r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1))
                : ((n.slideOffset =
                    (n.slideCount % n.options.slidesToScroll) *
                    n.slideWidth *
                    -1),
                  (r = (n.slideCount % n.options.slidesToScroll) * t * -1))))
          : i + n.options.slidesToShow > n.slideCount &&
            ((n.slideOffset =
              (i + n.options.slidesToShow - n.slideCount) * n.slideWidth),
            (r = (i + n.options.slidesToShow - n.slideCount) * t)),
        n.slideCount <= n.options.slidesToShow &&
          ((n.slideOffset = 0), (r = 0)),
        !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
          ? (n.slideOffset =
              (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
              (n.slideWidth * n.slideCount) / 2)
          : !0 === n.options.centerMode && !0 === n.options.infinite
          ? (n.slideOffset +=
              n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
              n.slideWidth)
          : !0 === n.options.centerMode &&
            ((n.slideOffset = 0),
            (n.slideOffset +=
              n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
        (e =
          !1 === n.options.vertical
            ? i * n.slideWidth * -1 + n.slideOffset
            : i * t * -1 + r),
        !0 === n.options.variableWidth &&
          ((o =
            n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite
              ? n.$slideTrack.children(".slick-slide").eq(i)
              : n.$slideTrack
                  .children(".slick-slide")
                  .eq(i + n.options.slidesToShow)),
          (e =
            !0 === n.options.rtl
              ? o[0]
                ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                : 0
              : o[0]
              ? -1 * o[0].offsetLeft
              : 0),
          !0 === n.options.centerMode &&
            ((o =
              n.slideCount <= n.options.slidesToShow ||
              !1 === n.options.infinite
                ? n.$slideTrack.children(".slick-slide").eq(i)
                : n.$slideTrack
                    .children(".slick-slide")
                    .eq(i + n.options.slidesToShow + 1)),
            (e =
              !0 === n.options.rtl
                ? o[0]
                  ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                ? -1 * o[0].offsetLeft
                : 0),
            (e += (n.$list.width() - o.outerWidth()) / 2))),
        e
      );
    }),
    (e.prototype.getOption = e.prototype.slickGetOption =
      function (i) {
        return this.options[i];
      }),
    (e.prototype.getNavigableIndexes = function () {
      var i,
        e = this,
        t = 0,
        o = 0,
        s = [];
      for (
        !1 === e.options.infinite
          ? (i = e.slideCount)
          : ((t = -1 * e.options.slidesToScroll),
            (o = -1 * e.options.slidesToScroll),
            (i = 2 * e.slideCount));
        t < i;

      )
        s.push(t),
          (t = o + e.options.slidesToScroll),
          (o +=
            e.options.slidesToScroll <= e.options.slidesToShow
              ? e.options.slidesToScroll
              : e.options.slidesToShow);
      return s;
    }),
    (e.prototype.getSlick = function () {
      return this;
    }),
    (e.prototype.getSlideCount = function () {
      var e,
        t,
        o,
        s = this;
      return (
        (o = !0 === s.options.centerMode ? Math.floor(s.$list.width() / 2) : 0),
        (t = -1 * s.swipeLeft + o),
        !0 === s.options.swipeToSlide
          ? (s.$slideTrack.find(".slick-slide").each(function (o, n) {
              var r, l;
              if (
                ((r = i(n).outerWidth()),
                (l = n.offsetLeft),
                !0 !== s.options.centerMode && (l += r / 2),
                t < l + r)
              )
                return (e = n), !1;
            }),
            Math.abs(i(e).attr("data-slick-index") - s.currentSlide) || 1)
          : s.options.slidesToScroll
      );
    }),
    (e.prototype.goTo = e.prototype.slickGoTo =
      function (i, e) {
        this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
      }),
    (e.prototype.init = function (e) {
      var t = this;
      i(t.$slider).hasClass("slick-initialized") ||
        (i(t.$slider).addClass("slick-initialized"),
        t.buildRows(),
        t.buildOut(),
        t.setProps(),
        t.startLoad(),
        t.loadSlider(),
        t.initializeEvents(),
        t.updateArrows(),
        t.updateDots(),
        t.checkResponsive(!0),
        t.focusHandler()),
        e && t.$slider.trigger("init", [t]),
        !0 === t.options.accessibility && t.initADA(),
        t.options.autoplay && ((t.paused = !1), t.autoPlay());
    }),
    (e.prototype.initADA = function () {
      var e = this,
        t = Math.ceil(e.slideCount / e.options.slidesToShow),
        o = e.getNavigableIndexes().filter(function (i) {
          return i >= 0 && i < e.slideCount;
        });
      e.$slides
        .add(e.$slideTrack.find(".slick-cloned"))
        .attr({ "aria-hidden": "true", tabindex: "-1" })
        .find("a, input, button, select")
        .attr({ tabindex: "-1" }),
        null !== e.$dots &&
          (e.$slides
            .not(e.$slideTrack.find(".slick-cloned"))
            .each(function (t) {
              var s = o.indexOf(t);
              if (
                (i(this).attr({
                  role: "tabpanel",
                  id: "slick-slide" + e.instanceUid + t,
                  tabindex: -1,
                }),
                -1 !== s)
              ) {
                var n = "slick-slide-control" + e.instanceUid + s;
                i("#" + n).length && i(this).attr({ "aria-describedby": n });
              }
            }),
          e.$dots
            .attr("role", "tablist")
            .find("li")
            .each(function (s) {
              var n = o[s];
              i(this).attr({ role: "presentation" }),
                i(this)
                  .find("button")
                  .first()
                  .attr({
                    role: "tab",
                    id: "slick-slide-control" + e.instanceUid + s,
                    "aria-controls": "slick-slide" + e.instanceUid + n,
                    "aria-label": s + 1 + " of " + t,
                    "aria-selected": null,
                    tabindex: "-1",
                  });
            })
            .eq(e.currentSlide)
            .find("button")
            .attr({ "aria-selected": "true", tabindex: "0" })
            .end());
      for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++)
        e.options.focusOnChange
          ? e.$slides.eq(s).attr({ tabindex: "0" })
          : e.$slides.eq(s).removeAttr("tabindex");
      e.activateADA();
    }),
    (e.prototype.initArrowEvents = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow
          .off("click.slick")
          .on("click.slick", { message: "previous" }, i.changeSlide),
        i.$nextArrow
          .off("click.slick")
          .on("click.slick", { message: "next" }, i.changeSlide),
        !0 === i.options.accessibility &&
          (i.$prevArrow.on("keydown.slick", i.keyHandler),
          i.$nextArrow.on("keydown.slick", i.keyHandler)));
    }),
    (e.prototype.initDotEvents = function () {
      var e = this;
      !0 === e.options.dots &&
        e.slideCount > e.options.slidesToShow &&
        (i("li", e.$dots).on(
          "click.slick",
          { message: "index" },
          e.changeSlide
        ),
        !0 === e.options.accessibility &&
          e.$dots.on("keydown.slick", e.keyHandler)),
        !0 === e.options.dots &&
          !0 === e.options.pauseOnDotsHover &&
          e.slideCount > e.options.slidesToShow &&
          i("li", e.$dots)
            .on("mouseenter.slick", i.proxy(e.interrupt, e, !0))
            .on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
    }),
    (e.prototype.initSlideEvents = function () {
      var e = this;
      e.options.pauseOnHover &&
        (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
    }),
    (e.prototype.initializeEvents = function () {
      var e = this;
      e.initArrowEvents(),
        e.initDotEvents(),
        e.initSlideEvents(),
        e.$list.on(
          "touchstart.slick mousedown.slick",
          { action: "start" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchmove.slick mousemove.slick",
          { action: "move" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchend.slick mouseup.slick",
          { action: "end" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchcancel.slick mouseleave.slick",
          { action: "end" },
          e.swipeHandler
        ),
        e.$list.on("click.slick", e.clickHandler),
        i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
        !0 === e.options.accessibility &&
          e.$list.on("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        i(window).on(
          "orientationchange.slick.slick-" + e.instanceUid,
          i.proxy(e.orientationChange, e)
        ),
        i(window).on(
          "resize.slick.slick-" + e.instanceUid,
          i.proxy(e.resize, e)
        ),
        i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
        i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
        i(e.setPosition);
    }),
    (e.prototype.initUI = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow.show(), i.$nextArrow.show()),
        !0 === i.options.dots &&
          i.slideCount > i.options.slidesToShow &&
          i.$dots.show();
    }),
    (e.prototype.keyHandler = function (i) {
      var e = this;
      i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
        (37 === i.keyCode && !0 === e.options.accessibility
          ? e.changeSlide({
              data: { message: !0 === e.options.rtl ? "next" : "previous" },
            })
          : 39 === i.keyCode &&
            !0 === e.options.accessibility &&
            e.changeSlide({
              data: { message: !0 === e.options.rtl ? "previous" : "next" },
            }));
    }),
    (e.prototype.lazyLoad = function () {
      function e(e) {
        i("img[data-lazy]", e).each(function () {
          var e = i(this),
            t = i(this).attr("data-lazy"),
            o = i(this).attr("data-srcset"),
            s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
            r = document.createElement("img");
          (r.onload = function () {
            e.animate({ opacity: 0 }, 100, function () {
              o && (e.attr("srcset", o), s && e.attr("sizes", s)),
                e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                  e.removeAttr("data-lazy data-srcset data-sizes").removeClass(
                    "slick-loading"
                  );
                }),
                n.$slider.trigger("lazyLoaded", [n, e, t]);
            });
          }),
            (r.onerror = function () {
              e
                .removeAttr("data-lazy")
                .removeClass("slick-loading")
                .addClass("slick-lazyload-error"),
                n.$slider.trigger("lazyLoadError", [n, e, t]);
            }),
            (r.src = t);
        });
      }
      var t,
        o,
        s,
        n = this;
      if (
        (!0 === n.options.centerMode
          ? !0 === n.options.infinite
            ? (s =
                (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                n.options.slidesToShow +
                2)
            : ((o = Math.max(
                0,
                n.currentSlide - (n.options.slidesToShow / 2 + 1)
              )),
              (s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
          : ((o = n.options.infinite
              ? n.options.slidesToShow + n.currentSlide
              : n.currentSlide),
            (s = Math.ceil(o + n.options.slidesToShow)),
            !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)),
        (t = n.$slider.find(".slick-slide").slice(o, s)),
        "anticipated" === n.options.lazyLoad)
      )
        for (
          var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0;
          a < n.options.slidesToScroll;
          a++
        )
          r < 0 && (r = n.slideCount - 1),
            (t = (t = t.add(d.eq(r))).add(d.eq(l))),
            r--,
            l++;
      e(t),
        n.slideCount <= n.options.slidesToShow
          ? e(n.$slider.find(".slick-slide"))
          : n.currentSlide >= n.slideCount - n.options.slidesToShow
          ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow))
          : 0 === n.currentSlide &&
            e(
              n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow)
            );
    }),
    (e.prototype.loadSlider = function () {
      var i = this;
      i.setPosition(),
        i.$slideTrack.css({ opacity: 1 }),
        i.$slider.removeClass("slick-loading"),
        i.initUI(),
        "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
    }),
    (e.prototype.next = e.prototype.slickNext =
      function () {
        this.changeSlide({ data: { message: "next" } });
      }),
    (e.prototype.orientationChange = function () {
      this.checkResponsive(), this.setPosition();
    }),
    (e.prototype.pause = e.prototype.slickPause =
      function () {
        this.autoPlayClear(), (this.paused = !0);
      }),
    (e.prototype.play = e.prototype.slickPlay =
      function () {
        var i = this;
        i.autoPlay(),
          (i.options.autoplay = !0),
          (i.paused = !1),
          (i.focussed = !1),
          (i.interrupted = !1);
      }),
    (e.prototype.postSlide = function (e) {
      var t = this;
      !t.unslicked &&
        (t.$slider.trigger("afterChange", [t, e]),
        (t.animating = !1),
        t.slideCount > t.options.slidesToShow && t.setPosition(),
        (t.swipeLeft = null),
        t.options.autoplay && t.autoPlay(),
        !0 === t.options.accessibility &&
          (t.initADA(), t.options.focusOnChange)) &&
        i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus();
    }),
    (e.prototype.prev = e.prototype.slickPrev =
      function () {
        this.changeSlide({ data: { message: "previous" } });
      }),
    (e.prototype.preventDefault = function (i) {
      i.preventDefault();
    }),
    (e.prototype.progressiveLazyLoad = function (e) {
      e = e || 1;
      var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i("img[data-lazy]", l.$slider);
      d.length
        ? ((t = d.first()),
          (o = t.attr("data-lazy")),
          (s = t.attr("data-srcset")),
          (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
          ((r = document.createElement("img")).onload = function () {
            s && (t.attr("srcset", s), n && t.attr("sizes", n)),
              t
                .attr("src", o)
                .removeAttr("data-lazy data-srcset data-sizes")
                .removeClass("slick-loading"),
              !0 === l.options.adaptiveHeight && l.setPosition(),
              l.$slider.trigger("lazyLoaded", [l, t, o]),
              l.progressiveLazyLoad();
          }),
          (r.onerror = function () {
            e < 3
              ? setTimeout(function () {
                  l.progressiveLazyLoad(e + 1);
                }, 500)
              : (t
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                l.$slider.trigger("lazyLoadError", [l, t, o]),
                l.progressiveLazyLoad());
          }),
          (r.src = o))
        : l.$slider.trigger("allImagesLoaded", [l]);
    }),
    (e.prototype.refresh = function (e) {
      var t,
        o,
        s = this;
      (o = s.slideCount - s.options.slidesToShow),
        !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
        s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
        (t = s.currentSlide),
        s.destroy(!0),
        i.extend(s, s.initials, { currentSlide: t }),
        s.init(),
        e || s.changeSlide({ data: { message: "index", index: t } }, !1);
    }),
    (e.prototype.registerBreakpoints = function () {
      var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;
      if ("array" === i.type(n) && n.length) {
        for (e in ((s.respondTo = s.options.respondTo || "window"), n))
          if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
            for (t = n[e].breakpoint; o >= 0; )
              s.breakpoints[o] &&
                s.breakpoints[o] === t &&
                s.breakpoints.splice(o, 1),
                o--;
            s.breakpoints.push(t), (s.breakpointSettings[t] = n[e].settings);
          }
        s.breakpoints.sort(function (i, e) {
          return s.options.mobileFirst ? i - e : e - i;
        });
      }
    }),
    (e.prototype.reinit = function () {
      var e = this;
      (e.$slides = e.$slideTrack
        .children(e.options.slide)
        .addClass("slick-slide")),
        (e.slideCount = e.$slides.length),
        e.currentSlide >= e.slideCount &&
          0 !== e.currentSlide &&
          (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
        e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
        e.registerBreakpoints(),
        e.setProps(),
        e.setupInfinite(),
        e.buildArrows(),
        e.updateArrows(),
        e.initArrowEvents(),
        e.buildDots(),
        e.updateDots(),
        e.initDotEvents(),
        e.cleanUpSlideEvents(),
        e.initSlideEvents(),
        e.checkResponsive(!1, !0),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        e.setSlideClasses(
          "number" == typeof e.currentSlide ? e.currentSlide : 0
        ),
        e.setPosition(),
        e.focusHandler(),
        (e.paused = !e.options.autoplay),
        e.autoPlay(),
        e.$slider.trigger("reInit", [e]);
    }),
    (e.prototype.resize = function () {
      var e = this;
      i(window).width() !== e.windowWidth &&
        (clearTimeout(e.windowDelay),
        (e.windowDelay = window.setTimeout(function () {
          (e.windowWidth = i(window).width()),
            e.checkResponsive(),
            e.unslicked || e.setPosition();
        }, 50)));
    }),
    (e.prototype.removeSlide = e.prototype.slickRemove =
      function (i, e, t) {
        var o = this;
        return (
          "boolean" == typeof i
            ? (i = !0 === (e = i) ? 0 : o.slideCount - 1)
            : (i = !0 === e ? --i : i),
          !(o.slideCount < 1 || i < 0 || i > o.slideCount - 1) &&
            (o.unload(),
            !0 === t
              ? o.$slideTrack.children().remove()
              : o.$slideTrack.children(this.options.slide).eq(i).remove(),
            (o.$slides = o.$slideTrack.children(this.options.slide)),
            o.$slideTrack.children(this.options.slide).detach(),
            o.$slideTrack.append(o.$slides),
            (o.$slidesCache = o.$slides),
            void o.reinit())
        );
      }),
    (e.prototype.setCSS = function (i) {
      var e,
        t,
        o = this,
        s = {};
      !0 === o.options.rtl && (i = -i),
        (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
        (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
        (s[o.positionProp] = i),
        !1 === o.transformsEnabled
          ? o.$slideTrack.css(s)
          : ((s = {}),
            !1 === o.cssTransitions
              ? ((s[o.animType] = "translate(" + e + ", " + t + ")"),
                o.$slideTrack.css(s))
              : ((s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)"),
                o.$slideTrack.css(s)));
    }),
    (e.prototype.setDimensions = function () {
      var i = this;
      !1 === i.options.vertical
        ? !0 === i.options.centerMode &&
          i.$list.css({ padding: "0px " + i.options.centerPadding })
        : (i.$list.height(
            i.$slides.first().outerHeight(!0) * i.options.slidesToShow
          ),
          !0 === i.options.centerMode &&
            i.$list.css({ padding: i.options.centerPadding + " 0px" })),
        (i.listWidth = i.$list.width()),
        (i.listHeight = i.$list.height()),
        !1 === i.options.vertical && !1 === i.options.variableWidth
          ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)),
            i.$slideTrack.width(
              Math.ceil(
                i.slideWidth * i.$slideTrack.children(".slick-slide").length
              )
            ))
          : !0 === i.options.variableWidth
          ? i.$slideTrack.width(5e3 * i.slideCount)
          : ((i.slideWidth = Math.ceil(i.listWidth)),
            i.$slideTrack.height(
              Math.ceil(
                i.$slides.first().outerHeight(!0) *
                  i.$slideTrack.children(".slick-slide").length
              )
            ));
      var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
      !1 === i.options.variableWidth &&
        i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
    }),
    (e.prototype.setFade = function () {
      var e,
        t = this;
      t.$slides.each(function (o, s) {
        (e = t.slideWidth * o * -1),
          !0 === t.options.rtl
            ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              })
            : i(s).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              });
      }),
        t.$slides
          .eq(t.currentSlide)
          .css({ zIndex: t.options.zIndex - 1, opacity: 1 });
    }),
    (e.prototype.setHeight = function () {
      var i = this;
      if (
        1 === i.options.slidesToShow &&
        !0 === i.options.adaptiveHeight &&
        !1 === i.options.vertical
      ) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
        i.$list.css("height", e);
      }
    }),
    (e.prototype.setOption = e.prototype.slickSetOption =
      function () {
        var e,
          t,
          o,
          s,
          n,
          r = this,
          l = !1;
        if (
          ("object" === i.type(arguments[0])
            ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
            : "string" === i.type(arguments[0]) &&
              ((o = arguments[0]),
              (s = arguments[1]),
              (l = arguments[2]),
              "responsive" === arguments[0] && "array" === i.type(arguments[1])
                ? (n = "responsive")
                : void 0 !== arguments[1] && (n = "single")),
          "single" === n)
        )
          r.options[o] = s;
        else if ("multiple" === n)
          i.each(o, function (i, e) {
            r.options[i] = e;
          });
        else if ("responsive" === n)
          for (t in s)
            if ("array" !== i.type(r.options.responsive))
              r.options.responsive = [s[t]];
            else {
              for (e = r.options.responsive.length - 1; e >= 0; )
                r.options.responsive[e].breakpoint === s[t].breakpoint &&
                  r.options.responsive.splice(e, 1),
                  e--;
              r.options.responsive.push(s[t]);
            }
        l && (r.unload(), r.reinit());
      }),
    (e.prototype.setPosition = function () {
      var i = this;
      i.setDimensions(),
        i.setHeight(),
        !1 === i.options.fade
          ? i.setCSS(i.getLeft(i.currentSlide))
          : i.setFade(),
        i.$slider.trigger("setPosition", [i]);
    }),
    (e.prototype.setProps = function () {
      var i = this,
        e = document.body.style;
      (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
        "top" === i.positionProp
          ? i.$slider.addClass("slick-vertical")
          : i.$slider.removeClass("slick-vertical"),
        (void 0 === e.WebkitTransition &&
          void 0 === e.MozTransition &&
          void 0 === e.msTransition) ||
          (!0 === i.options.useCSS && (i.cssTransitions = !0)),
        i.options.fade &&
          ("number" == typeof i.options.zIndex
            ? i.options.zIndex < 3 && (i.options.zIndex = 3)
            : (i.options.zIndex = i.defaults.zIndex)),
        void 0 !== e.OTransform &&
          ((i.animType = "OTransform"),
          (i.transformType = "-o-transform"),
          (i.transitionType = "OTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.webkitPerspective &&
            (i.animType = !1)),
        void 0 !== e.MozTransform &&
          ((i.animType = "MozTransform"),
          (i.transformType = "-moz-transform"),
          (i.transitionType = "MozTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.MozPerspective &&
            (i.animType = !1)),
        void 0 !== e.webkitTransform &&
          ((i.animType = "webkitTransform"),
          (i.transformType = "-webkit-transform"),
          (i.transitionType = "webkitTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.webkitPerspective &&
            (i.animType = !1)),
        void 0 !== e.msTransform &&
          ((i.animType = "msTransform"),
          (i.transformType = "-ms-transform"),
          (i.transitionType = "msTransition"),
          void 0 === e.msTransform && (i.animType = !1)),
        void 0 !== e.transform &&
          !1 !== i.animType &&
          ((i.animType = "transform"),
          (i.transformType = "transform"),
          (i.transitionType = "transition")),
        (i.transformsEnabled =
          i.options.useTransform && null !== i.animType && !1 !== i.animType);
    }),
    (e.prototype.setSlideClasses = function (i) {
      var e,
        t,
        o,
        s,
        n = this;
      if (
        ((t = n.$slider
          .find(".slick-slide")
          .removeClass("slick-active slick-center slick-current")
          .attr("aria-hidden", "true")),
        n.$slides.eq(i).addClass("slick-current"),
        !0 === n.options.centerMode)
      ) {
        var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
        (e = Math.floor(n.options.slidesToShow / 2)),
          !0 === n.options.infinite &&
            (i >= e && i <= n.slideCount - 1 - e
              ? n.$slides
                  .slice(i - e + r, i + e + 1)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : ((o = n.options.slidesToShow + i),
                t
                  .slice(o - e + 1 + r, o + e + 2)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")),
            0 === i
              ? t
                  .eq(t.length - 1 - n.options.slidesToShow)
                  .addClass("slick-center")
              : i === n.slideCount - 1 &&
                t.eq(n.options.slidesToShow).addClass("slick-center")),
          n.$slides.eq(i).addClass("slick-center");
      } else
        i >= 0 && i <= n.slideCount - n.options.slidesToShow
          ? n.$slides
              .slice(i, i + n.options.slidesToShow)
              .addClass("slick-active")
              .attr("aria-hidden", "false")
          : t.length <= n.options.slidesToShow
          ? t.addClass("slick-active").attr("aria-hidden", "false")
          : ((s = n.slideCount % n.options.slidesToShow),
            (o = !0 === n.options.infinite ? n.options.slidesToShow + i : i),
            n.options.slidesToShow == n.options.slidesToScroll &&
            n.slideCount - i < n.options.slidesToShow
              ? t
                  .slice(o - (n.options.slidesToShow - s), o + s)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : t
                  .slice(o, o + n.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false"));
      ("ondemand" !== n.options.lazyLoad &&
        "anticipated" !== n.options.lazyLoad) ||
        n.lazyLoad();
    }),
    (e.prototype.setupInfinite = function () {
      var e,
        t,
        o,
        s = this;
      if (
        (!0 === s.options.fade && (s.options.centerMode = !1),
        !0 === s.options.infinite &&
          !1 === s.options.fade &&
          ((t = null), s.slideCount > s.options.slidesToShow))
      ) {
        for (
          o =
            !0 === s.options.centerMode
              ? s.options.slidesToShow + 1
              : s.options.slidesToShow,
            e = s.slideCount;
          e > s.slideCount - o;
          e -= 1
        )
          (t = e - 1),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t - s.slideCount)
              .prependTo(s.$slideTrack)
              .addClass("slick-cloned");
        for (e = 0; e < o + s.slideCount; e += 1)
          (t = e),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t + s.slideCount)
              .appendTo(s.$slideTrack)
              .addClass("slick-cloned");
        s.$slideTrack
          .find(".slick-cloned")
          .find("[id]")
          .each(function () {
            i(this).attr("id", "");
          });
      }
    }),
    (e.prototype.interrupt = function (i) {
      i || this.autoPlay(), (this.interrupted = i);
    }),
    (e.prototype.selectHandler = function (e) {
      var t = i(e.target).is(".slick-slide")
          ? i(e.target)
          : i(e.target).parents(".slick-slide"),
        o = parseInt(t.attr("data-slick-index"));
      return (
        o || (o = 0),
        this.slideCount <= this.options.slidesToShow
          ? void this.slideHandler(o, !1, !0)
          : void this.slideHandler(o)
      );
    }),
    (e.prototype.slideHandler = function (i, e, t) {
      var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
      if (
        ((e = e || !1),
        !(
          (!0 === a.animating && !0 === a.options.waitForAnimate) ||
          (!0 === a.options.fade && a.currentSlide === i)
        ))
      )
        return (
          !1 === e && a.asNavFor(i),
          (o = i),
          (d = a.getLeft(o)),
          (r = a.getLeft(a.currentSlide)),
          (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
          !1 === a.options.infinite &&
          !1 === a.options.centerMode &&
          (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)
            ? void (
                !1 === a.options.fade &&
                ((o = a.currentSlide),
                !0 !== t && a.slideCount > a.options.slidesToShow
                  ? a.animateSlide(r, function () {
                      a.postSlide(o);
                    })
                  : a.postSlide(o))
              )
            : !1 === a.options.infinite &&
              !0 === a.options.centerMode &&
              (i < 0 || i > a.slideCount - a.options.slidesToScroll)
            ? void (
                !1 === a.options.fade &&
                ((o = a.currentSlide),
                !0 !== t && a.slideCount > a.options.slidesToShow
                  ? a.animateSlide(r, function () {
                      a.postSlide(o);
                    })
                  : a.postSlide(o))
              )
            : (a.options.autoplay && clearInterval(a.autoPlayTimer),
              (s =
                o < 0
                  ? a.slideCount % a.options.slidesToScroll != 0
                    ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                    : a.slideCount + o
                  : o >= a.slideCount
                  ? a.slideCount % a.options.slidesToScroll != 0
                    ? 0
                    : o - a.slideCount
                  : o),
              (a.animating = !0),
              a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
              (n = a.currentSlide),
              (a.currentSlide = s),
              a.setSlideClasses(a.currentSlide),
              a.options.asNavFor &&
                (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <=
                  l.options.slidesToShow &&
                l.setSlideClasses(a.currentSlide),
              a.updateDots(),
              a.updateArrows(),
              !0 === a.options.fade
                ? (!0 !== t
                    ? (a.fadeSlideOut(n),
                      a.fadeSlide(s, function () {
                        a.postSlide(s);
                      }))
                    : a.postSlide(s),
                  void a.animateHeight())
                : void (!0 !== t && a.slideCount > a.options.slidesToShow
                    ? a.animateSlide(d, function () {
                        a.postSlide(s);
                      })
                    : a.postSlide(s)))
        );
    }),
    (e.prototype.startLoad = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow.hide(), i.$nextArrow.hide()),
        !0 === i.options.dots &&
          i.slideCount > i.options.slidesToShow &&
          i.$dots.hide(),
        i.$slider.addClass("slick-loading");
    }),
    (e.prototype.swipeDirection = function () {
      var i,
        e,
        t,
        o,
        s = this;
      return (
        (i = s.touchObject.startX - s.touchObject.curX),
        (e = s.touchObject.startY - s.touchObject.curY),
        (t = Math.atan2(e, i)),
        (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
        o <= 45 && o >= 0
          ? !1 === s.options.rtl
            ? "left"
            : "right"
          : o <= 360 && o >= 315
          ? !1 === s.options.rtl
            ? "left"
            : "right"
          : o >= 135 && o <= 225
          ? !1 === s.options.rtl
            ? "right"
            : "left"
          : !0 === s.options.verticalSwiping
          ? o >= 35 && o <= 135
            ? "down"
            : "up"
          : "vertical"
      );
    }),
    (e.prototype.swipeEnd = function (i) {
      var e,
        t,
        o = this;
      if (((o.dragging = !1), (o.swiping = !1), o.scrolling))
        return (o.scrolling = !1), !1;
      if (
        ((o.interrupted = !1),
        (o.shouldClick = !(o.touchObject.swipeLength > 10)),
        void 0 === o.touchObject.curX)
      )
        return !1;
      if (
        (!0 === o.touchObject.edgeHit &&
          o.$slider.trigger("edge", [o, o.swipeDirection()]),
        o.touchObject.swipeLength >= o.touchObject.minSwipe)
      ) {
        switch ((t = o.swipeDirection())) {
          case "left":
          case "down":
            (e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide + o.getSlideCount())
              : o.currentSlide + o.getSlideCount()),
              (o.currentDirection = 0);
            break;
          case "right":
          case "up":
            (e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide - o.getSlideCount())
              : o.currentSlide - o.getSlideCount()),
              (o.currentDirection = 1);
        }
        "vertical" != t &&
          (o.slideHandler(e),
          (o.touchObject = {}),
          o.$slider.trigger("swipe", [o, t]));
      } else
        o.touchObject.startX !== o.touchObject.curX &&
          (o.slideHandler(o.currentSlide), (o.touchObject = {}));
    }),
    (e.prototype.swipeHandler = function (i) {
      var e = this;
      if (
        !(
          !1 === e.options.swipe ||
          ("ontouchend" in document && !1 === e.options.swipe) ||
          (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))
        )
      )
        switch (
          ((e.touchObject.fingerCount =
            i.originalEvent && void 0 !== i.originalEvent.touches
              ? i.originalEvent.touches.length
              : 1),
          (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
          !0 === e.options.verticalSwiping &&
            (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
          i.data.action)
        ) {
          case "start":
            e.swipeStart(i);
            break;
          case "move":
            e.swipeMove(i);
            break;
          case "end":
            e.swipeEnd(i);
        }
    }),
    (e.prototype.swipeMove = function (i) {
      var e,
        t,
        o,
        s,
        n,
        r,
        l = this;
      return (
        (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
        !(!l.dragging || l.scrolling || (n && 1 !== n.length)) &&
          ((e = l.getLeft(l.currentSlide)),
          (l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
          (l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
          (l.touchObject.swipeLength = Math.round(
            Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))
          )),
          (r = Math.round(
            Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))
          )),
          !l.options.verticalSwiping && !l.swiping && r > 4
            ? ((l.scrolling = !0), !1)
            : (!0 === l.options.verticalSwiping &&
                (l.touchObject.swipeLength = r),
              (t = l.swipeDirection()),
              void 0 !== i.originalEvent &&
                l.touchObject.swipeLength > 4 &&
                ((l.swiping = !0), i.preventDefault()),
              (s =
                (!1 === l.options.rtl ? 1 : -1) *
                (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
              !0 === l.options.verticalSwiping &&
                (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
              (o = l.touchObject.swipeLength),
              (l.touchObject.edgeHit = !1),
              !1 === l.options.infinite &&
                ((0 === l.currentSlide && "right" === t) ||
                  (l.currentSlide >= l.getDotCount() && "left" === t)) &&
                ((o = l.touchObject.swipeLength * l.options.edgeFriction),
                (l.touchObject.edgeHit = !0)),
              !1 === l.options.vertical
                ? (l.swipeLeft = e + o * s)
                : (l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s),
              !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
              !0 !== l.options.fade &&
                !1 !== l.options.touchMove &&
                (!0 === l.animating
                  ? ((l.swipeLeft = null), !1)
                  : void l.setCSS(l.swipeLeft))))
      );
    }),
    (e.prototype.swipeStart = function (i) {
      var e,
        t = this;
      return (
        (t.interrupted = !0),
        1 !== t.touchObject.fingerCount ||
        t.slideCount <= t.options.slidesToShow
          ? ((t.touchObject = {}), !1)
          : (void 0 !== i.originalEvent &&
              void 0 !== i.originalEvent.touches &&
              (e = i.originalEvent.touches[0]),
            (t.touchObject.startX = t.touchObject.curX =
              void 0 !== e ? e.pageX : i.clientX),
            (t.touchObject.startY = t.touchObject.curY =
              void 0 !== e ? e.pageY : i.clientY),
            void (t.dragging = !0))
      );
    }),
    (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
      function () {
        var i = this;
        null !== i.$slidesCache &&
          (i.unload(),
          i.$slideTrack.children(this.options.slide).detach(),
          i.$slidesCache.appendTo(i.$slideTrack),
          i.reinit());
      }),
    (e.prototype.unload = function () {
      var e = this;
      i(".slick-cloned", e.$slider).remove(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow &&
          e.htmlExpr.test(e.options.prevArrow) &&
          e.$prevArrow.remove(),
        e.$nextArrow &&
          e.htmlExpr.test(e.options.nextArrow) &&
          e.$nextArrow.remove(),
        e.$slides
          .removeClass("slick-slide slick-active slick-visible slick-current")
          .attr("aria-hidden", "true")
          .css("width", "");
    }),
    (e.prototype.unslick = function (i) {
      this.$slider.trigger("unslick", [this, i]), this.destroy();
    }),
    (e.prototype.updateArrows = function () {
      var i = this;
      Math.floor(i.options.slidesToShow / 2),
        !0 === i.options.arrows &&
          i.slideCount > i.options.slidesToShow &&
          !i.options.infinite &&
          (i.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          i.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          0 === i.currentSlide
            ? (i.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : i.currentSlide >= i.slideCount - i.options.slidesToShow &&
              !1 === i.options.centerMode
            ? (i.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : i.currentSlide >= i.slideCount - 1 &&
              !0 === i.options.centerMode &&
              (i.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
    }),
    (e.prototype.updateDots = function () {
      var i = this;
      null !== i.$dots &&
        (i.$dots.find("li").removeClass("slick-active").end(),
        i.$dots
          .find("li")
          .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
          .addClass("slick-active"));
    }),
    (e.prototype.visibility = function () {
      this.options.autoplay &&
        (document[this.hidden]
          ? (this.interrupted = !0)
          : (this.interrupted = !1));
    }),
    (i.fn.slick = function () {
      var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;
      for (i = 0; i < r; i++)
        if (
          ("object" == typeof s || void 0 === s
            ? (o[i].slick = new e(o[i], s))
            : (t = o[i].slick[s].apply(o[i].slick, n)),
          void 0 !== t)
        )
          return t;
      return o;
    });
});
/*! jQuery throttle / debounce - v1.1 */
!(function (t, n) {
  var o,
    u = t.jQuery || t.Cowboy || (t.Cowboy = {});
  (u.throttle = o =
    function (t, o, e, i) {
      var r,
        a = 0;
      function c() {
        var u = this,
          c = +new Date() - a,
          f = arguments;
        function d() {
          (a = +new Date()), e.apply(u, f);
        }
        i && !r && d(),
          r && clearTimeout(r),
          i === n && c > t
            ? d()
            : !0 !== o &&
              (r = setTimeout(
                i
                  ? function () {
                      r = n;
                    }
                  : d,
                i === n ? t - c : t
              ));
      }
      return (
        "boolean" != typeof o && ((i = e), (e = o), (o = n)),
        u.guid && (c.guid = e.guid = e.guid || u.guid++),
        c
      );
    }),
    (u.debounce = function (t, u, e) {
      return e === n ? o(t, u, !1) : o(t, e, !1 !== u);
    });
})(this);
/*! History */
"object" != typeof JSON && (JSON = {}),
  (function () {
    "use strict";
    function f(e) {
      return e < 10 ? "0" + e : e;
    }
    function quote(e) {
      return (
        (escapable.lastIndex = 0),
        escapable.test(e)
          ? '"' +
            e.replace(escapable, function (e) {
              var t = meta[e];
              return "string" == typeof t
                ? t
                : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
            }) +
            '"'
          : '"' + e + '"'
      );
    }
    function str(e, t) {
      var a,
        r,
        n,
        o,
        i,
        s = gap,
        u = t[e];
      switch (
        (u &&
          "object" == typeof u &&
          "function" == typeof u.toJSON &&
          (u = u.toJSON(e)),
        "function" == typeof rep && (u = rep.call(t, e, u)),
        typeof u)
      ) {
        case "string":
          return quote(u);
        case "number":
          return isFinite(u) ? String(u) : "null";
        case "boolean":
        case "null":
          return String(u);
        case "object":
          if (!u) return "null";
          if (
            ((gap += indent),
            (i = []),
            "[object Array]" === Object.prototype.toString.apply(u))
          ) {
            for (o = u.length, a = 0; a < o; a += 1) i[a] = str(a, u) || "null";
            return (
              (n =
                0 === i.length
                  ? "[]"
                  : gap
                  ? "[\n" + gap + i.join(",\n" + gap) + "\n" + s + "]"
                  : "[" + i.join(",") + "]"),
              (gap = s),
              n
            );
          }
          if (rep && "object" == typeof rep)
            for (o = rep.length, a = 0; a < o; a += 1)
              "string" == typeof rep[a] &&
                ((r = rep[a]),
                (n = str(r, u)) && i.push(quote(r) + (gap ? ": " : ":") + n));
          else
            for (r in u)
              Object.prototype.hasOwnProperty.call(u, r) &&
                (n = str(r, u)) &&
                i.push(quote(r) + (gap ? ": " : ":") + n);
          return (
            (n =
              0 === i.length
                ? "{}"
                : gap
                ? "{\n" + gap + i.join(",\n" + gap) + "\n" + s + "}"
                : "{" + i.join(",") + "}"),
            (gap = s),
            n
          );
      }
    }
    "function" != typeof Date.prototype.toJSON &&
      ((Date.prototype.toJSON = function (e) {
        return isFinite(this.valueOf())
          ? this.getUTCFullYear() +
              "-" +
              f(this.getUTCMonth() + 1) +
              "-" +
              f(this.getUTCDate()) +
              "T" +
              f(this.getUTCHours()) +
              ":" +
              f(this.getUTCMinutes()) +
              ":" +
              f(this.getUTCSeconds()) +
              "Z"
          : null;
      }),
      (String.prototype.toJSON =
        Number.prototype.toJSON =
        Boolean.prototype.toJSON =
          function (e) {
            return this.valueOf();
          }));
    var cx =
        /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
      escapable =
        /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
      gap,
      indent,
      meta = {
        "\b": "\\b",
        "\t": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\",
      },
      rep;
    "function" != typeof JSON.stringify &&
      (JSON.stringify = function (e, t, a) {
        var r;
        if (((gap = ""), (indent = ""), "number" == typeof a))
          for (r = 0; r < a; r += 1) indent += " ";
        else "string" == typeof a && (indent = a);
        if (
          ((rep = t),
          !t ||
            "function" == typeof t ||
            ("object" == typeof t && "number" == typeof t.length))
        )
          return str("", { "": e });
        throw new Error("JSON.stringify");
      }),
      "function" != typeof JSON.parse &&
        (JSON.parse = function (text, reviver) {
          function walk(e, t) {
            var a,
              r,
              n = e[t];
            if (n && "object" == typeof n)
              for (a in n)
                Object.prototype.hasOwnProperty.call(n, a) &&
                  (void 0 !== (r = walk(n, a)) ? (n[a] = r) : delete n[a]);
            return reviver.call(e, t, n);
          }
          var j;
          if (
            ((text = String(text)),
            (cx.lastIndex = 0),
            cx.test(text) &&
              (text = text.replace(cx, function (e) {
                return (
                  "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4)
                );
              })),
            /^[\],:{}\s]*$/.test(
              text
                .replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@")
                .replace(
                  /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
                  "]"
                )
                .replace(/(?:^|:|,)(?:\s*\[)+/g, "")
            ))
          )
            return (
              (j = eval("(" + text + ")")),
              "function" == typeof reviver ? walk({ "": j }, "") : j
            );
          throw new SyntaxError("JSON.parse");
        });
  })(),
  (function (e, t) {
    "use strict";
    var a = (e.History = e.History || {}),
      r = e.jQuery;
    if (void 0 !== a.Adapter)
      throw new Error("History.js Adapter has already been loaded...");
    (a.Adapter = {
      bind: function (e, t, a) {
        r(e).bind(t, a);
      },
      trigger: function (e, t, a) {
        r(e).trigger(t, a);
      },
      extractEventData: function (e, t, a) {
        return (
          (t && t.originalEvent && t.originalEvent[e]) || (a && a[e]) || void 0
        );
      },
      onDomLoad: function (e) {
        r(e);
      },
    }),
      void 0 !== a.init && a.init();
  })(window),
  (function (e, t) {
    "use strict";
    var a = e.document,
      r = e.setTimeout || r,
      n = e.clearTimeout || n,
      o = e.setInterval || o,
      i = (e.History = e.History || {});
    if (void 0 !== i.initHtml4)
      throw new Error("History.js HTML4 Support has already been loaded...");
    (i.initHtml4 = function () {
      if (void 0 !== i.initHtml4.initialized) return !1;
      (i.initHtml4.initialized = !0),
        (i.enabled = !0),
        (i.savedHashes = []),
        (i.isLastHash = function (e) {
          return e === i.getHashByIndex();
        }),
        (i.isHashEqual = function (e, t) {
          return (
            (e = encodeURIComponent(e).replace(/%25/g, "%")),
            (t = encodeURIComponent(t).replace(/%25/g, "%")),
            e === t
          );
        }),
        (i.saveHash = function (e) {
          return !i.isLastHash(e) && (i.savedHashes.push(e), !0);
        }),
        (i.getHashByIndex = function (e) {
          return void 0 === e
            ? i.savedHashes[i.savedHashes.length - 1]
            : e < 0
            ? i.savedHashes[i.savedHashes.length + e]
            : i.savedHashes[e];
        }),
        (i.discardedHashes = {}),
        (i.discardedStates = {}),
        (i.discardState = function (e, t, a) {
          var r,
            n = i.getHashByState(e);
          return (
            (r = { discardedState: e, backState: a, forwardState: t }),
            (i.discardedStates[n] = r),
            !0
          );
        }),
        (i.discardHash = function (e, t, a) {
          var r = { discardedHash: e, backState: a, forwardState: t };
          return (i.discardedHashes[e] = r), !0;
        }),
        (i.discardedState = function (e) {
          var t = i.getHashByState(e);
          return i.discardedStates[t] || !1;
        }),
        (i.discardedHash = function (e) {
          return i.discardedHashes[e] || !1;
        }),
        (i.recycleState = function (e) {
          var t = i.getHashByState(e);
          return i.discardedState(e) && delete i.discardedStates[t], !0;
        }),
        i.emulated.hashChange &&
          ((i.hashChangeInit = function () {
            i.checkerFunction = null;
            var t,
              r,
              n,
              s,
              u = "",
              l = Boolean(i.getHash());
            return (
              i.isInternetExplorer()
                ? ((t = "historyjs-iframe"),
                  (r = a.createElement("iframe")).setAttribute("id", t),
                  r.setAttribute("src", "#"),
                  (r.style.display = "none"),
                  a.body.appendChild(r),
                  r.contentWindow.document.open(),
                  r.contentWindow.document.close(),
                  (n = ""),
                  (s = !1),
                  (i.checkerFunction = function () {
                    if (s) return !1;
                    s = !0;
                    var t = i.getHash(),
                      a = i.getHash(r.contentWindow.document);
                    return (
                      t !== u
                        ? ((u = t),
                          a !== t &&
                            ((n = a = t),
                            r.contentWindow.document.open(),
                            r.contentWindow.document.close(),
                            (r.contentWindow.document.location.hash =
                              i.escapeHash(t))),
                          i.Adapter.trigger(e, "hashchange"))
                        : a !== n &&
                          ((n = a),
                          l && "" === a ? i.back() : i.setHash(a, !1)),
                      (s = !1),
                      !0
                    );
                  }))
                : (i.checkerFunction = function () {
                    var t = i.getHash() || "";
                    return (
                      t !== u && ((u = t), i.Adapter.trigger(e, "hashchange")),
                      !0
                    );
                  }),
              i.intervalList.push(
                o(i.checkerFunction, i.options.hashChangeInterval)
              ),
              !0
            );
          }),
          i.Adapter.onDomLoad(i.hashChangeInit)),
        i.emulated.pushState &&
          ((i.onHashChange = function (t) {
            var a,
              r = (t && t.newURL) || i.getLocationHref(),
              n = i.getHashByUrl(r),
              o = null;
            return i.isLastHash(n)
              ? (i.busy(!1), !1)
              : (i.doubleCheckComplete(),
                i.saveHash(n),
                n && i.isTraditionalAnchor(n)
                  ? (i.Adapter.trigger(e, "anchorchange"), i.busy(!1), !1)
                  : ((o = i.extractState(
                      i.getFullUrl(n || i.getLocationHref()),
                      !0
                    )),
                    i.isLastSavedState(o)
                      ? (i.busy(!1), !1)
                      : (i.getHashByState(o),
                        (a = i.discardedState(o))
                          ? (i.getHashByIndex(-2) ===
                            i.getHashByState(a.forwardState)
                              ? i.back(!1)
                              : i.forward(!1),
                            !1)
                          : (i.pushState(o.data, o.title, encodeURI(o.url), !1),
                            !0))));
          }),
          i.Adapter.bind(e, "hashchange", i.onHashChange),
          (i.pushState = function (t, a, r, n) {
            if (((r = encodeURI(r).replace(/%25/g, "%")), i.getHashByUrl(r)))
              throw new Error(
                "History.js does not support states with fragment-identifiers (hashes/anchors)."
              );
            if (!1 !== n && i.busy())
              return (
                i.pushQueue({
                  scope: i,
                  callback: i.pushState,
                  args: arguments,
                  queue: n,
                }),
                !1
              );
            i.busy(!0);
            var o = i.createStateObject(t, a, r),
              s = i.getHashByState(o),
              u = i.getState(!1),
              l = i.getHashByState(u),
              c = i.getHash(),
              d = i.expectedStateId == o.id;
            return (
              i.storeState(o),
              (i.expectedStateId = o.id),
              i.recycleState(o),
              i.setTitle(o),
              s === l
                ? (i.busy(!1), !1)
                : (i.saveState(o),
                  d || i.Adapter.trigger(e, "statechange"),
                  !i.isHashEqual(s, c) &&
                    !i.isHashEqual(s, i.getShortUrl(i.getLocationHref())) &&
                    i.setHash(s, !1),
                  i.busy(!1),
                  !0)
            );
          }),
          (i.replaceState = function (t, a, r, n) {
            if (((r = encodeURI(r).replace(/%25/g, "%")), i.getHashByUrl(r)))
              throw new Error(
                "History.js does not support states with fragment-identifiers (hashes/anchors)."
              );
            if (!1 !== n && i.busy())
              return (
                i.pushQueue({
                  scope: i,
                  callback: i.replaceState,
                  args: arguments,
                  queue: n,
                }),
                !1
              );
            i.busy(!0);
            var o = i.createStateObject(t, a, r),
              s = i.getHashByState(o),
              u = i.getState(!1),
              l = i.getHashByState(u),
              c = i.getStateByIndex(-2);
            return (
              i.discardState(u, o, c),
              s === l
                ? (i.storeState(o),
                  (i.expectedStateId = o.id),
                  i.recycleState(o),
                  i.setTitle(o),
                  i.saveState(o),
                  i.Adapter.trigger(e, "statechange"),
                  i.busy(!1))
                : i.pushState(o.data, o.title, o.url, !1),
              !0
            );
          })),
        i.emulated.pushState &&
          i.getHash() &&
          !i.emulated.hashChange &&
          i.Adapter.onDomLoad(function () {
            i.Adapter.trigger(e, "hashchange");
          });
    }),
      void 0 !== i.init && i.init();
  })(window),
  (function (e, t) {
    "use strict";
    var a = e.console || t,
      r = e.document,
      n = e.navigator,
      o = !1,
      i = e.setTimeout,
      s = e.clearTimeout,
      u = e.setInterval,
      l = e.clearInterval,
      c = e.JSON,
      d = e.alert,
      p = (e.History = e.History || {}),
      h = e.history;
    try {
      (o = e.sessionStorage).setItem("TEST", "1"), o.removeItem("TEST");
    } catch (e) {
      o = !1;
    }
    if (
      ((c.stringify = c.stringify || c.encode),
      (c.parse = c.parse || c.decode),
      void 0 !== p.init)
    )
      throw new Error("History.js Core has already been loaded...");
    (p.init = function (e) {
      return (
        void 0 !== p.Adapter &&
        (void 0 !== p.initCore && p.initCore(),
        void 0 !== p.initHtml4 && p.initHtml4(),
        !0)
      );
    }),
      (p.initCore = function (g) {
        if (void 0 !== p.initCore.initialized) return !1;
        if (
          ((p.initCore.initialized = !0),
          (p.options = p.options || {}),
          (p.options.hashChangeInterval = p.options.hashChangeInterval || 100),
          (p.options.safariPollInterval = p.options.safariPollInterval || 500),
          (p.options.doubleCheckInterval =
            p.options.doubleCheckInterval || 500),
          (p.options.disableSuid = p.options.disableSuid || !1),
          (p.options.storeInterval = p.options.storeInterval || 1e3),
          (p.options.busyDelay = p.options.busyDelay || 250),
          (p.options.debug = p.options.debug || !1),
          (p.options.initialTitle = p.options.initialTitle || r.title),
          (p.options.html4Mode = p.options.html4Mode || !1),
          (p.options.delayInit = p.options.delayInit || !1),
          (p.intervalList = []),
          (p.clearAllIntervals = function () {
            var e,
              t = p.intervalList;
            if (void 0 !== t && null !== t) {
              for (e = 0; e < t.length; e++) l(t[e]);
              p.intervalList = null;
            }
          }),
          (p.debug = function () {
            (p.options.debug || !1) && p.log.apply(p, arguments);
          }),
          (p.log = function () {
            var e,
              t,
              n,
              o,
              i,
              s = void 0 !== a && void 0 !== a.log && void 0 !== a.log.apply,
              u = r.getElementById("log");
            for (
              s
                ? ((o = Array.prototype.slice.call(arguments)),
                  (e = o.shift()),
                  void 0 !== a.debug
                    ? a.debug.apply(a, [e, o])
                    : a.log.apply(a, [e, o]))
                : (e = "\n" + arguments[0] + "\n"),
                t = 1,
                n = arguments.length;
              t < n;
              ++t
            ) {
              if ("object" == typeof (i = arguments[t]) && void 0 !== c)
                try {
                  i = c.stringify(i);
                } catch (e) {}
              e += "\n" + i + "\n";
            }
            return (
              u
                ? ((u.value += e + "\n-----\n"),
                  (u.scrollTop = u.scrollHeight - u.clientHeight))
                : s || d(e),
              !0
            );
          }),
          (p.getInternetExplorerMajorVersion = function () {
            return (p.getInternetExplorerMajorVersion.cached =
              void 0 !== p.getInternetExplorerMajorVersion.cached
                ? p.getInternetExplorerMajorVersion.cached
                : (function () {
                    for (
                      var e = 3,
                        t = r.createElement("div"),
                        a = t.getElementsByTagName("i");
                      (t.innerHTML =
                        "\x3c!--[if gt IE " +
                        ++e +
                        "]><i></i><![endif]--\x3e") && a[0];

                    );
                    return e > 4 && e;
                  })());
          }),
          (p.isInternetExplorer = function () {
            return (p.isInternetExplorer.cached =
              void 0 !== p.isInternetExplorer.cached
                ? p.isInternetExplorer.cached
                : Boolean(p.getInternetExplorerMajorVersion()));
          }),
          p.options.html4Mode
            ? (p.emulated = { pushState: !0, hashChange: !0 })
            : (p.emulated = {
                pushState: !Boolean(
                  e.history &&
                    e.history.pushState &&
                    e.history.replaceState &&
                    !/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(
                      n.userAgent
                    ) &&
                    !/AppleWebKit\/5([0-2]|3[0-2])/i.test(n.userAgent)
                ),
                hashChange: Boolean(
                  !("onhashchange" in e || "onhashchange" in r) ||
                    (p.isInternetExplorer() &&
                      p.getInternetExplorerMajorVersion() < 8)
                ),
              }),
          (p.enabled = !p.emulated.pushState),
          (p.bugs = {
            setHash: Boolean(
              !p.emulated.pushState &&
                "Apple Computer, Inc." === n.vendor &&
                /AppleWebKit\/5([0-2]|3[0-3])/.test(n.userAgent)
            ),
            safariPoll: Boolean(
              !p.emulated.pushState &&
                "Apple Computer, Inc." === n.vendor &&
                /AppleWebKit\/5([0-2]|3[0-3])/.test(n.userAgent)
            ),
            ieDoubleCheck: Boolean(
              p.isInternetExplorer() && p.getInternetExplorerMajorVersion() < 8
            ),
            hashEscape: Boolean(
              p.isInternetExplorer() && p.getInternetExplorerMajorVersion() < 7
            ),
          }),
          (p.isEmptyObject = function (e) {
            for (var t in e) if (e.hasOwnProperty(t)) return !1;
            return !0;
          }),
          (p.cloneObject = function (e) {
            var t, a;
            return e ? ((t = c.stringify(e)), (a = c.parse(t))) : (a = {}), a;
          }),
          (p.getRootUrl = function () {
            var e =
              r.location.protocol +
              "//" +
              (r.location.hostname || r.location.host);
            return r.location.port && (e += ":" + r.location.port), (e += "/");
          }),
          (p.getBaseHref = function () {
            var e = r.getElementsByTagName("base"),
              t = null,
              a = "";
            return (
              1 === e.length &&
                ((t = e[0]), (a = t.href.replace(/[^\/]+$/, ""))),
              (a = a.replace(/\/+$/, "")) && (a += "/"),
              a
            );
          }),
          (p.getBaseUrl = function () {
            return p.getBaseHref() || p.getBasePageUrl() || p.getRootUrl();
          }),
          (p.getPageUrl = function () {
            return ((p.getState(!1, !1) || {}).url || p.getLocationHref())
              .replace(/\/+$/, "")
              .replace(/[^\/]+$/, function (e, t, a) {
                return /\./.test(e) ? e : e + "/";
              });
          }),
          (p.getBasePageUrl = function () {
            return (
              p
                .getLocationHref()
                .replace(/[#\?].*/, "")
                .replace(/[^\/]+$/, function (e, t, a) {
                  return /[^\/]$/.test(e) ? "" : e;
                })
                .replace(/\/+$/, "") + "/"
            );
          }),
          (p.getFullUrl = function (e, t) {
            var a = e,
              r = e.substring(0, 1);
            return (
              (t = void 0 === t || t),
              /[a-z]+\:\/\//.test(e) ||
                (a =
                  "/" === r
                    ? p.getRootUrl() + e.replace(/^\/+/, "")
                    : "#" === r
                    ? p.getPageUrl().replace(/#.*/, "") + e
                    : "?" === r
                    ? p.getPageUrl().replace(/[\?#].*/, "") + e
                    : t
                    ? p.getBaseUrl() + e.replace(/^(\.\/)+/, "")
                    : p.getBasePageUrl() + e.replace(/^(\.\/)+/, "")),
              a.replace(/\#$/, "")
            );
          }),
          (p.getShortUrl = function (e) {
            var t = e,
              a = p.getBaseUrl(),
              r = p.getRootUrl();
            return (
              p.emulated.pushState && (t = t.replace(a, "")),
              (t = t.replace(r, "/")),
              p.isTraditionalAnchor(t) && (t = "./" + t),
              (t = t.replace(/^(\.\/)+/g, "./").replace(/\#$/, ""))
            );
          }),
          (p.getLocationHref = function (e) {
            return (e = e || r).URL === e.location.href
              ? e.location.href
              : e.location.href === decodeURIComponent(e.URL)
              ? e.URL
              : e.location.hash &&
                decodeURIComponent(e.location.href.replace(/^[^#]+/, "")) ===
                  e.location.hash
              ? e.location.href
              : -1 == e.URL.indexOf("#") && -1 != e.location.href.indexOf("#")
              ? e.location.href
              : e.URL || e.location.href;
          }),
          (p.store = {}),
          (p.idToState = p.idToState || {}),
          (p.stateToId = p.stateToId || {}),
          (p.urlToId = p.urlToId || {}),
          (p.storedStates = p.storedStates || []),
          (p.savedStates = p.savedStates || []),
          (p.normalizeStore = function () {
            (p.store.idToState = p.store.idToState || {}),
              (p.store.urlToId = p.store.urlToId || {}),
              (p.store.stateToId = p.store.stateToId || {});
          }),
          (p.getState = function (e, t) {
            void 0 === e && (e = !0), void 0 === t && (t = !0);
            var a = p.getLastSavedState();
            return (
              !a && t && (a = p.createStateObject()),
              e && ((a = p.cloneObject(a)), (a.url = a.cleanUrl || a.url)),
              a
            );
          }),
          (p.getIdByState = function (e) {
            var t,
              a = p.extractId(e.url);
            if (!a)
              if (((t = p.getStateString(e)), void 0 !== p.stateToId[t]))
                a = p.stateToId[t];
              else if (void 0 !== p.store.stateToId[t])
                a = p.store.stateToId[t];
              else {
                for (
                  ;
                  (a =
                    new Date().getTime() +
                    String(Math.random()).replace(/\D/g, "")),
                    void 0 !== p.idToState[a] ||
                      void 0 !== p.store.idToState[a];

                );
                (p.stateToId[t] = a), (p.idToState[a] = e);
              }
            return a;
          }),
          (p.normalizeState = function (e) {
            var t, a;
            return (
              (e && "object" == typeof e) || (e = {}),
              void 0 !== e.normalized
                ? e
                : ((e.data && "object" == typeof e.data) || (e.data = {}),
                  (t = {}),
                  (t.normalized = !0),
                  (t.title = e.title || ""),
                  (t.url = p.getFullUrl(e.url ? e.url : p.getLocationHref())),
                  (t.hash = p.getShortUrl(t.url)),
                  (t.data = p.cloneObject(e.data)),
                  (t.id = p.getIdByState(t)),
                  (t.cleanUrl = t.url.replace(/\??\&_suid.*/, "")),
                  (t.url = t.cleanUrl),
                  (a = !p.isEmptyObject(t.data)),
                  (t.title || a) &&
                    !0 !== p.options.disableSuid &&
                    ((t.hash = p
                      .getShortUrl(t.url)
                      .replace(/\??\&_suid.*/, "")),
                    /\?/.test(t.hash) || (t.hash += "?"),
                    (t.hash += "&_suid=" + t.id)),
                  (t.hashedUrl = p.getFullUrl(t.hash)),
                  (p.emulated.pushState || p.bugs.safariPoll) &&
                    p.hasUrlDuplicate(t) &&
                    (t.url = t.hashedUrl),
                  t)
            );
          }),
          (p.createStateObject = function (e, t, a) {
            var r = { data: e, title: t, url: a };
            return (r = p.normalizeState(r));
          }),
          (p.getStateById = function (e) {
            return (e = String(e)), p.idToState[e] || p.store.idToState[e] || t;
          }),
          (p.getStateString = function (e) {
            var t, a;
            return (
              (t = p.normalizeState(e)),
              (a = { data: t.data, title: e.title, url: e.url }),
              c.stringify(a)
            );
          }),
          (p.getStateId = function (e) {
            var t;
            return (t = p.normalizeState(e)), t.id;
          }),
          (p.getHashByState = function (e) {
            var t;
            return (t = p.normalizeState(e)), t.hash;
          }),
          (p.extractId = function (e) {
            var t, a;
            return (
              (a = -1 != e.indexOf("#") ? e.split("#")[0] : e),
              (t = /(.*)\&_suid=([0-9]+)$/.exec(a)),
              t ? t[1] || e : e,
              (t ? String(t[2] || "") : "") || !1
            );
          }),
          (p.isTraditionalAnchor = function (e) {
            return !/[\/\?\.]/.test(e);
          }),
          (p.extractState = function (e, t) {
            var a,
              r,
              n = null;
            return (
              (t = t || !1),
              (a = p.extractId(e)) && (n = p.getStateById(a)),
              n ||
                ((r = p.getFullUrl(e)),
                (a = p.getIdByUrl(r) || !1) && (n = p.getStateById(a)),
                !n &&
                  t &&
                  !p.isTraditionalAnchor(e) &&
                  (n = p.createStateObject(null, null, r))),
              n
            );
          }),
          (p.getIdByUrl = function (e) {
            return p.urlToId[e] || p.store.urlToId[e] || t;
          }),
          (p.getLastSavedState = function () {
            return p.savedStates[p.savedStates.length - 1] || t;
          }),
          (p.getLastStoredState = function () {
            return p.storedStates[p.storedStates.length - 1] || t;
          }),
          (p.hasUrlDuplicate = function (e) {
            var t;
            return (t = p.extractState(e.url)), t && t.id !== e.id;
          }),
          (p.storeState = function (e) {
            return (
              (p.urlToId[e.url] = e.id),
              p.storedStates.push(p.cloneObject(e)),
              e
            );
          }),
          (p.isLastSavedState = function (e) {
            var t,
              a,
              r,
              n = !1;
            return (
              p.savedStates.length &&
                ((t = e.id),
                (a = p.getLastSavedState()),
                (r = a.id),
                (n = t === r)),
              n
            );
          }),
          (p.saveState = function (e) {
            return (
              !p.isLastSavedState(e) &&
              (p.savedStates.push(p.cloneObject(e)), !0)
            );
          }),
          (p.getStateByIndex = function (e) {
            return void 0 === e
              ? p.savedStates[p.savedStates.length - 1]
              : e < 0
              ? p.savedStates[p.savedStates.length + e]
              : p.savedStates[e];
          }),
          (p.getCurrentIndex = function () {
            return p.savedStates.length < 1 ? 0 : p.savedStates.length - 1;
          }),
          (p.getHash = function (e) {
            var t = p.getLocationHref(e);
            return p.getHashByUrl(t);
          }),
          (p.unescapeHash = function (e) {
            var t = p.normalizeHash(e);
            return (t = decodeURIComponent(t));
          }),
          (p.normalizeHash = function (e) {
            return e.replace(/[^#]*#/, "").replace(/#.*/, "");
          }),
          (p.setHash = function (e, t) {
            var a, n;
            return !1 !== t && p.busy()
              ? (p.pushQueue({
                  scope: p,
                  callback: p.setHash,
                  args: arguments,
                  queue: t,
                }),
                !1)
              : (p.busy(!0),
                (a = p.extractState(e, !0)) && !p.emulated.pushState
                  ? p.pushState(a.data, a.title, a.url, !1)
                  : p.getHash() !== e &&
                    (p.bugs.setHash
                      ? ((n = p.getPageUrl()),
                        p.pushState(null, null, n + "#" + e, !1))
                      : (r.location.hash = e)),
                p);
          }),
          (p.escapeHash = function (t) {
            var a = p.normalizeHash(t);
            return (
              (a = e.encodeURIComponent(a)),
              p.bugs.hashEscape ||
                (a = a
                  .replace(/\%21/g, "!")
                  .replace(/\%26/g, "&")
                  .replace(/\%3D/g, "=")
                  .replace(/\%3F/g, "?")),
              a
            );
          }),
          (p.getHashByUrl = function (e) {
            var t = String(e).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
            return (t = p.unescapeHash(t));
          }),
          (p.setTitle = function (e) {
            var t,
              a = e.title;
            a ||
              ((t = p.getStateByIndex(0)) &&
                t.url === e.url &&
                (a = t.title || p.options.initialTitle));
            try {
              r.getElementsByTagName("title")[0].innerHTML = a
                .replace("<", "&lt;")
                .replace(">", "&gt;")
                .replace(" & ", " &amp; ");
            } catch (e) {}
            return (r.title = a), p;
          }),
          (p.queues = []),
          (p.busy = function (e) {
            if (
              (void 0 !== e
                ? (p.busy.flag = e)
                : void 0 === p.busy.flag && (p.busy.flag = !1),
              !p.busy.flag)
            ) {
              s(p.busy.timeout);
              var t = function () {
                var e, a, r;
                if (!p.busy.flag)
                  for (e = p.queues.length - 1; e >= 0; --e)
                    0 !== (a = p.queues[e]).length &&
                      ((r = a.shift()),
                      p.fireQueueItem(r),
                      (p.busy.timeout = i(t, p.options.busyDelay)));
              };
              p.busy.timeout = i(t, p.options.busyDelay);
            }
            return p.busy.flag;
          }),
          (p.busy.flag = !1),
          (p.fireQueueItem = function (e) {
            return e.callback.apply(e.scope || p, e.args || []);
          }),
          (p.pushQueue = function (e) {
            return (
              (p.queues[e.queue || 0] = p.queues[e.queue || 0] || []),
              p.queues[e.queue || 0].push(e),
              p
            );
          }),
          (p.queue = function (e, t) {
            return (
              "function" == typeof e && (e = { callback: e }),
              void 0 !== t && (e.queue = t),
              p.busy() ? p.pushQueue(e) : p.fireQueueItem(e),
              p
            );
          }),
          (p.clearQueue = function () {
            return (p.busy.flag = !1), (p.queues = []), p;
          }),
          (p.stateChanged = !1),
          (p.doubleChecker = !1),
          (p.doubleCheckComplete = function () {
            return (p.stateChanged = !0), p.doubleCheckClear(), p;
          }),
          (p.doubleCheckClear = function () {
            return (
              p.doubleChecker && (s(p.doubleChecker), (p.doubleChecker = !1)), p
            );
          }),
          (p.doubleCheck = function (e) {
            return (
              (p.stateChanged = !1),
              p.doubleCheckClear(),
              p.bugs.ieDoubleCheck &&
                (p.doubleChecker = i(function () {
                  return p.doubleCheckClear(), p.stateChanged || e(), !0;
                }, p.options.doubleCheckInterval)),
              p
            );
          }),
          (p.safariStatePoll = function () {
            var t = p.extractState(p.getLocationHref());
            if (!p.isLastSavedState(t))
              return (
                t || p.createStateObject(), p.Adapter.trigger(e, "popstate"), p
              );
          }),
          (p.back = function (e) {
            return !1 !== e && p.busy()
              ? (p.pushQueue({
                  scope: p,
                  callback: p.back,
                  args: arguments,
                  queue: e,
                }),
                !1)
              : (p.busy(!0),
                p.doubleCheck(function () {
                  p.back(!1);
                }),
                h.go(-1),
                !0);
          }),
          (p.forward = function (e) {
            return !1 !== e && p.busy()
              ? (p.pushQueue({
                  scope: p,
                  callback: p.forward,
                  args: arguments,
                  queue: e,
                }),
                !1)
              : (p.busy(!0),
                p.doubleCheck(function () {
                  p.forward(!1);
                }),
                h.go(1),
                !0);
          }),
          (p.go = function (e, t) {
            var a;
            if (e > 0) for (a = 1; a <= e; ++a) p.forward(t);
            else {
              if (!(e < 0))
                throw new Error(
                  "History.go: History.go requires a positive or negative integer passed."
                );
              for (a = -1; a >= e; --a) p.back(t);
            }
            return p;
          }),
          p.emulated.pushState)
        ) {
          var f = function () {};
          (p.pushState = p.pushState || f),
            (p.replaceState = p.replaceState || f);
        } else
          (p.onPopState = function (t, a) {
            var r,
              n,
              o = !1,
              i = !1;
            return (
              p.doubleCheckComplete(),
              (r = p.getHash())
                ? ((n = p.extractState(r || p.getLocationHref(), !0))
                    ? p.replaceState(n.data, n.title, n.url, !1)
                    : (p.Adapter.trigger(e, "anchorchange"), p.busy(!1)),
                  (p.expectedStateId = !1),
                  !1)
                : ((o = p.Adapter.extractEventData("state", t, a) || !1),
                  (i = o
                    ? p.getStateById(o)
                    : p.expectedStateId
                    ? p.getStateById(p.expectedStateId)
                    : p.extractState(p.getLocationHref())) ||
                    (i = p.createStateObject(null, null, p.getLocationHref())),
                  (p.expectedStateId = !1),
                  p.isLastSavedState(i)
                    ? (p.busy(!1), !1)
                    : (p.storeState(i),
                      p.saveState(i),
                      p.setTitle(i),
                      p.Adapter.trigger(e, "statechange"),
                      p.busy(!1),
                      !0))
            );
          }),
            p.Adapter.bind(e, "popstate", p.onPopState),
            (p.pushState = function (t, a, r, n) {
              if (p.getHashByUrl(r) && p.emulated.pushState)
                throw new Error(
                  "History.js does not support states with fragement-identifiers (hashes/anchors)."
                );
              if (!1 !== n && p.busy())
                return (
                  p.pushQueue({
                    scope: p,
                    callback: p.pushState,
                    args: arguments,
                    queue: n,
                  }),
                  !1
                );
              p.busy(!0);
              var o = p.createStateObject(t, a, r);
              return (
                p.isLastSavedState(o)
                  ? p.busy(!1)
                  : (p.storeState(o),
                    (p.expectedStateId = o.id),
                    h.pushState(o.id, o.title, o.url),
                    p.Adapter.trigger(e, "popstate")),
                !0
              );
            }),
            (p.replaceState = function (t, a, r, n) {
              if (p.getHashByUrl(r) && p.emulated.pushState)
                throw new Error(
                  "History.js does not support states with fragement-identifiers (hashes/anchors)."
                );
              if (!1 !== n && p.busy())
                return (
                  p.pushQueue({
                    scope: p,
                    callback: p.replaceState,
                    args: arguments,
                    queue: n,
                  }),
                  !1
                );
              p.busy(!0);
              var o = p.createStateObject(t, a, r);
              return (
                p.isLastSavedState(o)
                  ? p.busy(!1)
                  : (p.storeState(o),
                    (p.expectedStateId = o.id),
                    h.replaceState(o.id, o.title, o.url),
                    p.Adapter.trigger(e, "popstate")),
                !0
              );
            });
        if (o) {
          try {
            p.store = c.parse(o.getItem("History.store")) || {};
          } catch (e) {
            p.store = {};
          }
          p.normalizeStore();
        } else (p.store = {}), p.normalizeStore();
        p.Adapter.bind(e, "unload", p.clearAllIntervals),
          p.saveState(p.storeState(p.extractState(p.getLocationHref(), !0))),
          o &&
            ((p.onUnload = function () {
              var e, t, a;
              try {
                e = c.parse(o.getItem("History.store")) || {};
              } catch (t) {
                e = {};
              }
              (e.idToState = e.idToState || {}),
                (e.urlToId = e.urlToId || {}),
                (e.stateToId = e.stateToId || {});
              for (t in p.idToState)
                p.idToState.hasOwnProperty(t) &&
                  (e.idToState[t] = p.idToState[t]);
              for (t in p.urlToId)
                p.urlToId.hasOwnProperty(t) && (e.urlToId[t] = p.urlToId[t]);
              for (t in p.stateToId)
                p.stateToId.hasOwnProperty(t) &&
                  (e.stateToId[t] = p.stateToId[t]);
              (p.store = e), p.normalizeStore(), (a = c.stringify(e));
              try {
                o.setItem("History.store", a);
              } catch (e) {
                if (e.code !== DOMException.QUOTA_EXCEEDED_ERR) throw e;
                o.length &&
                  (o.removeItem("History.store"),
                  o.setItem("History.store", a));
              }
            }),
            p.intervalList.push(u(p.onUnload, p.options.storeInterval)),
            p.Adapter.bind(e, "beforeunload", p.onUnload),
            p.Adapter.bind(e, "unload", p.onUnload)),
          p.emulated.pushState ||
            (p.bugs.safariPoll &&
              p.intervalList.push(
                u(p.safariStatePoll, p.options.safariPollInterval)
              ),
            ("Apple Computer, Inc." !== n.vendor &&
              "Mozilla" !== (n.appCodeName || "")) ||
              (p.Adapter.bind(e, "hashchange", function () {
                p.Adapter.trigger(e, "popstate");
              }),
              p.getHash() &&
                p.Adapter.onDomLoad(function () {
                  p.Adapter.trigger(e, "hashchange");
                })));
      }),
      (!p.options || !p.options.delayInit) && p.init();
  })(window);
/*! Currency tools */
if (void 0 === Currency) var Currency = {};
(Currency.cookie = {
  name: "roarStorage_currency",
  write: function (t) {
    try {
      localStorage.setItem(this.name, t);
    } catch (t) {}
  },
  read: function () {
    try {
      return localStorage.getItem(this.name);
    } catch (t) {
      return null;
    }
  },
  destroy: function () {
    try {
      localStorage.setItem(this.name, null);
    } catch (t) {}
  },
}),
  (Currency.moneyFormats = {
    USD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} USD",
    },
    EUR: {
      money_format: "&euro;{{amount}}",
      money_with_currency_format: "&euro;{{amount}} EUR",
    },
    GBP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} GBP",
    },
    CAD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} CAD",
    },
    ALL: {
      money_format: "Lek {{amount}}",
      money_with_currency_format: "Lek {{amount}} ALL",
    },
    DZD: {
      money_format: "DA {{amount}}",
      money_with_currency_format: "DA {{amount}} DZD",
    },
    AOA: {
      money_format: "Kz{{amount}}",
      money_with_currency_format: "Kz{{amount}} AOA",
    },
    ARS: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} ARS",
    },
    AMD: {
      money_format: "{{amount}} AMD",
      money_with_currency_format: "{{amount}} AMD",
    },
    AWG: {
      money_format: "Afl{{amount}}",
      money_with_currency_format: "Afl{{amount}} AWG",
    },
    AUD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} AUD",
    },
    BBD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} Bds",
    },
    AZN: {
      money_format: "m.{{amount}}",
      money_with_currency_format: "m.{{amount}} AZN",
    },
    BDT: {
      money_format: "Tk {{amount}}",
      money_with_currency_format: "Tk {{amount}} BDT",
    },
    BSD: {
      money_format: "BS${{amount}}",
      money_with_currency_format: "BS${{amount}} BSD",
    },
    BHD: {
      money_format: "{{amount}}0 BD",
      money_with_currency_format: "{{amount}}0 BHD",
    },
    BYR: {
      money_format: "Br {{amount}}",
      money_with_currency_format: "Br {{amount}} BYR",
    },
    BZD: {
      money_format: "BZ${{amount}}",
      money_with_currency_format: "BZ${{amount}} BZD",
    },
    BTN: {
      money_format: "Nu {{amount}}",
      money_with_currency_format: "Nu {{amount}} BTN",
    },
    BAM: {
      money_format: "KM {{amount_with_comma_separator}}",
      money_with_currency_format: "KM {{amount_with_comma_separator}} BAM",
    },
    BRL: {
      money_format: "R$ {{amount_with_comma_separator}}",
      money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL",
    },
    BOB: {
      money_format: "Bs{{amount_with_comma_separator}}",
      money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB",
    },
    BWP: {
      money_format: "P{{amount}}",
      money_with_currency_format: "P{{amount}} BWP",
    },
    BND: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} BND",
    },
    BGN: {
      money_format: "{{amount}} лв",
      money_with_currency_format: "{{amount}} лв BGN",
    },
    MMK: {
      money_format: "K{{amount}}",
      money_with_currency_format: "K{{amount}} MMK",
    },
    KHR: {
      money_format: "KHR{{amount}}",
      money_with_currency_format: "KHR{{amount}}",
    },
    KYD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} KYD",
    },
    XAF: {
      money_format: "FCFA{{amount}}",
      money_with_currency_format: "FCFA{{amount}} XAF",
    },
    CLP: {
      money_format: "${{amount_no_decimals}}",
      money_with_currency_format: "${{amount_no_decimals}} CLP",
    },
    CNY: {
      money_format: "&#165;{{amount}}",
      money_with_currency_format: "&#165;{{amount}} CNY",
    },
    COP: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} COP",
    },
    CRC: {
      money_format: "&#8353; {{amount_with_comma_separator}}",
      money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC",
    },
    HRK: {
      money_format: "{{amount_with_comma_separator}} kn",
      money_with_currency_format: "{{amount_with_comma_separator}} kn HRK",
    },
    CZK: {
      money_format: "{{amount_with_comma_separator}} K&#269;",
      money_with_currency_format: "{{amount_with_comma_separator}} K&#269;",
    },
    DKK: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "kr.{{amount_with_comma_separator}}",
    },
    DOP: {
      money_format: "RD$ {{amount}}",
      money_with_currency_format: "RD$ {{amount}}",
    },
    XCD: {
      money_format: "${{amount}}",
      money_with_currency_format: "EC${{amount}}",
    },
    EGP: {
      money_format: "LE {{amount}}",
      money_with_currency_format: "LE {{amount}} EGP",
    },
    ETB: {
      money_format: "Br{{amount}}",
      money_with_currency_format: "Br{{amount}} ETB",
    },
    XPF: {
      money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
      money_with_currency_format:
        "{{amount_no_decimals_with_comma_separator}} XPF",
    },
    FJD: {
      money_format: "${{amount}}",
      money_with_currency_format: "FJ${{amount}}",
    },
    GMD: {
      money_format: "D {{amount}}",
      money_with_currency_format: "D {{amount}} GMD",
    },
    GHS: {
      money_format: "GH&#8373;{{amount}}",
      money_with_currency_format: "GH&#8373;{{amount}}",
    },
    GTQ: {
      money_format: "Q{{amount}}",
      money_with_currency_format: "{{amount}} GTQ",
    },
    GYD: {
      money_format: "G${{amount}}",
      money_with_currency_format: "${{amount}} GYD",
    },
    GEL: {
      money_format: "{{amount}} GEL",
      money_with_currency_format: "{{amount}} GEL",
    },
    HNL: {
      money_format: "L {{amount}}",
      money_with_currency_format: "L {{amount}} HNL",
    },
    HKD: {
      money_format: "${{amount}}",
      money_with_currency_format: "HK${{amount}}",
    },
    HUF: {
      money_format: "{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format:
        "{{amount_no_decimals_with_comma_separator}} Ft",
    },
    ISK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr ISK",
    },
    INR: {
      money_format: "Rs. {{amount}}",
      money_with_currency_format: "Rs. {{amount}}",
    },
    IDR: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "Rp {{amount_with_comma_separator}}",
    },
    ILS: {
      money_format: "{{amount}} NIS",
      money_with_currency_format: "{{amount}} NIS",
    },
    JMD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} JMD",
    },
    JPY: {
      money_format: "&#165;{{amount_no_decimals}}",
      money_with_currency_format: "&#165;{{amount_no_decimals}} JPY",
    },
    JEP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} JEP",
    },
    JOD: {
      money_format: "{{amount}}0 JD",
      money_with_currency_format: "{{amount}}0 JOD",
    },
    KZT: {
      money_format: "{{amount}} KZT",
      money_with_currency_format: "{{amount}} KZT",
    },
    KES: {
      money_format: "KSh{{amount}}",
      money_with_currency_format: "KSh{{amount}}",
    },
    KWD: {
      money_format: "{{amount}}0 KD",
      money_with_currency_format: "{{amount}}0 KWD",
    },
    KGS: {
      money_format: "лв{{amount}}",
      money_with_currency_format: "лв{{amount}}",
    },
    LVL: {
      money_format: "Ls {{amount}}",
      money_with_currency_format: "Ls {{amount}} LVL",
    },
    LBP: {
      money_format: "L&pound;{{amount}}",
      money_with_currency_format: "L&pound;{{amount}} LBP",
    },
    LTL: {
      money_format: "{{amount}} Lt",
      money_with_currency_format: "{{amount}} Lt",
    },
    MGA: {
      money_format: "Ar {{amount}}",
      money_with_currency_format: "Ar {{amount}} MGA",
    },
    MKD: {
      money_format: "ден {{amount}}",
      money_with_currency_format: "ден {{amount}} MKD",
    },
    MOP: {
      money_format: "MOP${{amount}}",
      money_with_currency_format: "MOP${{amount}}",
    },
    MVR: {
      money_format: "Rf{{amount}}",
      money_with_currency_format: "Rf{{amount}} MRf",
    },
    MXN: {
      money_format: "$ {{amount}}",
      money_with_currency_format: "$ {{amount}} MXN",
    },
    MYR: {
      money_format: "RM{{amount}} MYR",
      money_with_currency_format: "RM{{amount}} MYR",
    },
    MUR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} MUR",
    },
    MDL: {
      money_format: "{{amount}} MDL",
      money_with_currency_format: "{{amount}} MDL",
    },
    MAD: {
      money_format: "{{amount}} dh",
      money_with_currency_format: "Dh {{amount}} MAD",
    },
    MNT: {
      money_format: "{{amount_no_decimals}} &#8366",
      money_with_currency_format: "{{amount_no_decimals}} MNT",
    },
    MZN: {
      money_format: "{{amount}} Mt",
      money_with_currency_format: "Mt {{amount}} MZN",
    },
    NAD: {
      money_format: "N${{amount}}",
      money_with_currency_format: "N${{amount}} NAD",
    },
    NPR: {
      money_format: "Rs{{amount}}",
      money_with_currency_format: "Rs{{amount}} NPR",
    },
    ANG: {
      money_format: "&fnof;{{amount}}",
      money_with_currency_format: "{{amount}} NA&fnof;",
    },
    NZD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} NZD",
    },
    NIO: {
      money_format: "C${{amount}}",
      money_with_currency_format: "C${{amount}} NIO",
    },
    NGN: {
      money_format: "&#8358;{{amount}}",
      money_with_currency_format: "&#8358;{{amount}} NGN",
    },
    NOK: {
      money_format: "kr {{amount_with_comma_separator}}",
      money_with_currency_format: "kr {{amount_with_comma_separator}} NOK",
    },
    OMR: {
      money_format: "{{amount_with_comma_separator}} OMR",
      money_with_currency_format: "{{amount_with_comma_separator}} OMR",
    },
    PKR: {
      money_format: "Rs.{{amount}}",
      money_with_currency_format: "Rs.{{amount}} PKR",
    },
    PGK: {
      money_format: "K {{amount}}",
      money_with_currency_format: "K {{amount}} PGK",
    },
    PYG: {
      money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format:
        "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
    },
    PEN: {
      money_format: "S/. {{amount}}",
      money_with_currency_format: "S/. {{amount}} PEN",
    },
    PHP: {
      money_format: "&#8369;{{amount}}",
      money_with_currency_format: "&#8369;{{amount}} PHP",
    },
    PLN: {
      money_format: "{{amount_with_comma_separator}} zl",
      money_with_currency_format: "{{amount_with_comma_separator}} zl PLN",
    },
    QAR: {
      money_format: "QAR {{amount_with_comma_separator}}",
      money_with_currency_format: "QAR {{amount_with_comma_separator}}",
    },
    RON: {
      money_format: "{{amount_with_comma_separator}} lei",
      money_with_currency_format: "{{amount_with_comma_separator}} lei RON",
    },
    RUB: {
      money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
      money_with_currency_format:
        "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
    },
    RWF: {
      money_format: "{{amount_no_decimals}} RF",
      money_with_currency_format: "{{amount_no_decimals}} RWF",
    },
    WST: {
      money_format: "WS$ {{amount}}",
      money_with_currency_format: "WS$ {{amount}} WST",
    },
    SAR: {
      money_format: "{{amount}} SR",
      money_with_currency_format: "{{amount}} SAR",
    },
    STD: {
      money_format: "Db {{amount}}",
      money_with_currency_format: "Db {{amount}} STD",
    },
    RSD: {
      money_format: "{{amount}} RSD",
      money_with_currency_format: "{{amount}} RSD",
    },
    SCR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} SCR",
    },
    SGD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} SGD",
    },
    SYP: {
      money_format: "S&pound;{{amount}}",
      money_with_currency_format: "S&pound;{{amount}} SYP",
    },
    ZAR: {
      money_format: "R {{amount}}",
      money_with_currency_format: "R {{amount}} ZAR",
    },
    KRW: {
      money_format: "&#8361;{{amount_no_decimals}}",
      money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW",
    },
    LKR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} LKR",
    },
    SEK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr SEK",
    },
    CHF: {
      money_format: "SFr. {{amount}}",
      money_with_currency_format: "SFr. {{amount}} CHF",
    },
    TWD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TWD",
    },
    THB: {
      money_format: "{{amount}} &#xe3f;",
      money_with_currency_format: "{{amount}} &#xe3f; THB",
    },
    TZS: {
      money_format: "{{amount}} TZS",
      money_with_currency_format: "{{amount}} TZS",
    },
    TTD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TTD",
    },
    TND: {
      money_format: "{{amount}}",
      money_with_currency_format: "{{amount}} DT",
    },
    TRY: {
      money_format: "{{amount}}TL",
      money_with_currency_format: "{{amount}}TL",
    },
    UGX: {
      money_format: "Ush {{amount_no_decimals}}",
      money_with_currency_format: "Ush {{amount_no_decimals}} UGX",
    },
    UAH: {
      money_format: "₴{{amount}}",
      money_with_currency_format: "₴{{amount}} UAH",
    },
    AED: {
      money_format: "Dhs. {{amount}}",
      money_with_currency_format: "Dhs. {{amount}} AED",
    },
    UYU: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} UYU",
    },
    VUV: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}}VT",
    },
    VEF: {
      money_format: "Bs. {{amount_with_comma_separator}}",
      money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF",
    },
    VND: {
      money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
      money_with_currency_format:
        "{{amount_no_decimals_with_comma_separator}} VND",
    },
    XBT: {
      money_format: "{{amount_no_decimals}} BTC",
      money_with_currency_format: "{{amount_no_decimals}} BTC",
    },
    XOF: {
      money_format: "CFA{{amount}}",
      money_with_currency_format: "CFA{{amount}} XOF",
    },
    ZMW: {
      money_format: "K{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format:
        "ZMW{{amount_no_decimals_with_comma_separator}}",
    },
    AFN: {
      money_format: "&#65;&#102; {{amount}}",
      money_with_currency_format: "&#65;&#102; {{amount}} AFN",
    },
    CVE: {
      money_format: "&#36; {{amount}}",
      money_with_currency_format: "&#36; {{amount}} CVE",
    },
    KMF: {
      money_format: "&#67;&#70; {{amount}}",
      money_with_currency_format: "&#67;&#70; {{amount}} KMF",
    },
    CDF: {
      money_format: "&#70;&#67; {{amount}}",
      money_with_currency_format: "&#70;&#67; {{amount}} CDF",
    },
    HTG: {
      money_format: "&#71; {{amount}}",
      money_with_currency_format: "&#71; {{amount}} HTG",
    },
    LAK: {
      money_format: "&#8365; {{amount}}",
      money_with_currency_format: "&#8365; {{amount}} LAK",
    },
    LSL: {
      money_format: "&#76; {{amount}}",
      money_with_currency_format: "&#76; {{amount}} LSL",
    },
    LRD: {
      money_format: "&#36; {{amount}}",
      money_with_currency_format: "&#36; {{amount}} LRD",
    },
    MWK: {
      money_format: "&#77;&#75; {{amount}}",
      money_with_currency_format: "&#77;&#75; {{amount}} MWK",
    },
    SDG: {
      money_format: "&#163; {{amount}}",
      money_with_currency_format: "&#163; {{amount}} SDG",
    },
    SBD: {
      money_format: "&#36; {{amount}}",
      money_with_currency_format: "&#36; {{amount}} SBD",
    },
    SRD: {
      money_format: "&#36; {{amount}}",
      money_with_currency_format: "&#36; {{amount}} SRD",
    },
    SZL: {
      money_format: "&#76; {{amount}}",
      money_with_currency_format: "&#76; {{amount}} SZL",
    },
    TMT: {
      money_format: "&#109; {{amount}}",
      money_with_currency_format: "&#109; {{amount}} TMT",
    },
    UZS: {
      money_format: "&#1083;&#1074; {{amount}}",
      money_with_currency_format: "&#1083;&#1074; {{amount}} UZS",
    },
    YER: {
      money_format: "&#65020; {{amount}}",
      money_with_currency_format: "&#65020; {{amount}} YER",
    },
  }),
  (Currency.formatMoney = function (o, m) {
    if ("function" == typeof Shopify.formatMoney)
      return Shopify.formatMoney(o, m);
    "string" == typeof o && (o = o.replace(".", ""));
    var t = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      a = m || "${{amount}}";
    function r(o, m) {
      return void 0 === o ? m : o;
    }
    function _(o, m, t, n) {
      if (
        ((m = r(m, 2)), (t = r(t, ",")), (n = r(n, ".")), isNaN(o) || null == o)
      )
        return 0;
      var a = (o = (o / 100).toFixed(m)).split(".");
      return (
        a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t) +
        (a[1] ? n + a[1] : "")
      );
    }
    switch (a.match(n)[1]) {
      case "amount":
        t = _(o, 2);
        break;
      case "amount_no_decimals":
        t = _(o, 0);
        break;
      case "amount_with_comma_separator":
        t = _(o, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        t = _(o, 0, ".", ",");
    }
    return a.replace(n, t);
  }),
  (Currency.currentCurrency = ""),
  (Currency.format = "money_with_currency_format"),
  (Currency.convertAll = function (o, m, t, n) {
    jQuery(t || "span.money").each(function () {
      if (jQuery(this).attr("data-currency") !== m) {
        if (jQuery(this).attr("data-currency-" + m))
          jQuery(this).html(jQuery(this).attr("data-currency-" + m));
        else {
          var t = 0,
            a = Currency.moneyFormats[o][n || Currency.format] || "{{amount}}",
            r = Currency.moneyFormats[m][n || Currency.format] || "{{amount}}";
          t =
            -1 !== a.indexOf("amount_no_decimals")
              ? Currency.convert(
                  100 *
                    parseInt(
                      jQuery(this)
                        .html()
                        .replace(/[^0-9]/g, ""),
                      10
                    ),
                  o,
                  m
                )
              : "JOD" === o || "KWD" == o || "BHD" == o
              ? Currency.convert(
                  parseInt(
                    jQuery(this)
                      .html()
                      .replace(/[^0-9]/g, ""),
                    10
                  ) / 10,
                  o,
                  m
                )
              : Currency.convert(
                  parseInt(
                    jQuery(this)
                      .html()
                      .replace(/[^0-9]/g, ""),
                    10
                  ),
                  o,
                  m
                );
          var _ = Currency.formatMoney(t, r);
          jQuery(this).html(_), jQuery(this).attr("data-currency-" + m, _);
        }
        jQuery(this).attr("data-currency", m);
      }
    }),
      (this.currentCurrency = m),
      this.cookie.write(m);
  });
/*! VelocityJS.org (1.0.0) */
!(function (e) {
  function t(e) {
    var t = e.length,
      r = $.type(e);
    return "function" === r || $.isWindow(e)
      ? !1
      : 1 === e.nodeType && t
      ? !0
      : "array" === r ||
        0 === t ||
        ("number" == typeof t && t > 0 && t - 1 in e);
  }
  if (!e.jQuery) {
    var $ = function (e, t) {
      return new $.fn.init(e, t);
    };
    ($.isWindow = function (e) {
      return null != e && e == e.window;
    }),
      ($.type = function (e) {
        return null == e
          ? e + ""
          : "object" == typeof e || "function" == typeof e
          ? a[o.call(e)] || "object"
          : typeof e;
      }),
      ($.isArray =
        Array.isArray ||
        function (e) {
          return "array" === $.type(e);
        }),
      ($.isPlainObject = function (e) {
        var t;
        if (!e || "object" !== $.type(e) || e.nodeType || $.isWindow(e))
          return !1;
        try {
          if (
            e.constructor &&
            !n.call(e, "constructor") &&
            !n.call(e.constructor.prototype, "isPrototypeOf")
          )
            return !1;
        } catch (r) {
          return !1;
        }
        for (t in e);
        return void 0 === t || n.call(e, t);
      }),
      ($.each = function (e, r, a) {
        var n,
          o = 0,
          i = e.length,
          s = t(e);
        if (a) {
          if (s) for (; i > o && ((n = r.apply(e[o], a)), n !== !1); o++);
          else for (o in e) if (((n = r.apply(e[o], a)), n === !1)) break;
        } else if (s)
          for (; i > o && ((n = r.call(e[o], o, e[o])), n !== !1); o++);
        else for (o in e) if (((n = r.call(e[o], o, e[o])), n === !1)) break;
        return e;
      }),
      ($.data = function (e, t, a) {
        if (void 0 === a) {
          var n = e[$.expando],
            o = n && r[n];
          if (void 0 === t) return o;
          if (o && t in o) return o[t];
        } else if (void 0 !== t) {
          var n = e[$.expando] || (e[$.expando] = ++$.uuid);
          return (r[n] = r[n] || {}), (r[n][t] = a), a;
        }
      }),
      ($.removeData = function (e, t) {
        var a = e[$.expando],
          n = a && r[a];
        n &&
          $.each(t, function (e, t) {
            delete n[t];
          });
      }),
      ($.extend = function () {
        var e,
          t,
          r,
          a,
          n,
          o,
          i = arguments[0] || {},
          s = 1,
          l = arguments.length,
          u = !1;
        for (
          "boolean" == typeof i && ((u = i), (i = arguments[s] || {}), s++),
            "object" != typeof i && "function" !== $.type(i) && (i = {}),
            s === l && ((i = this), s--);
          l > s;
          s++
        )
          if (null != (n = arguments[s]))
            for (a in n)
              (e = i[a]),
                (r = n[a]),
                i !== r &&
                  (u && r && ($.isPlainObject(r) || (t = $.isArray(r)))
                    ? (t
                        ? ((t = !1), (o = e && $.isArray(e) ? e : []))
                        : (o = e && $.isPlainObject(e) ? e : {}),
                      (i[a] = $.extend(u, o, r)))
                    : void 0 !== r && (i[a] = r));
        return i;
      }),
      ($.queue = function (e, r, a) {
        function n(e, r) {
          var a = r || [];
          return (
            null != e &&
              (t(Object(e))
                ? !(function (e, t) {
                    for (var r = +t.length, a = 0, n = e.length; r > a; )
                      e[n++] = t[a++];
                    if (r !== r) for (; void 0 !== t[a]; ) e[n++] = t[a++];
                    return (e.length = n), e;
                  })(a, "string" == typeof e ? [e] : e)
                : [].push.call(a, e)),
            a
          );
        }
        if (e) {
          r = (r || "fx") + "queue";
          var o = $.data(e, r);
          return a
            ? (!o || $.isArray(a) ? (o = $.data(e, r, n(a))) : o.push(a), o)
            : o || [];
        }
      }),
      ($.dequeue = function (e, t) {
        $.each(e.nodeType ? [e] : e, function (e, r) {
          t = t || "fx";
          var a = $.queue(r, t),
            n = a.shift();
          "inprogress" === n && (n = a.shift()),
            n &&
              ("fx" === t && a.unshift("inprogress"),
              n.call(r, function () {
                $.dequeue(r, t);
              }));
        });
      }),
      ($.fn = $.prototype =
        {
          init: function (e) {
            if (e.nodeType) return (this[0] = e), this;
            throw new Error("Not a DOM node.");
          },
          offset: function () {
            var t = this[0].getBoundingClientRect();
            return {
              top:
                t.top +
                (e.pageYOffset || document.scrollTop || 0) -
                (document.clientTop || 0),
              left:
                t.left +
                (e.pageXOffset || document.scrollLeft || 0) -
                (document.clientLeft || 0),
            };
          },
          position: function () {
            function e() {
              for (
                var e = this.offsetParent || document;
                e &&
                "html" === !e.nodeType.toLowerCase &&
                "static" === e.style.position;

              )
                e = e.offsetParent;
              return e || document;
            }
            var t = this[0],
              e = e.apply(t),
              r = this.offset(),
              a = /^(?:body|html)$/i.test(e.nodeName)
                ? { top: 0, left: 0 }
                : $(e).offset();
            return (
              (r.top -= parseFloat(t.style.marginTop) || 0),
              (r.left -= parseFloat(t.style.marginLeft) || 0),
              e.style &&
                ((a.top += parseFloat(e.style.borderTopWidth) || 0),
                (a.left += parseFloat(e.style.borderLeftWidth) || 0)),
              { top: r.top - a.top, left: r.left - a.left }
            );
          },
        });
    var r = {};
    ($.expando = "velocity" + new Date().getTime()), ($.uuid = 0);
    for (
      var a = {},
        n = a.hasOwnProperty,
        o = a.toString,
        i =
          "Boolean Number String Function Array Date RegExp Object Error".split(
            " "
          ),
        s = 0;
      s < i.length;
      s++
    )
      a["[object " + i[s] + "]"] = i[s].toLowerCase();
    ($.fn.init.prototype = $.fn), (e.Velocity = { Utilities: $ });
  }
})(window),
  (function (e) {
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : e();
  })(function () {
    return (function (e, t, r, a) {
      function n(e) {
        for (var t = -1, r = e ? e.length : 0, a = []; ++t < r; ) {
          var n = e[t];
          n && a.push(n);
        }
        return a;
      }
      function o(e) {
        return (
          g.isWrapped(e) ? (e = [].slice.call(e)) : g.isNode(e) && (e = [e]), e
        );
      }
      function i(e) {
        var t = $.data(e, "velocity");
        return null === t ? a : t;
      }
      function s(e) {
        return function (t) {
          return Math.round(t * e) * (1 / e);
        };
      }
      function l(e, r, a, n) {
        function o(e, t) {
          return 1 - 3 * t + 3 * e;
        }
        function i(e, t) {
          return 3 * t - 6 * e;
        }
        function s(e) {
          return 3 * e;
        }
        function l(e, t, r) {
          return ((o(t, r) * e + i(t, r)) * e + s(t)) * e;
        }
        function u(e, t, r) {
          return 3 * o(t, r) * e * e + 2 * i(t, r) * e + s(t);
        }
        function c(t, r) {
          for (var n = 0; m > n; ++n) {
            var o = u(r, e, a);
            if (0 === o) return r;
            var i = l(r, e, a) - t;
            r -= i / o;
          }
          return r;
        }
        function p() {
          for (var t = 0; b > t; ++t) w[t] = l(t * x, e, a);
        }
        function f(t, r, n) {
          var o,
            i,
            s = 0;
          do
            (i = r + (n - r) / 2),
              (o = l(i, e, a) - t),
              o > 0 ? (n = i) : (r = i);
          while (Math.abs(o) > h && ++s < v);
          return i;
        }
        function d(t) {
          for (var r = 0, n = 1, o = b - 1; n != o && w[n] <= t; ++n) r += x;
          --n;
          var i = (t - w[n]) / (w[n + 1] - w[n]),
            s = r + i * x,
            l = u(s, e, a);
          return l >= y ? c(t, s) : 0 == l ? s : f(t, r, r + x);
        }
        function g() {
          (V = !0), (e != r || a != n) && p();
        }
        var m = 4,
          y = 0.001,
          h = 1e-7,
          v = 10,
          b = 11,
          x = 1 / (b - 1),
          S = "Float32Array" in t;
        if (4 !== arguments.length) return !1;
        for (var P = 0; 4 > P; ++P)
          if (
            "number" != typeof arguments[P] ||
            isNaN(arguments[P]) ||
            !isFinite(arguments[P])
          )
            return !1;
        (e = Math.min(e, 1)),
          (a = Math.min(a, 1)),
          (e = Math.max(e, 0)),
          (a = Math.max(a, 0));
        var w = S ? new Float32Array(b) : new Array(b),
          V = !1,
          C = function (t) {
            return (
              V || g(),
              e === r && a === n ? t : 0 === t ? 0 : 1 === t ? 1 : l(d(t), r, n)
            );
          };
        C.getControlPoints = function () {
          return [
            { x: e, y: r },
            { x: a, y: n },
          ];
        };
        var T = "generateBezier(" + [e, r, a, n] + ")";
        return (
          (C.toString = function () {
            return T;
          }),
          C
        );
      }
      function u(e, t) {
        var r = e;
        return (
          g.isString(e)
            ? v.Easings[e] || (r = !1)
            : (r =
                g.isArray(e) && 1 === e.length
                  ? s.apply(null, e)
                  : g.isArray(e) && 2 === e.length
                  ? b.apply(null, e.concat([t]))
                  : g.isArray(e) && 4 === e.length
                  ? l.apply(null, e)
                  : !1),
          r === !1 &&
            (r = v.Easings[v.defaults.easing] ? v.defaults.easing : h),
          r
        );
      }
      function c(e) {
        if (e)
          for (
            var t = new Date().getTime(), r = 0, n = v.State.calls.length;
            n > r;
            r++
          )
            if (v.State.calls[r]) {
              var o = v.State.calls[r],
                s = o[0],
                l = o[2],
                u = o[3];
              u || (u = v.State.calls[r][3] = t - 16);
              for (
                var f = Math.min((t - u) / l.duration, 1), d = 0, m = s.length;
                m > d;
                d++
              ) {
                var y = s[d],
                  h = y.element;
                if (i(h)) {
                  var b = !1;
                  if (
                    l.display !== a &&
                    null !== l.display &&
                    "none" !== l.display
                  ) {
                    if ("flex" === l.display) {
                      var S = [
                        "-webkit-box",
                        "-moz-box",
                        "-ms-flexbox",
                        "-webkit-flex",
                      ];
                      $.each(S, function (e, t) {
                        x.setPropertyValue(h, "display", t);
                      });
                    }
                    x.setPropertyValue(h, "display", l.display);
                  }
                  l.visibility &&
                    "hidden" !== l.visibility &&
                    x.setPropertyValue(h, "visibility", l.visibility);
                  for (var w in y)
                    if ("element" !== w) {
                      var V = y[w],
                        C,
                        T = g.isString(V.easing)
                          ? v.Easings[V.easing]
                          : V.easing;
                      if (
                        ((C =
                          1 === f
                            ? V.endValue
                            : V.startValue +
                              (V.endValue - V.startValue) * T(f)),
                        (V.currentValue = C),
                        x.Hooks.registered[w])
                      ) {
                        var k = x.Hooks.getRoot(w),
                          A = i(h).rootPropertyValueCache[k];
                        A && (V.rootPropertyValue = A);
                      }
                      var F = x.setPropertyValue(
                        h,
                        w,
                        V.currentValue +
                          (0 === parseFloat(C) ? "" : V.unitType),
                        V.rootPropertyValue,
                        V.scrollData
                      );
                      x.Hooks.registered[w] &&
                        (i(h).rootPropertyValueCache[k] = x.Normalizations
                          .registered[k]
                          ? x.Normalizations.registered[k](
                              "extract",
                              null,
                              F[1]
                            )
                          : F[1]),
                        "transform" === F[0] && (b = !0);
                    }
                  l.mobileHA &&
                    i(h).transformCache.translate3d === a &&
                    ((i(h).transformCache.translate3d = "(0px, 0px, 0px)"),
                    (b = !0)),
                    b && x.flushTransformCache(h);
                }
              }
              l.display !== a &&
                "none" !== l.display &&
                (v.State.calls[r][2].display = !1),
                l.visibility &&
                  "hidden" !== l.visibility &&
                  (v.State.calls[r][2].visibility = !1),
                l.progress &&
                  l.progress.call(
                    o[1],
                    o[1],
                    f,
                    Math.max(0, u + l.duration - t),
                    u
                  ),
                1 === f && p(r);
            }
        v.State.isTicking && P(c);
      }
      function p(e, t) {
        if (!v.State.calls[e]) return !1;
        for (
          var r = v.State.calls[e][0],
            n = v.State.calls[e][1],
            o = v.State.calls[e][2],
            s = v.State.calls[e][4],
            l = !1,
            u = 0,
            c = r.length;
          c > u;
          u++
        ) {
          var p = r[u].element;
          if (
            (t ||
              o.loop ||
              ("none" === o.display &&
                x.setPropertyValue(p, "display", o.display),
              "hidden" === o.visibility &&
                x.setPropertyValue(p, "visibility", o.visibility)),
            ($.queue(p)[1] === a ||
              !/\.velocityQueueEntryFlag/i.test($.queue(p)[1])) &&
              i(p))
          ) {
            (i(p).isAnimating = !1), (i(p).rootPropertyValueCache = {});
            var f = !1;
            $.each(x.Lists.transforms3D, function (e, t) {
              var r = /^scale/.test(t) ? 1 : 0,
                n = i(p).transformCache[t];
              i(p).transformCache[t] !== a &&
                new RegExp("^\\(" + r + "[^.]").test(n) &&
                ((f = !0), delete i(p).transformCache[t]);
            }),
              o.mobileHA && ((f = !0), delete i(p).transformCache.translate3d),
              f && x.flushTransformCache(p),
              x.Values.removeClass(p, "velocity-animating");
          }
          if (!t && o.complete && !o.loop && u === c - 1)
            try {
              o.complete.call(n, n);
            } catch (d) {
              setTimeout(function () {
                throw d;
              }, 1);
            }
          s && o.loop !== !0 && s(n),
            o.loop !== !0 ||
              t ||
              ($.each(i(p).tweensContainer, function (e, t) {
                /^rotate/.test(e) &&
                  360 === parseFloat(t.endValue) &&
                  ((t.endValue = 0), (t.startValue = 360));
              }),
              v(p, "reverse", { loop: !0, delay: o.delay })),
            o.queue !== !1 && $.dequeue(p, o.queue);
        }
        v.State.calls[e] = !1;
        for (var g = 0, m = v.State.calls.length; m > g; g++)
          if (v.State.calls[g] !== !1) {
            l = !0;
            break;
          }
        l === !1 &&
          ((v.State.isTicking = !1),
          delete v.State.calls,
          (v.State.calls = []));
      }
      var f = (function () {
          if (r.documentMode) return r.documentMode;
          for (var e = 7; e > 4; e--) {
            var t = r.createElement("div");
            if (
              ((t.innerHTML =
                "<!--[if IE " + e + "]><span></span><![endif]-->"),
              t.getElementsByTagName("span").length)
            )
              return (t = null), e;
          }
          return a;
        })(),
        d = (function () {
          var e = 0;
          return (
            t.webkitRequestAnimationFrame ||
            t.mozRequestAnimationFrame ||
            function (t) {
              var r = new Date().getTime(),
                a;
              return (
                (a = Math.max(0, 16 - (r - e))),
                (e = r + a),
                setTimeout(function () {
                  t(r + a);
                }, a)
              );
            }
          );
        })(),
        g = {
          isString: function (e) {
            return "string" == typeof e;
          },
          isArray:
            Array.isArray ||
            function (e) {
              return "[object Array]" === Object.prototype.toString.call(e);
            },
          isFunction: function (e) {
            return "[object Function]" === Object.prototype.toString.call(e);
          },
          isNode: function (e) {
            return e && e.nodeType;
          },
          isNodeList: function (e) {
            return (
              "object" == typeof e &&
              /^\[object (HTMLCollection|NodeList|Object)\]$/.test(
                Object.prototype.toString.call(e)
              ) &&
              e.length !== a &&
              (0 === e.length || ("object" == typeof e[0] && e[0].nodeType > 0))
            );
          },
          isWrapped: function (e) {
            return e && (e.jquery || (t.Zepto && t.Zepto.zepto.isZ(e)));
          },
          isSVG: function (e) {
            return t.SVGElement && e instanceof SVGElement;
          },
          isEmptyObject: function (e) {
            var t;
            for (t in e) return !1;
            return !0;
          },
        },
        $,
        m = !1;
      if (
        (e.fn && e.fn.jquery ? (($ = e), (m = !0)) : ($ = t.Velocity.Utilities),
        8 >= f && !m)
      )
        throw new Error(
          "Velocity: IE8 and below require jQuery to be loaded before Velocity."
        );
      if (7 >= f) return void (jQuery.fn.velocity = jQuery.fn.animate);
      var y = 400,
        h = "swing",
        v = {
          State: {
            isMobile:
              /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
              ),
            isAndroid: /Android/i.test(navigator.userAgent),
            isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
            isChrome: t.chrome,
            isFirefox: /Firefox/i.test(navigator.userAgent),
            prefixElement: r.createElement("div"),
            prefixMatches: {},
            scrollAnchor: null,
            scrollPropertyLeft: null,
            scrollPropertyTop: null,
            isTicking: !1,
            calls: [],
          },
          CSS: {},
          Utilities: $,
          Sequences: {},
          Easings: {},
          Promise: t.Promise,
          defaults: {
            queue: "",
            duration: y,
            easing: h,
            begin: null,
            complete: null,
            progress: null,
            display: a,
            loop: !1,
            delay: !1,
            mobileHA: !0,
            _cacheValues: !0,
          },
          init: function (e) {
            $.data(e, "velocity", {
              isSVG: g.isSVG(e),
              isAnimating: !1,
              computedStyle: null,
              tweensContainer: null,
              rootPropertyValueCache: {},
              transformCache: {},
            });
          },
          animate: null,
          hook: null,
          mock: !1,
          version: { major: 1, minor: 0, patch: 0 },
          debug: !1,
        };
      t.pageYOffset !== a
        ? ((v.State.scrollAnchor = t),
          (v.State.scrollPropertyLeft = "pageXOffset"),
          (v.State.scrollPropertyTop = "pageYOffset"))
        : ((v.State.scrollAnchor =
            r.documentElement || r.body.parentNode || r.body),
          (v.State.scrollPropertyLeft = "scrollLeft"),
          (v.State.scrollPropertyTop = "scrollTop"));
      var b = (function () {
        function e(e) {
          return -e.tension * e.x - e.friction * e.v;
        }
        function t(t, r, a) {
          var n = {
            x: t.x + a.dx * r,
            v: t.v + a.dv * r,
            tension: t.tension,
            friction: t.friction,
          };
          return { dx: n.v, dv: e(n) };
        }
        function r(r, a) {
          var n = { dx: r.v, dv: e(r) },
            o = t(r, 0.5 * a, n),
            i = t(r, 0.5 * a, o),
            s = t(r, a, i),
            l = (1 / 6) * (n.dx + 2 * (o.dx + i.dx) + s.dx),
            u = (1 / 6) * (n.dv + 2 * (o.dv + i.dv) + s.dv);
          return (r.x = r.x + l * a), (r.v = r.v + u * a), r;
        }
        return function a(e, t, n) {
          var o = { x: -1, v: 0, tension: null, friction: null },
            i = [0],
            s = 0,
            l = 1e-4,
            u = 0.016,
            c,
            p,
            f;
          for (
            e = parseFloat(e) || 500,
              t = parseFloat(t) || 20,
              n = n || null,
              o.tension = e,
              o.friction = t,
              c = null !== n,
              c ? ((s = a(e, t)), (p = (s / n) * u)) : (p = u);
            ;

          )
            if (
              ((f = r(f || o, p)),
              i.push(1 + f.x),
              (s += 16),
              !(Math.abs(f.x) > l && Math.abs(f.v) > l))
            )
              break;
          return c
            ? function (e) {
                return i[(e * (i.length - 1)) | 0];
              }
            : s;
        };
      })();
      (v.Easings = {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return 0.5 - Math.cos(e * Math.PI) / 2;
        },
        spring: function (e) {
          return 1 - Math.cos(4.5 * e * Math.PI) * Math.exp(6 * -e);
        },
      }),
        $.each(
          [
            ["ease", [0.25, 0.1, 0.25, 1]],
            ["ease-in", [0.42, 0, 1, 1]],
            ["ease-out", [0, 0, 0.58, 1]],
            ["ease-in-out", [0.42, 0, 0.58, 1]],
            ["easeInSine", [0.47, 0, 0.745, 0.715]],
            ["easeOutSine", [0.39, 0.575, 0.565, 1]],
            ["easeInOutSine", [0.445, 0.05, 0.55, 0.95]],
            ["easeInQuad", [0.55, 0.085, 0.68, 0.53]],
            ["easeOutQuad", [0.25, 0.46, 0.45, 0.94]],
            ["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]],
            ["easeInCubic", [0.55, 0.055, 0.675, 0.19]],
            ["easeOutCubic", [0.215, 0.61, 0.355, 1]],
            ["easeInOutCubic", [0.645, 0.045, 0.355, 1]],
            ["easeInQuart", [0.895, 0.03, 0.685, 0.22]],
            ["easeOutQuart", [0.165, 0.84, 0.44, 1]],
            ["easeInOutQuart", [0.77, 0, 0.175, 1]],
            ["easeInQuint", [0.755, 0.05, 0.855, 0.06]],
            ["easeOutQuint", [0.23, 1, 0.32, 1]],
            ["easeInOutQuint", [0.86, 0, 0.07, 1]],
            ["easeInExpo", [0.95, 0.05, 0.795, 0.035]],
            ["easeOutExpo", [0.19, 1, 0.22, 1]],
            ["easeInOutExpo", [1, 0, 0, 1]],
            ["easeInCirc", [0.6, 0.04, 0.98, 0.335]],
            ["easeOutCirc", [0.075, 0.82, 0.165, 1]],
            ["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]],
          ],
          function (e, t) {
            v.Easings[t[0]] = l.apply(null, t[1]);
          }
        );
      var x = (v.CSS = {
        RegEx: {
          isHex: /^#([A-f\d]{3}){1,2}$/i,
          valueUnwrap: /^[A-z]+\((.*)\)$/i,
          wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
          valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi,
        },
        Lists: {
          colors: [
            "fill",
            "stroke",
            "stopColor",
            "color",
            "backgroundColor",
            "borderColor",
            "borderTopColor",
            "borderRightColor",
            "borderBottomColor",
            "borderLeftColor",
            "outlineColor",
          ],
          transformsBase: [
            "translateX",
            "translateY",
            "scale",
            "scaleX",
            "scaleY",
            "skewX",
            "skewY",
            "rotateZ",
          ],
          transforms3D: [
            "transformPerspective",
            "translateZ",
            "scaleZ",
            "rotateX",
            "rotateY",
          ],
        },
        Hooks: {
          templates: {
            textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
            boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
            clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
            backgroundPosition: ["X Y", "0% 0%"],
            transformOrigin: ["X Y Z", "50% 50% 0px"],
            perspectiveOrigin: ["X Y", "50% 50%"],
          },
          registered: {},
          register: function () {
            for (var e = 0; e < x.Lists.colors.length; e++)
              x.Hooks.templates[x.Lists.colors[e]] = [
                "Red Green Blue Alpha",
                "255 255 255 1",
              ];
            var t, r, a;
            if (f)
              for (t in x.Hooks.templates) {
                (r = x.Hooks.templates[t]), (a = r[0].split(" "));
                var n = r[1].match(x.RegEx.valueSplit);
                "Color" === a[0] &&
                  (a.push(a.shift()),
                  n.push(n.shift()),
                  (x.Hooks.templates[t] = [a.join(" "), n.join(" ")]));
              }
            for (t in x.Hooks.templates) {
              (r = x.Hooks.templates[t]), (a = r[0].split(" "));
              for (var e in a) {
                var o = t + a[e],
                  i = e;
                x.Hooks.registered[o] = [t, i];
              }
            }
          },
          getRoot: function (e) {
            var t = x.Hooks.registered[e];
            return t ? t[0] : e;
          },
          cleanRootPropertyValue: function (e, t) {
            return (
              x.RegEx.valueUnwrap.test(t) &&
                (t = t.match(x.Hooks.RegEx.valueUnwrap)[1]),
              x.Values.isCSSNullValue(t) && (t = x.Hooks.templates[e][1]),
              t
            );
          },
          extractValue: function (e, t) {
            var r = x.Hooks.registered[e];
            if (r) {
              var a = r[0],
                n = r[1];
              return (
                (t = x.Hooks.cleanRootPropertyValue(a, t)),
                t.toString().match(x.RegEx.valueSplit)[n]
              );
            }
            return t;
          },
          injectValue: function (e, t, r) {
            var a = x.Hooks.registered[e];
            if (a) {
              var n = a[0],
                o = a[1],
                i,
                s;
              return (
                (r = x.Hooks.cleanRootPropertyValue(n, r)),
                (i = r.toString().match(x.RegEx.valueSplit)),
                (i[o] = t),
                (s = i.join(" "))
              );
            }
            return r;
          },
        },
        Normalizations: {
          registered: {
            clip: function (e, t, r) {
              switch (e) {
                case "name":
                  return "clip";
                case "extract":
                  var a;
                  return (
                    x.RegEx.wrappedValueAlreadyExtracted.test(r)
                      ? (a = r)
                      : ((a = r.toString().match(x.RegEx.valueUnwrap)),
                        (a = a ? a[1].replace(/,(\s+)?/g, " ") : r)),
                    a
                  );
                case "inject":
                  return "rect(" + r + ")";
              }
            },
            opacity: function (e, t, r) {
              if (8 >= f)
                switch (e) {
                  case "name":
                    return "filter";
                  case "extract":
                    var a = r.toString().match(/alpha\(opacity=(.*)\)/i);
                    return (r = a ? a[1] / 100 : 1);
                  case "inject":
                    return (
                      (t.style.zoom = 1),
                      parseFloat(r) >= 1
                        ? ""
                        : "alpha(opacity=" +
                          parseInt(100 * parseFloat(r), 10) +
                          ")"
                    );
                }
              else
                switch (e) {
                  case "name":
                    return "opacity";
                  case "extract":
                    return r;
                  case "inject":
                    return r;
                }
            },
          },
          register: function () {
            9 >= f ||
              v.State.isGingerbread ||
              (x.Lists.transformsBase = x.Lists.transformsBase.concat(
                x.Lists.transforms3D
              ));
            for (var e = 0; e < x.Lists.transformsBase.length; e++)
              !(function () {
                var t = x.Lists.transformsBase[e];
                x.Normalizations.registered[t] = function (e, r, n) {
                  switch (e) {
                    case "name":
                      return "transform";
                    case "extract":
                      return i(r) === a || i(r).transformCache[t] === a
                        ? /^scale/i.test(t)
                          ? 1
                          : 0
                        : i(r).transformCache[t].replace(/[()]/g, "");
                    case "inject":
                      var o = !1;
                      switch (t.substr(0, t.length - 1)) {
                        case "translate":
                          o = !/(%|px|em|rem|vw|vh|\d)$/i.test(n);
                          break;
                        case "scal":
                        case "scale":
                          v.State.isAndroid &&
                            i(r).transformCache[t] === a &&
                            1 > n &&
                            (n = 1),
                            (o = !/(\d)$/i.test(n));
                          break;
                        case "skew":
                          o = !/(deg|\d)$/i.test(n);
                          break;
                        case "rotate":
                          o = !/(deg|\d)$/i.test(n);
                      }
                      return (
                        o || (i(r).transformCache[t] = "(" + n + ")"),
                        i(r).transformCache[t]
                      );
                  }
                };
              })();
            for (var e = 0; e < x.Lists.colors.length; e++)
              !(function () {
                var t = x.Lists.colors[e];
                x.Normalizations.registered[t] = function (e, r, n) {
                  switch (e) {
                    case "name":
                      return t;
                    case "extract":
                      var o;
                      if (x.RegEx.wrappedValueAlreadyExtracted.test(n)) o = n;
                      else {
                        var i,
                          s = {
                            black: "rgb(0, 0, 0)",
                            blue: "rgb(0, 0, 255)",
                            gray: "rgb(128, 128, 128)",
                            green: "rgb(0, 128, 0)",
                            red: "rgb(255, 0, 0)",
                            white: "rgb(255, 255, 255)",
                          };
                        /^[A-z]+$/i.test(n)
                          ? (i = s[n] !== a ? s[n] : s.black)
                          : x.RegEx.isHex.test(n)
                          ? (i = "rgb(" + x.Values.hexToRgb(n).join(" ") + ")")
                          : /^rgba?\(/i.test(n) || (i = s.black),
                          (o = (i || n)
                            .toString()
                            .match(x.RegEx.valueUnwrap)[1]
                            .replace(/,(\s+)?/g, " "));
                      }
                      return (
                        8 >= f || 3 !== o.split(" ").length || (o += " 1"), o
                      );
                    case "inject":
                      return (
                        8 >= f
                          ? 4 === n.split(" ").length &&
                            (n = n.split(/\s+/).slice(0, 3).join(" "))
                          : 3 === n.split(" ").length && (n += " 1"),
                        (8 >= f ? "rgb" : "rgba") +
                          "(" +
                          n.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") +
                          ")"
                      );
                  }
                };
              })();
          },
        },
        Names: {
          camelCase: function (e) {
            return e.replace(/-(\w)/g, function (e, t) {
              return t.toUpperCase();
            });
          },
          SVGAttribute: function (e) {
            var t = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
            return (
              (f || (v.State.isAndroid && !v.State.isChrome)) &&
                (t += "|transform"),
              new RegExp("^(" + t + ")$", "i").test(e)
            );
          },
          prefixCheck: function (e) {
            if (v.State.prefixMatches[e]) return [v.State.prefixMatches[e], !0];
            for (
              var t = ["", "Webkit", "Moz", "ms", "O"], r = 0, a = t.length;
              a > r;
              r++
            ) {
              var n;
              if (
                ((n =
                  0 === r
                    ? e
                    : t[r] +
                      e.replace(/^\w/, function (e) {
                        return e.toUpperCase();
                      })),
                g.isString(v.State.prefixElement.style[n]))
              )
                return (v.State.prefixMatches[e] = n), [n, !0];
            }
            return [e, !1];
          },
        },
        Values: {
          hexToRgb: function (e) {
            var t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
              r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
              a;
            return (
              (e = e.replace(t, function (e, t, r, a) {
                return t + t + r + r + a + a;
              })),
              (a = r.exec(e)),
              a
                ? [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)]
                : [0, 0, 0]
            );
          },
          isCSSNullValue: function (e) {
            return (
              0 == e ||
              /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(e)
            );
          },
          getUnitType: function (e) {
            return /^(rotate|skew)/i.test(e)
              ? "deg"
              : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(
                  e
                )
              ? ""
              : "px";
          },
          getDisplayType: function (e) {
            var t = e.tagName.toString().toLowerCase();
            return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(
              t
            )
              ? "inline"
              : /^(li)$/i.test(t)
              ? "list-item"
              : /^(tr)$/i.test(t)
              ? "table-row"
              : "block";
          },
          addClass: function (e, t) {
            e.classList
              ? e.classList.add(t)
              : (e.className += (e.className.length ? " " : "") + t);
          },
          removeClass: function (e, t) {
            e.classList
              ? e.classList.remove(t)
              : (e.className = e.className
                  .toString()
                  .replace(
                    new RegExp(
                      "(^|\\s)" + t.split(" ").join("|") + "(\\s|$)",
                      "gi"
                    ),
                    " "
                  ));
          },
        },
        getPropertyValue: function (e, r, n, o) {
          function s(e, r) {
            function n() {
              u && x.setPropertyValue(e, "display", "none");
            }
            var l = 0;
            if (8 >= f) l = $.css(e, r);
            else {
              var u = !1;
              if (
                (/^(width|height)$/.test(r) &&
                  0 === x.getPropertyValue(e, "display") &&
                  ((u = !0),
                  x.setPropertyValue(e, "display", x.Values.getDisplayType(e))),
                !o)
              ) {
                if (
                  "height" === r &&
                  "border-box" !==
                    x.getPropertyValue(e, "boxSizing").toString().toLowerCase()
                ) {
                  var c =
                    e.offsetHeight -
                    (parseFloat(x.getPropertyValue(e, "borderTopWidth")) || 0) -
                    (parseFloat(x.getPropertyValue(e, "borderBottomWidth")) ||
                      0) -
                    (parseFloat(x.getPropertyValue(e, "paddingTop")) || 0) -
                    (parseFloat(x.getPropertyValue(e, "paddingBottom")) || 0);
                  return n(), c;
                }
                if (
                  "width" === r &&
                  "border-box" !==
                    x.getPropertyValue(e, "boxSizing").toString().toLowerCase()
                ) {
                  var p =
                    e.offsetWidth -
                    (parseFloat(x.getPropertyValue(e, "borderLeftWidth")) ||
                      0) -
                    (parseFloat(x.getPropertyValue(e, "borderRightWidth")) ||
                      0) -
                    (parseFloat(x.getPropertyValue(e, "paddingLeft")) || 0) -
                    (parseFloat(x.getPropertyValue(e, "paddingRight")) || 0);
                  return n(), p;
                }
              }
              var d;
              (d =
                i(e) === a
                  ? t.getComputedStyle(e, null)
                  : i(e).computedStyle
                  ? i(e).computedStyle
                  : (i(e).computedStyle = t.getComputedStyle(e, null))),
                (f || v.State.isFirefox) &&
                  "borderColor" === r &&
                  (r = "borderTopColor"),
                (l = 9 === f && "filter" === r ? d.getPropertyValue(r) : d[r]),
                ("" === l || null === l) && (l = e.style[r]),
                n();
            }
            if ("auto" === l && /^(top|right|bottom|left)$/i.test(r)) {
              var g = s(e, "position");
              ("fixed" === g || ("absolute" === g && /top|left/i.test(r))) &&
                (l = $(e).position()[r] + "px");
            }
            return l;
          }
          var l;
          if (x.Hooks.registered[r]) {
            var u = r,
              c = x.Hooks.getRoot(u);
            n === a && (n = x.getPropertyValue(e, x.Names.prefixCheck(c)[0])),
              x.Normalizations.registered[c] &&
                (n = x.Normalizations.registered[c]("extract", e, n)),
              (l = x.Hooks.extractValue(u, n));
          } else if (x.Normalizations.registered[r]) {
            var p, d;
            (p = x.Normalizations.registered[r]("name", e)),
              "transform" !== p &&
                ((d = s(e, x.Names.prefixCheck(p)[0])),
                x.Values.isCSSNullValue(d) &&
                  x.Hooks.templates[r] &&
                  (d = x.Hooks.templates[r][1])),
              (l = x.Normalizations.registered[r]("extract", e, d));
          }
          return (
            /^[\d-]/.test(l) ||
              (l =
                i(e) && i(e).isSVG && x.Names.SVGAttribute(r)
                  ? /^(height|width)$/i.test(r)
                    ? e.getBBox()[r]
                    : e.getAttribute(r)
                  : s(e, x.Names.prefixCheck(r)[0])),
            x.Values.isCSSNullValue(l) && (l = 0),
            v.debug >= 2 && console.log("Get " + r + ": " + l),
            l
          );
        },
        setPropertyValue: function (e, r, a, n, o) {
          var s = r;
          if ("scroll" === r)
            o.container
              ? (o.container["scroll" + o.direction] = a)
              : "Left" === o.direction
              ? t.scrollTo(a, o.alternateValue)
              : t.scrollTo(o.alternateValue, a);
          else if (
            x.Normalizations.registered[r] &&
            "transform" === x.Normalizations.registered[r]("name", e)
          )
            x.Normalizations.registered[r]("inject", e, a),
              (s = "transform"),
              (a = i(e).transformCache[r]);
          else {
            if (x.Hooks.registered[r]) {
              var l = r,
                u = x.Hooks.getRoot(r);
              (n = n || x.getPropertyValue(e, u)),
                (a = x.Hooks.injectValue(l, a, n)),
                (r = u);
            }
            if (
              (x.Normalizations.registered[r] &&
                ((a = x.Normalizations.registered[r]("inject", e, a)),
                (r = x.Normalizations.registered[r]("name", e))),
              (s = x.Names.prefixCheck(r)[0]),
              8 >= f)
            )
              try {
                e.style[s] = a;
              } catch (c) {
                v.debug &&
                  console.log(
                    "Browser does not support [" + a + "] for [" + s + "]"
                  );
              }
            else
              i(e) && i(e).isSVG && x.Names.SVGAttribute(r)
                ? e.setAttribute(r, a)
                : (e.style[s] = a);
            v.debug >= 2 && console.log("Set " + r + " (" + s + "): " + a);
          }
          return [s, a];
        },
        flushTransformCache: function (e) {
          function t(t) {
            return parseFloat(x.getPropertyValue(e, t));
          }
          var r = "";
          if ((f || (v.State.isAndroid && !v.State.isChrome)) && i(e).isSVG) {
            var a = {
              translate: [t("translateX"), t("translateY")],
              skewX: [t("skewX")],
              skewY: [t("skewY")],
              scale:
                1 !== t("scale")
                  ? [t("scale"), t("scale")]
                  : [t("scaleX"), t("scaleY")],
              rotate: [t("rotateZ"), 0, 0],
            };
            $.each(i(e).transformCache, function (e) {
              /^translate/i.test(e)
                ? (e = "translate")
                : /^scale/i.test(e)
                ? (e = "scale")
                : /^rotate/i.test(e) && (e = "rotate"),
                a[e] && ((r += e + "(" + a[e].join(" ") + ") "), delete a[e]);
            });
          } else {
            var n, o;
            $.each(i(e).transformCache, function (t) {
              return (
                (n = i(e).transformCache[t]),
                "transformPerspective" === t
                  ? ((o = n), !0)
                  : (9 === f && "rotateZ" === t && (t = "rotate"),
                    void (r += t + n + " "))
              );
            }),
              o && (r = "perspective" + o + " " + r);
          }
          x.setPropertyValue(e, "transform", r);
        },
      });
      x.Hooks.register(),
        x.Normalizations.register(),
        (v.hook = function (e, t, r) {
          var n = a;
          return (
            (e = o(e)),
            $.each(e, function (e, o) {
              if ((i(o) === a && v.init(o), r === a))
                n === a && (n = v.CSS.getPropertyValue(o, t));
              else {
                var s = v.CSS.setPropertyValue(o, t, r);
                "transform" === s[0] && v.CSS.flushTransformCache(o), (n = s);
              }
            }),
            n
          );
        });
      var S = function () {
        function e() {
          return f ? k.promise || null : d;
        }
        function s() {
          function e(e) {
            function f(e, t) {
              var r = a,
                n = a,
                i = a;
              return (
                g.isArray(e)
                  ? ((r = e[0]),
                    (!g.isArray(e[1]) && /^[\d-]/.test(e[1])) ||
                    g.isFunction(e[1]) ||
                    x.RegEx.isHex.test(e[1])
                      ? (i = e[1])
                      : ((g.isString(e[1]) && !x.RegEx.isHex.test(e[1])) ||
                          g.isArray(e[1])) &&
                        ((n = t ? e[1] : u(e[1], s.duration)),
                        e[2] !== a && (i = e[2])))
                  : (r = e),
                t || (n = n || s.easing),
                g.isFunction(r) && (r = r.call(o, V, w)),
                g.isFunction(i) && (i = i.call(o, V, w)),
                [r || 0, n, i]
              );
            }
            function d(e, t) {
              var r, a;
              return (
                (a = (t || 0)
                  .toString()
                  .toLowerCase()
                  .replace(/[%A-z]+$/, function (e) {
                    return (r = e), "";
                  })),
                r || (r = x.Values.getUnitType(e)),
                [a, r]
              );
            }
            function m() {
              var e = {
                  myParent: o.parentNode || r.body,
                  position: x.getPropertyValue(o, "position"),
                  fontSize: x.getPropertyValue(o, "fontSize"),
                },
                a =
                  e.position === L.lastPosition && e.myParent === L.lastParent,
                n = e.fontSize === L.lastFontSize;
              (L.lastParent = e.myParent),
                (L.lastPosition = e.position),
                (L.lastFontSize = e.fontSize);
              var s = 100,
                l = {};
              if (n && a)
                (l.emToPx = L.lastEmToPx),
                  (l.percentToPxWidth = L.lastPercentToPxWidth),
                  (l.percentToPxHeight = L.lastPercentToPxHeight);
              else {
                var u = i(o).isSVG
                  ? r.createElementNS("http://www.w3.org/2000/svg", "rect")
                  : r.createElement("div");
                v.init(u),
                  e.myParent.appendChild(u),
                  $.each(
                    ["overflow", "overflowX", "overflowY"],
                    function (e, t) {
                      v.CSS.setPropertyValue(u, t, "hidden");
                    }
                  ),
                  v.CSS.setPropertyValue(u, "position", e.position),
                  v.CSS.setPropertyValue(u, "fontSize", e.fontSize),
                  v.CSS.setPropertyValue(u, "boxSizing", "content-box"),
                  $.each(
                    [
                      "minWidth",
                      "maxWidth",
                      "width",
                      "minHeight",
                      "maxHeight",
                      "height",
                    ],
                    function (e, t) {
                      v.CSS.setPropertyValue(u, t, s + "%");
                    }
                  ),
                  v.CSS.setPropertyValue(u, "paddingLeft", s + "em"),
                  (l.percentToPxWidth = L.lastPercentToPxWidth =
                    (parseFloat(x.getPropertyValue(u, "width", null, !0)) ||
                      1) / s),
                  (l.percentToPxHeight = L.lastPercentToPxHeight =
                    (parseFloat(x.getPropertyValue(u, "height", null, !0)) ||
                      1) / s),
                  (l.emToPx = L.lastEmToPx =
                    (parseFloat(x.getPropertyValue(u, "paddingLeft")) || 1) /
                    s),
                  e.myParent.removeChild(u);
              }
              return (
                null === L.remToPx &&
                  (L.remToPx =
                    parseFloat(x.getPropertyValue(r.body, "fontSize")) || 16),
                null === L.vwToPx &&
                  ((L.vwToPx = parseFloat(t.innerWidth) / 100),
                  (L.vhToPx = parseFloat(t.innerHeight) / 100)),
                (l.remToPx = L.remToPx),
                (l.vwToPx = L.vwToPx),
                (l.vhToPx = L.vhToPx),
                v.debug >= 1 &&
                  console.log("Unit ratios: " + JSON.stringify(l), o),
                l
              );
            }
            if (s.begin && 0 === V)
              try {
                s.begin.call(h, h);
              } catch (y) {
                setTimeout(function () {
                  throw y;
                }, 1);
              }
            if ("scroll" === A) {
              var S = /^x$/i.test(s.axis) ? "Left" : "Top",
                C = parseFloat(s.offset) || 0,
                T,
                F,
                E;
              s.container
                ? g.isWrapped(s.container) || g.isNode(s.container)
                  ? ((s.container = s.container[0] || s.container),
                    (T = s.container["scroll" + S]),
                    (E = T + $(o).position()[S.toLowerCase()] + C))
                  : (s.container = null)
                : ((T = v.State.scrollAnchor[v.State["scrollProperty" + S]]),
                  (F =
                    v.State.scrollAnchor[
                      v.State[
                        "scrollProperty" + ("Left" === S ? "Top" : "Left")
                      ]
                    ]),
                  (E = $(o).offset()[S.toLowerCase()] + C)),
                (l = {
                  scroll: {
                    rootPropertyValue: !1,
                    startValue: T,
                    currentValue: T,
                    endValue: E,
                    unitType: "",
                    easing: s.easing,
                    scrollData: {
                      container: s.container,
                      direction: S,
                      alternateValue: F,
                    },
                  },
                  element: o,
                }),
                v.debug &&
                  console.log("tweensContainer (scroll): ", l.scroll, o);
            } else if ("reverse" === A) {
              if (!i(o).tweensContainer) return void $.dequeue(o, s.queue);
              "none" === i(o).opts.display && (i(o).opts.display = "auto"),
                "hidden" === i(o).opts.visibility &&
                  (i(o).opts.visibility = "visible"),
                (i(o).opts.loop = !1),
                (i(o).opts.begin = null),
                (i(o).opts.complete = null),
                P.easing || delete s.easing,
                P.duration || delete s.duration,
                (s = $.extend({}, i(o).opts, s));
              var j = $.extend(!0, {}, i(o).tweensContainer);
              for (var H in j)
                if ("element" !== H) {
                  var N = j[H].startValue;
                  (j[H].startValue = j[H].currentValue = j[H].endValue),
                    (j[H].endValue = N),
                    g.isEmptyObject(P) || (j[H].easing = s.easing),
                    v.debug &&
                      console.log(
                        "reverse tweensContainer (" +
                          H +
                          "): " +
                          JSON.stringify(j[H]),
                        o
                      );
                }
              l = j;
            } else if ("start" === A) {
              var j;
              i(o).tweensContainer &&
                i(o).isAnimating === !0 &&
                (j = i(o).tweensContainer),
                $.each(b, function (e, t) {
                  if (RegExp("^" + x.Lists.colors.join("$|^") + "$").test(e)) {
                    var r = f(t, !0),
                      n = r[0],
                      o = r[1],
                      i = r[2];
                    if (x.RegEx.isHex.test(n)) {
                      for (
                        var s = ["Red", "Green", "Blue"],
                          l = x.Values.hexToRgb(n),
                          u = i ? x.Values.hexToRgb(i) : a,
                          c = 0;
                        c < s.length;
                        c++
                      )
                        b[e + s[c]] = [l[c], o, u ? u[c] : u];
                      delete b[e];
                    }
                  }
                });
              for (var z in b) {
                var q = f(b[z]),
                  R = q[0],
                  M = q[1],
                  I = q[2];
                z = x.Names.camelCase(z);
                var W = x.Hooks.getRoot(z),
                  B = !1;
                if (
                  i(o).isSVG ||
                  x.Names.prefixCheck(W)[1] !== !1 ||
                  x.Normalizations.registered[W] !== a
                ) {
                  ((s.display !== a &&
                    null !== s.display &&
                    "none" !== s.display) ||
                    (s.visibility && "hidden" !== s.visibility)) &&
                    /opacity|filter/.test(z) &&
                    !I &&
                    0 !== R &&
                    (I = 0),
                    s._cacheValues && j && j[z]
                      ? (I === a && (I = j[z].endValue + j[z].unitType),
                        (B = i(o).rootPropertyValueCache[W]))
                      : x.Hooks.registered[z]
                      ? I === a
                        ? ((B = x.getPropertyValue(o, W)),
                          (I = x.getPropertyValue(o, z, B)))
                        : (B = x.Hooks.templates[W][1])
                      : I === a && (I = x.getPropertyValue(o, z));
                  var G,
                    D,
                    X,
                    Y = !1;
                  if (
                    ((G = d(z, I)),
                    (I = G[0]),
                    (X = G[1]),
                    (G = d(z, R)),
                    (R = G[0].replace(/^([+-\/*])=/, function (e, t) {
                      return (Y = t), "";
                    })),
                    (D = G[1]),
                    (I = parseFloat(I) || 0),
                    (R = parseFloat(R) || 0),
                    "%" === D &&
                      (/^(fontSize|lineHeight)$/.test(z)
                        ? ((R /= 100), (D = "em"))
                        : /^scale/.test(z)
                        ? ((R /= 100), (D = ""))
                        : /(Red|Green|Blue)$/i.test(z) &&
                          ((R = (R / 100) * 255), (D = ""))),
                    /[\/*]/.test(Y))
                  )
                    D = X;
                  else if (X !== D && 0 !== I)
                    if (0 === R) D = X;
                    else {
                      p = p || m();
                      var Q =
                        /margin|padding|left|right|width|text|word|letter/i.test(
                          z
                        ) ||
                        /X$/.test(z) ||
                        "x" === z
                          ? "x"
                          : "y";
                      switch (X) {
                        case "%":
                          I *=
                            "x" === Q
                              ? p.percentToPxWidth
                              : p.percentToPxHeight;
                          break;
                        case "px":
                          break;
                        default:
                          I *= p[X + "ToPx"];
                      }
                      switch (D) {
                        case "%":
                          I *=
                            1 /
                            ("x" === Q
                              ? p.percentToPxWidth
                              : p.percentToPxHeight);
                          break;
                        case "px":
                          break;
                        default:
                          I *= 1 / p[D + "ToPx"];
                      }
                    }
                  switch (Y) {
                    case "+":
                      R = I + R;
                      break;
                    case "-":
                      R = I - R;
                      break;
                    case "*":
                      R = I * R;
                      break;
                    case "/":
                      R = I / R;
                  }
                  (l[z] = {
                    rootPropertyValue: B,
                    startValue: I,
                    currentValue: I,
                    endValue: R,
                    unitType: D,
                    easing: M,
                  }),
                    v.debug &&
                      console.log(
                        "tweensContainer (" + z + "): " + JSON.stringify(l[z]),
                        o
                      );
                } else
                  v.debug &&
                    console.log(
                      "Skipping [" + W + "] due to a lack of browser support."
                    );
              }
              l.element = o;
            }
            l.element &&
              (x.Values.addClass(o, "velocity-animating"),
              O.push(l),
              "" === s.queue && ((i(o).tweensContainer = l), (i(o).opts = s)),
              (i(o).isAnimating = !0),
              V === w - 1
                ? (v.State.calls.length > 1e4 &&
                    (v.State.calls = n(v.State.calls)),
                  v.State.calls.push([O, h, s, null, k.resolver]),
                  v.State.isTicking === !1 && ((v.State.isTicking = !0), c()))
                : V++);
          }
          var o = this,
            s = $.extend({}, v.defaults, P),
            l = {},
            p;
          if (
            (i(o) === a && v.init(o),
            parseFloat(s.delay) &&
              s.queue !== !1 &&
              $.queue(o, s.queue, function (e) {
                (v.velocityQueueEntryFlag = !0),
                  (i(o).delayTimer = {
                    setTimeout: setTimeout(e, parseFloat(s.delay)),
                    next: e,
                  });
              }),
            v.mock === !0)
          )
            s.duration = 1;
          else
            switch (s.duration.toString().toLowerCase()) {
              case "fast":
                s.duration = 200;
                break;
              case "normal":
                s.duration = y;
                break;
              case "slow":
                s.duration = 600;
                break;
              default:
                s.duration = parseFloat(s.duration) || 1;
            }
          (s.easing = u(s.easing, s.duration)),
            s.begin && !g.isFunction(s.begin) && (s.begin = null),
            s.progress && !g.isFunction(s.progress) && (s.progress = null),
            s.complete && !g.isFunction(s.complete) && (s.complete = null),
            s.display !== a &&
              null !== s.display &&
              ((s.display = s.display.toString().toLowerCase()),
              "auto" === s.display &&
                (s.display = v.CSS.Values.getDisplayType(o))),
            s.visibility &&
              (s.visibility = s.visibility.toString().toLowerCase()),
            (s.mobileHA =
              s.mobileHA && v.State.isMobile && !v.State.isGingerbread),
            s.queue === !1
              ? s.delay
                ? setTimeout(e, s.delay)
                : e()
              : $.queue(o, s.queue, function (t, r) {
                  return r === !0
                    ? (k.promise && k.resolver(h), !0)
                    : ((v.velocityQueueEntryFlag = !0), void e(t));
                }),
            ("" !== s.queue && "fx" !== s.queue) ||
              "inprogress" === $.queue(o)[0] ||
              $.dequeue(o);
        }
        var l =
            arguments[0] &&
            (($.isPlainObject(arguments[0].properties) &&
              !arguments[0].properties.names) ||
              g.isString(arguments[0].properties)),
          f,
          d,
          m,
          h,
          b,
          P;
        if (
          (g.isWrapped(this)
            ? ((f = !1), (m = 0), (h = this), (d = this))
            : ((f = !0),
              (m = 1),
              (h = l ? arguments[0].elements : arguments[0])),
          (h = o(h)))
        ) {
          l
            ? ((b = arguments[0].properties), (P = arguments[0].options))
            : ((b = arguments[m]), (P = arguments[m + 1]));
          var w = h.length,
            V = 0;
          if ("stop" !== b && !$.isPlainObject(P)) {
            var C = m + 1;
            P = {};
            for (var T = C; T < arguments.length; T++)
              g.isArray(arguments[T]) ||
              (!/fast|normal|slow/i.test(arguments[T].toString()) &&
                !/^\d/.test(arguments[T]))
                ? g.isString(arguments[T]) || g.isArray(arguments[T])
                  ? (P.easing = arguments[T])
                  : g.isFunction(arguments[T]) && (P.complete = arguments[T])
                : (P.duration = arguments[T]);
          }
          var k = { promise: null, resolver: null, rejecter: null };
          f &&
            v.Promise &&
            (k.promise = new v.Promise(function (e, t) {
              (k.resolver = e), (k.rejecter = t);
            }));
          var A;
          switch (b) {
            case "scroll":
              A = "scroll";
              break;
            case "reverse":
              A = "reverse";
              break;
            case "stop":
              $.each(h, function (e, t) {
                i(t) &&
                  i(t).delayTimer &&
                  (clearTimeout(i(t).delayTimer.setTimeout),
                  i(t).delayTimer.next && i(t).delayTimer.next(),
                  delete i(t).delayTimer);
              });
              var F = [];
              return (
                $.each(v.State.calls, function (e, t) {
                  t &&
                    $.each(t[1], function (r, n) {
                      var o = g.isString(P) ? P : "";
                      return P !== a && t[2].queue !== o
                        ? !0
                        : void $.each(h, function (t, r) {
                            r === n &&
                              (P !== a &&
                                ($.each($.queue(r, o), function (e, t) {
                                  g.isFunction(t) && t(null, !0);
                                }),
                                $.queue(r, o, [])),
                              i(r) &&
                                "" === o &&
                                $.each(i(r).tweensContainer, function (e, t) {
                                  t.endValue = t.currentValue;
                                }),
                              F.push(e));
                          });
                    });
                }),
                $.each(F, function (e, t) {
                  p(t, !0);
                }),
                k.promise && k.resolver(h),
                e()
              );
            default:
              if (!$.isPlainObject(b) || g.isEmptyObject(b)) {
                if (g.isString(b) && v.Sequences[b]) {
                  var E = $.extend({}, P),
                    j = E.duration,
                    H = E.delay || 0;
                  return (
                    E.backwards === !0 && (h = h.reverse()),
                    $.each(h, function (e, t) {
                      parseFloat(E.stagger)
                        ? (E.delay = H + parseFloat(E.stagger) * e)
                        : g.isFunction(E.stagger) &&
                          (E.delay = H + E.stagger.call(t, e, w)),
                        E.drag &&
                          ((E.duration =
                            parseFloat(j) ||
                            (/^(callout|transition)/.test(b) ? 1e3 : y)),
                          (E.duration = Math.max(
                            E.duration *
                              (E.backwards ? 1 - e / w : (e + 1) / w),
                            0.75 * E.duration,
                            200
                          ))),
                        v.Sequences[b].call(
                          t,
                          t,
                          E || {},
                          e,
                          w,
                          h,
                          k.promise ? k : a
                        );
                    }),
                    e()
                  );
                }
                var N =
                  "Velocity: First argument (" +
                  b +
                  ") was not a property map, a known action, or a registered sequence. Aborting.";
                return (
                  k.promise ? k.rejecter(new Error(N)) : console.log(N), e()
                );
              }
              A = "start";
          }
          var L = {
              lastParent: null,
              lastPosition: null,
              lastFontSize: null,
              lastPercentToPxWidth: null,
              lastPercentToPxHeight: null,
              lastEmToPx: null,
              remToPx: null,
              vwToPx: null,
              vhToPx: null,
            },
            O = [];
          $.each(h, function (e, t) {
            g.isNode(t) && s.call(t);
          });
          var E = $.extend({}, v.defaults, P),
            z;
          if (((E.loop = parseInt(E.loop)), (z = 2 * E.loop - 1), E.loop))
            for (var q = 0; z > q; q++) {
              var R = { delay: E.delay };
              q === z - 1 &&
                ((R.display = E.display),
                (R.visibility = E.visibility),
                (R.complete = E.complete)),
                S(h, "reverse", R);
            }
          return e();
        }
      };
      (v = $.extend(S, v)), (v.animate = S);
      var P = t.requestAnimationFrame || d;
      return (
        v.State.isMobile ||
          r.hidden === a ||
          r.addEventListener("visibilitychange", function () {
            r.hidden
              ? ((P = function (e) {
                  return setTimeout(function () {
                    e(!0);
                  }, 16);
                }),
                c())
              : (P = t.requestAnimationFrame || d);
          }),
        (e.Velocity = v),
        e !== t && ((e.fn.velocity = S), (e.fn.velocity.defaults = v.defaults)),
        $.each(["Down", "Up"], function (e, t) {
          v.Sequences["slide" + t] = function (e, r, n, o, i, s) {
            var l = $.extend({}, r),
              u = l.begin,
              c = l.complete,
              p = {
                height: "",
                marginTop: "",
                marginBottom: "",
                paddingTop: "",
                paddingBottom: "",
              },
              f = {};
            l.display === a &&
              (l.display =
                "Down" === t
                  ? "inline" === v.CSS.Values.getDisplayType(e)
                    ? "inline-block"
                    : "block"
                  : "none"),
              (l.begin = function () {
                u && u.call(i, i),
                  (f.overflow = e.style.overflow),
                  (e.style.overflow = "hidden");
                for (var r in p) {
                  f[r] = e.style[r];
                  var a = v.CSS.getPropertyValue(e, r);
                  p[r] = "Down" === t ? [a, 0] : [0, a];
                }
              }),
              (l.complete = function () {
                for (var t in f) e.style[t] = f[t];
                c && c.call(i, i), s && s.resolver(i);
              }),
              v(e, p, l);
          };
        }),
        $.each(["In", "Out"], function (e, t) {
          v.Sequences["fade" + t] = function (e, r, n, o, i, s) {
            var l = $.extend({}, r),
              u = { opacity: "In" === t ? 1 : 0 },
              c = l.complete;
            (l.complete =
              n !== o - 1
                ? (l.begin = null)
                : function () {
                    c && c.call(i, i), s && s.resolver(i);
                  }),
              l.display === a && (l.display = "In" === t ? "auto" : "none"),
              v(this, u, l);
          };
        }),
        v
      );
    })(window.jQuery || window.Zepto || window, window, document);
  });
/*! NProgress */
!(function (n, e) {
  "function" == typeof define && define.amd
    ? define(e)
    : "object" == typeof exports
    ? (module.exports = e())
    : (n.NProgress = e());
})(this, function () {
  var n,
    e,
    t = { version: "0.2.0" },
    r = (t.settings = {
      minimum: 0.08,
      easing: "linear",
      positionUsing: "",
      speed: 200,
      trickle: !0,
      trickleSpeed: 200,
      showSpinner: !0,
      barSelector: '[role="bar"]',
      spinnerSelector: '[role="spinner"]',
      parent: "body",
      template:
        '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>',
    });
  function i(n, e, t) {
    return n < e ? e : n > t ? t : n;
  }
  function s(n) {
    return 100 * (-1 + n);
  }
  (t.configure = function (n) {
    var e, t;
    for (e in n) void 0 !== (t = n[e]) && n.hasOwnProperty(e) && (r[e] = t);
    return this;
  }),
    (t.status = null),
    (t.set = function (n) {
      var e = t.isStarted();
      (n = i(n, r.minimum, 1)), (t.status = 1 === n ? null : n);
      var u = t.render(!e),
        c = u.querySelector(r.barSelector),
        l = r.speed,
        f = r.easing;
      return (
        u.offsetWidth,
        o(function (e) {
          "" === r.positionUsing && (r.positionUsing = t.getPositioningCSS()),
            a(
              c,
              (function (n, e, t) {
                var i;
                i =
                  "translate3d" === r.positionUsing
                    ? { transform: "translate3d(" + s(n) + "%,0,0)" }
                    : "translate" === r.positionUsing
                    ? { transform: "translate(" + s(n) + "%,0)" }
                    : { "margin-left": s(n) + "%" };
                return (i.transition = "all " + e + "ms " + t), i;
              })(n, l, f)
            ),
            1 === n
              ? (a(u, { transition: "none", opacity: 1 }),
                u.offsetWidth,
                setTimeout(function () {
                  a(u, { transition: "all " + l + "ms linear", opacity: 0 }),
                    setTimeout(function () {
                      t.remove(), e();
                    }, l);
                }, l))
              : setTimeout(e, l);
        }),
        this
      );
    }),
    (t.isStarted = function () {
      return "number" == typeof t.status;
    }),
    (t.start = function () {
      t.status || t.set(0);
      var n = function () {
        setTimeout(function () {
          t.status && (t.trickle(), n());
        }, r.trickleSpeed);
      };
      return r.trickle && n(), this;
    }),
    (t.done = function (n) {
      return n || t.status ? t.inc(0.3 + 0.5 * Math.random()).set(1) : this;
    }),
    (t.inc = function (n) {
      var e = t.status;
      return e
        ? e > 1
          ? void 0
          : ("number" != typeof n &&
              (n =
                e >= 0 && e < 0.2
                  ? 0.1
                  : e >= 0.2 && e < 0.5
                  ? 0.04
                  : e >= 0.5 && e < 0.8
                  ? 0.02
                  : e >= 0.8 && e < 0.99
                  ? 0.005
                  : 0),
            (e = i(e + n, 0, 0.994)),
            t.set(e))
        : t.start();
    }),
    (t.trickle = function () {
      return t.inc();
    }),
    (n = 0),
    (e = 0),
    (t.promise = function (r) {
      return r && "resolved" !== r.state()
        ? (0 === e && t.start(),
          n++,
          e++,
          r.always(function () {
            0 == --e ? ((n = 0), t.done()) : t.set((n - e) / n);
          }),
          this)
        : this;
    }),
    (t.render = function (n) {
      if (t.isRendered()) return document.getElementById("nprogress");
      c(document.documentElement, "nprogress-busy");
      var e = document.createElement("div");
      (e.id = "nprogress"), (e.innerHTML = r.template);
      var i,
        o = e.querySelector(r.barSelector),
        u = n ? "-100" : s(t.status || 0),
        l = document.querySelector(r.parent);
      return (
        a(o, {
          transition: "all 0 linear",
          transform: "translate3d(" + u + "%,0,0)",
        }),
        r.showSpinner || ((i = e.querySelector(r.spinnerSelector)) && d(i)),
        l != document.body && c(l, "nprogress-custom-parent"),
        l.appendChild(e),
        e
      );
    }),
    (t.remove = function () {
      l(document.documentElement, "nprogress-busy"),
        l(document.querySelector(r.parent), "nprogress-custom-parent");
      var n = document.getElementById("nprogress");
      n && d(n);
    }),
    (t.isRendered = function () {
      return !!document.getElementById("nprogress");
    }),
    (t.getPositioningCSS = function () {
      var n = document.body.style,
        e =
          "WebkitTransform" in n
            ? "Webkit"
            : "MozTransform" in n
            ? "Moz"
            : "msTransform" in n
            ? "ms"
            : "OTransform" in n
            ? "O"
            : "";
      return e + "Perspective" in n
        ? "translate3d"
        : e + "Transform" in n
        ? "translate"
        : "margin";
    });
  var o = (function () {
      var n = [];
      function e() {
        var t = n.shift();
        t && t(e);
      }
      return function (t) {
        n.push(t), 1 == n.length && e();
      };
    })(),
    a = (function () {
      var n = ["Webkit", "O", "Moz", "ms"],
        e = {};
      function t(t) {
        return (
          (t = t
            .replace(/^-ms-/, "ms-")
            .replace(/-([\da-z])/gi, function (n, e) {
              return e.toUpperCase();
            })),
          e[t] ||
            (e[t] = (function (e) {
              var t = document.body.style;
              if (e in t) return e;
              for (
                var r, i = n.length, s = e.charAt(0).toUpperCase() + e.slice(1);
                i--;

              )
                if ((r = n[i] + s) in t) return r;
              return e;
            })(t))
        );
      }
      function r(n, e, r) {
        (e = t(e)), (n.style[e] = r);
      }
      return function (n, e) {
        var t,
          i,
          s = arguments;
        if (2 == s.length)
          for (t in e)
            void 0 !== (i = e[t]) && e.hasOwnProperty(t) && r(n, t, i);
        else r(n, s[1], s[2]);
      };
    })();
  function u(n, e) {
    return ("string" == typeof n ? n : f(n)).indexOf(" " + e + " ") >= 0;
  }
  function c(n, e) {
    var t = f(n),
      r = t + e;
    u(t, e) || (n.className = r.substring(1));
  }
  function l(n, e) {
    var t,
      r = f(n);
    u(n, e) &&
      ((t = r.replace(" " + e + " ", " ")),
      (n.className = t.substring(1, t.length - 1)));
  }
  function f(n) {
    return (" " + ((n && n.className) || "") + " ").replace(/\s+/gi, " ");
  }
  function d(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
  }
  return t;
});
/*! PhotoSwipe - v4.1.2 */
!(function (a, b) {
  "function" == typeof define && define.amd
    ? define(b)
    : "object" == typeof exports
    ? (module.exports = b())
    : (a.PhotoSwipe = b());
})(this, function () {
  "use strict";
  var a = function (a, b, c, d) {
    var e = {
      features: null,
      bind: function (a, b, c, d) {
        var e = (d ? "remove" : "add") + "EventListener";
        b = b.split(" ");
        for (var f = 0; f < b.length; f++) b[f] && a[e](b[f], c, !1);
      },
      isArray: function (a) {
        return a instanceof Array;
      },
      createEl: function (a, b) {
        var c = document.createElement(b || "div");
        return a && (c.className = a), c;
      },
      getScrollY: function () {
        var a = window.pageYOffset;
        return void 0 !== a ? a : document.documentElement.scrollTop;
      },
      unbind: function (a, b, c) {
        e.bind(a, b, c, !0);
      },
      removeClass: function (a, b) {
        var c = new RegExp("(\\s|^)" + b + "(\\s|$)");
        a.className = a.className
          .replace(c, " ")
          .replace(/^\s\s*/, "")
          .replace(/\s\s*$/, "");
      },
      addClass: function (a, b) {
        e.hasClass(a, b) || (a.className += (a.className ? " " : "") + b);
      },
      hasClass: function (a, b) {
        return (
          a.className && new RegExp("(^|\\s)" + b + "(\\s|$)").test(a.className)
        );
      },
      getChildByClass: function (a, b) {
        for (var c = a.firstChild; c; ) {
          if (e.hasClass(c, b)) return c;
          c = c.nextSibling;
        }
      },
      arraySearch: function (a, b, c) {
        for (var d = a.length; d--; ) if (a[d][c] === b) return d;
        return -1;
      },
      extend: function (a, b, c) {
        for (var d in b)
          if (b.hasOwnProperty(d)) {
            if (c && a.hasOwnProperty(d)) continue;
            a[d] = b[d];
          }
      },
      easing: {
        sine: {
          out: function (a) {
            return Math.sin(a * (Math.PI / 2));
          },
          inOut: function (a) {
            return -(Math.cos(Math.PI * a) - 1) / 2;
          },
        },
        cubic: {
          out: function (a) {
            return --a * a * a + 1;
          },
        },
      },
      detectFeatures: function () {
        if (e.features) return e.features;
        var a = e.createEl(),
          b = a.style,
          c = "",
          d = {};
        if (
          ((d.oldIE = document.all && !document.addEventListener),
          (d.touch = "ontouchstart" in window),
          window.requestAnimationFrame &&
            ((d.raf = window.requestAnimationFrame),
            (d.caf = window.cancelAnimationFrame)),
          (d.pointerEvent =
            navigator.pointerEnabled || navigator.msPointerEnabled),
          !d.pointerEvent)
        ) {
          var f = navigator.userAgent;
          if (/iP(hone|od)/.test(navigator.platform)) {
            var g = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
            g &&
              g.length > 0 &&
              ((g = parseInt(g[1], 10)),
              g >= 1 && g < 8 && (d.isOldIOSPhone = !0));
          }
          var h = f.match(/Android\s([0-9\.]*)/),
            i = h ? h[1] : 0;
          (i = parseFloat(i)),
            i >= 1 &&
              (i < 4.4 && (d.isOldAndroid = !0), (d.androidVersion = i)),
            (d.isMobileOpera = /opera mini|opera mobi/i.test(f));
        }
        for (
          var j,
            k,
            l = ["transform", "perspective", "animationName"],
            m = ["", "webkit", "Moz", "ms", "O"],
            n = 0;
          n < 4;
          n++
        ) {
          c = m[n];
          for (var o = 0; o < 3; o++)
            (j = l[o]),
              (k = c + (c ? j.charAt(0).toUpperCase() + j.slice(1) : j)),
              !d[j] && k in b && (d[j] = k);
          c &&
            !d.raf &&
            ((c = c.toLowerCase()),
            (d.raf = window[c + "RequestAnimationFrame"]),
            d.raf &&
              (d.caf =
                window[c + "CancelAnimationFrame"] ||
                window[c + "CancelRequestAnimationFrame"]));
        }
        if (!d.raf) {
          var p = 0;
          (d.raf = function (a) {
            var b = new Date().getTime(),
              c = Math.max(0, 16 - (b - p)),
              d = window.setTimeout(function () {
                a(b + c);
              }, c);
            return (p = b + c), d;
          }),
            (d.caf = function (a) {
              clearTimeout(a);
            });
        }
        return (
          (d.svg =
            !!document.createElementNS &&
            !!document.createElementNS("http://www.w3.org/2000/svg", "svg")
              .createSVGRect),
          (e.features = d),
          d
        );
      },
    };
    e.detectFeatures(),
      e.features.oldIE &&
        (e.bind = function (a, b, c, d) {
          b = b.split(" ");
          for (
            var e,
              f = (d ? "detach" : "attach") + "Event",
              g = function () {
                c.handleEvent.call(c);
              },
              h = 0;
            h < b.length;
            h++
          )
            if ((e = b[h]))
              if ("object" == typeof c && c.handleEvent) {
                if (d) {
                  if (!c["oldIE" + e]) return !1;
                } else c["oldIE" + e] = g;
                a[f]("on" + e, c["oldIE" + e]);
              } else a[f]("on" + e, c);
        });
    var f = this,
      g = 25,
      h = 3,
      i = {
        allowPanToNext: !0,
        spacing: 0.12,
        bgOpacity: 1,
        mouseUsed: !1,
        loop: !0,
        pinchToClose: !0,
        closeOnScroll: !0,
        closeOnVerticalDrag: !0,
        verticalDragRange: 0.75,
        hideAnimationDuration: 333,
        showAnimationDuration: 333,
        showHideOpacity: !1,
        focus: !0,
        escKey: !0,
        arrowKeys: !0,
        mainScrollEndFriction: 0.35,
        panEndFriction: 0.35,
        isClickableElement: function (a) {
          return "A" === a.tagName;
        },
        getDoubleTapZoom: function (a, b) {
          return a ? 1 : b.initialZoomLevel < 0.7 ? 1 : 1.33;
        },
        maxSpreadZoom: 1.33,
        modal: !0,
        scaleMode: "fit",
      };
    e.extend(i, d);
    var j,
      k,
      l,
      m,
      n,
      o,
      p,
      q,
      r,
      s,
      t,
      u,
      v,
      w,
      x,
      y,
      z,
      A,
      B,
      C,
      D,
      E,
      F,
      G,
      H,
      I,
      J,
      K,
      L,
      M,
      N,
      O,
      P,
      Q,
      R,
      S,
      T,
      U,
      V,
      W,
      X,
      Y,
      Z,
      $,
      _,
      aa,
      ba,
      ca,
      da,
      ea,
      fa,
      ga,
      ha,
      ia,
      ja,
      ka,
      la,
      ma = function () {
        return { x: 0, y: 0 };
      },
      na = ma(),
      oa = ma(),
      pa = ma(),
      qa = {},
      ra = 0,
      sa = {},
      ta = ma(),
      ua = 0,
      va = !0,
      wa = [],
      xa = {},
      ya = !1,
      za = function (a, b) {
        e.extend(f, b.publicMethods), wa.push(a);
      },
      Aa = function (a) {
        var b = ac();
        return a > b - 1 ? a - b : a < 0 ? b + a : a;
      },
      Ba = {},
      Ca = function (a, b) {
        return Ba[a] || (Ba[a] = []), Ba[a].push(b);
      },
      Da = function (a) {
        var b = Ba[a];
        if (b) {
          var c = Array.prototype.slice.call(arguments);
          c.shift();
          for (var d = 0; d < b.length; d++) b[d].apply(f, c);
        }
      },
      Ea = function () {
        return new Date().getTime();
      },
      Fa = function (a) {
        (ja = a), (f.bg.style.opacity = a * i.bgOpacity);
      },
      Ga = function (a, b, c, d, e) {
        (!ya || (e && e !== f.currItem)) &&
          (d /= e ? e.fitRatio : f.currItem.fitRatio),
          (a[E] = u + b + "px, " + c + "px" + v + " scale(" + d + ")");
      },
      Ha = function (a) {
        ea &&
          (a &&
            (s > f.currItem.fitRatio
              ? ya || (mc(f.currItem, !1, !0), (ya = !0))
              : ya && (mc(f.currItem), (ya = !1))),
          Ga(ea, pa.x, pa.y, s));
      },
      Ia = function (a) {
        a.container &&
          Ga(
            a.container.style,
            a.initialPosition.x,
            a.initialPosition.y,
            a.initialZoomLevel,
            a
          );
      },
      Ja = function (a, b) {
        b[E] = u + a + "px, 0px" + v;
      },
      Ka = function (a, b) {
        if (!i.loop && b) {
          var c = m + (ta.x * ra - a) / ta.x,
            d = Math.round(a - tb.x);
          ((c < 0 && d > 0) || (c >= ac() - 1 && d < 0)) &&
            (a = tb.x + d * i.mainScrollEndFriction);
        }
        (tb.x = a), Ja(a, n);
      },
      La = function (a, b) {
        var c = ub[a] - sa[a];
        return oa[a] + na[a] + c - c * (b / t);
      },
      Ma = function (a, b) {
        (a.x = b.x), (a.y = b.y), b.id && (a.id = b.id);
      },
      Na = function (a) {
        (a.x = Math.round(a.x)), (a.y = Math.round(a.y));
      },
      Oa = null,
      Pa = function () {
        Oa &&
          (e.unbind(document, "mousemove", Pa),
          e.addClass(a, "pswp--has_mouse"),
          (i.mouseUsed = !0),
          Da("mouseUsed")),
          (Oa = setTimeout(function () {
            Oa = null;
          }, 100));
      },
      Qa = function () {
        e.bind(document, "keydown", f),
          N.transform && e.bind(f.scrollWrap, "click", f),
          i.mouseUsed || e.bind(document, "mousemove", Pa),
          e.bind(window, "resize scroll orientationchange", f),
          Da("bindEvents");
      },
      Ra = function () {
        e.unbind(window, "resize scroll orientationchange", f),
          e.unbind(window, "scroll", r.scroll),
          e.unbind(document, "keydown", f),
          e.unbind(document, "mousemove", Pa),
          N.transform && e.unbind(f.scrollWrap, "click", f),
          V && e.unbind(window, p, f),
          clearTimeout(O),
          Da("unbindEvents");
      },
      Sa = function (a, b) {
        var c = ic(f.currItem, qa, a);
        return b && (da = c), c;
      },
      Ta = function (a) {
        return a || (a = f.currItem), a.initialZoomLevel;
      },
      Ua = function (a) {
        return a || (a = f.currItem), a.w > 0 ? i.maxSpreadZoom : 1;
      },
      Va = function (a, b, c, d) {
        return d === f.currItem.initialZoomLevel
          ? ((c[a] = f.currItem.initialPosition[a]), !0)
          : ((c[a] = La(a, d)),
            c[a] > b.min[a]
              ? ((c[a] = b.min[a]), !0)
              : c[a] < b.max[a] && ((c[a] = b.max[a]), !0));
      },
      Wa = function () {
        if (E) {
          var b = N.perspective && !G;
          return (
            (u = "translate" + (b ? "3d(" : "(")),
            void (v = N.perspective ? ", 0px)" : ")")
          );
        }
        (E = "left"),
          e.addClass(a, "pswp--ie"),
          (Ja = function (a, b) {
            b.left = a + "px";
          }),
          (Ia = function (a) {
            var b = a.fitRatio > 1 ? 1 : a.fitRatio,
              c = a.container.style,
              d = b * a.w,
              e = b * a.h;
            (c.width = d + "px"),
              (c.height = e + "px"),
              (c.left = a.initialPosition.x + "px"),
              (c.top = a.initialPosition.y + "px");
          }),
          (Ha = function () {
            if (ea) {
              var a = ea,
                b = f.currItem,
                c = b.fitRatio > 1 ? 1 : b.fitRatio,
                d = c * b.w,
                e = c * b.h;
              (a.width = d + "px"),
                (a.height = e + "px"),
                (a.left = pa.x + "px"),
                (a.top = pa.y + "px");
            }
          });
      },
      Xa = function (a) {
        var b = "";
        i.escKey && 27 === a.keyCode
          ? (b = "close")
          : i.arrowKeys &&
            (37 === a.keyCode
              ? (b = "prev")
              : 39 === a.keyCode && (b = "next")),
          b &&
            (a.ctrlKey ||
              a.altKey ||
              a.shiftKey ||
              a.metaKey ||
              (a.preventDefault ? a.preventDefault() : (a.returnValue = !1),
              f[b]()));
      },
      Ya = function (a) {
        a && (Y || X || fa || T) && (a.preventDefault(), a.stopPropagation());
      },
      Za = function () {
        f.setScrollOffset(0, e.getScrollY());
      },
      $a = {},
      _a = 0,
      ab = function (a) {
        $a[a] && ($a[a].raf && I($a[a].raf), _a--, delete $a[a]);
      },
      bb = function (a) {
        $a[a] && ab(a), $a[a] || (_a++, ($a[a] = {}));
      },
      cb = function () {
        for (var a in $a) $a.hasOwnProperty(a) && ab(a);
      },
      db = function (a, b, c, d, e, f, g) {
        var h,
          i = Ea();
        bb(a);
        var j = function () {
          if ($a[a]) {
            if (((h = Ea() - i), h >= d)) return ab(a), f(c), void (g && g());
            f((c - b) * e(h / d) + b), ($a[a].raf = H(j));
          }
        };
        j();
      },
      eb = {
        shout: Da,
        listen: Ca,
        viewportSize: qa,
        options: i,
        isMainScrollAnimating: function () {
          return fa;
        },
        getZoomLevel: function () {
          return s;
        },
        getCurrentIndex: function () {
          return m;
        },
        isDragging: function () {
          return V;
        },
        isZooming: function () {
          return aa;
        },
        setScrollOffset: function (a, b) {
          (sa.x = a), (M = sa.y = b), Da("updateScrollOffset", sa);
        },
        applyZoomPan: function (a, b, c, d) {
          (pa.x = b), (pa.y = c), (s = a), Ha(d);
        },
        init: function () {
          if (!j && !k) {
            var c;
            (f.framework = e),
              (f.template = a),
              (f.bg = e.getChildByClass(a, "pswp__bg")),
              (J = a.className),
              (j = !0),
              (N = e.detectFeatures()),
              (H = N.raf),
              (I = N.caf),
              (E = N.transform),
              (L = N.oldIE),
              (f.scrollWrap = e.getChildByClass(a, "pswp__scroll-wrap")),
              (f.container = e.getChildByClass(
                f.scrollWrap,
                "pswp__container"
              )),
              (n = f.container.style),
              (f.itemHolders = y =
                [
                  { el: f.container.children[0], wrap: 0, index: -1 },
                  { el: f.container.children[1], wrap: 0, index: -1 },
                  { el: f.container.children[2], wrap: 0, index: -1 },
                ]),
              (y[0].el.style.display = y[2].el.style.display = "none"),
              Wa(),
              (r = {
                resize: f.updateSize,
                orientationchange: function () {
                  clearTimeout(O),
                    (O = setTimeout(function () {
                      qa.x !== f.scrollWrap.clientWidth && f.updateSize();
                    }, 500));
                },
                scroll: Za,
                keydown: Xa,
                click: Ya,
              });
            var d = N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
            for (
              (N.animationName && N.transform && !d) ||
                (i.showAnimationDuration = i.hideAnimationDuration = 0),
                c = 0;
              c < wa.length;
              c++
            )
              f["init" + wa[c]]();
            if (b) {
              var g = (f.ui = new b(f, e));
              g.init();
            }
            Da("firstUpdate"),
              (m = m || i.index || 0),
              (isNaN(m) || m < 0 || m >= ac()) && (m = 0),
              (f.currItem = _b(m)),
              (N.isOldIOSPhone || N.isOldAndroid) && (va = !1),
              a.setAttribute("aria-hidden", "false"),
              i.modal &&
                (va
                  ? (a.style.position = "fixed")
                  : ((a.style.position = "absolute"),
                    (a.style.top = e.getScrollY() + "px"))),
              void 0 === M && (Da("initialLayout"), (M = K = e.getScrollY()));
            var l = "pswp--open ";
            for (
              i.mainClass && (l += i.mainClass + " "),
                i.showHideOpacity && (l += "pswp--animate_opacity "),
                l += G ? "pswp--touch" : "pswp--notouch",
                l += N.animationName ? " pswp--css_animation" : "",
                l += N.svg ? " pswp--svg" : "",
                e.addClass(a, l),
                f.updateSize(),
                o = -1,
                ua = null,
                c = 0;
              c < h;
              c++
            )
              Ja((c + o) * ta.x, y[c].el.style);
            L || e.bind(f.scrollWrap, q, f),
              Ca("initialZoomInEnd", function () {
                f.setContent(y[0], m - 1),
                  f.setContent(y[2], m + 1),
                  (y[0].el.style.display = y[2].el.style.display = "block"),
                  i.focus && a.focus(),
                  Qa();
              }),
              f.setContent(y[1], m),
              f.updateCurrItem(),
              Da("afterInit"),
              va ||
                (w = setInterval(function () {
                  _a ||
                    V ||
                    aa ||
                    s !== f.currItem.initialZoomLevel ||
                    f.updateSize();
                }, 1e3)),
              e.addClass(a, "pswp--visible");
          }
        },
        close: function () {
          j &&
            ((j = !1),
            (k = !0),
            Da("close"),
            Ra(),
            cc(f.currItem, null, !0, f.destroy));
        },
        destroy: function () {
          Da("destroy"),
            Xb && clearTimeout(Xb),
            a.setAttribute("aria-hidden", "true"),
            (a.className = J),
            w && clearInterval(w),
            e.unbind(f.scrollWrap, q, f),
            e.unbind(window, "scroll", f),
            zb(),
            cb(),
            (Ba = null);
        },
        panTo: function (a, b, c) {
          c ||
            (a > da.min.x ? (a = da.min.x) : a < da.max.x && (a = da.max.x),
            b > da.min.y ? (b = da.min.y) : b < da.max.y && (b = da.max.y)),
            (pa.x = a),
            (pa.y = b),
            Ha();
        },
        handleEvent: function (a) {
          (a = a || window.event), r[a.type] && r[a.type](a);
        },
        goTo: function (a) {
          a = Aa(a);
          var b = a - m;
          (ua = b),
            (m = a),
            (f.currItem = _b(m)),
            (ra -= b),
            Ka(ta.x * ra),
            cb(),
            (fa = !1),
            f.updateCurrItem();
        },
        next: function () {
          f.goTo(m + 1);
        },
        prev: function () {
          f.goTo(m - 1);
        },
        updateCurrZoomItem: function (a) {
          if ((a && Da("beforeChange", 0), y[1].el.children.length)) {
            var b = y[1].el.children[0];
            ea = e.hasClass(b, "pswp__zoom-wrap") ? b.style : null;
          } else ea = null;
          (da = f.currItem.bounds),
            (t = s = f.currItem.initialZoomLevel),
            (pa.x = da.center.x),
            (pa.y = da.center.y),
            a && Da("afterChange");
        },
        invalidateCurrItems: function () {
          x = !0;
          for (var a = 0; a < h; a++) y[a].item && (y[a].item.needsUpdate = !0);
        },
        updateCurrItem: function (a) {
          if (0 !== ua) {
            var b,
              c = Math.abs(ua);
            if (!(a && c < 2)) {
              (f.currItem = _b(m)),
                (ya = !1),
                Da("beforeChange", ua),
                c >= h && ((o += ua + (ua > 0 ? -h : h)), (c = h));
              for (var d = 0; d < c; d++)
                ua > 0
                  ? ((b = y.shift()),
                    (y[h - 1] = b),
                    o++,
                    Ja((o + 2) * ta.x, b.el.style),
                    f.setContent(b, m - c + d + 1 + 1))
                  : ((b = y.pop()),
                    y.unshift(b),
                    o--,
                    Ja(o * ta.x, b.el.style),
                    f.setContent(b, m + c - d - 1 - 1));
              if (ea && 1 === Math.abs(ua)) {
                var e = _b(z);
                e.initialZoomLevel !== s && (ic(e, qa), mc(e), Ia(e));
              }
              (ua = 0), f.updateCurrZoomItem(), (z = m), Da("afterChange");
            }
          }
        },
        updateSize: function (b) {
          if (!va && i.modal) {
            var c = e.getScrollY();
            if (
              (M !== c && ((a.style.top = c + "px"), (M = c)),
              !b && xa.x === window.innerWidth && xa.y === window.innerHeight)
            )
              return;
            (xa.x = window.innerWidth),
              (xa.y = window.innerHeight),
              (a.style.height = xa.y + "px");
          }
          if (
            ((qa.x = f.scrollWrap.clientWidth),
            (qa.y = f.scrollWrap.clientHeight),
            Za(),
            (ta.x = qa.x + Math.round(qa.x * i.spacing)),
            (ta.y = qa.y),
            Ka(ta.x * ra),
            Da("beforeResize"),
            void 0 !== o)
          ) {
            for (var d, g, j, k = 0; k < h; k++)
              (d = y[k]),
                Ja((k + o) * ta.x, d.el.style),
                (j = m + k - 1),
                i.loop && ac() > 2 && (j = Aa(j)),
                (g = _b(j)),
                g && (x || g.needsUpdate || !g.bounds)
                  ? (f.cleanSlide(g),
                    f.setContent(d, j),
                    1 === k && ((f.currItem = g), f.updateCurrZoomItem(!0)),
                    (g.needsUpdate = !1))
                  : d.index === -1 && j >= 0 && f.setContent(d, j),
                g && g.container && (ic(g, qa), mc(g), Ia(g));
            x = !1;
          }
          (t = s = f.currItem.initialZoomLevel),
            (da = f.currItem.bounds),
            da && ((pa.x = da.center.x), (pa.y = da.center.y), Ha(!0)),
            Da("resize");
        },
        zoomTo: function (a, b, c, d, f) {
          b &&
            ((t = s),
            (ub.x = Math.abs(b.x) - pa.x),
            (ub.y = Math.abs(b.y) - pa.y),
            Ma(oa, pa));
          var g = Sa(a, !1),
            h = {};
          Va("x", g, h, a), Va("y", g, h, a);
          var i = s,
            j = { x: pa.x, y: pa.y };
          Na(h);
          var k = function (b) {
            1 === b
              ? ((s = a), (pa.x = h.x), (pa.y = h.y))
              : ((s = (a - i) * b + i),
                (pa.x = (h.x - j.x) * b + j.x),
                (pa.y = (h.y - j.y) * b + j.y)),
              f && f(b),
              Ha(1 === b);
          };
          c ? db("customZoomTo", 0, 1, c, d || e.easing.sine.inOut, k) : k(1);
        },
      },
      fb = 30,
      gb = 10,
      hb = {},
      ib = {},
      jb = {},
      kb = {},
      lb = {},
      mb = [],
      nb = {},
      ob = [],
      pb = {},
      qb = 0,
      rb = ma(),
      sb = 0,
      tb = ma(),
      ub = ma(),
      vb = ma(),
      wb = function (a, b) {
        return a.x === b.x && a.y === b.y;
      },
      xb = function (a, b) {
        return Math.abs(a.x - b.x) < g && Math.abs(a.y - b.y) < g;
      },
      yb = function (a, b) {
        return (
          (pb.x = Math.abs(a.x - b.x)),
          (pb.y = Math.abs(a.y - b.y)),
          Math.sqrt(pb.x * pb.x + pb.y * pb.y)
        );
      },
      zb = function () {
        Z && (I(Z), (Z = null));
      },
      Ab = function () {
        V && ((Z = H(Ab)), Qb());
      },
      Bb = function () {
        return !("fit" === i.scaleMode && s === f.currItem.initialZoomLevel);
      },
      Cb = function (a, b) {
        return (
          !(!a || a === document) &&
          !(
            a.getAttribute("class") &&
            a.getAttribute("class").indexOf("pswp__scroll-wrap") > -1
          ) &&
          (b(a) ? a : Cb(a.parentNode, b))
        );
      },
      Db = {},
      Eb = function (a, b) {
        return (
          (Db.prevent = !Cb(a.target, i.isClickableElement)),
          Da("preventDragEvent", a, b, Db),
          Db.prevent
        );
      },
      Fb = function (a, b) {
        return (b.x = a.pageX), (b.y = a.pageY), (b.id = a.identifier), b;
      },
      Gb = function (a, b, c) {
        (c.x = 0.5 * (a.x + b.x)), (c.y = 0.5 * (a.y + b.y));
      },
      Hb = function (a, b, c) {
        if (a - Q > 50) {
          var d = ob.length > 2 ? ob.shift() : {};
          (d.x = b), (d.y = c), ob.push(d), (Q = a);
        }
      },
      Ib = function () {
        var a = pa.y - f.currItem.initialPosition.y;
        return 1 - Math.abs(a / (qa.y / 2));
      },
      Jb = {},
      Kb = {},
      Lb = [],
      Mb = function (a) {
        for (; Lb.length > 0; ) Lb.pop();
        return (
          F
            ? ((la = 0),
              mb.forEach(function (a) {
                0 === la ? (Lb[0] = a) : 1 === la && (Lb[1] = a), la++;
              }))
            : a.type.indexOf("touch") > -1
            ? a.touches &&
              a.touches.length > 0 &&
              ((Lb[0] = Fb(a.touches[0], Jb)),
              a.touches.length > 1 && (Lb[1] = Fb(a.touches[1], Kb)))
            : ((Jb.x = a.pageX), (Jb.y = a.pageY), (Jb.id = ""), (Lb[0] = Jb)),
          Lb
        );
      },
      Nb = function (a, b) {
        var c,
          d,
          e,
          g,
          h = 0,
          j = pa[a] + b[a],
          k = b[a] > 0,
          l = tb.x + b.x,
          m = tb.x - nb.x;
        return (
          (c = j > da.min[a] || j < da.max[a] ? i.panEndFriction : 1),
          (j = pa[a] + b[a] * c),
          (!i.allowPanToNext && s !== f.currItem.initialZoomLevel) ||
          (ea
            ? "h" !== ga ||
              "x" !== a ||
              X ||
              (k
                ? (j > da.min[a] &&
                    ((c = i.panEndFriction),
                    (h = da.min[a] - j),
                    (d = da.min[a] - oa[a])),
                  (d <= 0 || m < 0) && ac() > 1
                    ? ((g = l), m < 0 && l > nb.x && (g = nb.x))
                    : da.min.x !== da.max.x && (e = j))
                : (j < da.max[a] &&
                    ((c = i.panEndFriction),
                    (h = j - da.max[a]),
                    (d = oa[a] - da.max[a])),
                  (d <= 0 || m > 0) && ac() > 1
                    ? ((g = l), m > 0 && l < nb.x && (g = nb.x))
                    : da.min.x !== da.max.x && (e = j)))
            : (g = l),
          "x" !== a)
            ? void (fa || $ || (s > f.currItem.fitRatio && (pa[a] += b[a] * c)))
            : (void 0 !== g && (Ka(g, !0), ($ = g !== nb.x)),
              da.min.x !== da.max.x &&
                (void 0 !== e ? (pa.x = e) : $ || (pa.x += b.x * c)),
              void 0 !== g)
        );
      },
      Ob = function (a) {
        if (!("mousedown" === a.type && a.button > 0)) {
          if ($b) return void a.preventDefault();
          if (!U || "mousedown" !== a.type) {
            if ((Eb(a, !0) && a.preventDefault(), Da("pointerDown"), F)) {
              var b = e.arraySearch(mb, a.pointerId, "id");
              b < 0 && (b = mb.length),
                (mb[b] = { x: a.pageX, y: a.pageY, id: a.pointerId });
            }
            var c = Mb(a),
              d = c.length;
            (_ = null),
              cb(),
              (V && 1 !== d) ||
                ((V = ha = !0),
                e.bind(window, p, f),
                (S = ka = ia = T = $ = Y = W = X = !1),
                (ga = null),
                Da("firstTouchStart", c),
                Ma(oa, pa),
                (na.x = na.y = 0),
                Ma(kb, c[0]),
                Ma(lb, kb),
                (nb.x = ta.x * ra),
                (ob = [{ x: kb.x, y: kb.y }]),
                (Q = P = Ea()),
                Sa(s, !0),
                zb(),
                Ab()),
              !aa &&
                d > 1 &&
                !fa &&
                !$ &&
                ((t = s),
                (X = !1),
                (aa = W = !0),
                (na.y = na.x = 0),
                Ma(oa, pa),
                Ma(hb, c[0]),
                Ma(ib, c[1]),
                Gb(hb, ib, vb),
                (ub.x = Math.abs(vb.x) - pa.x),
                (ub.y = Math.abs(vb.y) - pa.y),
                (ba = ca = yb(hb, ib)));
          }
        }
      },
      Pb = function (a) {
        if ((a.preventDefault(), F)) {
          var b = e.arraySearch(mb, a.pointerId, "id");
          if (b > -1) {
            var c = mb[b];
            (c.x = a.pageX), (c.y = a.pageY);
          }
        }
        if (V) {
          var d = Mb(a);
          if (ga || Y || aa) _ = d;
          else if (tb.x !== ta.x * ra) ga = "h";
          else {
            var f = Math.abs(d[0].x - kb.x) - Math.abs(d[0].y - kb.y);
            Math.abs(f) >= gb && ((ga = f > 0 ? "h" : "v"), (_ = d));
          }
        }
      },
      Qb = function () {
        if (_) {
          var a = _.length;
          if (0 !== a)
            if (
              (Ma(hb, _[0]),
              (jb.x = hb.x - kb.x),
              (jb.y = hb.y - kb.y),
              aa && a > 1)
            ) {
              if (
                ((kb.x = hb.x), (kb.y = hb.y), !jb.x && !jb.y && wb(_[1], ib))
              )
                return;
              Ma(ib, _[1]), X || ((X = !0), Da("zoomGestureStarted"));
              var b = yb(hb, ib),
                c = Vb(b);
              c >
                f.currItem.initialZoomLevel +
                  f.currItem.initialZoomLevel / 15 && (ka = !0);
              var d = 1,
                e = Ta(),
                g = Ua();
              if (c < e)
                if (i.pinchToClose && !ka && t <= f.currItem.initialZoomLevel) {
                  var h = e - c,
                    j = 1 - h / (e / 1.2);
                  Fa(j), Da("onPinchClose", j), (ia = !0);
                } else
                  (d = (e - c) / e), d > 1 && (d = 1), (c = e - d * (e / 3));
              else
                c > g &&
                  ((d = (c - g) / (6 * e)), d > 1 && (d = 1), (c = g + d * e));
              d < 0 && (d = 0),
                (ba = b),
                Gb(hb, ib, rb),
                (na.x += rb.x - vb.x),
                (na.y += rb.y - vb.y),
                Ma(vb, rb),
                (pa.x = La("x", c)),
                (pa.y = La("y", c)),
                (S = c > s),
                (s = c),
                Ha();
            } else {
              if (!ga) return;
              if (
                (ha &&
                  ((ha = !1),
                  Math.abs(jb.x) >= gb && (jb.x -= _[0].x - lb.x),
                  Math.abs(jb.y) >= gb && (jb.y -= _[0].y - lb.y)),
                (kb.x = hb.x),
                (kb.y = hb.y),
                0 === jb.x && 0 === jb.y)
              )
                return;
              if ("v" === ga && i.closeOnVerticalDrag && !Bb()) {
                (na.y += jb.y), (pa.y += jb.y);
                var k = Ib();
                return (T = !0), Da("onVerticalDrag", k), Fa(k), void Ha();
              }
              Hb(Ea(), hb.x, hb.y), (Y = !0), (da = f.currItem.bounds);
              var l = Nb("x", jb);
              l || (Nb("y", jb), Na(pa), Ha());
            }
        }
      },
      Rb = function (a) {
        if (N.isOldAndroid) {
          if (U && "mouseup" === a.type) return;
          a.type.indexOf("touch") > -1 &&
            (clearTimeout(U),
            (U = setTimeout(function () {
              U = 0;
            }, 600)));
        }
        Da("pointerUp"), Eb(a, !1) && a.preventDefault();
        var b;
        if (F) {
          var c = e.arraySearch(mb, a.pointerId, "id");
          if (c > -1)
            if (((b = mb.splice(c, 1)[0]), navigator.pointerEnabled))
              b.type = a.pointerType || "mouse";
            else {
              var d = { 4: "mouse", 2: "touch", 3: "pen" };
              (b.type = d[a.pointerType]),
                b.type || (b.type = a.pointerType || "mouse");
            }
        }
        var g,
          h = Mb(a),
          j = h.length;
        if (("mouseup" === a.type && (j = 0), 2 === j)) return (_ = null), !0;
        1 === j && Ma(lb, h[0]),
          0 !== j ||
            ga ||
            fa ||
            (b ||
              ("mouseup" === a.type
                ? (b = { x: a.pageX, y: a.pageY, type: "mouse" })
                : a.changedTouches &&
                  a.changedTouches[0] &&
                  (b = {
                    x: a.changedTouches[0].pageX,
                    y: a.changedTouches[0].pageY,
                    type: "touch",
                  })),
            Da("touchRelease", a, b));
        var k = -1;
        if (
          (0 === j &&
            ((V = !1),
            e.unbind(window, p, f),
            zb(),
            aa ? (k = 0) : sb !== -1 && (k = Ea() - sb)),
          (sb = 1 === j ? Ea() : -1),
          (g = k !== -1 && k < 150 ? "zoom" : "swipe"),
          aa &&
            j < 2 &&
            ((aa = !1),
            1 === j && (g = "zoomPointerUp"),
            Da("zoomGestureEnded")),
          (_ = null),
          Y || X || fa || T)
        )
          if ((cb(), R || (R = Sb()), R.calculateSwipeSpeed("x"), T)) {
            var l = Ib();
            if (l < i.verticalDragRange) f.close();
            else {
              var m = pa.y,
                n = ja;
              db("verticalDrag", 0, 1, 300, e.easing.cubic.out, function (a) {
                (pa.y = (f.currItem.initialPosition.y - m) * a + m),
                  Fa((1 - n) * a + n),
                  Ha();
              }),
                Da("onVerticalDrag", 1);
            }
          } else {
            if (($ || fa) && 0 === j) {
              var o = Ub(g, R);
              if (o) return;
              g = "zoomPointerUp";
            }
            if (!fa)
              return "swipe" !== g
                ? void Wb()
                : void (!$ && s > f.currItem.fitRatio && Tb(R));
          }
      },
      Sb = function () {
        var a,
          b,
          c = {
            lastFlickOffset: {},
            lastFlickDist: {},
            lastFlickSpeed: {},
            slowDownRatio: {},
            slowDownRatioReverse: {},
            speedDecelerationRatio: {},
            speedDecelerationRatioAbs: {},
            distanceOffset: {},
            backAnimDestination: {},
            backAnimStarted: {},
            calculateSwipeSpeed: function (d) {
              ob.length > 1
                ? ((a = Ea() - Q + 50), (b = ob[ob.length - 2][d]))
                : ((a = Ea() - P), (b = lb[d])),
                (c.lastFlickOffset[d] = kb[d] - b),
                (c.lastFlickDist[d] = Math.abs(c.lastFlickOffset[d])),
                c.lastFlickDist[d] > 20
                  ? (c.lastFlickSpeed[d] = c.lastFlickOffset[d] / a)
                  : (c.lastFlickSpeed[d] = 0),
                Math.abs(c.lastFlickSpeed[d]) < 0.1 &&
                  (c.lastFlickSpeed[d] = 0),
                (c.slowDownRatio[d] = 0.95),
                (c.slowDownRatioReverse[d] = 1 - c.slowDownRatio[d]),
                (c.speedDecelerationRatio[d] = 1);
            },
            calculateOverBoundsAnimOffset: function (a, b) {
              c.backAnimStarted[a] ||
                (pa[a] > da.min[a]
                  ? (c.backAnimDestination[a] = da.min[a])
                  : pa[a] < da.max[a] && (c.backAnimDestination[a] = da.max[a]),
                void 0 !== c.backAnimDestination[a] &&
                  ((c.slowDownRatio[a] = 0.7),
                  (c.slowDownRatioReverse[a] = 1 - c.slowDownRatio[a]),
                  c.speedDecelerationRatioAbs[a] < 0.05 &&
                    ((c.lastFlickSpeed[a] = 0),
                    (c.backAnimStarted[a] = !0),
                    db(
                      "bounceZoomPan" + a,
                      pa[a],
                      c.backAnimDestination[a],
                      b || 300,
                      e.easing.sine.out,
                      function (b) {
                        (pa[a] = b), Ha();
                      }
                    ))));
            },
            calculateAnimOffset: function (a) {
              c.backAnimStarted[a] ||
                ((c.speedDecelerationRatio[a] =
                  c.speedDecelerationRatio[a] *
                  (c.slowDownRatio[a] +
                    c.slowDownRatioReverse[a] -
                    (c.slowDownRatioReverse[a] * c.timeDiff) / 10)),
                (c.speedDecelerationRatioAbs[a] = Math.abs(
                  c.lastFlickSpeed[a] * c.speedDecelerationRatio[a]
                )),
                (c.distanceOffset[a] =
                  c.lastFlickSpeed[a] *
                  c.speedDecelerationRatio[a] *
                  c.timeDiff),
                (pa[a] += c.distanceOffset[a]));
            },
            panAnimLoop: function () {
              if (
                $a.zoomPan &&
                (($a.zoomPan.raf = H(c.panAnimLoop)),
                (c.now = Ea()),
                (c.timeDiff = c.now - c.lastNow),
                (c.lastNow = c.now),
                c.calculateAnimOffset("x"),
                c.calculateAnimOffset("y"),
                Ha(),
                c.calculateOverBoundsAnimOffset("x"),
                c.calculateOverBoundsAnimOffset("y"),
                c.speedDecelerationRatioAbs.x < 0.05 &&
                  c.speedDecelerationRatioAbs.y < 0.05)
              )
                return (
                  (pa.x = Math.round(pa.x)),
                  (pa.y = Math.round(pa.y)),
                  Ha(),
                  void ab("zoomPan")
                );
            },
          };
        return c;
      },
      Tb = function (a) {
        return (
          a.calculateSwipeSpeed("y"),
          (da = f.currItem.bounds),
          (a.backAnimDestination = {}),
          (a.backAnimStarted = {}),
          Math.abs(a.lastFlickSpeed.x) <= 0.05 &&
          Math.abs(a.lastFlickSpeed.y) <= 0.05
            ? ((a.speedDecelerationRatioAbs.x = a.speedDecelerationRatioAbs.y =
                0),
              a.calculateOverBoundsAnimOffset("x"),
              a.calculateOverBoundsAnimOffset("y"),
              !0)
            : (bb("zoomPan"), (a.lastNow = Ea()), void a.panAnimLoop())
        );
      },
      Ub = function (a, b) {
        var c;
        fa || (qb = m);
        var d;
        if ("swipe" === a) {
          var g = kb.x - lb.x,
            h = b.lastFlickDist.x < 10;
          g > fb && (h || b.lastFlickOffset.x > 20)
            ? (d = -1)
            : g < -fb && (h || b.lastFlickOffset.x < -20) && (d = 1);
        }
        var j;
        d &&
          ((m += d),
          m < 0
            ? ((m = i.loop ? ac() - 1 : 0), (j = !0))
            : m >= ac() && ((m = i.loop ? 0 : ac() - 1), (j = !0)),
          (j && !i.loop) || ((ua += d), (ra -= d), (c = !0)));
        var k,
          l = ta.x * ra,
          n = Math.abs(l - tb.x);
        return (
          c || l > tb.x == b.lastFlickSpeed.x > 0
            ? ((k =
                Math.abs(b.lastFlickSpeed.x) > 0
                  ? n / Math.abs(b.lastFlickSpeed.x)
                  : 333),
              (k = Math.min(k, 400)),
              (k = Math.max(k, 250)))
            : (k = 333),
          qb === m && (c = !1),
          (fa = !0),
          Da("mainScrollAnimStart"),
          db("mainScroll", tb.x, l, k, e.easing.cubic.out, Ka, function () {
            cb(),
              (fa = !1),
              (qb = -1),
              (c || qb !== m) && f.updateCurrItem(),
              Da("mainScrollAnimComplete");
          }),
          c && f.updateCurrItem(!0),
          c
        );
      },
      Vb = function (a) {
        return (1 / ca) * a * t;
      },
      Wb = function () {
        var a = s,
          b = Ta(),
          c = Ua();
        s < b ? (a = b) : s > c && (a = c);
        var d,
          g = 1,
          h = ja;
        return ia && !S && !ka && s < b
          ? (f.close(), !0)
          : (ia &&
              (d = function (a) {
                Fa((g - h) * a + h);
              }),
            f.zoomTo(a, 0, 200, e.easing.cubic.out, d),
            !0);
      };
    za("Gestures", {
      publicMethods: {
        initGestures: function () {
          var a = function (a, b, c, d, e) {
            (A = a + b), (B = a + c), (C = a + d), (D = e ? a + e : "");
          };
          (F = N.pointerEvent),
            F && N.touch && (N.touch = !1),
            F
              ? navigator.pointerEnabled
                ? a("pointer", "down", "move", "up", "cancel")
                : a("MSPointer", "Down", "Move", "Up", "Cancel")
              : N.touch
              ? (a("touch", "start", "move", "end", "cancel"), (G = !0))
              : a("mouse", "down", "move", "up"),
            (p = B + " " + C + " " + D),
            (q = A),
            F &&
              !G &&
              (G =
                navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
            (f.likelyTouchDevice = G),
            (r[A] = Ob),
            (r[B] = Pb),
            (r[C] = Rb),
            D && (r[D] = r[C]),
            N.touch &&
              ((q += " mousedown"),
              (p += " mousemove mouseup"),
              (r.mousedown = r[A]),
              (r.mousemove = r[B]),
              (r.mouseup = r[C])),
            G || (i.allowPanToNext = !1);
        },
      },
    });
    var Xb,
      Yb,
      Zb,
      $b,
      _b,
      ac,
      bc,
      cc = function (b, c, d, g) {
        Xb && clearTimeout(Xb), ($b = !0), (Zb = !0);
        var h;
        b.initialLayout
          ? ((h = b.initialLayout), (b.initialLayout = null))
          : (h = i.getThumbBoundsFn && i.getThumbBoundsFn(m));
        var j = d ? i.hideAnimationDuration : i.showAnimationDuration,
          k = function () {
            ab("initialZoom"),
              d
                ? (f.template.removeAttribute("style"),
                  f.bg.removeAttribute("style"))
                : (Fa(1),
                  c && (c.style.display = "block"),
                  e.addClass(a, "pswp--animated-in"),
                  Da("initialZoom" + (d ? "OutEnd" : "InEnd"))),
              g && g(),
              ($b = !1);
          };
        if (!j || !h || void 0 === h.x)
          return (
            Da("initialZoom" + (d ? "Out" : "In")),
            (s = b.initialZoomLevel),
            Ma(pa, b.initialPosition),
            Ha(),
            (a.style.opacity = d ? 0 : 1),
            Fa(1),
            void (j
              ? setTimeout(function () {
                  k();
                }, j)
              : k())
          );
        var n = function () {
          var c = l,
            g = !f.currItem.src || f.currItem.loadError || i.showHideOpacity;
          b.miniImg && (b.miniImg.style.webkitBackfaceVisibility = "hidden"),
            d ||
              ((s = h.w / b.w),
              (pa.x = h.x),
              (pa.y = h.y - K),
              (f[g ? "template" : "bg"].style.opacity = 0.001),
              Ha()),
            bb("initialZoom"),
            d && !c && e.removeClass(a, "pswp--animated-in"),
            g &&
              (d
                ? e[(c ? "remove" : "add") + "Class"](
                    a,
                    "pswp--animate_opacity"
                  )
                : setTimeout(function () {
                    e.addClass(a, "pswp--animate_opacity");
                  }, 30)),
            (Xb = setTimeout(
              function () {
                if ((Da("initialZoom" + (d ? "Out" : "In")), d)) {
                  var f = h.w / b.w,
                    i = { x: pa.x, y: pa.y },
                    l = s,
                    m = ja,
                    n = function (b) {
                      1 === b
                        ? ((s = f), (pa.x = h.x), (pa.y = h.y - M))
                        : ((s = (f - l) * b + l),
                          (pa.x = (h.x - i.x) * b + i.x),
                          (pa.y = (h.y - M - i.y) * b + i.y)),
                        Ha(),
                        g ? (a.style.opacity = 1 - b) : Fa(m - b * m);
                    };
                  c
                    ? db("initialZoom", 0, 1, j, e.easing.cubic.out, n, k)
                    : (n(1), (Xb = setTimeout(k, j + 20)));
                } else
                  (s = b.initialZoomLevel),
                    Ma(pa, b.initialPosition),
                    Ha(),
                    Fa(1),
                    g ? (a.style.opacity = 1) : Fa(1),
                    (Xb = setTimeout(k, j + 20));
              },
              d ? 25 : 90
            ));
        };
        n();
      },
      dc = {},
      ec = [],
      fc = {
        index: 0,
        errorMsg:
          '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
        forceProgressiveLoading: !1,
        preload: [1, 1],
        getNumItemsFn: function () {
          return Yb.length;
        },
      },
      gc = function () {
        return {
          center: { x: 0, y: 0 },
          max: { x: 0, y: 0 },
          min: { x: 0, y: 0 },
        };
      },
      hc = function (a, b, c) {
        var d = a.bounds;
        (d.center.x = Math.round((dc.x - b) / 2)),
          (d.center.y = Math.round((dc.y - c) / 2) + a.vGap.top),
          (d.max.x = b > dc.x ? Math.round(dc.x - b) : d.center.x),
          (d.max.y = c > dc.y ? Math.round(dc.y - c) + a.vGap.top : d.center.y),
          (d.min.x = b > dc.x ? 0 : d.center.x),
          (d.min.y = c > dc.y ? a.vGap.top : d.center.y);
      },
      ic = function (a, b, c) {
        if (a.src && !a.loadError) {
          var d = !c;
          if (
            (d &&
              (a.vGap || (a.vGap = { top: 0, bottom: 0 }),
              Da("parseVerticalMargin", a)),
            (dc.x = b.x),
            (dc.y = b.y - a.vGap.top - a.vGap.bottom),
            d)
          ) {
            var e = dc.x / a.w,
              f = dc.y / a.h;
            a.fitRatio = e < f ? e : f;
            var g = i.scaleMode;
            "orig" === g ? (c = 1) : "fit" === g && (c = a.fitRatio),
              c > 1 && (c = 1),
              (a.initialZoomLevel = c),
              a.bounds || (a.bounds = gc());
          }
          if (!c) return;
          return (
            hc(a, a.w * c, a.h * c),
            d &&
              c === a.initialZoomLevel &&
              (a.initialPosition = a.bounds.center),
            a.bounds
          );
        }
        return (
          (a.w = a.h = 0),
          (a.initialZoomLevel = a.fitRatio = 1),
          (a.bounds = gc()),
          (a.initialPosition = a.bounds.center),
          a.bounds
        );
      },
      jc = function (a, b, c, d, e, g) {
        b.loadError ||
          (d &&
            ((b.imageAppended = !0),
            mc(b, d, b === f.currItem && ya),
            c.appendChild(d),
            g &&
              setTimeout(function () {
                b &&
                  b.loaded &&
                  b.placeholder &&
                  ((b.placeholder.style.display = "none"),
                  (b.placeholder = null));
              }, 500)));
      },
      kc = function (a) {
        (a.loading = !0), (a.loaded = !1);
        var b = (a.img = e.createEl("pswp__img", "img")),
          c = function () {
            (a.loading = !1),
              (a.loaded = !0),
              a.loadComplete ? a.loadComplete(a) : (a.img = null),
              (b.onload = b.onerror = null),
              (b = null);
          };
        return (
          (b.onload = c),
          (b.onerror = function () {
            (a.loadError = !0), c();
          }),
          (b.src = a.src),
          b
        );
      },
      lc = function (a, b) {
        if (a.src && a.loadError && a.container)
          return (
            b && (a.container.innerHTML = ""),
            (a.container.innerHTML = i.errorMsg.replace("%url%", a.src)),
            !0
          );
      },
      mc = function (a, b, c) {
        if (a.src) {
          b || (b = a.container.lastChild);
          var d = c ? a.w : Math.round(a.w * a.fitRatio),
            e = c ? a.h : Math.round(a.h * a.fitRatio);
          a.placeholder &&
            !a.loaded &&
            ((a.placeholder.style.width = d + "px"),
            (a.placeholder.style.height = e + "px")),
            (b.style.width = d + "px"),
            (b.style.height = e + "px");
        }
      },
      nc = function () {
        if (ec.length) {
          for (var a, b = 0; b < ec.length; b++)
            (a = ec[b]),
              a.holder.index === a.index &&
                jc(a.index, a.item, a.baseDiv, a.img, !1, a.clearPlaceholder);
          ec = [];
        }
      };
    za("Controller", {
      publicMethods: {
        lazyLoadItem: function (a) {
          a = Aa(a);
          var b = _b(a);
          b &&
            ((!b.loaded && !b.loading) || x) &&
            (Da("gettingData", a, b), b.src && kc(b));
        },
        initController: function () {
          e.extend(i, fc, !0),
            (f.items = Yb = c),
            (_b = f.getItemAt),
            (ac = i.getNumItemsFn),
            (bc = i.loop),
            ac() < 3 && (i.loop = !1),
            Ca("beforeChange", function (a) {
              var b,
                c = i.preload,
                d = null === a || a >= 0,
                e = Math.min(c[0], ac()),
                g = Math.min(c[1], ac());
              for (b = 1; b <= (d ? g : e); b++) f.lazyLoadItem(m + b);
              for (b = 1; b <= (d ? e : g); b++) f.lazyLoadItem(m - b);
            }),
            Ca("initialLayout", function () {
              f.currItem.initialLayout =
                i.getThumbBoundsFn && i.getThumbBoundsFn(m);
            }),
            Ca("mainScrollAnimComplete", nc),
            Ca("initialZoomInEnd", nc),
            Ca("destroy", function () {
              for (var a, b = 0; b < Yb.length; b++)
                (a = Yb[b]),
                  a.container && (a.container = null),
                  a.placeholder && (a.placeholder = null),
                  a.img && (a.img = null),
                  a.preloader && (a.preloader = null),
                  a.loadError && (a.loaded = a.loadError = !1);
              ec = null;
            });
        },
        getItemAt: function (a) {
          return a >= 0 && void 0 !== Yb[a] && Yb[a];
        },
        allowProgressiveImg: function () {
          return (
            i.forceProgressiveLoading ||
            !G ||
            i.mouseUsed ||
            screen.width > 1200
          );
        },
        setContent: function (a, b) {
          i.loop && (b = Aa(b));
          var c = f.getItemAt(a.index);
          c && (c.container = null);
          var d,
            g = f.getItemAt(b);
          if (!g) return void (a.el.innerHTML = "");
          Da("gettingData", b, g), (a.index = b), (a.item = g);
          var h = (g.container = e.createEl("pswp__zoom-wrap"));
          if (
            (!g.src &&
              g.html &&
              (g.html.tagName ? h.appendChild(g.html) : (h.innerHTML = g.html)),
            lc(g),
            ic(g, qa),
            !g.src || g.loadError || g.loaded)
          )
            g.src &&
              !g.loadError &&
              ((d = e.createEl("pswp__img", "img")),
              (d.style.opacity = 1),
              (d.src = g.src),
              mc(g, d),
              jc(b, g, h, d, !0));
          else {
            if (
              ((g.loadComplete = function (c) {
                if (j) {
                  if (a && a.index === b) {
                    if (lc(c, !0))
                      return (
                        (c.loadComplete = c.img = null),
                        ic(c, qa),
                        Ia(c),
                        void (a.index === m && f.updateCurrZoomItem())
                      );
                    c.imageAppended
                      ? !$b &&
                        c.placeholder &&
                        ((c.placeholder.style.display = "none"),
                        (c.placeholder = null))
                      : N.transform && (fa || $b)
                      ? ec.push({
                          item: c,
                          baseDiv: h,
                          img: c.img,
                          index: b,
                          holder: a,
                          clearPlaceholder: !0,
                        })
                      : jc(b, c, h, c.img, fa || $b, !0);
                  }
                  (c.loadComplete = null),
                    (c.img = null),
                    Da("imageLoadComplete", b, c);
                }
              }),
              e.features.transform)
            ) {
              var k = "pswp__img pswp__img--placeholder";
              k += g.msrc ? "" : " pswp__img--placeholder--blank";
              var l = e.createEl(k, g.msrc ? "img" : "");
              g.msrc && (l.src = g.msrc),
                mc(g, l),
                h.appendChild(l),
                (g.placeholder = l);
            }
            g.loading || kc(g),
              f.allowProgressiveImg() &&
                (!Zb && N.transform
                  ? ec.push({
                      item: g,
                      baseDiv: h,
                      img: g.img,
                      index: b,
                      holder: a,
                    })
                  : jc(b, g, h, g.img, !0, !0));
          }
          Zb || b !== m ? Ia(g) : ((ea = h.style), cc(g, d || g.img)),
            (a.el.innerHTML = ""),
            a.el.appendChild(h);
        },
        cleanSlide: function (a) {
          a.img && (a.img.onload = a.img.onerror = null),
            (a.loaded = a.loading = a.img = a.imageAppended = !1);
        },
      },
    });
    var oc,
      pc = {},
      qc = function (a, b, c) {
        var d = document.createEvent("CustomEvent"),
          e = {
            origEvent: a,
            target: a.target,
            releasePoint: b,
            pointerType: c || "touch",
          };
        d.initCustomEvent("pswpTap", !0, !0, e), a.target.dispatchEvent(d);
      };
    za("Tap", {
      publicMethods: {
        initTap: function () {
          Ca("firstTouchStart", f.onTapStart),
            Ca("touchRelease", f.onTapRelease),
            Ca("destroy", function () {
              (pc = {}), (oc = null);
            });
        },
        onTapStart: function (a) {
          a.length > 1 && (clearTimeout(oc), (oc = null));
        },
        onTapRelease: function (a, b) {
          if (b && !Y && !W && !_a) {
            var c = b;
            if (oc && (clearTimeout(oc), (oc = null), xb(c, pc)))
              return void Da("doubleTap", c);
            if ("mouse" === b.type) return void qc(a, b, "mouse");
            var d = a.target.tagName.toUpperCase();
            if ("BUTTON" === d || e.hasClass(a.target, "pswp__single-tap"))
              return void qc(a, b);
            Ma(pc, c),
              (oc = setTimeout(function () {
                qc(a, b), (oc = null);
              }, 300));
          }
        },
      },
    });
    var rc;
    za("DesktopZoom", {
      publicMethods: {
        initDesktopZoom: function () {
          L ||
            (G
              ? Ca("mouseUsed", function () {
                  f.setupDesktopZoom();
                })
              : f.setupDesktopZoom(!0));
        },
        setupDesktopZoom: function (b) {
          rc = {};
          var c = "wheel mousewheel DOMMouseScroll";
          Ca("bindEvents", function () {
            e.bind(a, c, f.handleMouseWheel);
          }),
            Ca("unbindEvents", function () {
              rc && e.unbind(a, c, f.handleMouseWheel);
            }),
            (f.mouseZoomedIn = !1);
          var d,
            g = function () {
              f.mouseZoomedIn &&
                (e.removeClass(a, "pswp--zoomed-in"), (f.mouseZoomedIn = !1)),
                s < 1
                  ? e.addClass(a, "pswp--zoom-allowed")
                  : e.removeClass(a, "pswp--zoom-allowed"),
                h();
            },
            h = function () {
              d && (e.removeClass(a, "pswp--dragging"), (d = !1));
            };
          Ca("resize", g),
            Ca("afterChange", g),
            Ca("pointerDown", function () {
              f.mouseZoomedIn && ((d = !0), e.addClass(a, "pswp--dragging"));
            }),
            Ca("pointerUp", h),
            b || g();
        },
        handleMouseWheel: function (a) {
          if (s <= f.currItem.fitRatio)
            return (
              i.modal &&
                (!i.closeOnScroll || _a || V
                  ? a.preventDefault()
                  : E && Math.abs(a.deltaY) > 2 && ((l = !0), f.close())),
              !0
            );
          if ((a.stopPropagation(), (rc.x = 0), "deltaX" in a))
            1 === a.deltaMode
              ? ((rc.x = 18 * a.deltaX), (rc.y = 18 * a.deltaY))
              : ((rc.x = a.deltaX), (rc.y = a.deltaY));
          else if ("wheelDelta" in a)
            a.wheelDeltaX && (rc.x = -0.16 * a.wheelDeltaX),
              a.wheelDeltaY
                ? (rc.y = -0.16 * a.wheelDeltaY)
                : (rc.y = -0.16 * a.wheelDelta);
          else {
            if (!("detail" in a)) return;
            rc.y = a.detail;
          }
          Sa(s, !0);
          var b = pa.x - rc.x,
            c = pa.y - rc.y;
          (i.modal ||
            (b <= da.min.x &&
              b >= da.max.x &&
              c <= da.min.y &&
              c >= da.max.y)) &&
            a.preventDefault(),
            f.panTo(b, c);
        },
        toggleDesktopZoom: function (b) {
          b = b || { x: qa.x / 2 + sa.x, y: qa.y / 2 + sa.y };
          var c = i.getDoubleTapZoom(!0, f.currItem),
            d = s === c;
          (f.mouseZoomedIn = !d),
            f.zoomTo(d ? f.currItem.initialZoomLevel : c, b, 333),
            e[(d ? "remove" : "add") + "Class"](a, "pswp--zoomed-in");
        },
      },
    });
    var sc,
      tc,
      uc,
      vc,
      wc,
      xc,
      yc,
      zc,
      Ac,
      Bc,
      Cc,
      Dc,
      Ec = { history: !0, galleryUID: 1 },
      Fc = function () {
        return Cc.hash.substring(1);
      },
      Gc = function () {
        sc && clearTimeout(sc), uc && clearTimeout(uc);
      },
      Hc = function () {
        var a = Fc(),
          b = {};
        if (a.length < 5) return b;
        var c,
          d = a.split("&");
        for (c = 0; c < d.length; c++)
          if (d[c]) {
            var e = d[c].split("=");
            e.length < 2 || (b[e[0]] = e[1]);
          }
        if (i.galleryPIDs) {
          var f = b.pid;
          for (b.pid = 0, c = 0; c < Yb.length; c++)
            if (Yb[c].pid === f) {
              b.pid = c;
              break;
            }
        } else b.pid = parseInt(b.pid, 10) - 1;
        return b.pid < 0 && (b.pid = 0), b;
      },
      Ic = function () {
        if ((uc && clearTimeout(uc), _a || V))
          return void (uc = setTimeout(Ic, 500));
        vc ? clearTimeout(tc) : (vc = !0);
        var a = m + 1,
          b = _b(m);
        b.hasOwnProperty("pid") && (a = b.pid);
        var c = yc + "&gid=" + i.galleryUID + "&pid=" + a;
        zc || (Cc.hash.indexOf(c) === -1 && (Bc = !0));
        var d = Cc.href.split("#")[0] + "#" + c;
        Dc
          ? "#" + c !== window.location.hash &&
            history[zc ? "replaceState" : "pushState"]("", document.title, d)
          : zc
          ? Cc.replace(d)
          : (Cc.hash = c),
          (zc = !0),
          (tc = setTimeout(function () {
            vc = !1;
          }, 60));
      };
    za("History", {
      publicMethods: {
        initHistory: function () {
          if ((e.extend(i, Ec, !0), i.history)) {
            (Cc = window.location),
              (Bc = !1),
              (Ac = !1),
              (zc = !1),
              (yc = Fc()),
              (Dc = "pushState" in history),
              yc.indexOf("gid=") > -1 &&
                ((yc = yc.split("&gid=")[0]), (yc = yc.split("?gid=")[0])),
              Ca("afterChange", f.updateURL),
              Ca("unbindEvents", function () {
                e.unbind(window, "hashchange", f.onHashChange);
              });
            var a = function () {
              (xc = !0),
                Ac ||
                  (Bc
                    ? history.back()
                    : yc
                    ? (Cc.hash = yc)
                    : Dc
                    ? history.pushState(
                        "",
                        document.title,
                        Cc.pathname + Cc.search
                      )
                    : (Cc.hash = "")),
                Gc();
            };
            Ca("unbindEvents", function () {
              l && a();
            }),
              Ca("destroy", function () {
                xc || a();
              }),
              Ca("firstUpdate", function () {
                m = Hc().pid;
              });
            var b = yc.indexOf("pid=");
            b > -1 &&
              ((yc = yc.substring(0, b)),
              "&" === yc.slice(-1) && (yc = yc.slice(0, -1))),
              setTimeout(function () {
                j && e.bind(window, "hashchange", f.onHashChange);
              }, 40);
          }
        },
        onHashChange: function () {
          return Fc() === yc
            ? ((Ac = !0), void f.close())
            : void (vc || ((wc = !0), f.goTo(Hc().pid), (wc = !1)));
        },
        updateURL: function () {
          Gc(), wc || (zc ? (sc = setTimeout(Ic, 800)) : Ic());
        },
      },
    }),
      e.extend(f, eb);
  };
  return a;
});
!(function (a, b) {
  "function" == typeof define && define.amd
    ? define(b)
    : "object" == typeof exports
    ? (module.exports = b())
    : (a.PhotoSwipeUI_Default = b());
})(this, function () {
  "use strict";
  var a = function (a, b) {
    var c,
      d,
      e,
      f,
      g,
      h,
      i,
      j,
      k,
      l,
      m,
      n,
      o,
      p,
      q,
      r,
      s,
      t,
      u,
      v = this,
      w = !1,
      x = !0,
      y = !0,
      z = {
        barsSize: { top: 44, bottom: "auto" },
        closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
        timeToIdle: 4e3,
        timeToIdleOutside: 1e3,
        loadingIndicatorDelay: 1e3,
        addCaptionHTMLFn: function (a, b) {
          return a.title
            ? ((b.children[0].innerHTML = a.title), !0)
            : ((b.children[0].innerHTML = ""), !1);
        },
        closeEl: !0,
        captionEl: !0,
        fullscreenEl: !0,
        zoomEl: !0,
        shareEl: !0,
        counterEl: !0,
        arrowEl: !0,
        preloaderEl: !0,
        tapToClose: !1,
        tapToToggleControls: !0,
        clickToCloseNonZoomable: !0,
        shareButtons: [
          {
            id: "facebook",
            label: "Share on Facebook",
            url: "https://www.facebook.com/sharer/sharer.php?u={{url}}",
          },
          {
            id: "twitter",
            label: "Tweet",
            url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}",
          },
          {
            id: "pinterest",
            label: "Pin it",
            url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}",
          },
          {
            id: "download",
            label: "Download image",
            url: "{{raw_image_url}}",
            download: !0,
          },
        ],
        getImageURLForShare: function () {
          return a.currItem.src || "";
        },
        getPageURLForShare: function () {
          return window.location.href;
        },
        getTextForShare: function () {
          return a.currItem.title || "";
        },
        indexIndicatorSep: " / ",
        fitControlsWidth: 1200,
      },
      A = function (a) {
        if (r) return !0;
        (a = a || window.event), q.timeToIdle && q.mouseUsed && !k && K();
        for (
          var c,
            d,
            e = a.target || a.srcElement,
            f = e.getAttribute("class") || "",
            g = 0;
          g < S.length;
          g++
        )
          (c = S[g]),
            c.onTap &&
              f.indexOf("pswp__" + c.name) > -1 &&
              (c.onTap(), (d = !0));
        if (d) {
          a.stopPropagation && a.stopPropagation(), (r = !0);
          var h = b.features.isOldAndroid ? 600 : 30;
          s = setTimeout(function () {
            r = !1;
          }, h);
        }
      },
      B = function () {
        return (
          !a.likelyTouchDevice ||
          q.mouseUsed ||
          screen.width > q.fitControlsWidth
        );
      },
      C = function (a, c, d) {
        b[(d ? "add" : "remove") + "Class"](a, "pswp__" + c);
      },
      D = function () {
        var a = 1 === q.getNumItemsFn();
        a !== p && (C(d, "ui--one-slide", a), (p = a));
      },
      E = function () {
        C(i, "share-modal--hidden", y);
      },
      F = function () {
        return (
          (y = !y),
          y
            ? (b.removeClass(i, "pswp__share-modal--fade-in"),
              setTimeout(function () {
                y && E();
              }, 300))
            : (E(),
              setTimeout(function () {
                y || b.addClass(i, "pswp__share-modal--fade-in");
              }, 30)),
          y || H(),
          !1
        );
      },
      G = function (b) {
        b = b || window.event;
        var c = b.target || b.srcElement;
        return (
          a.shout("shareLinkClick", b, c),
          !!c.href &&
            (!!c.hasAttribute("download") ||
              (window.open(
                c.href,
                "pswp_share",
                "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" +
                  (window.screen ? Math.round(screen.width / 2 - 275) : 100)
              ),
              y || F(),
              !1))
        );
      },
      H = function () {
        for (var a, b, c, d, e, f = "", g = 0; g < q.shareButtons.length; g++)
          (a = q.shareButtons[g]),
            (c = q.getImageURLForShare(a)),
            (d = q.getPageURLForShare(a)),
            (e = q.getTextForShare(a)),
            (b = a.url
              .replace("{{url}}", encodeURIComponent(d))
              .replace("{{image_url}}", encodeURIComponent(c))
              .replace("{{raw_image_url}}", c)
              .replace("{{text}}", encodeURIComponent(e))),
            (f +=
              '<a href="' +
              b +
              '" target="_blank" class="pswp__share--' +
              a.id +
              '"' +
              (a.download ? "download" : "") +
              ">" +
              a.label +
              "</a>"),
            q.parseShareButtonOut && (f = q.parseShareButtonOut(a, f));
        (i.children[0].innerHTML = f), (i.children[0].onclick = G);
      },
      I = function (a) {
        for (var c = 0; c < q.closeElClasses.length; c++)
          if (b.hasClass(a, "pswp__" + q.closeElClasses[c])) return !0;
      },
      J = 0,
      K = function () {
        clearTimeout(u), (J = 0), k && v.setIdle(!1);
      },
      L = function (a) {
        a = a ? a : window.event;
        var b = a.relatedTarget || a.toElement;
        (b && "HTML" !== b.nodeName) ||
          (clearTimeout(u),
          (u = setTimeout(function () {
            v.setIdle(!0);
          }, q.timeToIdleOutside)));
      },
      M = function () {
        q.fullscreenEl &&
          !b.features.isOldAndroid &&
          (c || (c = v.getFullscreenAPI()),
          c
            ? (b.bind(document, c.eventK, v.updateFullscreen),
              v.updateFullscreen(),
              b.addClass(a.template, "pswp--supports-fs"))
            : b.removeClass(a.template, "pswp--supports-fs"));
      },
      N = function () {
        q.preloaderEl &&
          (O(!0),
          l("beforeChange", function () {
            clearTimeout(o),
              (o = setTimeout(function () {
                a.currItem && a.currItem.loading
                  ? (!a.allowProgressiveImg() ||
                      (a.currItem.img && !a.currItem.img.naturalWidth)) &&
                    O(!1)
                  : O(!0);
              }, q.loadingIndicatorDelay));
          }),
          l("imageLoadComplete", function (b, c) {
            a.currItem === c && O(!0);
          }));
      },
      O = function (a) {
        n !== a && (C(m, "preloader--active", !a), (n = a));
      },
      P = function (a) {
        var c = a.vGap;
        if (B()) {
          var g = q.barsSize;
          if (q.captionEl && "auto" === g.bottom)
            if (
              (f ||
                ((f = b.createEl("pswp__caption pswp__caption--fake")),
                f.appendChild(b.createEl("pswp__caption__center")),
                d.insertBefore(f, e),
                b.addClass(d, "pswp__ui--fit")),
              q.addCaptionHTMLFn(a, f, !0))
            ) {
              var h = f.clientHeight;
              c.bottom = parseInt(h, 10) || 44;
            } else c.bottom = g.top;
          else c.bottom = "auto" === g.bottom ? 0 : g.bottom;
          c.top = g.top;
        } else c.top = c.bottom = 0;
      },
      Q = function () {
        q.timeToIdle &&
          l("mouseUsed", function () {
            b.bind(document, "mousemove", K),
              b.bind(document, "mouseout", L),
              (t = setInterval(function () {
                J++, 2 === J && v.setIdle(!0);
              }, q.timeToIdle / 2));
          });
      },
      R = function () {
        l("onVerticalDrag", function (a) {
          x && a < 0.95
            ? v.hideControls()
            : !x && a >= 0.95 && v.showControls();
        });
        var a;
        l("onPinchClose", function (b) {
          x && b < 0.9
            ? (v.hideControls(), (a = !0))
            : a && !x && b > 0.9 && v.showControls();
        }),
          l("zoomGestureEnded", function () {
            (a = !1), a && !x && v.showControls();
          });
      },
      S = [
        {
          name: "caption",
          option: "captionEl",
          onInit: function (a) {
            e = a;
          },
        },
        {
          name: "share-modal",
          option: "shareEl",
          onInit: function (a) {
            i = a;
          },
          onTap: function () {
            F();
          },
        },
        {
          name: "button--share",
          option: "shareEl",
          onInit: function (a) {
            h = a;
          },
          onTap: function () {
            F();
          },
        },
        { name: "button--zoom", option: "zoomEl", onTap: a.toggleDesktopZoom },
        {
          name: "counter",
          option: "counterEl",
          onInit: function (a) {
            g = a;
          },
        },
        { name: "button--close", option: "closeEl", onTap: a.close },
        { name: "button--arrow--left", option: "arrowEl", onTap: a.prev },
        { name: "button--arrow--right", option: "arrowEl", onTap: a.next },
        {
          name: "button--fs",
          option: "fullscreenEl",
          onTap: function () {
            c.isFullscreen() ? c.exit() : c.enter();
          },
        },
        {
          name: "preloader",
          option: "preloaderEl",
          onInit: function (a) {
            m = a;
          },
        },
      ],
      T = function () {
        var a,
          c,
          e,
          f = function (d) {
            if (d)
              for (var f = d.length, g = 0; g < f; g++) {
                (a = d[g]), (c = a.className);
                for (var h = 0; h < S.length; h++)
                  (e = S[h]),
                    c.indexOf("pswp__" + e.name) > -1 &&
                      (q[e.option]
                        ? (b.removeClass(a, "pswp__element--disabled"),
                          e.onInit && e.onInit(a))
                        : b.addClass(a, "pswp__element--disabled"));
              }
          };
        f(d.children);
        var g = b.getChildByClass(d, "pswp__top-bar");
        g && f(g.children);
      };
    (v.init = function () {
      b.extend(a.options, z, !0),
        (q = a.options),
        (d = b.getChildByClass(a.scrollWrap, "pswp__ui")),
        (l = a.listen),
        R(),
        l("beforeChange", v.update),
        l("doubleTap", function (b) {
          var c = a.currItem.initialZoomLevel;
          a.getZoomLevel() !== c
            ? a.zoomTo(c, b, 333)
            : a.zoomTo(q.getDoubleTapZoom(!1, a.currItem), b, 333);
        }),
        l("preventDragEvent", function (a, b, c) {
          var d = a.target || a.srcElement;
          d &&
            d.getAttribute("class") &&
            a.type.indexOf("mouse") > -1 &&
            (d.getAttribute("class").indexOf("__caption") > 0 ||
              /(SMALL|STRONG|EM)/i.test(d.tagName)) &&
            (c.prevent = !1);
        }),
        l("bindEvents", function () {
          b.bind(d, "pswpTap click", A),
            b.bind(a.scrollWrap, "pswpTap", v.onGlobalTap),
            a.likelyTouchDevice ||
              b.bind(a.scrollWrap, "mouseover", v.onMouseOver);
        }),
        l("unbindEvents", function () {
          y || F(),
            t && clearInterval(t),
            b.unbind(document, "mouseout", L),
            b.unbind(document, "mousemove", K),
            b.unbind(d, "pswpTap click", A),
            b.unbind(a.scrollWrap, "pswpTap", v.onGlobalTap),
            b.unbind(a.scrollWrap, "mouseover", v.onMouseOver),
            c &&
              (b.unbind(document, c.eventK, v.updateFullscreen),
              c.isFullscreen() && ((q.hideAnimationDuration = 0), c.exit()),
              (c = null));
        }),
        l("destroy", function () {
          q.captionEl &&
            (f && d.removeChild(f), b.removeClass(e, "pswp__caption--empty")),
            i && (i.children[0].onclick = null),
            b.removeClass(d, "pswp__ui--over-close"),
            b.addClass(d, "pswp__ui--hidden"),
            v.setIdle(!1);
        }),
        q.showAnimationDuration || b.removeClass(d, "pswp__ui--hidden"),
        l("initialZoomIn", function () {
          q.showAnimationDuration && b.removeClass(d, "pswp__ui--hidden");
        }),
        l("initialZoomOut", function () {
          b.addClass(d, "pswp__ui--hidden");
        }),
        l("parseVerticalMargin", P),
        T(),
        q.shareEl && h && i && (y = !0),
        D(),
        Q(),
        M(),
        N();
    }),
      (v.setIdle = function (a) {
        (k = a), C(d, "ui--idle", a);
      }),
      (v.update = function () {
        x && a.currItem
          ? (v.updateIndexIndicator(),
            q.captionEl &&
              (q.addCaptionHTMLFn(a.currItem, e),
              C(e, "caption--empty", !a.currItem.title)),
            (w = !0))
          : (w = !1),
          y || F(),
          D();
      }),
      (v.updateFullscreen = function (d) {
        d &&
          setTimeout(function () {
            a.setScrollOffset(0, b.getScrollY());
          }, 50),
          b[(c.isFullscreen() ? "add" : "remove") + "Class"](
            a.template,
            "pswp--fs"
          );
      }),
      (v.updateIndexIndicator = function () {
        q.counterEl &&
          (g.innerHTML =
            a.getCurrentIndex() + 1 + q.indexIndicatorSep + q.getNumItemsFn());
      }),
      (v.onGlobalTap = function (c) {
        c = c || window.event;
        var d = c.target || c.srcElement;
        if (!r)
          if (c.detail && "mouse" === c.detail.pointerType) {
            if (I(d)) return void a.close();
            b.hasClass(d, "pswp__img") &&
              (1 === a.getZoomLevel() && a.getZoomLevel() <= a.currItem.fitRatio
                ? q.clickToCloseNonZoomable && a.close()
                : a.toggleDesktopZoom(c.detail.releasePoint));
          } else if (
            (q.tapToToggleControls && (x ? v.hideControls() : v.showControls()),
            q.tapToClose && (b.hasClass(d, "pswp__img") || I(d)))
          )
            return void a.close();
      }),
      (v.onMouseOver = function (a) {
        a = a || window.event;
        var b = a.target || a.srcElement;
        C(d, "ui--over-close", I(b));
      }),
      (v.hideControls = function () {
        b.addClass(d, "pswp__ui--hidden"), (x = !1);
      }),
      (v.showControls = function () {
        (x = !0), w || v.update(), b.removeClass(d, "pswp__ui--hidden");
      }),
      (v.supportsFullscreen = function () {
        var a = document;
        return !!(
          a.exitFullscreen ||
          a.mozCancelFullScreen ||
          a.webkitExitFullscreen ||
          a.msExitFullscreen
        );
      }),
      (v.getFullscreenAPI = function () {
        var b,
          c = document.documentElement,
          d = "fullscreenchange";
        return (
          c.requestFullscreen
            ? (b = {
                enterK: "requestFullscreen",
                exitK: "exitFullscreen",
                elementK: "fullscreenElement",
                eventK: d,
              })
            : c.mozRequestFullScreen
            ? (b = {
                enterK: "mozRequestFullScreen",
                exitK: "mozCancelFullScreen",
                elementK: "mozFullScreenElement",
                eventK: "moz" + d,
              })
            : c.webkitRequestFullscreen
            ? (b = {
                enterK: "webkitRequestFullscreen",
                exitK: "webkitExitFullscreen",
                elementK: "webkitFullscreenElement",
                eventK: "webkit" + d,
              })
            : c.msRequestFullscreen &&
              (b = {
                enterK: "msRequestFullscreen",
                exitK: "msExitFullscreen",
                elementK: "msFullscreenElement",
                eventK: "MSFullscreenChange",
              }),
          b &&
            ((b.enter = function () {
              return (
                (j = q.closeOnScroll),
                (q.closeOnScroll = !1),
                "webkitRequestFullscreen" !== this.enterK
                  ? a.template[this.enterK]()
                  : void a.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
              );
            }),
            (b.exit = function () {
              return (q.closeOnScroll = j), document[this.exitK]();
            }),
            (b.isFullscreen = function () {
              return document[this.elementK];
            })),
          b
        );
      });
  };
  return a;
});
/*! Sticky-kit v1.1.2 */
(function () {
  var t, i;
  (t = this.jQuery || window.jQuery),
    (i = t(window)),
    (t.fn.stick_in_parent = function (o) {
      var s, e, n, r, c, l, a, f, p, u, h;
      for (
        null == o && (o = {}),
          h = o.sticky_class,
          c = o.inner_scrolling,
          u = o.recalc_every,
          p = o.parent,
          f = o.offset_top,
          a = o.spacer,
          e = o.bottoming,
          null == f && (f = 0),
          null == p && (p = void 0),
          null == c && (c = !0),
          null == h && (h = "is_stuck"),
          s = t(document),
          null == e && (e = !0),
          n = function (o, n, r, l, d, g, k, m) {
            var v, y, _, b, w, x, C, I, z, A, j, M;
            if (!o.data("sticky_kit")) {
              if (
                (o.data("sticky_kit", !0),
                (w = s.height()),
                (C = o.parent()),
                null != p && (C = C.closest(p)),
                !C.length)
              )
                throw "failed to find stick parent";
              if (
                ((v = _ = !1),
                (j = null != a ? a && o.closest(a) : t("<div />")) &&
                  j.css("position", o.css("position")),
                (I = function () {
                  var t, i, e;
                  if (
                    !m &&
                    ((w = s.height()),
                    (t = parseInt(C.css("border-top-width"), 10)),
                    (i = parseInt(C.css("padding-top"), 10)),
                    (n = parseInt(C.css("padding-bottom"), 10)),
                    (r = C.offset().top + t + i),
                    (l = C.height()),
                    _ &&
                      ((v = _ = !1),
                      null == a && (o.insertAfter(j), j.detach()),
                      o
                        .css({ position: "", top: "", width: "", bottom: "" })
                        .removeClass(h),
                      (e = !0)),
                    (d =
                      o.offset().top -
                      (parseInt(o.css("margin-top"), 10) || 0) -
                      f),
                    (g = o.outerHeight(!0)),
                    (k = o.css("float")),
                    j &&
                      j.css({
                        width: o.outerWidth(!0),
                        height: g,
                        display: o.css("display"),
                        "vertical-align": o.css("vertical-align"),
                        float: k,
                      }),
                    e)
                  )
                    return M();
                })(),
                g !== l)
              )
                return (
                  (b = void 0),
                  (x = f),
                  (A = u),
                  (M = function () {
                    var t, p, y, z;
                    if (
                      !m &&
                      ((y = !1),
                      null != A && 0 >= --A && ((A = u), I(), (y = !0)),
                      y || s.height() === w || I(),
                      (y = i.scrollTop()),
                      null != b && (p = y - b),
                      (b = y),
                      _
                        ? (e &&
                            ((z = y + g + x > l + r),
                            v &&
                              !z &&
                              ((v = !1),
                              o
                                .css({ position: "fixed", bottom: "", top: x })
                                .trigger("sticky_kit:unbottom"))),
                          y < d &&
                            ((_ = !1),
                            (x = f),
                            null == a &&
                              (("left" !== k && "right" !== k) ||
                                o.insertAfter(j),
                              j.detach()),
                            (t = { position: "", width: "", top: "" }),
                            o
                              .css(t)
                              .removeClass(h)
                              .trigger("sticky_kit:unstick")),
                          c &&
                            ((t = i.height()),
                            g + f > t &&
                              !v &&
                              ((x -= p),
                              (x = Math.max(t - g, x)),
                              (x = Math.min(f, x)),
                              _ && o.css({ top: x + "px" }))))
                        : y > d &&
                          ((_ = !0),
                          ((t = { position: "fixed", top: x }).width =
                            "border-box" === o.css("box-sizing")
                              ? o.outerWidth() + "px"
                              : o.width() + "px"),
                          o.css(t).addClass(h),
                          null == a &&
                            (o.after(j),
                            ("left" !== k && "right" !== k) || j.append(o)),
                          o.trigger("sticky_kit:stick")),
                      _ && e && (null == z && (z = y + g + x > l + r), !v && z))
                    )
                      return (
                        (v = !0),
                        "static" === C.css("position") &&
                          C.css({ position: "relative" }),
                        o
                          .css({ position: "absolute", bottom: n, top: "auto" })
                          .trigger("sticky_kit:bottom")
                      );
                  }),
                  (z = function () {
                    return I(), M();
                  }),
                  (y = function () {
                    if (
                      ((m = !0),
                      i.off("touchmove", M),
                      i.off("scroll", M),
                      i.off("resize", z),
                      t(document.body).off("sticky_kit:recalc", z),
                      o.off("sticky_kit:detach", y),
                      o.removeData("sticky_kit"),
                      o.css({ position: "", bottom: "", top: "", width: "" }),
                      C.position("position", ""),
                      _)
                    )
                      return (
                        null == a &&
                          (("left" !== k && "right" !== k) || o.insertAfter(j),
                          j.remove()),
                        o.removeClass(h)
                      );
                  }),
                  i.on("touchmove", M),
                  i.on("scroll", M),
                  i.on("resize", z),
                  t(document.body).on("sticky_kit:recalc", z),
                  o.on("sticky_kit:detach", y),
                  setTimeout(M, 0)
                );
            }
          },
          r = 0,
          l = this.length;
        r < l;
        r++
      )
        (o = this[r]), n(t(o));
      return this;
    });
}).call(this);
/*! Countdown for jQuery v2.1.0 */
!(function () {
  "use strict";
  var t = !1;
  (window.JQClass = function () {}),
    (JQClass.classes = {}),
    (JQClass.extend = function e(n) {
      function a() {
        !t && this._init && this._init.apply(this, arguments);
      }
      var s = this.prototype;
      t = !0;
      var i = new this();
      for (var r in ((t = !1), n))
        if ("function" == typeof n[r] && "function" == typeof s[r])
          i[r] = (function (t, e) {
            return function () {
              var n = this._super;
              this._super = function (e) {
                return s[t].apply(this, e || []);
              };
              var a = e.apply(this, arguments);
              return (this._super = n), a;
            };
          })(r, n[r]);
        else if (
          "object" == typeof n[r] &&
          "object" == typeof s[r] &&
          "defaultOptions" === r
        ) {
          var o,
            u = s[r],
            c = n[r],
            h = {};
          for (o in u) h[o] = u[o];
          for (o in c) h[o] = c[o];
          i[r] = h;
        } else i[r] = n[r];
      return (
        (a.prototype = i), (a.prototype.constructor = a), (a.extend = e), a
      );
    });
})(),
  (function ($) {
    "use strict";
    function camelCase(t) {
      return t.replace(/-([a-z])/g, function (t, e) {
        return e.toUpperCase();
      });
    }
    (JQClass.classes.JQPlugin = JQClass.extend({
      name: "plugin",
      defaultOptions: {},
      regionalOptions: {},
      deepMerge: !0,
      _getMarker: function () {
        return "is-" + this.name;
      },
      _init: function () {
        $.extend(
          this.defaultOptions,
          (this.regionalOptions && this.regionalOptions[""]) || {}
        );
        var t = camelCase(this.name);
        ($[t] = this),
          ($.fn[t] = function (e) {
            var n = Array.prototype.slice.call(arguments, 1),
              a = this,
              s = this;
            return (
              this.each(function () {
                if ("string" == typeof e) {
                  if ("_" === e[0] || !$[t][e]) throw "Unknown method: " + e;
                  var i = $[t][e].apply($[t], [this].concat(n));
                  if (i !== a && void 0 !== i) return (s = i), !1;
                } else $[t]._attach(this, e);
              }),
              s
            );
          });
      },
      setDefaults: function (t) {
        $.extend(this.defaultOptions, t || {});
      },
      _attach: function (t, e) {
        if (!(t = $(t)).hasClass(this._getMarker())) {
          t.addClass(this._getMarker()),
            (e = $.extend(
              this.deepMerge,
              {},
              this.defaultOptions,
              this._getMetadata(t),
              e || {}
            ));
          var n = $.extend(
            { name: this.name, elem: t, options: e },
            this._instSettings(t, e)
          );
          t.data(this.name, n), this._postAttach(t, n), this.option(t, e);
        }
      },
      _instSettings: function (t, e) {
        return {};
      },
      _postAttach: function (t, e) {},
      _getMetadata: function (elem) {
        try {
          var data = elem.data(this.name.toLowerCase()) || "";
          for (var key in ((data = data
            .replace(/(\\?)'/g, function (t, e) {
              return e ? "'" : '"';
            })
            .replace(/([a-zA-Z0-9]+):/g, function (t, e, n) {
              var a = data.substring(0, n).match(/"/g);
              return a && a.length % 2 != 0 ? e + ":" : '"' + e + '":';
            })
            .replace(/\\:/g, ":")),
          (data = $.parseJSON("{" + data + "}")),
          data))
            if (data.hasOwnProperty(key)) {
              var value = data[key];
              "string" == typeof value &&
                value.match(/^new Date\(([-0-9,\s]*)\)$/) &&
                (data[key] = eval(value));
            }
          return data;
        } catch (t) {
          return {};
        }
      },
      _getInst: function (t) {
        return $(t).data(this.name) || {};
      },
      option: function (t, e, n) {
        var a = (t = $(t)).data(this.name),
          s = e || {};
        return !e || ("string" == typeof e && void 0 === n)
          ? (s = (a || {}).options) && e
            ? s[e]
            : s
          : void (
              t.hasClass(this._getMarker()) &&
              ("string" == typeof e && ((s = {}), (s[e] = n)),
              this._optionsChanged(t, a, s),
              $.extend(a.options, s))
            );
      },
      _optionsChanged: function (t, e, n) {},
      destroy: function (t) {
        (t = $(t)).hasClass(this._getMarker()) &&
          (this._preDestroy(t, this._getInst(t)),
          t.removeData(this.name).removeClass(this._getMarker()));
      },
      _preDestroy: function (t, e) {},
    })),
      ($.JQPlugin = {
        createPlugin: function (t, e) {
          "object" == typeof t && ((e = t), (t = "JQPlugin")),
            (t = camelCase(t));
          var n = camelCase(e.name);
          (JQClass.classes[n] = JQClass.classes[t].extend(e)),
            new JQClass.classes[n]();
        },
      });
  })(jQuery);
!(function (e) {
  "use strict";
  var i = "countdown";
  e.JQPlugin.createPlugin({
    name: i,
    defaultOptions: {
      until: null,
      since: null,
      timezone: null,
      serverSync: null,
      format: "dHMS",
      layout: "",
      compact: !1,
      padZeroes: !1,
      significant: 0,
      description: "",
      expiryUrl: "",
      expiryText: "",
      alwaysExpire: !1,
      onExpiry: null,
      onTick: null,
      tickInterval: 1,
    },
    regionalOptions: {
      "": {
        labels: [
          "Years",
          "Months",
          "Weeks",
          "Days",
          "Hours",
          "Minutes",
          "Seconds",
        ],
        labels1: ["Year", "Month", "Week", "Day", "Hour", "Minute", "Second"],
        compactLabels: ["y", "m", "w", "d"],
        whichLabels: null,
        digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
        timeSeparator: ":",
        isRTL: !1,
      },
    },
    _rtlClass: i + "-rtl",
    _sectionClass: i + "-section",
    _amountClass: i + "-amount",
    _periodClass: i + "-period",
    _rowClass: i + "-row",
    _holdingClass: i + "-holding",
    _showClass: i + "-show",
    _descrClass: i + "-descr",
    _timerElems: [],
    _init: function () {
      var i = this;
      this._super(), (this._serverSyncs = []);
      var t =
          "function" == typeof Date.now
            ? Date.now
            : function () {
                return new Date().getTime();
              },
        s = window.performance && "function" == typeof window.performance.now,
        n =
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimationFrame ||
          null,
        o = 0;
      !n || e.noRequestAnimationFrame
        ? ((e.noRequestAnimationFrame = null),
          (e.countdown._timer = setInterval(function () {
            i._updateElems();
          }, 1e3)))
        : ((o =
            window.animationStartTime ||
            window.webkitAnimationStartTime ||
            window.mozAnimationStartTime ||
            window.oAnimationStartTime ||
            window.msAnimationStartTime ||
            t()),
          n(function e(r) {
            var a =
              r < 1e12
                ? s
                  ? window.performance.now() +
                    window.performance.timing.navigationStart
                  : t()
                : r || t();
            a - o >= 1e3 && (i._updateElems(), (o = a)), n(e);
          }));
    },
    UTCDate: function (e, i, t, s, n, o, r, a) {
      "object" == typeof i &&
        i instanceof Date &&
        ((a = i.getMilliseconds()),
        (r = i.getSeconds()),
        (o = i.getMinutes()),
        (n = i.getHours()),
        (s = i.getDate()),
        (t = i.getMonth()),
        (i = i.getFullYear()));
      var l = new Date();
      return (
        l.setUTCFullYear(i),
        l.setUTCDate(1),
        l.setUTCMonth(t || 0),
        l.setUTCDate(s || 1),
        l.setUTCHours(n || 0),
        l.setUTCMinutes((o || 0) - (Math.abs(e) < 30 ? 60 * e : e)),
        l.setUTCSeconds(r || 0),
        l.setUTCMilliseconds(a || 0),
        l
      );
    },
    periodsToSeconds: function (e) {
      return (
        31557600 * e[0] +
        2629800 * e[1] +
        604800 * e[2] +
        86400 * e[3] +
        3600 * e[4] +
        60 * e[5] +
        e[6]
      );
    },
    resync: function () {
      var i = this;
      e("." + this._getMarker()).each(function () {
        var t = e.data(this, i.name);
        if (t.options.serverSync) {
          for (var s = null, n = 0; n < i._serverSyncs.length; n++)
            if (i._serverSyncs[n][0] === t.options.serverSync) {
              s = i._serverSyncs[n];
              break;
            }
          if (i._eqNull(s[2])) {
            var o = e.isFunction(t.options.serverSync)
              ? t.options.serverSync.apply(this, [])
              : null;
            s[2] = (o ? new Date().getTime() - o.getTime() : 0) - s[1];
          }
          t._since &&
            t._since.setMilliseconds(t._since.getMilliseconds() + s[2]),
            t._until.setMilliseconds(t._until.getMilliseconds() + s[2]);
        }
      });
      for (var t = 0; t < i._serverSyncs.length; t++)
        i._eqNull(i._serverSyncs[t][2]) ||
          ((i._serverSyncs[t][1] += i._serverSyncs[t][2]),
          delete i._serverSyncs[t][2]);
    },
    _instSettings: function (e, i) {
      return { _periods: [0, 0, 0, 0, 0, 0, 0] };
    },
    _addElem: function (e) {
      this._hasElem(e) || this._timerElems.push(e);
    },
    _hasElem: function (i) {
      return e.inArray(i, this._timerElems) > -1;
    },
    _removeElem: function (i) {
      this._timerElems = e.map(this._timerElems, function (e) {
        return e === i ? null : e;
      });
    },
    _updateElems: function () {
      for (var e = this._timerElems.length - 1; e >= 0; e--)
        this._updateCountdown(this._timerElems[e]);
    },
    _optionsChanged: function (i, t, s) {
      s.layout &&
        (s.layout = s.layout.replace(/&lt;/g, "<").replace(/&gt;/g, ">")),
        this._resetExtraLabels(t.options, s);
      var n = t.options.timezone !== s.timezone;
      e.extend(t.options, s),
        this._adjustSettings(
          i,
          t,
          !this._eqNull(s.until) || !this._eqNull(s.since) || n
        );
      var o = new Date();
      ((t._since && t._since < o) || (t._until && t._until > o)) &&
        this._addElem(i[0]),
        this._updateCountdown(i, t);
    },
    _updateCountdown: function (i, t) {
      if (((i = i.jquery ? i : e(i)), (t = t || this._getInst(i)))) {
        if (
          (i
            .html(this._generateHTML(t))
            .toggleClass(this._rtlClass, t.options.isRTL),
          "pause" !== t._hold && e.isFunction(t.options.onTick))
        ) {
          var s =
            "lap" !== t._hold
              ? t._periods
              : this._calculatePeriods(
                  t,
                  t._show,
                  t.options.significant,
                  new Date()
                );
          (1 !== t.options.tickInterval &&
            this.periodsToSeconds(s) % t.options.tickInterval != 0) ||
            t.options.onTick.apply(i[0], [s]);
        }
        if (
          "pause" !== t._hold &&
          (t._since
            ? t._now.getTime() < t._since.getTime()
            : t._now.getTime() >= t._until.getTime()) &&
          !t._expiring
        ) {
          if (
            ((t._expiring = !0), this._hasElem(i[0]) || t.options.alwaysExpire)
          ) {
            if (
              (this._removeElem(i[0]),
              e.isFunction(t.options.onExpiry) &&
                t.options.onExpiry.apply(i[0], []),
              t.options.expiryText)
            ) {
              var n = t.options.layout;
              (t.options.layout = t.options.expiryText),
                this._updateCountdown(i[0], t),
                (t.options.layout = n);
            }
            t.options.expiryUrl && (window.location = t.options.expiryUrl);
          }
          t._expiring = !1;
        } else "pause" === t._hold && this._removeElem(i[0]);
      }
    },
    _resetExtraLabels: function (e, i) {
      var t = null;
      for (t in i) t.match(/[Ll]abels[02-9]|compactLabels1/) && (e[t] = i[t]);
      for (t in e)
        t.match(/[Ll]abels[02-9]|compactLabels1/) &&
          void 0 === i[t] &&
          (e[t] = null);
    },
    _eqNull: function (e) {
      return null == e;
    },
    _adjustSettings: function (i, t, s) {
      for (var n = null, o = 0; o < this._serverSyncs.length; o++)
        if (this._serverSyncs[o][0] === t.options.serverSync) {
          n = this._serverSyncs[o][1];
          break;
        }
      var r = null,
        a = null;
      if (this._eqNull(n)) {
        var l = e.isFunction(t.options.serverSync)
          ? t.options.serverSync.apply(i[0], [])
          : null;
        (r = new Date()),
          (a = l ? r.getTime() - l.getTime() : 0),
          this._serverSyncs.push([t.options.serverSync, a]);
      } else (r = new Date()), (a = t.options.serverSync ? n : 0);
      var _ = t.options.timezone;
      (_ = this._eqNull(_) ? -r.getTimezoneOffset() : _),
        (s || (!s && this._eqNull(t._until) && this._eqNull(t._since))) &&
          ((t._since = t.options.since),
          this._eqNull(t._since) ||
            ((t._since = this.UTCDate(_, this._determineTime(t._since, null))),
            t._since &&
              a &&
              t._since.setMilliseconds(t._since.getMilliseconds() + a)),
          (t._until = this.UTCDate(_, this._determineTime(t.options.until, r))),
          a && t._until.setMilliseconds(t._until.getMilliseconds() + a)),
        (t._show = this._determineShow(t));
    },
    _preDestroy: function (e, i) {
      this._removeElem(e[0]), e.empty();
    },
    pause: function (e) {
      this._hold(e, "pause");
    },
    lap: function (e) {
      this._hold(e, "lap");
    },
    resume: function (e) {
      this._hold(e, null);
    },
    toggle: function (i) {
      this[(e.data(i, this.name) || {})._hold ? "resume" : "pause"](i);
    },
    toggleLap: function (i) {
      this[(e.data(i, this.name) || {})._hold ? "resume" : "lap"](i);
    },
    _hold: function (i, t) {
      var s = e.data(i, this.name);
      if (s) {
        if ("pause" === s._hold && !t) {
          s._periods = s._savePeriods;
          var n = s._since ? "-" : "+";
          (s[s._since ? "_since" : "_until"] = this._determineTime(
            n +
              s._periods[0] +
              "y" +
              n +
              s._periods[1] +
              "o" +
              n +
              s._periods[2] +
              "w" +
              n +
              s._periods[3] +
              "d" +
              n +
              s._periods[4] +
              "h" +
              n +
              s._periods[5] +
              "m" +
              n +
              s._periods[6] +
              "s"
          )),
            this._addElem(i);
        }
        (s._hold = t),
          (s._savePeriods = "pause" === t ? s._periods : null),
          e.data(i, this.name, s),
          this._updateCountdown(i, s);
      }
    },
    getTimes: function (i) {
      var t = e.data(i, this.name);
      return t
        ? "pause" === t._hold
          ? t._savePeriods
          : t._hold
          ? this._calculatePeriods(
              t,
              t._show,
              t.options.significant,
              new Date()
            )
          : t._periods
        : null;
    },
    _determineTime: function (e, i) {
      var t,
        s,
        n = this,
        o = this._eqNull(e)
          ? i
          : "string" == typeof e
          ? (function (e) {
              e = e.toLowerCase();
              for (
                var i = new Date(),
                  t = i.getFullYear(),
                  s = i.getMonth(),
                  o = i.getDate(),
                  r = i.getHours(),
                  a = i.getMinutes(),
                  l = i.getSeconds(),
                  _ = /([+-]?[0-9]+)\s*(s|m|h|d|w|o|y)?/g,
                  p = _.exec(e);
                p;

              ) {
                switch (p[2] || "s") {
                  case "s":
                    l += parseInt(p[1], 10);
                    break;
                  case "m":
                    a += parseInt(p[1], 10);
                    break;
                  case "h":
                    r += parseInt(p[1], 10);
                    break;
                  case "d":
                    o += parseInt(p[1], 10);
                    break;
                  case "w":
                    o += 7 * parseInt(p[1], 10);
                    break;
                  case "o":
                    (s += parseInt(p[1], 10)),
                      (o = Math.min(o, n._getDaysInMonth(t, s)));
                    break;
                  case "y":
                    (t += parseInt(p[1], 10)),
                      (o = Math.min(o, n._getDaysInMonth(t, s)));
                }
                p = _.exec(e);
              }
              return new Date(t, s, o, r, a, l, 0);
            })(e)
          : "number" == typeof e
          ? ((t = e), (s = new Date()).setTime(s.getTime() + 1e3 * t), s)
          : e;
      return o && o.setMilliseconds(0), o;
    },
    _getDaysInMonth: function (e, i) {
      return 32 - new Date(e, i, 32).getDate();
    },
    _normalLabels: function (e) {
      return e;
    },
    _generateHTML: function (i) {
      var t = this;
      i._periods = i._hold
        ? i._periods
        : this._calculatePeriods(i, i._show, i.options.significant, new Date());
      var s = !1,
        n = 0,
        o = i.options.significant,
        r = e.extend({}, i._show),
        a = null;
      for (a = 0; a <= 6; a++)
        (s = s || ("?" === i._show[a] && i._periods[a] > 0)),
          (r[a] = "?" !== i._show[a] || s ? i._show[a] : null),
          (n += r[a] ? 1 : 0),
          (o -= i._periods[a] > 0 ? 1 : 0);
      var l = [!1, !1, !1, !1, !1, !1, !1];
      for (a = 6; a >= 0; a--)
        i._show[a] && (i._periods[a] ? (l[a] = !0) : ((l[a] = o > 0), o--));
      var _ = i.options.compact ? i.options.compactLabels : i.options.labels,
        p = i.options.whichLabels || this._normalLabels,
        c = function (e) {
          var s = i.options["compactLabels" + p(i._periods[e])];
          return r[e]
            ? t._translateDigits(i, i._periods[e]) + (s ? s[e] : _[e]) + " "
            : "";
        },
        u = i.options.padZeroes ? 2 : 1,
        h = function (e) {
          var s = i.options["labels" + p(i._periods[e])];
          return (!i.options.significant && r[e]) ||
            (i.options.significant && l[e])
            ? '<span class="' +
                t._sectionClass +
                '"><span class="' +
                t._amountClass +
                '">' +
                t._minDigits(i, i._periods[e], u) +
                '</span><span class="' +
                t._periodClass +
                '">' +
                (s ? s[e] : _[e]) +
                "</span></span>"
            : "";
        };
      return i.options.layout
        ? this._buildLayout(
            i,
            r,
            i.options.layout,
            i.options.compact,
            i.options.significant,
            l
          )
        : (i.options.compact
            ? '<span class="' +
              this._rowClass +
              " " +
              this._amountClass +
              (i._hold ? " " + this._holdingClass : "") +
              '">' +
              c(0) +
              c(1) +
              c(2) +
              c(3) +
              (r[4] ? this._minDigits(i, i._periods[4], 2) : "") +
              (r[5]
                ? (r[4] ? i.options.timeSeparator : "") +
                  this._minDigits(i, i._periods[5], 2)
                : "") +
              (r[6]
                ? (r[4] || r[5] ? i.options.timeSeparator : "") +
                  this._minDigits(i, i._periods[6], 2)
                : "")
            : '<span class="' +
              this._rowClass +
              " " +
              this._showClass +
              (i.options.significant || n) +
              (i._hold ? " " + this._holdingClass : "") +
              '">' +
              h(0) +
              h(1) +
              h(2) +
              h(3) +
              h(4) +
              h(5) +
              h(6)) +
            "</span>" +
            (i.options.description
              ? '<span class="' +
                this._rowClass +
                " " +
                this._descrClass +
                '">' +
                i.options.description +
                "</span>"
              : "");
    },
    _buildLayout: function (i, t, s, n, o, r) {
      for (
        var a = i.options[n ? "compactLabels" : "labels"],
          l = i.options.whichLabels || this._normalLabels,
          _ = function (e) {
            return (i.options[
              (n ? "compactLabels" : "labels") + l(i._periods[e])
            ] || a)[e];
          },
          p = function (e, t) {
            return i.options.digits[Math.floor(e / t) % 10];
          },
          c = {
            desc: i.options.description,
            sep: i.options.timeSeparator,
            yl: _(0),
            yn: this._minDigits(i, i._periods[0], 1),
            ynn: this._minDigits(i, i._periods[0], 2),
            ynnn: this._minDigits(i, i._periods[0], 3),
            y1: p(i._periods[0], 1),
            y10: p(i._periods[0], 10),
            y100: p(i._periods[0], 100),
            y1000: p(i._periods[0], 1e3),
            ol: _(1),
            on: this._minDigits(i, i._periods[1], 1),
            onn: this._minDigits(i, i._periods[1], 2),
            onnn: this._minDigits(i, i._periods[1], 3),
            o1: p(i._periods[1], 1),
            o10: p(i._periods[1], 10),
            o100: p(i._periods[1], 100),
            o1000: p(i._periods[1], 1e3),
            wl: _(2),
            wn: this._minDigits(i, i._periods[2], 1),
            wnn: this._minDigits(i, i._periods[2], 2),
            wnnn: this._minDigits(i, i._periods[2], 3),
            w1: p(i._periods[2], 1),
            w10: p(i._periods[2], 10),
            w100: p(i._periods[2], 100),
            w1000: p(i._periods[2], 1e3),
            dl: _(3),
            dn: this._minDigits(i, i._periods[3], 1),
            dnn: this._minDigits(i, i._periods[3], 2),
            dnnn: this._minDigits(i, i._periods[3], 3),
            d1: p(i._periods[3], 1),
            d10: p(i._periods[3], 10),
            d100: p(i._periods[3], 100),
            d1000: p(i._periods[3], 1e3),
            hl: _(4),
            hn: this._minDigits(i, i._periods[4], 1),
            hnn: this._minDigits(i, i._periods[4], 2),
            hnnn: this._minDigits(i, i._periods[4], 3),
            h1: p(i._periods[4], 1),
            h10: p(i._periods[4], 10),
            h100: p(i._periods[4], 100),
            h1000: p(i._periods[4], 1e3),
            ml: _(5),
            mn: this._minDigits(i, i._periods[5], 1),
            mnn: this._minDigits(i, i._periods[5], 2),
            mnnn: this._minDigits(i, i._periods[5], 3),
            m1: p(i._periods[5], 1),
            m10: p(i._periods[5], 10),
            m100: p(i._periods[5], 100),
            m1000: p(i._periods[5], 1e3),
            sl: _(6),
            sn: this._minDigits(i, i._periods[6], 1),
            snn: this._minDigits(i, i._periods[6], 2),
            snnn: this._minDigits(i, i._periods[6], 3),
            s1: p(i._periods[6], 1),
            s10: p(i._periods[6], 10),
            s100: p(i._periods[6], 100),
            s1000: p(i._periods[6], 1e3),
          },
          u = s,
          h = 0;
        h <= 6;
        h++
      ) {
        var d = "yowdhms".charAt(h),
          m = new RegExp("\\{" + d + "<\\}([\\s\\S]*)\\{" + d + ">\\}", "g");
        u = u.replace(m, (!o && t[h]) || (o && r[h]) ? "$1" : "");
      }
      return (
        e.each(c, function (e, i) {
          var t = new RegExp("\\{" + e + "\\}", "g");
          u = u.replace(t, i);
        }),
        u
      );
    },
    _minDigits: function (e, i, t) {
      return (i = "" + i).length >= t
        ? this._translateDigits(e, i)
        : ((i = "0000000000" + i),
          this._translateDigits(e, i.substr(i.length - t)));
    },
    _translateDigits: function (e, i) {
      return ("" + i).replace(/[0-9]/g, function (i) {
        return e.options.digits[i];
      });
    },
    _determineShow: function (e) {
      var i = e.options.format,
        t = [];
      return (
        (t[0] = i.match("y") ? "?" : i.match("Y") ? "!" : null),
        (t[1] = i.match("o") ? "?" : i.match("O") ? "!" : null),
        (t[2] = i.match("w") ? "?" : i.match("W") ? "!" : null),
        (t[3] = i.match("d") ? "?" : i.match("D") ? "!" : null),
        (t[4] = i.match("h") ? "?" : i.match("H") ? "!" : null),
        (t[5] = i.match("m") ? "?" : i.match("M") ? "!" : null),
        (t[6] = i.match("s") ? "?" : i.match("S") ? "!" : null),
        t
      );
    },
    _calculatePeriods: function (e, i, t, s) {
      (e._now = s), e._now.setMilliseconds(0);
      var n = new Date(e._now.getTime());
      e._since
        ? s.getTime() < e._since.getTime()
          ? (e._now = s = n)
          : (s = e._since)
        : (n.setTime(e._until.getTime()),
          s.getTime() > e._until.getTime() && (e._now = s = n));
      var o = [0, 0, 0, 0, 0, 0, 0];
      if (i[0] || i[1]) {
        var r = this._getDaysInMonth(s.getFullYear(), s.getMonth()),
          a = this._getDaysInMonth(n.getFullYear(), n.getMonth()),
          l =
            n.getDate() === s.getDate() ||
            (n.getDate() >= Math.min(r, a) && s.getDate() >= Math.min(r, a)),
          _ = function (e) {
            return 60 * (60 * e.getHours() + e.getMinutes()) + e.getSeconds();
          },
          p = Math.max(
            0,
            12 * (n.getFullYear() - s.getFullYear()) +
              n.getMonth() -
              s.getMonth() +
              ((n.getDate() < s.getDate() && !l) || (l && _(n) < _(s)) ? -1 : 0)
          );
        (o[0] = i[0] ? Math.floor(p / 12) : 0),
          (o[1] = i[1] ? p - 12 * o[0] : 0);
        var c = (s = new Date(s.getTime())).getDate() === r,
          u = this._getDaysInMonth(s.getFullYear() + o[0], s.getMonth() + o[1]);
        s.getDate() > u && s.setDate(u),
          s.setFullYear(s.getFullYear() + o[0]),
          s.setMonth(s.getMonth() + o[1]),
          c && s.setDate(u);
      }
      var h = Math.floor((n.getTime() - s.getTime()) / 1e3),
        d = null,
        m = function (e, t) {
          (o[e] = i[e] ? Math.floor(h / t) : 0), (h -= o[e] * t);
        };
      if (
        (m(2, 604800),
        m(3, 86400),
        m(4, 3600),
        m(5, 60),
        m(6, 1),
        h > 0 && !e._since)
      ) {
        var g = [1, 12, 4.3482, 7, 24, 60, 60],
          w = 6,
          f = 1;
        for (d = 6; d >= 0; d--)
          i[d] &&
            (o[w] >= f && ((o[w] = 0), (h = 1)),
            h > 0 && (o[d]++, (h = 0), (w = d), (f = 1))),
            (f *= g[d]);
      }
      if (t) for (d = 0; d <= 6; d++) t && o[d] ? t-- : t || (o[d] = 0);
      return o;
    },
  });
})(jQuery);
/*! Imagesloaded */
!(function (e, t) {
  "function" == typeof define && define.amd
    ? define("ev-emitter/ev-emitter", t)
    : "object" == typeof module && module.exports
    ? (module.exports = t())
    : (e.EvEmitter = t());
})("undefined" != typeof window ? window : this, function () {
  function e() {}
  var t = e.prototype;
  return (
    (t.on = function (e, t) {
      if (e && t) {
        var i = (this._events = this._events || {}),
          n = (i[e] = i[e] || []);
        return -1 == n.indexOf(t) && n.push(t), this;
      }
    }),
    (t.once = function (e, t) {
      if (e && t) {
        this.on(e, t);
        var i = (this._onceEvents = this._onceEvents || {}),
          n = (i[e] = i[e] || {});
        return (n[t] = !0), this;
      }
    }),
    (t.off = function (e, t) {
      var i = this._events && this._events[e];
      if (i && i.length) {
        var n = i.indexOf(t);
        return -1 != n && i.splice(n, 1), this;
      }
    }),
    (t.emitEvent = function (e, t) {
      var i = this._events && this._events[e];
      if (i && i.length) {
        var n = 0,
          o = i[n];
        t = t || [];
        for (var r = this._onceEvents && this._onceEvents[e]; o; ) {
          var s = r && r[o];
          s && (this.off(e, o), delete r[o]),
            o.apply(this, t),
            (n += s ? 0 : 1),
            (o = i[n]);
        }
        return this;
      }
    }),
    (t.allOff = t.removeAllListeners =
      function () {
        delete this._events, delete this._onceEvents;
      }),
    e
  );
}),
  (function (e, t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["ev-emitter/ev-emitter"], function (i) {
          return t(e, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("ev-emitter")))
      : (e.imagesLoaded = t(e, e.EvEmitter));
  })("undefined" != typeof window ? window : this, function (e, t) {
    function i(e, t) {
      for (var i in t) e[i] = t[i];
      return e;
    }
    function n(e) {
      var t = [];
      if (Array.isArray(e)) t = e;
      else if ("number" == typeof e.length)
        for (var i = 0; i < e.length; i++) t.push(e[i]);
      else t.push(e);
      return t;
    }
    function o(e, t, r) {
      return this instanceof o
        ? ("string" == typeof e && (e = document.querySelectorAll(e)),
          (this.elements = n(e)),
          (this.options = i({}, this.options)),
          "function" == typeof t ? (r = t) : i(this.options, t),
          r && this.on("always", r),
          this.getImages(),
          h && (this.jqDeferred = new h.Deferred()),
          void setTimeout(
            function () {
              this.check();
            }.bind(this)
          ))
        : new o(e, t, r);
    }
    function r(e) {
      this.img = e;
    }
    function s(e, t) {
      (this.url = e), (this.element = t), (this.img = new Image());
    }
    var h = e.jQuery,
      a = e.console;
    (o.prototype = Object.create(t.prototype)),
      (o.prototype.options = {}),
      (o.prototype.getImages = function () {
        (this.images = []), this.elements.forEach(this.addElementImages, this);
      }),
      (o.prototype.addElementImages = function (e) {
        "IMG" == e.nodeName && this.addImage(e),
          this.options.background === !0 && this.addElementBackgroundImages(e);
        var t = e.nodeType;
        if (t && d[t]) {
          for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
            var o = i[n];
            this.addImage(o);
          }
          if ("string" == typeof this.options.background) {
            var r = e.querySelectorAll(this.options.background);
            for (n = 0; n < r.length; n++) {
              var s = r[n];
              this.addElementBackgroundImages(s);
            }
          }
        }
      });
    var d = { 1: !0, 9: !0, 11: !0 };
    return (
      (o.prototype.addElementBackgroundImages = function (e) {
        var t = getComputedStyle(e);
        if (t)
          for (
            var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage);
            null !== n;

          ) {
            var o = n && n[2];
            o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
          }
      }),
      (o.prototype.addImage = function (e) {
        var t = new r(e);
        this.images.push(t);
      }),
      (o.prototype.addBackground = function (e, t) {
        var i = new s(e, t);
        this.images.push(i);
      }),
      (o.prototype.check = function () {
        function e(e, i, n) {
          setTimeout(function () {
            t.progress(e, i, n);
          });
        }
        var t = this;
        return (
          (this.progressedCount = 0),
          (this.hasAnyBroken = !1),
          this.images.length
            ? void this.images.forEach(function (t) {
                t.once("progress", e), t.check();
              })
            : void this.complete()
        );
      }),
      (o.prototype.progress = function (e, t, i) {
        this.progressedCount++,
          (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
          this.emitEvent("progress", [this, e, t]),
          this.jqDeferred &&
            this.jqDeferred.notify &&
            this.jqDeferred.notify(this, e),
          this.progressedCount == this.images.length && this.complete(),
          this.options.debug && a && a.log("progress: " + i, e, t);
      }),
      (o.prototype.complete = function () {
        var e = this.hasAnyBroken ? "fail" : "done";
        if (
          ((this.isComplete = !0),
          this.emitEvent(e, [this]),
          this.emitEvent("always", [this]),
          this.jqDeferred)
        ) {
          var t = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[t](this);
        }
      }),
      (r.prototype = Object.create(t.prototype)),
      (r.prototype.check = function () {
        var e = this.getIsImageComplete();
        return e
          ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
          : ((this.proxyImage = new Image()),
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            void (this.proxyImage.src = this.img.src));
      }),
      (r.prototype.getIsImageComplete = function () {
        return this.img.complete && void 0 !== this.img.naturalWidth;
      }),
      (r.prototype.confirm = function (e, t) {
        (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
      }),
      (r.prototype.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
      }),
      (r.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }),
      (r.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }),
      (r.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this),
          this.proxyImage.removeEventListener("error", this),
          this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (s.prototype = Object.create(r.prototype)),
      (s.prototype.check = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this),
          (this.img.src = this.url);
        var e = this.getIsImageComplete();
        e &&
          (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
          this.unbindEvents());
      }),
      (s.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (s.prototype.confirm = function (e, t) {
        (this.isLoaded = e),
          this.emitEvent("progress", [this, this.element, t]);
      }),
      (o.makeJQueryPlugin = function (t) {
        (t = t || e.jQuery),
          t &&
            ((h = t),
            (h.fn.imagesLoaded = function (e, t) {
              var i = new o(this, e, t);
              return i.jqDeferred.promise(h(this));
            }));
      }),
      o.makeJQueryPlugin(),
      o
    );
  });
/*! jQuery mmenu */
!(function (e) {
  function t() {
    e[n].glbl ||
      ((l = {
        $wndw: e(window),
        $docu: e(document),
        $html: e("html"),
        $body: e("body"),
      }),
      (s = {}),
      (a = {}),
      (r = {}),
      e.each([s, a, r], function (e, t) {
        t.add = function (e) {
          e = e.split(" ");
          for (var n = 0, i = e.length; n < i; n++) t[e[n]] = t.mm(e[n]);
        };
      }),
      (s.mm = function (e) {
        return "mm-" + e;
      }),
      s.add(
        "wrapper menu panels panel nopanel navbar listview nolistview listitem btn hidden"
      ),
      (s.umm = function (e) {
        return "mm-" == e.slice(0, 3) && (e = e.slice(3)), e;
      }),
      (a.mm = function (e) {
        return "mm-" + e;
      }),
      a.add("parent child title"),
      (r.mm = function (e) {
        return e + ".mm";
      }),
      r.add(
        "transitionend webkitTransitionEnd click scroll resize keydown mousedown mouseup touchstart touchmove touchend orientationchange"
      ),
      (e[n]._c = s),
      (e[n]._d = a),
      (e[n]._e = r),
      (e[n].glbl = l));
  }
  var n = "mmenu",
    i = "7.0.5";
  if (!(e[n] && e[n].version > i)) {
    (e[n] = function (e, t, n) {
      return (
        (this.$menu = e),
        (this._api = [
          "bind",
          "getInstance",
          "initPanels",
          "openPanel",
          "closePanel",
          "closeAllPanels",
          "setSelected",
        ]),
        (this.opts = t),
        (this.conf = n),
        (this.vars = {}),
        (this.cbck = {}),
        (this.mtch = {}),
        "function" == typeof this.___deprecated && this.___deprecated(),
        this._initHooks(),
        this._initWrappers(),
        this._initAddons(),
        this._initExtensions(),
        this._initMenu(),
        this._initPanels(),
        this._initOpened(),
        this._initAnchors(),
        this._initMatchMedia(),
        "function" == typeof this.___debug && this.___debug(),
        this
      );
    }),
      (e[n].version = i),
      (e[n].uniqueId = 0),
      (e[n].wrappers = {}),
      (e[n].addons = {}),
      (e[n].defaults = {
        hooks: {},
        extensions: [],
        wrappers: [],
        navbar: { add: !0, title: "Menu", titleLink: "parent" },
        onClick: { setSelected: !0 },
        slidingSubmenus: !0,
      }),
      (e[n].configuration = {
        classNames: {
          divider: "Divider",
          inset: "Inset",
          nolistview: "NoListview",
          nopanel: "NoPanel",
          panel: "Panel",
          selected: "Selected",
          spacer: "Spacer",
          vertical: "Vertical",
        },
        clone: !1,
        openingInterval: 25,
        panelNodetype: "ul, ol, div",
        transitionDuration: 400,
      }),
      (e[n].prototype = {
        getInstance: function () {
          return this;
        },
        initPanels: function (e) {
          this._initPanels(e);
        },
        openPanel: function (t, i) {
          if (
            (this.trigger("openPanel:before", t),
            t &&
              t.length &&
              (t.is("." + s.panel) || (t = t.closest("." + s.panel)),
              t.is("." + s.panel)))
          ) {
            var r = this;
            if (
              ("boolean" != typeof i && (i = !0),
              t.parent("." + s.listitem + "_vertical").length)
            )
              t
                .parents("." + s.listitem + "_vertical")
                .addClass(s.listitem + "_opened")
                .children("." + s.panel)
                .removeClass(s.hidden),
                this.openPanel(
                  t
                    .parents("." + s.panel)
                    .not(function () {
                      return e(this).parent(
                        "." + s.listitem + "_vertical"
                      ).length;
                    })
                    .first()
                ),
                this.trigger("openPanel:start", t),
                this.trigger("openPanel:finish", t);
            else {
              if (t.hasClass(s.panel + "_opened")) return;
              var l = this.$pnls.children("." + s.panel),
                o = this.$pnls.children("." + s.panel + "_opened");
              if (!e[n].support.csstransitions)
                return (
                  o.addClass(s.hidden).removeClass(s.panel + "_opened"),
                  t.removeClass(s.hidden).addClass(s.panel + "_opened"),
                  this.trigger("openPanel:start", t),
                  void this.trigger("openPanel:finish", t)
                );
              l.not(t).removeClass(s.panel + "_opened-parent");
              for (var d = t.data(a.parent); d; )
                (d = d.closest("." + s.panel)),
                  d.parent("." + s.listitem + "_vertical").length ||
                    d.addClass(s.panel + "_opened-parent"),
                  (d = d.data(a.parent));
              l
                .removeClass(s.panel + "_highest")
                .not(o)
                .not(t)
                .addClass(s.hidden),
                t.removeClass(s.hidden);
              var c = function () {
                  o.removeClass(s.panel + "_opened"),
                    t.addClass(s.panel + "_opened"),
                    t.hasClass(s.panel + "_opened-parent")
                      ? (o.addClass(s.panel + "_highest"),
                        t.removeClass(s.panel + "_opened-parent"))
                      : (o.addClass(s.panel + "_opened-parent"),
                        t.addClass(s.panel + "_highest")),
                    r.trigger("openPanel:start", t);
                },
                h = function () {
                  o.removeClass(s.panel + "_highest").addClass(s.hidden),
                    t.removeClass(s.panel + "_highest"),
                    r.trigger("openPanel:finish", t);
                };
              i && !t.hasClass(s.panel + "_noanimation")
                ? setTimeout(function () {
                    r.__transitionend(
                      t,
                      function () {
                        h();
                      },
                      r.conf.transitionDuration
                    ),
                      c();
                  }, r.conf.openingInterval)
                : (c(), h());
            }
            this.trigger("openPanel:after", t);
          }
        },
        closePanel: function (e) {
          this.trigger("closePanel:before", e);
          var t = e.parent();
          t.hasClass(s.listitem + "_vertical") &&
            (t.removeClass(s.listitem + "_opened"),
            e.addClass(s.hidden),
            this.trigger("closePanel", e)),
            this.trigger("closePanel:after", e);
        },
        closeAllPanels: function (e) {
          this.trigger("closeAllPanels:before"),
            this.$pnls
              .find("." + s.listview)
              .children()
              .removeClass(s.listitem + "_selected")
              .filter("." + s.listitem + "_vertical")
              .removeClass(s.listitem + "_opened");
          var t = this.$pnls.children("." + s.panel),
            n = e && e.length ? e : t.first();
          this.$pnls
            .children("." + s.panel)
            .not(n)
            .removeClass(s.panel + "_opened")
            .removeClass(s.panel + "_opened-parent")
            .removeClass(s.panel + "_highest")
            .addClass(s.hidden),
            this.openPanel(n, !1),
            this.trigger("closeAllPanels:after");
        },
        togglePanel: function (e) {
          var t = e.parent();
          t.hasClass(s.listitem + "_vertical") &&
            this[
              t.hasClass(s.listitem + "_opened") ? "closePanel" : "openPanel"
            ](e);
        },
        setSelected: function (e) {
          this.trigger("setSelected:before", e),
            this.$menu
              .find("." + s.listitem + "_selected")
              .removeClass(s.listitem + "_selected"),
            e.addClass(s.listitem + "_selected"),
            this.trigger("setSelected:after", e);
        },
        bind: function (e, t) {
          (this.cbck[e] = this.cbck[e] || []), this.cbck[e].push(t);
        },
        trigger: function () {
          var e = this,
            t = Array.prototype.slice.call(arguments),
            n = t.shift();
          if (this.cbck[n])
            for (var i = 0, s = this.cbck[n].length; i < s; i++)
              this.cbck[n][i].apply(e, t);
        },
        matchMedia: function (e, t, n) {
          var i = { yes: t, no: n };
          (this.mtch[e] = this.mtch[e] || []), this.mtch[e].push(i);
        },
        _initHooks: function () {
          for (var e in this.opts.hooks) this.bind(e, this.opts.hooks[e]);
        },
        _initWrappers: function () {
          this.trigger("initWrappers:before");
          for (var t = 0; t < this.opts.wrappers.length; t++) {
            var i = e[n].wrappers[this.opts.wrappers[t]];
            "function" == typeof i && i.call(this);
          }
          this.trigger("initWrappers:after");
        },
        _initAddons: function () {
          this.trigger("initAddons:before");
          var t;
          for (t in e[n].addons)
            e[n].addons[t].add.call(this),
              (e[n].addons[t].add = function () {});
          for (t in e[n].addons) e[n].addons[t].setup.call(this);
          this.trigger("initAddons:after");
        },
        _initExtensions: function () {
          this.trigger("initExtensions:before");
          var e = this;
          this.opts.extensions.constructor === Array &&
            (this.opts.extensions = { all: this.opts.extensions });
          for (var t in this.opts.extensions)
            (this.opts.extensions[t] = this.opts.extensions[t].length
              ? s.menu + "_" + this.opts.extensions[t].join(" " + s.menu + "_")
              : ""),
              this.opts.extensions[t] &&
                !(function (t) {
                  e.matchMedia(
                    t,
                    function () {
                      this.$menu.addClass(this.opts.extensions[t]);
                    },
                    function () {
                      this.$menu.removeClass(this.opts.extensions[t]);
                    }
                  );
                })(t);
          this.trigger("initExtensions:after");
        },
        _initMenu: function () {
          this.trigger("initMenu:before");
          this.conf.clone &&
            ((this.$orig = this.$menu),
            (this.$menu = this.$orig.clone()),
            this.$menu
              .add(this.$menu.find("[id]"))
              .filter("[id]")
              .each(function () {
                e(this).attr("id", s.mm(e(this).attr("id")));
              })),
            this.$menu.attr(
              "id",
              this.$menu.attr("id") || this.__getUniqueId()
            ),
            (this.$pnls = e('<div class="' + s.panels + '" />')
              .append(this.$menu.children(this.conf.panelNodetype))
              .prependTo(this.$menu)),
            this.$menu.addClass(s.menu).parent().addClass(s.wrapper),
            this.trigger("initMenu:after");
        },
        _initPanels: function (t) {
          this.trigger("initPanels:before", t),
            (t = t || this.$pnls.children(this.conf.panelNodetype));
          var n = e(),
            i = this,
            a = function (t) {
              t.filter(i.conf.panelNodetype).each(function (t) {
                var r = i._initPanel(e(this));
                if (r) {
                  i._initNavbar(r), i._initListview(r), (n = n.add(r));
                  var l = r
                    .children("." + s.listview)
                    .children("li")
                    .children(i.conf.panelNodetype)
                    .add(r.children("." + i.conf.classNames.panel));
                  l.length && a(l);
                }
              });
            };
          a(t), this.trigger("initPanels:after", n);
        },
        _initPanel: function (e) {
          this.trigger("initPanel:before", e);
          if (e.hasClass(s.panel)) return e;
          if (
            (this.__refactorClass(e, this.conf.classNames.panel, s.panel),
            this.__refactorClass(e, this.conf.classNames.nopanel, s.nopanel),
            this.__refactorClass(
              e,
              this.conf.classNames.inset,
              s.listview + "_inset"
            ),
            e.filter("." + s.listview + "_inset").addClass(s.nopanel),
            e.hasClass(s.nopanel))
          )
            return !1;
          var t =
            e.hasClass(this.conf.classNames.vertical) ||
            !this.opts.slidingSubmenus;
          e.removeClass(this.conf.classNames.vertical);
          var n = e.attr("id") || this.__getUniqueId();
          e.is("ul, ol") &&
            (e.removeAttr("id"), e.wrap("<div />"), (e = e.parent())),
            e.attr("id", n),
            e.addClass(s.panel + " " + s.hidden);
          var i = e.parent("li");
          return (
            t ? i.addClass(s.listitem + "_vertical") : e.appendTo(this.$pnls),
            i.length && (i.data(a.child, e), e.data(a.parent, i)),
            this.trigger("initPanel:after", e),
            e
          );
        },
        _initNavbar: function (t) {
          if (
            (this.trigger("initNavbar:before", t),
            !t.children("." + s.navbar).length)
          ) {
            var n = t.data(a.parent),
              i = e('<div class="' + s.navbar + '" />'),
              r = this.__getPanelTitle(t, this.opts.navbar.title),
              l = "";
            if (n && n.length) {
              if (n.hasClass(s.listitem + "_vertical")) return;
              if (n.parent().is("." + s.listview))
                var o = n.children("a, span").not("." + s.btn + "_next");
              else
                var o = n
                  .closest("." + s.panel)
                  .find('a[href="#' + t.attr("id") + '"]');
              (o = o.first()), (n = o.closest("." + s.panel));
              var d = n.attr("id");
              switch (
                ((r = this.__getPanelTitle(
                  t,
                  e("<span>" + o.text() + "</span>").text()
                )),
                this.opts.navbar.titleLink)
              ) {
                case "anchor":
                  l = o.attr("href");
                  break;
                case "parent":
                  l = "#" + d;
              }
              i.append(
                '<a class="' +
                  s.btn +
                  " " +
                  s.btn +
                  "_prev " +
                  s.navbar +
                  '__btn" href="#' +
                  d +
                  '" />'
              );
            } else if (!this.opts.navbar.title) return;
            this.opts.navbar.add && t.addClass(s.panel + "_has-navbar"),
              i
                .append(
                  '<a class="' +
                    s.navbar +
                    '__title"' +
                    (l.length ? ' href="' + l + '"' : "") +
                    ">" +
                    r +
                    "</a>"
                )
                .prependTo(t),
              this.trigger("initNavbar:after", t);
          }
        },
        _initListview: function (t) {
          this.trigger("initListview:before", t);
          var n = this.__childAddBack(t, "ul, ol");
          this.__refactorClass(
            n,
            this.conf.classNames.nolistview,
            s.nolistview
          );
          var i = n
            .not("." + s.nolistview)
            .addClass(s.listview)
            .children()
            .addClass(s.listitem);
          this.__refactorClass(
            i,
            this.conf.classNames.selected,
            s.listitem + "_selected"
          ),
            this.__refactorClass(
              i,
              this.conf.classNames.divider,
              s.listitem + "_divider"
            ),
            this.__refactorClass(
              i,
              this.conf.classNames.spacer,
              s.listitem + "_spacer"
            );
          var r = t.data(a.parent);
          if (
            r &&
            r.is("." + s.listitem) &&
            !r.children("." + s.btn + "_next").length
          ) {
            var l = r.children("a, span").first(),
              o = e(
                '<a class="' + s.btn + '_next" href="#' + t.attr("id") + '" />'
              ).insertBefore(l);
            l.is("span") && o.addClass(s.btn + "_fullwidth");
          }
          this.trigger("initListview:after", t);
        },
        _initOpened: function () {
          this.trigger("initOpened:before");
          var e = this.$pnls
              .find("." + s.listitem + "_selected")
              .removeClass(s.listitem + "_selected")
              .last()
              .addClass(s.listitem + "_selected"),
            t = e.length
              ? e.closest("." + s.panel)
              : this.$pnls.children("." + s.panel).first();
          this.openPanel(t, !1), this.trigger("initOpened:after");
        },
        _initAnchors: function () {
          this.trigger("initAnchors:before");
          var t = this;
          l.$body.on(r.click + "-oncanvas", "a[href]", function (i) {
            var a = e(this),
              r = a.attr("href"),
              l = t.$menu.find(a).length,
              o = a.is("." + s.listitem + " > a"),
              d = a.is('[rel="external"]') || a.is('[target="_blank"]');
            if (l && r.length > 1 && "#" == r.slice(0, 1))
              try {
                var c = t.$menu.find(r);
                if (c.is("." + s.panel))
                  return (
                    t[
                      a.parent().hasClass(s.listitem + "_vertical")
                        ? "togglePanel"
                        : "openPanel"
                    ](c),
                    void i.preventDefault()
                  );
              } catch (h) {}
            var f = {
              close: null,
              setSelected: null,
              preventDefault: "#" == r.slice(0, 1),
            };
            for (var p in e[n].addons) {
              var u = e[n].addons[p].clickAnchor.call(t, a, l, o, d);
              if (u) {
                if ("boolean" == typeof u) return void i.preventDefault();
                "object" == typeof u && (f = e.extend({}, f, u));
              }
            }
            l &&
              o &&
              !d &&
              (t.__valueOrFn(a, t.opts.onClick.setSelected, f.setSelected) &&
                t.setSelected(e(i.target).parent()),
              t.__valueOrFn(
                a,
                t.opts.onClick.preventDefault,
                f.preventDefault
              ) && i.preventDefault(),
              t.__valueOrFn(a, t.opts.onClick.close, f.close) &&
                t.opts.offCanvas &&
                "function" == typeof t.close &&
                t.close());
          }),
            this.trigger("initAnchors:after");
        },
        _initMatchMedia: function () {
          var e = this;
          for (var t in this.mtch)
            !(function () {
              var n = t,
                i = window.matchMedia(n);
              e._fireMatchMedia(n, i),
                i.addListener(function (t) {
                  e._fireMatchMedia(n, t);
                });
            })();
        },
        _fireMatchMedia: function (e, t) {
          for (
            var n = t.matches ? "yes" : "no", i = 0;
            i < this.mtch[e].length;
            i++
          )
            this.mtch[e][i][n].call(this);
        },
        _getOriginalMenuId: function () {
          var e = this.$menu.attr("id");
          return this.conf.clone && e && e.length && (e = s.umm(e)), e;
        },
        __api: function () {
          var t = this,
            n = {};
          return (
            e.each(this._api, function (e) {
              var i = this;
              n[i] = function () {
                var e = t[i].apply(t, arguments);
                return "undefined" == typeof e ? n : e;
              };
            }),
            n
          );
        },
        __valueOrFn: function (e, t, n) {
          if ("function" == typeof t) {
            var i = t.call(e[0]);
            if ("undefined" != typeof i) return i;
          }
          return ("function" != typeof t && "undefined" != typeof t) ||
            "undefined" == typeof n
            ? t
            : n;
        },
        __getPanelTitle: function (t, i) {
          var s;
          return (
            "function" == typeof this.opts.navbar.title &&
              (s = this.opts.navbar.title.call(t[0])),
            "undefined" == typeof s && (s = t.data(a.title)),
            "undefined" != typeof s
              ? s
              : "string" == typeof i
              ? e[n].i18n(i)
              : e[n].i18n(e[n].defaults.navbar.title)
          );
        },
        __refactorClass: function (e, t, n) {
          return e
            .filter("." + t)
            .removeClass(t)
            .addClass(n);
        },
        __findAddBack: function (e, t) {
          return e.find(t).add(e.filter(t));
        },
        __childAddBack: function (e, t) {
          return e.children(t).add(e.filter(t));
        },
        __filterListItems: function (e) {
          return e.not("." + s.listitem + "_divider").not("." + s.hidden);
        },
        __filterListItemAnchors: function (e) {
          return this.__filterListItems(e)
            .children("a")
            .not("." + s.btn + "_next");
        },
        __openPanelWoAnimation: function (e) {
          e.hasClass(s.panel + "_noanimation") ||
            (e.addClass(s.panel + "_noanimation"),
            this.__transitionend(
              e,
              function () {
                e.removeClass(s.panel + "_noanimation");
              },
              this.conf.openingInterval
            ),
            this.openPanel(e));
        },
        __transitionend: function (e, t, n) {
          var i = !1,
            s = function (n) {
              ("undefined" != typeof n && n.target != e[0]) ||
                (i ||
                  (e.off(r.transitionend),
                  e.off(r.webkitTransitionEnd),
                  t.call(e[0])),
                (i = !0));
            };
          e.on(r.transitionend, s),
            e.on(r.webkitTransitionEnd, s),
            setTimeout(s, 1.1 * n);
        },
        __getUniqueId: function () {
          return s.mm(e[n].uniqueId++);
        },
      }),
      (e.fn[n] = function (i, s) {
        t(),
          (i = e.extend(!0, {}, e[n].defaults, i)),
          (s = e.extend(!0, {}, e[n].configuration, s));
        var a = e();
        return (
          this.each(function () {
            var t = e(this);
            if (!t.data(n)) {
              var r = new e[n](t, i, s);
              r.$menu.data(n, r.__api()), (a = a.add(r.$menu));
            }
          }),
          a
        );
      }),
      (e[n].i18n = (function () {
        var t = {};
        return function (n) {
          switch (typeof n) {
            case "object":
              return e.extend(t, n), t;
            case "string":
              return t[n] || n;
            case "undefined":
            default:
              return t;
          }
        };
      })()),
      (e[n].support = {
        touch: "ontouchstart" in window || navigator.msMaxTouchPoints || !1,
        csstransitions: (function () {
          return (
            "undefined" == typeof Modernizr ||
            "undefined" == typeof Modernizr.csstransitions ||
            Modernizr.csstransitions
          );
        })(),
        csstransforms: (function () {
          return (
            "undefined" == typeof Modernizr ||
            "undefined" == typeof Modernizr.csstransforms ||
            Modernizr.csstransforms
          );
        })(),
        csstransforms3d: (function () {
          return (
            "undefined" == typeof Modernizr ||
            "undefined" == typeof Modernizr.csstransforms3d ||
            Modernizr.csstransforms3d
          );
        })(),
      });
    var s, a, r, l;
  }
})(jQuery);
